import * as Operations from './graphql_op';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHoc from '@apollo/client/react/hoc';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ChallengeConditionInfoblockConfigVisualisationInput: any;
  ChallengeConditionInput: any;
  ChallengeVisualisationInput: any;
  ContentAttachmentInput: any;
  CreditConfigTypeInput: any;
  DashboardConfigWidgetInput: any;
  JSON: any;
  JourneyCreateInput: any;
  JourneyUpdateInput: any;
  MailEngineInput: any;
  MailTemplateAttachmentInput: any;
  PaymentConfigInput: any;
  UserNotificationInput: any;
};

export type ActivityConversion = {
  __typename?: 'ActivityConversion';
  activity: Scalars['String'];
  creditsPerKm: Scalars['Float'];
  kcalPerHour: Scalars['Float'];
};

export type ActivityConversionInput = {
  activity: Scalars['String'];
  creditsPerKm: Scalars['Float'];
  kcalPerHour: Scalars['Float'];
};

export type Ambassador = {
  __typename?: 'Ambassador';
  activityTypes?: Maybe<Array<Scalars['String']>>;
  commentCount: Scalars['Int'];
  comments: Array<AmbassadorComment>;
  createdOn?: Maybe<Scalars['Float']>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  info?: Maybe<Array<Maybe<TextByLanguage>>>;
  place: Scalars['String'];
  tags?: Maybe<Array<AmbassadorTag>>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  userId?: Maybe<Scalars['String']>;
  withAdvancedMode?: Maybe<Scalars['Boolean']>;
};

export type AmbassadorComment = Comment & {
  __typename?: 'AmbassadorComment';
  ambassador: Ambassador;
  comment: Scalars['String'];
  createdAt: Scalars['Float'];
  deleted: Scalars['Boolean'];
  id: Scalars['String'];
  moderated: Scalars['Boolean'];
  parentId?: Maybe<Scalars['String']>;
  reported: Scalars['Boolean'];
  subComments: Array<SubComment>;
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type AmbassadorConfig = {
  __typename?: 'AmbassadorConfig';
  ambassadorIntro?: Maybe<Array<Maybe<TextByLanguage>>>;
  caption?: Maybe<Array<Maybe<TextByLanguage>>>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  heroImage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<AmbassadorConfigImage>;
  intro?: Maybe<Array<Maybe<TextByLanguage>>>;
  place: Scalars['String'];
  preview?: Maybe<Array<Maybe<TextByLanguage>>>;
  sequence?: Maybe<Scalars['Int']>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  visibility?: Maybe<AmbassadorConfigVisibility>;
  withAdvancedMode?: Maybe<Scalars['Boolean']>;
};

export type AmbassadorConfigFilter = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  place?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

export type AmbassadorConfigImage = {
  __typename?: 'AmbassadorConfigImage';
  shape?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
};

export type AmbassadorConfigImageInput = {
  shape?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
};

export type AmbassadorConfigVisibility = {
  __typename?: 'AmbassadorConfigVisibility';
  icons?: Maybe<Scalars['Boolean']>;
  info?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['Boolean']>;
};

export type AmbassadorConfigVisibilityInput = {
  icons?: InputMaybe<Scalars['Boolean']>;
  info?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['Boolean']>;
};

export type AmbassadorFilter = {
  activityTypes?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  place?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  textSearch?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AmbassadorTag = {
  __typename?: 'AmbassadorTag';
  color: Scalars['String'];
  description: Array<TextByLanguage>;
  id: Scalars['String'];
  image: Scalars['String'];
  title: Array<TextByLanguage>;
};

export type Application = {
  __typename?: 'Application';
  id: Scalars['String'];
  name: Scalars['String'];
  project: Project;
  roles: Array<Role>;
};

export type Article = {
  __typename?: 'Article';
  articleNumber: Scalars['String'];
  availableStock: Scalars['Int'];
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  currentStock: Scalars['Int'];
  description: Array<Maybe<TextByLanguage>>;
  expiresOn?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  image: Scalars['String'];
  isDraft?: Maybe<Scalars['Boolean']>;
  orderRestrictions?: Maybe<ArticleOrderRestrictions>;
  price: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  publishOn?: Maybe<Scalars['Float']>;
  relatedContents?: Maybe<Array<Content>>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  thirdParty?: Maybe<Scalars['String']>;
  title: Array<Maybe<TextByLanguage>>;
  type: Scalars['String'];
  voucher?: Maybe<ArticleVoucher>;
};

export type ArticleFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export type ArticleOrder = {
  __typename?: 'ArticleOrder';
  addressInfo: ArticleOrderAddressInfo;
  id: Scalars['String'];
  orders: Array<ArticleOrderItem>;
  user: User;
};

export type ArticleOrderAddressInfo = {
  __typename?: 'ArticleOrderAddressInfo';
  city: Scalars['String'];
  country: Scalars['String'];
  number: Scalars['String'];
  street: Scalars['String'];
  zip: Scalars['String'];
};

export type ArticleOrderFilter = {
  articleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ArticleOrderItem = {
  __typename?: 'ArticleOrderItem';
  amount: Scalars['Int'];
  article: Article;
};

export type ArticleOrderRestrictions = {
  __typename?: 'ArticleOrderRestrictions';
  enableMaxItemsPerPerson?: Maybe<Scalars['Boolean']>;
  enableMaxItemsPeriod?: Maybe<Scalars['Boolean']>;
  maxItemsPerPerson?: Maybe<Scalars['Int']>;
  maxItemsPeriod?: Maybe<Scalars['String']>;
};

export type ArticleOrderRestrictionsInput = {
  enableMaxItemsPerPerson?: InputMaybe<Scalars['Boolean']>;
  enableMaxItemsPeriod?: InputMaybe<Scalars['Boolean']>;
  maxItemsPerPerson?: InputMaybe<Scalars['Int']>;
  maxItemsPeriod?: InputMaybe<Scalars['String']>;
};

export type ArticleVoucher = {
  __typename?: 'ArticleVoucher';
  instruction?: Maybe<Array<Maybe<TextByLanguage>>>;
  vouchers?: Maybe<Array<Maybe<ArticleVoucherItem>>>;
};

export type ArticleVoucherItem = {
  __typename?: 'ArticleVoucherItem';
  code: Scalars['String'];
  orderId?: Maybe<Scalars['String']>;
  used: Scalars['Boolean'];
  userId?: Maybe<Scalars['String']>;
};

export type Challenge = {
  __typename?: 'Challenge';
  activityMultipliers?: Maybe<ChallengeActivityMultipliers>;
  activityTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  autoParticipationEnabled?: Maybe<Scalars['Boolean']>;
  commentCount: Scalars['Int'];
  comments: Array<ChallengeComment>;
  conditions?: Maybe<Array<Maybe<ChallengeCondition>>>;
  conditionsInOrder?: Maybe<Scalars['Boolean']>;
  data?: Maybe<Scalars['JSON']>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  difficultyLevel?: Maybe<Scalars['Int']>;
  disableComments?: Maybe<Scalars['Boolean']>;
  duration?: Maybe<ChallengeDuration>;
  enabledLocales?: Maybe<Array<Scalars['String']>>;
  endless?: Maybe<ChallengeEndless>;
  exceedConditionLimit?: Maybe<Scalars['Boolean']>;
  expiresOn?: Maybe<Scalars['Float']>;
  featured?: Maybe<Scalars['Boolean']>;
  galleries: Array<ChallengeGallery>;
  galleryCount: Scalars['Int'];
  hideInList?: Maybe<Scalars['Boolean']>;
  hideProgressInDetails?: Maybe<Scalars['Boolean']>;
  hideProgressInInsights?: Maybe<Scalars['Boolean']>;
  hideProgressInList?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  likeCount: Scalars['Int'];
  likes: Array<ChallengeLike>;
  milestones?: Maybe<Array<Maybe<ChallengeMilestone>>>;
  participationProfileRequirements?: Maybe<Array<ChallengeProfileFields>>;
  payment?: Maybe<ChallengePayment>;
  priority?: Maybe<Scalars['Int']>;
  publishedOn?: Maybe<Scalars['Float']>;
  registration?: Maybe<ChallengeRegistration>;
  relatedContents?: Maybe<Array<Content>>;
  rewards?: Maybe<ChallengeRewards>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtitle?: Maybe<Array<Maybe<TextByLanguage>>>;
  superDates?: Maybe<SuperDates>;
  tags?: Maybe<Array<ChallengeTag>>;
  team?: Maybe<ChallengeTeamConfig>;
  teams?: Maybe<Array<Maybe<ChallengeTeam>>>;
  tieBreaker?: Maybe<ChallengeTieBreaker>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  totals?: Maybe<ChallengeTotals>;
  ultimateSyncTime?: Maybe<Scalars['Float']>;
  viewCompletedParticipants?: Maybe<Scalars['Boolean']>;
  viewParticipantCount?: Maybe<Scalars['Boolean']>;
  viewParticipants?: Maybe<Scalars['Boolean']>;
  viewTeamCount?: Maybe<Scalars['Boolean']>;
  visualisations?: Maybe<Array<Maybe<ChallengeVisualisation>>>;
  visualizeType?: Maybe<Scalars['String']>;
  voucherConfiguration?: Maybe<ChallengeVoucherConfiguration>;
  withAdvancedMode?: Maybe<Scalars['Boolean']>;
};

export type ChallengeActivityCondition = ChallengeCondition & {
  __typename?: 'ChallengeActivityCondition';
  activities?: Maybe<Array<Maybe<Scalars['String']>>>;
  blockManualActivities?: Maybe<ChallengeConditionBlockManualActivities>;
  credits?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  inOneGo?: Maybe<ChallengeConditionInOneGo>;
  repeated?: Maybe<ChallengeConditionRepeat>;
  sequence?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Float']>;
  timespan?: Maybe<ChallengeConditionTimespan>;
  title?: Maybe<Array<TextByLanguage>>;
  type?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  unitType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type ChallengeActivityConditionInput = {
  activities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  blockManualActivities?: InputMaybe<ChallengeConditionBlockManualActivitiesInput>;
  credits?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  inOneGo?: InputMaybe<ChallengeConditionInOneGoInput>;
  repeated?: InputMaybe<ChallengeConditionRepeatInput>;
  sequence?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Float']>;
  timespan?: InputMaybe<ChallengeConditionTimespanInput>;
  title?: InputMaybe<Array<TextByLanguageInput>>;
  type?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type ChallengeActivityMultipliers = {
  __typename?: 'ChallengeActivityMultipliers';
  cycling?: Maybe<Scalars['Float']>;
  running?: Maybe<Scalars['Float']>;
  swimming?: Maybe<Scalars['Float']>;
  walking?: Maybe<Scalars['Float']>;
  workout?: Maybe<Scalars['Float']>;
};

export type ChallengeActivityMultipliersInput = {
  cycling?: InputMaybe<Scalars['Float']>;
  running?: InputMaybe<Scalars['Float']>;
  swimming?: InputMaybe<Scalars['Float']>;
  walking?: InputMaybe<Scalars['Float']>;
  workout?: InputMaybe<Scalars['Float']>;
};

export type ChallengeBarVisualisationInput = {
  clickable?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Array<InputMaybe<ChallengeConditionBarVisualisationInput>>>;
  dataType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type ChallengeComment = Comment & {
  __typename?: 'ChallengeComment';
  challenge: Challenge;
  comment: Scalars['String'];
  createdAt: Scalars['Float'];
  deleted: Scalars['Boolean'];
  id: Scalars['String'];
  moderated: Scalars['Boolean'];
  parentId?: Maybe<Scalars['String']>;
  reported: Scalars['Boolean'];
  subComments: Array<SubComment>;
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type ChallengeCondition = {
  credits?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Float']>;
  title?: Maybe<Array<TextByLanguage>>;
  type?: Maybe<Scalars['String']>;
};

export type ChallengeConditionBackgroundBarVisualisation = {
  __typename?: 'ChallengeConditionBackgroundBarVisualisation';
  color?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};

export type ChallengeConditionBackgroundBarVisualisationInput = {
  color?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionBackgroundVisualisation = {
  __typename?: 'ChallengeConditionBackgroundVisualisation';
  color?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};

export type ChallengeConditionBackgroundVisualisationInput = {
  color?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionBarLabelVisualisation = {
  __typename?: 'ChallengeConditionBarLabelVisualisation';
  backgroundColor?: Maybe<Scalars['String']>;
  limitCharacters?: Maybe<Scalars['Boolean']>;
  textDirection?: Maybe<Scalars['String']>;
};

export type ChallengeConditionBarLabelVisualisationInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  limitCharacters?: InputMaybe<Scalars['Boolean']>;
  textDirection?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionBarVisualisation = ChallengeConditionVisualisation & {
  __typename?: 'ChallengeConditionBarVisualisation';
  background?: Maybe<ChallengeConditionBackgroundBarVisualisation>;
  colors?: Maybe<Array<Maybe<Scalars['String']>>>;
  conditionId?: Maybe<Scalars['String']>;
  currentValue?: Maybe<Scalars['Boolean']>;
  endValue?: Maybe<Scalars['Boolean']>;
  font?: Maybe<ChallengeConditionFontVisualisation>;
  label?: Maybe<ChallengeConditionBarLabelVisualisation>;
  margin?: Maybe<ChallengeConditionMarginVisualisation>;
  numberOfItems?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['String']>;
};

export type ChallengeConditionBarVisualisationInput = {
  background?: InputMaybe<ChallengeConditionBackgroundBarVisualisationInput>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  conditionId?: InputMaybe<Scalars['String']>;
  currentValue?: InputMaybe<Scalars['Boolean']>;
  endValue?: InputMaybe<Scalars['Boolean']>;
  font?: InputMaybe<ChallengeConditionFontVisualisationInput>;
  label?: InputMaybe<ChallengeConditionBarLabelVisualisationInput>;
  margin?: InputMaybe<ChallengeConditionMarginVisualisationInput>;
  numberOfItems?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionBlockManualActivities = {
  __typename?: 'ChallengeConditionBlockManualActivities';
  enabled: Scalars['Boolean'];
};

export type ChallengeConditionBlockManualActivitiesInput = {
  enabled: Scalars['Boolean'];
};

export type ChallengeConditionFontVisualisation = {
  __typename?: 'ChallengeConditionFontVisualisation';
  color?: Maybe<Scalars['String']>;
  family?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
};

export type ChallengeConditionFontVisualisationInput = {
  color?: InputMaybe<Scalars['String']>;
  family?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionGridColumnVisualisation = {
  __typename?: 'ChallengeConditionGridColumnVisualisation';
  columnType?: Maybe<Scalars['String']>;
  conditionId?: Maybe<Scalars['String']>;
  filterEnabled?: Maybe<Scalars['Boolean']>;
  header?: Maybe<Array<Maybe<TextByLanguage>>>;
  profileProperty?: Maybe<Scalars['String']>;
};

export type ChallengeConditionGridColumnVisualisationInput = {
  columnType?: InputMaybe<Scalars['String']>;
  conditionId?: InputMaybe<Scalars['String']>;
  filterEnabled?: InputMaybe<Scalars['Boolean']>;
  header?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  profileProperty?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionGridHeaderVisualisation = {
  __typename?: 'ChallengeConditionGridHeaderVisualisation';
  color?: Maybe<Scalars['String']>;
  font?: Maybe<ChallengeConditionFontVisualisation>;
  transparent?: Maybe<Scalars['Float']>;
};

export type ChallengeConditionGridHeaderVisualisationInput = {
  color?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<ChallengeConditionFontVisualisationInput>;
  transparent?: InputMaybe<Scalars['Float']>;
};

export type ChallengeConditionGridImagesVisualisation = {
  __typename?: 'ChallengeConditionGridImagesVisualisation';
  inProgress?: Maybe<Scalars['String']>;
  notStarted?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['String']>;
};

export type ChallengeConditionGridImagesVisualisationInput = {
  inProgress?: InputMaybe<Scalars['String']>;
  notStarted?: InputMaybe<Scalars['String']>;
  success?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionGridVisualisation = ChallengeConditionVisualisation & {
  __typename?: 'ChallengeConditionGridVisualisation';
  background?: Maybe<ChallengeConditionBackgroundVisualisation>;
  columns?: Maybe<Array<Maybe<ChallengeConditionGridColumnVisualisation>>>;
  conditionId?: Maybe<Scalars['String']>;
  header?: Maybe<ChallengeConditionGridHeaderVisualisation>;
  images?: Maybe<ChallengeConditionGridImagesVisualisation>;
  item?: Maybe<ChallengeConditionGridHeaderVisualisation>;
  margin?: Maybe<ChallengeConditionMarginVisualisation>;
  order?: Maybe<Scalars['String']>;
  rowLabel?: Maybe<ChallengeConditionGridHeaderVisualisation>;
};

export type ChallengeConditionGridVisualisationInput = {
  background?: InputMaybe<ChallengeConditionBackgroundVisualisationInput>;
  columns?: InputMaybe<Array<InputMaybe<ChallengeConditionGridColumnVisualisationInput>>>;
  conditionId?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<ChallengeConditionGridHeaderVisualisationInput>;
  images?: InputMaybe<ChallengeConditionGridImagesVisualisationInput>;
  item?: InputMaybe<ChallengeConditionGridHeaderVisualisationInput>;
  margin?: InputMaybe<ChallengeConditionMarginVisualisationInput>;
  order?: InputMaybe<Scalars['String']>;
  rowLabel?: InputMaybe<ChallengeConditionGridHeaderVisualisationInput>;
};

export type ChallengeConditionInOneGo = {
  __typename?: 'ChallengeConditionInOneGo';
  enabled?: Maybe<Scalars['Boolean']>;
  repeat?: Maybe<Scalars['Int']>;
};

export type ChallengeConditionInOneGoInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  repeat?: InputMaybe<Scalars['Int']>;
};

export type ChallengeConditionInfoblockConditionLabelVisualisation = {
  __typename?: 'ChallengeConditionInfoblockConditionLabelVisualisation';
  conditionId?: Maybe<Scalars['String']>;
  text?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type ChallengeConditionInfoblockConditionLabelVisualisationInput = {
  conditionId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type ChallengeConditionInfoblockConfigVisualisation = {
  type?: Maybe<Scalars['String']>;
};

export type ChallengeConditionInfoblockCurrentDayConditionVisualisation = ChallengeConditionInfoblockConfigVisualisation & {
  __typename?: 'ChallengeConditionInfoblockCurrentDayConditionVisualisation';
  conditionLabels?: Maybe<Array<Maybe<ChallengeConditionInfoblockConditionLabelVisualisation>>>;
  font?: Maybe<ChallengeConditionFontVisualisation>;
  type?: Maybe<Scalars['String']>;
};

export type ChallengeConditionInfoblockCurrentDayConditionVisualisationInput = {
  conditionLabels?: InputMaybe<Array<InputMaybe<ChallengeConditionInfoblockConditionLabelVisualisationInput>>>;
  font?: InputMaybe<ChallengeConditionFontVisualisationInput>;
  type?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionInfoblockCurrentDayGoalVisualisation = ChallengeConditionInfoblockConfigVisualisation & {
  __typename?: 'ChallengeConditionInfoblockCurrentDayGoalVisualisation';
  title?: Maybe<ChallengeConditionInfoblockTitleVisualisation>;
  type?: Maybe<Scalars['String']>;
};

export type ChallengeConditionInfoblockCurrentDayGoalVisualisationInput = {
  title?: InputMaybe<ChallengeConditionInfoblockTitleVisualisationInput>;
  type?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionInfoblockNextDayGoalVisualisation = ChallengeConditionInfoblockConfigVisualisation & {
  __typename?: 'ChallengeConditionInfoblockNextDayGoalVisualisation';
  title?: Maybe<ChallengeConditionInfoblockTitleVisualisation>;
  type?: Maybe<Scalars['String']>;
};

export type ChallengeConditionInfoblockNextDayGoalVisualisationInput = {
  title?: InputMaybe<ChallengeConditionInfoblockTitleVisualisationInput>;
  type?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionInfoblockParticipantCountAllConditionsCompletedValueVisualisation = {
  __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedValueVisualisation';
  font?: Maybe<ChallengeConditionFontVisualisation>;
};

export type ChallengeConditionInfoblockParticipantCountAllConditionsCompletedValueVisualisationInput = {
  font?: InputMaybe<ChallengeConditionFontVisualisationInput>;
};

export type ChallengeConditionInfoblockParticipantCountAllConditionsCompletedVisualisation = ChallengeConditionInfoblockConfigVisualisation & {
  __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedVisualisation';
  title?: Maybe<ChallengeConditionInfoblockTitleVisualisation>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<ChallengeConditionInfoblockParticipantCountAllConditionsCompletedValueVisualisation>;
};

export type ChallengeConditionInfoblockParticipantCountAllConditionsCompletedVisualisationInput = {
  title?: InputMaybe<ChallengeConditionInfoblockTitleVisualisationInput>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<ChallengeConditionInfoblockParticipantCountAllConditionsCompletedValueVisualisationInput>;
};

export type ChallengeConditionInfoblockTitleVisualisation = {
  __typename?: 'ChallengeConditionInfoblockTitleVisualisation';
  font?: Maybe<ChallengeConditionFontVisualisation>;
  label?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type ChallengeConditionInfoblockTitleVisualisationInput = {
  font?: InputMaybe<ChallengeConditionFontVisualisationInput>;
  label?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type ChallengeConditionInfoblockVisualisation = ChallengeConditionVisualisation & {
  __typename?: 'ChallengeConditionInfoblockVisualisation';
  background?: Maybe<ChallengeConditionBackgroundVisualisation>;
  conditionId?: Maybe<Scalars['String']>;
  infoblock?: Maybe<ChallengeConditionInfoblockConfigVisualisation>;
  margin?: Maybe<ChallengeConditionMarginVisualisation>;
};

export type ChallengeConditionInfoblockVisualisationInput = {
  background?: InputMaybe<ChallengeConditionBackgroundVisualisationInput>;
  conditionId?: InputMaybe<Scalars['String']>;
  infoblock?: InputMaybe<Scalars['JSON']>;
  margin?: InputMaybe<ChallengeConditionMarginVisualisationInput>;
};

export type ChallengeConditionLeaderboardColumnVisualisation = {
  __typename?: 'ChallengeConditionLeaderboardColumnVisualisation';
  filterEnabled?: Maybe<Scalars['Boolean']>;
  header?: Maybe<Array<Maybe<TextByLanguage>>>;
  profileProperty?: Maybe<Scalars['String']>;
};

export type ChallengeConditionLeaderboardColumnVisualisationInput = {
  filterEnabled?: InputMaybe<Scalars['Boolean']>;
  header?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  profileProperty?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionLeaderboardHeaderVisualisation = {
  __typename?: 'ChallengeConditionLeaderboardHeaderVisualisation';
  color?: Maybe<Scalars['String']>;
  font?: Maybe<ChallengeConditionFontVisualisation>;
  transparent?: Maybe<Scalars['Float']>;
};

export type ChallengeConditionLeaderboardHeaderVisualisationInput = {
  color?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<ChallengeConditionFontVisualisationInput>;
  transparent?: InputMaybe<Scalars['Float']>;
};

export type ChallengeConditionLeaderboardItemVisualisation = {
  __typename?: 'ChallengeConditionLeaderboardItemVisualisation';
  color?: Maybe<Scalars['String']>;
  font?: Maybe<ChallengeConditionFontVisualisation>;
  top?: Maybe<ChallengeConditionLeaderboardTopItemVisualisation>;
  transparent?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  unitType?: Maybe<Scalars['String']>;
};

export type ChallengeConditionLeaderboardItemVisualisationInput = {
  color?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<ChallengeConditionFontVisualisationInput>;
  top?: InputMaybe<ChallengeConditionLeaderboardTopItemVisualisationInput>;
  transparent?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionLeaderboardTopItemVisualisation = {
  __typename?: 'ChallengeConditionLeaderboardTopItemVisualisation';
  color?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type ChallengeConditionLeaderboardTopItemVisualisationInput = {
  color?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
};

export type ChallengeConditionLeaderboardVisualisation = ChallengeConditionVisualisation & {
  __typename?: 'ChallengeConditionLeaderboardVisualisation';
  availableUnitTypeRankings?: Maybe<Array<Scalars['String']>>;
  background?: Maybe<ChallengeConditionBackgroundVisualisation>;
  columns?: Maybe<Array<Maybe<ChallengeConditionLeaderboardColumnVisualisation>>>;
  conditionId?: Maybe<Scalars['String']>;
  header?: Maybe<ChallengeConditionLeaderboardHeaderVisualisation>;
  item?: Maybe<ChallengeConditionLeaderboardItemVisualisation>;
  margin?: Maybe<ChallengeConditionMarginVisualisation>;
  medalImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  minWidth?: Maybe<Scalars['String']>;
  numberOfItems?: Maybe<Scalars['Int']>;
};

export type ChallengeConditionLeaderboardVisualisationInput = {
  availableUnitTypeRankings?: InputMaybe<Array<Scalars['String']>>;
  background?: InputMaybe<ChallengeConditionBackgroundVisualisationInput>;
  columns?: InputMaybe<Array<InputMaybe<ChallengeConditionLeaderboardColumnVisualisationInput>>>;
  conditionId?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<ChallengeConditionLeaderboardHeaderVisualisationInput>;
  item?: InputMaybe<ChallengeConditionLeaderboardItemVisualisationInput>;
  margin?: InputMaybe<ChallengeConditionMarginVisualisationInput>;
  medalImages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minWidth?: InputMaybe<Scalars['String']>;
  numberOfItems?: InputMaybe<Scalars['Int']>;
};

export type ChallengeConditionMarginVisualisation = {
  __typename?: 'ChallengeConditionMarginVisualisation';
  bottom?: Maybe<Scalars['String']>;
  left?: Maybe<Scalars['String']>;
  right?: Maybe<Scalars['String']>;
  top?: Maybe<Scalars['String']>;
};

export type ChallengeConditionMarginVisualisationInput = {
  bottom?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Scalars['String']>;
  right?: InputMaybe<Scalars['String']>;
  top?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionRepeat = {
  __typename?: 'ChallengeConditionRepeat';
  enabled?: Maybe<Scalars['Boolean']>;
  sequential?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Int']>;
};

export type ChallengeConditionRepeatInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  sequential?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type ChallengeConditionTimelineBannerCounterVisualisation = {
  __typename?: 'ChallengeConditionTimelineBannerCounterVisualisation';
  activityTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  font?: Maybe<ChallengeConditionFontVisualisation>;
  image?: Maybe<Scalars['String']>;
  unitType?: Maybe<Scalars['String']>;
};

export type ChallengeConditionTimelineBannerCounterVisualisationInput = {
  activityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  font?: InputMaybe<ChallengeConditionFontVisualisationInput>;
  image?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionTimelineBannerGoalVisualisation = {
  __typename?: 'ChallengeConditionTimelineBannerGoalVisualisation';
  currentValue?: Maybe<Scalars['Boolean']>;
  endValue?: Maybe<Scalars['Boolean']>;
  font?: Maybe<ChallengeConditionFontVisualisation>;
  image?: Maybe<Scalars['String']>;
};

export type ChallengeConditionTimelineBannerGoalVisualisationInput = {
  currentValue?: InputMaybe<Scalars['Boolean']>;
  endValue?: InputMaybe<Scalars['Boolean']>;
  font?: InputMaybe<ChallengeConditionFontVisualisationInput>;
  image?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionTimelineBannerRepeaterVisualisation = {
  __typename?: 'ChallengeConditionTimelineBannerRepeaterVisualisation';
  currentFont?: Maybe<ChallengeConditionFontVisualisation>;
  image?: Maybe<Scalars['String']>;
  repeat?: Maybe<Scalars['Int']>;
  totalFont?: Maybe<ChallengeConditionFontVisualisation>;
};

export type ChallengeConditionTimelineBannerRepeaterVisualisationInput = {
  currentFont?: InputMaybe<ChallengeConditionFontVisualisationInput>;
  image?: InputMaybe<Scalars['String']>;
  repeat?: InputMaybe<Scalars['Int']>;
  totalFont?: InputMaybe<ChallengeConditionFontVisualisationInput>;
};

export type ChallengeConditionTimelineBannerVisualisation = {
  __typename?: 'ChallengeConditionTimelineBannerVisualisation';
  backgroundColor?: Maybe<Scalars['String']>;
  counters?: Maybe<Array<Maybe<ChallengeConditionTimelineBannerCounterVisualisation>>>;
  goal?: Maybe<ChallengeConditionTimelineBannerGoalVisualisation>;
  image?: Maybe<Scalars['String']>;
  repeater?: Maybe<ChallengeConditionTimelineBannerRepeaterVisualisation>;
};

export type ChallengeConditionTimelineBannerVisualisationInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  counters?: InputMaybe<Array<InputMaybe<ChallengeConditionTimelineBannerCounterVisualisationInput>>>;
  goal?: InputMaybe<ChallengeConditionTimelineBannerGoalVisualisationInput>;
  image?: InputMaybe<Scalars['String']>;
  repeater?: InputMaybe<ChallengeConditionTimelineBannerRepeaterVisualisationInput>;
};

export type ChallengeConditionTimelineFlagVisualisation = {
  __typename?: 'ChallengeConditionTimelineFlagVisualisation';
  font?: Maybe<ChallengeConditionFontVisualisation>;
  image?: Maybe<Scalars['String']>;
};

export type ChallengeConditionTimelineFlagVisualisationInput = {
  font?: InputMaybe<ChallengeConditionFontVisualisationInput>;
  image?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionTimelineVisualisation = ChallengeConditionVisualisation & {
  __typename?: 'ChallengeConditionTimelineVisualisation';
  backgroundImage?: Maybe<Scalars['String']>;
  banner?: Maybe<ChallengeConditionTimelineBannerVisualisation>;
  conditionId?: Maybe<Scalars['String']>;
  flag?: Maybe<ChallengeConditionTimelineFlagVisualisation>;
  foregroundImage?: Maybe<Scalars['String']>;
  splitterImage?: Maybe<Scalars['String']>;
  successImage?: Maybe<Scalars['String']>;
};

export type ChallengeConditionTimelineVisualisationInput = {
  backgroundImage?: InputMaybe<Scalars['String']>;
  banner?: InputMaybe<ChallengeConditionTimelineBannerVisualisationInput>;
  conditionId?: InputMaybe<Scalars['String']>;
  flag?: InputMaybe<ChallengeConditionTimelineFlagVisualisationInput>;
  foregroundImage?: InputMaybe<Scalars['String']>;
  splitterImage?: InputMaybe<Scalars['String']>;
  successImage?: InputMaybe<Scalars['String']>;
};

export type ChallengeConditionTimespan = {
  __typename?: 'ChallengeConditionTimespan';
  enabled?: Maybe<Scalars['Boolean']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type ChallengeConditionTimespanInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  unit?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type ChallengeConditionVisualisation = {
  conditionId?: Maybe<Scalars['String']>;
};

export type ChallengeDuration = {
  __typename?: 'ChallengeDuration';
  end?: Maybe<Scalars['Float']>;
  start?: Maybe<Scalars['Float']>;
};

export type ChallengeDurationInput = {
  end?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
};

export type ChallengeEndless = {
  __typename?: 'ChallengeEndless';
  activityTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  enabled?: Maybe<Scalars['Boolean']>;
  rankingAlgorithm?: Maybe<Scalars['String']>;
  unitType?: Maybe<Scalars['String']>;
};

export type ChallengeEndlessInput = {
  activityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  rankingAlgorithm?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Scalars['String']>;
};

export type ChallengeFilter = {
  activity?: InputMaybe<Scalars['String']>;
  enabledLocales?: InputMaybe<Array<Scalars['String']>>;
  endsAfter?: InputMaybe<Scalars['Float']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textSearch?: InputMaybe<Scalars['String']>;
  textSearchLocale?: InputMaybe<Scalars['String']>;
};

export type ChallengeFormCondition = ChallengeCondition & {
  __typename?: 'ChallengeFormCondition';
  credits?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['Float']>;
  formTemplate?: Maybe<FormTemplate>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Float']>;
  title?: Maybe<Array<TextByLanguage>>;
  type?: Maybe<Scalars['String']>;
};

export type ChallengeFormConditionInput = {
  credits?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Float']>;
  formTemplate?: InputMaybe<FormTemplateInput>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Array<TextByLanguageInput>>;
  type?: InputMaybe<Scalars['String']>;
};

export type ChallengeGallery = Gallery & {
  __typename?: 'ChallengeGallery';
  challenge?: Maybe<Challenge>;
  commentCount: Scalars['Int'];
  comments: Array<GalleryComment>;
  createdOn?: Maybe<Scalars['Float']>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  expiresOn?: Maybe<Scalars['Float']>;
  featured?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  images: Array<GalleryImage>;
  isDraft?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  likes: Array<GalleryLike>;
  preview?: Maybe<Array<Maybe<TextByLanguage>>>;
  publishOn?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags: Array<GalleryTag>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['String']>;
};


export type ChallengeGalleryImagesArgs = {
  filter?: InputMaybe<GalleryImageFilter>;
};

export type ChallengeGridVisualisationInput = {
  clickable?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Array<InputMaybe<ChallengeConditionGridVisualisationInput>>>;
  dataType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type ChallengeInfoblockVisualisationInput = {
  conditions?: InputMaybe<Array<InputMaybe<ChallengeConditionInfoblockVisualisationInput>>>;
  dataType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type ChallengeLeaderboardVisualisationInput = {
  clickable?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Array<InputMaybe<ChallengeConditionLeaderboardVisualisationInput>>>;
  dataType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type ChallengeLike = Like & {
  __typename?: 'ChallengeLike';
  challenge?: Maybe<Challenge>;
  id: Scalars['String'];
  likedOn: Scalars['Float'];
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type ChallengeMilestone = {
  __typename?: 'ChallengeMilestone';
  conditionId?: Maybe<Scalars['String']>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  email?: Maybe<ChallengeMilestoneEmail>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  notificationsEnabled?: Maybe<Scalars['Boolean']>;
  percentage?: Maybe<Scalars['Float']>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type ChallengeMilestoneEmail = {
  __typename?: 'ChallengeMilestoneEmail';
  body?: Maybe<Array<Maybe<TextByLanguage>>>;
  subject?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type ChallengeMilestoneEmailInput = {
  body?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  subject?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type ChallengeMilestoneInput = {
  conditionId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  email?: InputMaybe<ChallengeMilestoneEmailInput>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  notificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  percentage?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type ChallengeParticipant = {
  __typename?: 'ChallengeParticipant';
  banned?: Maybe<Scalars['Boolean']>;
  challenge: Challenge;
  createdOn?: Maybe<Scalars['Float']>;
  creditRewardClaimed?: Maybe<Scalars['Boolean']>;
  formConditionData?: Maybe<Array<Maybe<ChallengeParticipantFormConditionData>>>;
  id: Scalars['String'];
  progress?: Maybe<Scalars['Float']>;
  progressPerCondition?: Maybe<Array<ChallengeParticipantProgressPerCondition>>;
  ranking?: Maybe<Scalars['Int']>;
  rankingInTeam?: Maybe<Scalars['Int']>;
  rankingPerCondition?: Maybe<Array<ChallengeParticipantRankingPerCondition>>;
  status?: Maybe<Scalars['String']>;
  team?: Maybe<ChallengeTeam>;
  tieBreakerAnswers?: Maybe<ChallengeParticipantTieBreakerAnswers>;
  user: User;
  userId: Scalars['String'];
};


export type ChallengeParticipantFormConditionDataArgs = {
  filter?: InputMaybe<ChallengeParticipantFormConditionForChallengeParticipantDataFilter>;
};

export type ChallengeParticipantFilter = {
  challengeIds?: InputMaybe<Array<Scalars['String']>>;
  teamIds?: InputMaybe<Array<Scalars['String']>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ChallengeParticipantFormConditionData = {
  __typename?: 'ChallengeParticipantFormConditionData';
  challengeId: Scalars['String'];
  conditionId: Scalars['String'];
  createdOn?: Maybe<Scalars['Float']>;
  data?: Maybe<Scalars['JSON']>;
  projectId: Scalars['String'];
  teamId: Scalars['String'];
  userId: Scalars['String'];
};

export type ChallengeParticipantFormConditionDataFilter = {
  ids?: InputMaybe<Array<InputMaybe<ChallengeParticipantFormConditionDataId>>>;
};

export type ChallengeParticipantFormConditionDataId = {
  challengeId?: InputMaybe<Scalars['String']>;
  conditionId?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ChallengeParticipantFormConditionForChallengeParticipantDataFilter = {
  conditionId: Scalars['String'];
};

export type ChallengeParticipantProgressPerCondition = {
  __typename?: 'ChallengeParticipantProgressPerCondition';
  condition: ChallengeCondition;
  progress: Scalars['Int'];
};

export type ChallengeParticipantRankingPerCondition = {
  __typename?: 'ChallengeParticipantRankingPerCondition';
  condition: ChallengeCondition;
  ranking: Scalars['Int'];
};

export type ChallengeParticipantTieBreakerAnswers = {
  __typename?: 'ChallengeParticipantTieBreakerAnswers';
  answer1: Scalars['String'];
  answer2: Scalars['String'];
};

export type ChallengePayment = {
  __typename?: 'ChallengePayment';
  action?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  freeCredits?: Maybe<Scalars['Int']>;
  overwriteDefinitions?: Maybe<Array<Maybe<ChallengePaymentOverwriteDefinition>>>;
  payAmount?: Maybe<Scalars['Float']>;
};

export type ChallengePaymentInput = {
  action?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  freeCredits?: InputMaybe<Scalars['Int']>;
  overwriteDefinitions?: InputMaybe<Array<InputMaybe<ChallengePaymentOverwriteDefinitionInput>>>;
  payAmount?: InputMaybe<Scalars['Float']>;
};

export type ChallengePaymentOverwriteDefinition = {
  __typename?: 'ChallengePaymentOverwriteDefinition';
  action?: Maybe<Scalars['String']>;
  freeCredits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  payAmount?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChallengePaymentOverwriteDefinitionInput = {
  action?: InputMaybe<Scalars['String']>;
  freeCredits?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  payAmount?: InputMaybe<Scalars['Float']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ChallengePrize = {
  __typename?: 'ChallengePrize';
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type ChallengePrizeInput = {
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type ChallengeProfileFields = {
  __typename?: 'ChallengeProfileFields';
  label?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type ChallengeProfileFieldsInput = {
  label?: InputMaybe<Scalars['String']>;
  list?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  required?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type ChallengeRegistration = {
  __typename?: 'ChallengeRegistration';
  enableMaxParticipants?: Maybe<Scalars['Boolean']>;
  enableUltimateTime?: Maybe<Scalars['Boolean']>;
  maxParticipants?: Maybe<Scalars['Int']>;
  participateOnStart?: Maybe<Scalars['Boolean']>;
  ultimateTime?: Maybe<Scalars['Float']>;
};

export type ChallengeRegistrationInput = {
  enableMaxParticipants?: InputMaybe<Scalars['Boolean']>;
  enableUltimateTime?: InputMaybe<Scalars['Boolean']>;
  maxParticipants?: InputMaybe<Scalars['Int']>;
  participateOnStart?: InputMaybe<Scalars['Boolean']>;
  ultimateTime?: InputMaybe<Scalars['Float']>;
};

export type ChallengeRewards = {
  __typename?: 'ChallengeRewards';
  credits?: Maybe<Scalars['Float']>;
  prizes?: Maybe<Array<Maybe<ChallengePrize>>>;
};

export type ChallengeRewardsInput = {
  credits?: InputMaybe<Scalars['Float']>;
  prizes?: InputMaybe<Array<InputMaybe<ChallengePrizeInput>>>;
};

export type ChallengeTag = {
  __typename?: 'ChallengeTag';
  color: Scalars['String'];
  description: Array<TextByLanguage>;
  id: Scalars['String'];
  image: Scalars['String'];
  title: Array<TextByLanguage>;
};

export type ChallengeTeam = {
  __typename?: 'ChallengeTeam';
  captainUser?: Maybe<User>;
  captainUserId?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  description?: Maybe<Array<TextByLanguage>>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  memberCount?: Maybe<Scalars['Int']>;
  memberIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  members?: Maybe<Array<Maybe<User>>>;
  profileValue?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type ChallengeTeamConfig = {
  __typename?: 'ChallengeTeamConfig';
  detailViewTypes?: Maybe<Array<Scalars['String']>>;
  enabled?: Maybe<Scalars['Boolean']>;
  everyone?: Maybe<Scalars['Boolean']>;
  fixedTeams?: Maybe<Scalars['Boolean']>;
  hideInOverview?: Maybe<Scalars['Boolean']>;
  inviteCodeEnabled?: Maybe<Scalars['Boolean']>;
  maxMembers?: Maybe<Scalars['Int']>;
  profileProperty?: Maybe<Scalars['String']>;
};

export type ChallengeTeamConfigInput = {
  detailViewTypes?: InputMaybe<Array<Scalars['String']>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  fixedTeams?: InputMaybe<Scalars['Boolean']>;
  hideInOverview?: InputMaybe<Scalars['Boolean']>;
  inviteCodeEnabled?: InputMaybe<Scalars['Boolean']>;
  maxMembers?: InputMaybe<Scalars['Int']>;
  profileProperty?: InputMaybe<Scalars['String']>;
};

export type ChallengeTeamFilter = {
  challengeId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type ChallengeTieBreaker = {
  __typename?: 'ChallengeTieBreaker';
  active?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  forAllTeamMembers?: Maybe<Scalars['Boolean']>;
  question1?: Maybe<Array<Maybe<TextByLanguage>>>;
  question2?: Maybe<Array<Maybe<TextByLanguage>>>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type ChallengeTieBreakerInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  forAllTeamMembers?: InputMaybe<Scalars['Boolean']>;
  question1?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  question2?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type ChallengeTimelineVisualisationInput = {
  clickable?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Array<InputMaybe<ChallengeConditionTimelineVisualisationInput>>>;
  dataType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type ChallengeTotals = {
  __typename?: 'ChallengeTotals';
  caloriesUnit?: Maybe<Scalars['String']>;
  caloriesVisible?: Maybe<Scalars['Boolean']>;
  creditsEarnedVisible?: Maybe<Scalars['Boolean']>;
  distanceUnit?: Maybe<Scalars['String']>;
  distanceVisible?: Maybe<Scalars['Boolean']>;
  durationUnit?: Maybe<Scalars['String']>;
  durationVisible?: Maybe<Scalars['Boolean']>;
  elevationUnit?: Maybe<Scalars['String']>;
  elevationVisible?: Maybe<Scalars['Boolean']>;
  stepsVisible?: Maybe<Scalars['Boolean']>;
  workoutsVisible?: Maybe<Scalars['Boolean']>;
};

export type ChallengeTotalsInput = {
  caloriesUnit?: InputMaybe<Scalars['String']>;
  caloriesVisible?: InputMaybe<Scalars['Boolean']>;
  creditsEarnedVisible?: InputMaybe<Scalars['Boolean']>;
  distanceUnit?: InputMaybe<Scalars['String']>;
  distanceVisible?: InputMaybe<Scalars['Boolean']>;
  durationUnit?: InputMaybe<Scalars['String']>;
  durationVisible?: InputMaybe<Scalars['Boolean']>;
  elevationUnit?: InputMaybe<Scalars['String']>;
  elevationVisible?: InputMaybe<Scalars['Boolean']>;
  stepsVisible?: InputMaybe<Scalars['Boolean']>;
  workoutsVisible?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeVisualisation = {
  __typename?: 'ChallengeVisualisation';
  clickable?: Maybe<Scalars['Boolean']>;
  conditions?: Maybe<Array<Maybe<ChallengeConditionVisualisation>>>;
  dataType?: Maybe<Scalars['String']>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  id?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type?: Maybe<Scalars['String']>;
};

export type ChallengeVoucherConfiguration = {
  __typename?: 'ChallengeVoucherConfiguration';
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  required: Scalars['Boolean'];
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  url?: Maybe<Scalars['String']>;
};

export type ChallengeVoucherConfigurationInput = {
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  required: Scalars['Boolean'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  url?: InputMaybe<Scalars['String']>;
};

export type CheckupLocation = {
  __typename?: 'CheckupLocation';
  cost: CheckupLocationCost;
  id: Scalars['String'];
  location: Scalars['String'];
  position: CheckupLocationPosition;
  title: Array<TextByLanguage>;
};

export type CheckupLocationAvailability = {
  __typename?: 'CheckupLocationAvailability';
  checkupLocation: CheckupLocation;
  checkupLocationId: Scalars['String'];
  coach: User;
  coachId: Scalars['String'];
  coachType: Scalars['String'];
  cost?: Maybe<CheckupLocationAvailabilityCost>;
  free: Scalars['Boolean'];
  from: Scalars['Float'];
  id: Scalars['String'];
  to: Scalars['Float'];
};

export type CheckupLocationAvailabilityCost = {
  __typename?: 'CheckupLocationAvailabilityCost';
  amount?: Maybe<Scalars['Float']>;
  description: Array<TextByLanguage>;
};

export type CheckupLocationAvailabilityCostInput = {
  amount?: InputMaybe<Scalars['Float']>;
  description: Array<TextByLanguageInput>;
};

export type CheckupLocationAvailabilityFilter = {
  checkupLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  coachTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  from?: InputMaybe<Scalars['Float']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  to?: InputMaybe<Scalars['Float']>;
};

export type CheckupLocationCost = {
  __typename?: 'CheckupLocationCost';
  amount?: Maybe<Scalars['Float']>;
  description: Array<TextByLanguage>;
};

export type CheckupLocationCostInput = {
  amount?: InputMaybe<Scalars['Float']>;
  description: Array<TextByLanguageInput>;
};

export type CheckupLocationFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
};

export type CheckupLocationPosition = {
  __typename?: 'CheckupLocationPosition';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CheckupLocationPositionInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CheckupParticipation = {
  __typename?: 'CheckupParticipation';
  bookedOn: Scalars['Float'];
  checkupEnd: Scalars['Float'];
  checkupLocation: CheckupLocation;
  checkupLocationId: Scalars['String'];
  checkupResultPdf?: Maybe<Scalars['String']>;
  checkupStart: Scalars['Float'];
  id: Scalars['String'];
  isPaid: Scalars['Boolean'];
  journey?: Maybe<Journey>;
  journeyId?: Maybe<Scalars['String']>;
  journeyParticipation?: Maybe<JourneyParticipation>;
  paidOn?: Maybe<Scalars['Float']>;
  payments: Array<Payment>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type CheckupParticipationFilter = {
  from?: InputMaybe<Scalars['Float']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  journeyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  to?: InputMaybe<Scalars['Float']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userSearch?: InputMaybe<Scalars['String']>;
};

export type ChildJourneySubFilter = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type ChronoRaceEvent = {
  __typename?: 'ChronoRaceEvent';
  country?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['Float']>;
  eventCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['String']>;
  registrationAllowed?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['Float']>;
  subEvents?: Maybe<Array<Maybe<ChronoRaceSubEvent>>>;
  title?: Maybe<Scalars['String']>;
};

export type ChronoRaceEventFilter = {
  eventId?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['Float']>;
};

export type ChronoRaceSubEvent = {
  __typename?: 'ChronoRaceSubEvent';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type Comment = {
  comment: Scalars['String'];
  createdAt: Scalars['Float'];
  deleted: Scalars['Boolean'];
  id: Scalars['String'];
  moderated: Scalars['Boolean'];
  parentId?: Maybe<Scalars['String']>;
  reported: Scalars['Boolean'];
  subComments: Array<SubComment>;
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type CommentFilter = {
  type?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['String']>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Company = {
  __typename?: 'Company';
  avatar?: Maybe<Scalars['String']>;
  brandColor?: Maybe<Scalars['String']>;
  coach?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  connect?: Maybe<CompanyConnect>;
  hasSupport?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  introMessage?: Maybe<Array<TextByLanguage>>;
  introTitle?: Maybe<Array<TextByLanguage>>;
  languages?: Maybe<Array<Scalars['String']>>;
  limitRegistrations: Scalars['Boolean'];
  logo?: Maybe<Scalars['String']>;
  maxRegistrations: Scalars['Int'];
  name: Scalars['String'];
  profileRequirements?: Maybe<Array<ProfileFields>>;
  project: Project;
  role: Scalars['String'];
  team?: Maybe<CompanyTeam>;
};

export type CompanyConnect = {
  __typename?: 'CompanyConnect';
  picture?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Array<TextByLanguage>>;
  title?: Maybe<Array<TextByLanguage>>;
};

export type CompanyConnectInput = {
  picture?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Array<TextByLanguageInput>>;
  title?: InputMaybe<Array<TextByLanguageInput>>;
};

export type CompanyFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CompanyTeam = {
  __typename?: 'CompanyTeam';
  picture?: Maybe<Scalars['String']>;
  selectPicture?: Maybe<Scalars['String']>;
  selectSubtitle?: Maybe<Array<TextByLanguage>>;
  selectTitle?: Maybe<Array<TextByLanguage>>;
  subtitle?: Maybe<Array<TextByLanguage>>;
  title?: Maybe<Array<TextByLanguage>>;
};

export type CompanyTeamInput = {
  picture?: InputMaybe<Scalars['String']>;
  selectPicture?: InputMaybe<Scalars['String']>;
  selectSubtitle?: InputMaybe<Array<TextByLanguageInput>>;
  selectTitle?: InputMaybe<Array<TextByLanguageInput>>;
  subtitle?: InputMaybe<Array<TextByLanguageInput>>;
  title?: InputMaybe<Array<TextByLanguageInput>>;
};

export type ConfirmCodeChallenge = {
  __typename?: 'ConfirmCodeChallenge';
  confirmCodeChallengeId?: Maybe<Scalars['String']>;
};

export type Content = {
  __typename?: 'Content';
  attachments: Array<ContentAttachment>;
  commentCount: Scalars['Int'];
  comments: Array<ContentComment>;
  content?: Maybe<Array<Maybe<TextByLanguage>>>;
  disableComments?: Maybe<Scalars['Boolean']>;
  enabledLocales: Array<Scalars['String']>;
  expiresOn?: Maybe<Scalars['Float']>;
  featured?: Maybe<Scalars['Boolean']>;
  galleries: Array<ContentGallery>;
  galleryCount: Scalars['Int'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  isAdvancedMode?: Maybe<Scalars['Boolean']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  likes: Array<ContentLike>;
  preview?: Maybe<Array<Maybe<TextByLanguage>>>;
  publishOn?: Maybe<Scalars['Float']>;
  relatedWith?: Maybe<Array<ContentRelatedObject>>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags: Array<ContentTag>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type ContentAttachment = {
  type: Scalars['String'];
};

export type ContentComment = Comment & {
  __typename?: 'ContentComment';
  comment: Scalars['String'];
  content: Content;
  createdAt: Scalars['Float'];
  deleted: Scalars['Boolean'];
  id: Scalars['String'];
  moderated: Scalars['Boolean'];
  parentId?: Maybe<Scalars['String']>;
  reported: Scalars['Boolean'];
  subComments: Array<SubComment>;
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type ContentFilter = {
  enabledLocales?: InputMaybe<Array<Scalars['String']>>;
  expireAfter?: InputMaybe<Scalars['Float']>;
  expireBefore?: InputMaybe<Scalars['Float']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAfter?: InputMaybe<Scalars['Float']>;
  publishedBefore?: InputMaybe<Scalars['Float']>;
  relatedWith?: InputMaybe<Array<ContentRelatedObjectInput>>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  textSearch?: InputMaybe<Scalars['String']>;
  textSearchLocale?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ContentGallery = Gallery & {
  __typename?: 'ContentGallery';
  commentCount: Scalars['Int'];
  comments: Array<GalleryComment>;
  content?: Maybe<Content>;
  createdOn?: Maybe<Scalars['Float']>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  expiresOn?: Maybe<Scalars['Float']>;
  featured?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  images: Array<GalleryImage>;
  isDraft?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  likes: Array<GalleryLike>;
  preview?: Maybe<Array<Maybe<TextByLanguage>>>;
  publishOn?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags: Array<GalleryTag>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['String']>;
};


export type ContentGalleryImagesArgs = {
  filter?: InputMaybe<GalleryImageFilter>;
};

export type ContentImageAttachment = ContentAttachment & {
  __typename?: 'ContentImageAttachment';
  type: Scalars['String'];
  url: Scalars['String'];
};

export type ContentImageAttachmentInput = {
  type: Scalars['String'];
  url: Scalars['String'];
};

export type ContentLike = Like & {
  __typename?: 'ContentLike';
  content?: Maybe<Content>;
  id: Scalars['String'];
  likedOn: Scalars['Float'];
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type ContentRelatedObject = {
  __typename?: 'ContentRelatedObject';
  type?: Maybe<Scalars['String']>;
  typeIds?: Maybe<Array<Scalars['String']>>;
};

export type ContentRelatedObjectInput = {
  type?: InputMaybe<Scalars['String']>;
  typeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ContentTag = {
  __typename?: 'ContentTag';
  color: Scalars['String'];
  description: Array<TextByLanguage>;
  id: Scalars['String'];
  image: Scalars['String'];
  title: Array<TextByLanguage>;
};

export type CreditConfig = {
  __typename?: 'CreditConfig';
  capping?: Maybe<Array<CreditConfigCapping>>;
  collectionPeriod?: Maybe<CreditConfigCollectionPeriod>;
  spentCreditsLimit?: Maybe<CreditConfigSpentCreditsLimit>;
  types?: Maybe<Array<CreditConfigType>>;
};

export type CreditConfigCapping = {
  __typename?: 'CreditConfigCapping';
  capping?: Maybe<Scalars['Int']>;
  types?: Maybe<Array<Scalars['String']>>;
};

export type CreditConfigCappingInput = {
  capping?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<Scalars['String']>>;
};

export type CreditConfigCollectionPeriod = {
  __typename?: 'CreditConfigCollectionPeriod';
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type CreditConfigCollectionPeriodInput = {
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type CreditConfigInput = {
  capping?: InputMaybe<Array<CreditConfigCappingInput>>;
  collectionPeriod?: InputMaybe<CreditConfigCollectionPeriodInput>;
  spentCreditsLimit?: InputMaybe<CreditConfigSpentCreditsLimitInput>;
  types?: InputMaybe<Array<Scalars['CreditConfigTypeInput']>>;
};

export type CreditConfigSpentCreditsLimit = {
  __typename?: 'CreditConfigSpentCreditsLimit';
  countForLastXDays?: Maybe<Scalars['Int']>;
  countInCollectionPeriod?: Maybe<Scalars['Boolean']>;
  value: Scalars['Int'];
};

export type CreditConfigSpentCreditsLimitInput = {
  countForLastXDays?: InputMaybe<Scalars['Int']>;
  countInCollectionPeriod?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Int'];
};

export type CreditConfigType = {
  enabled?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  version: Scalars['String'];
};

export type CreditConfigTypeActivityV1 = CreditConfigType & {
  __typename?: 'CreditConfigTypeActivityV1';
  activityConversions?: Maybe<Array<ActivityConversion>>;
  clientFactor: Scalars['Float'];
  creditsDecimals: Scalars['Float'];
  creditsPerStep: Scalars['Float'];
  enabled?: Maybe<Scalars['Boolean']>;
  roundCredits: Scalars['Boolean'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type CreditConfigTypeActivityV1Input = {
  activityConversions?: InputMaybe<Array<ActivityConversionInput>>;
  clientFactor: Scalars['Float'];
  creditsDecimals: Scalars['Float'];
  creditsPerStep: Scalars['Float'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  roundCredits: Scalars['Boolean'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type CreditConfigTypeActivityV2 = CreditConfigType & {
  __typename?: 'CreditConfigTypeActivityV2';
  creditsDecimals: Scalars['Float'];
  creditsPerKcal: Scalars['Float'];
  creditsPerStep: Scalars['Float'];
  enabled?: Maybe<Scalars['Boolean']>;
  manualCreditsPerKcal: Scalars['Float'];
  manualCreditsPerStep: Scalars['Float'];
  roundCredits: Scalars['Boolean'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type CreditConfigTypeActivityV2Input = {
  creditsDecimals: Scalars['Float'];
  creditsPerKcal: Scalars['Float'];
  creditsPerStep: Scalars['Float'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  manualCreditsPerKcal: Scalars['Float'];
  manualCreditsPerStep: Scalars['Float'];
  roundCredits: Scalars['Boolean'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type CreditConfigTypeActivityV3 = CreditConfigType & {
  __typename?: 'CreditConfigTypeActivityV3';
  creditsPerKcal: Scalars['Float'];
  enabled?: Maybe<Scalars['Boolean']>;
  hoursPerStep: Scalars['Float'];
  kcalPerHour?: Maybe<Array<KcalPerHour>>;
  kcalPerHourForSteps: Scalars['Float'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type CreditConfigTypeActivityV3Input = {
  creditsPerKcal: Scalars['Float'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  hoursPerStep: Scalars['Float'];
  kcalPerHour?: InputMaybe<Array<KcalPerHourInput>>;
  kcalPerHourForSteps: Scalars['Float'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type CreditConfigTypeGeneric = CreditConfigType & {
  __typename?: 'CreditConfigTypeGeneric';
  credits: Scalars['Int'];
  enabled?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  version: Scalars['String'];
};

export type CreditConfigTypeGenericInput = {
  credits: Scalars['Int'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
  version: Scalars['String'];
};

export type DashboardConfig = {
  __typename?: 'DashboardConfig';
  background?: Maybe<DashboardConfigWidgetBackground>;
  desktopWidths?: Maybe<Array<Maybe<Scalars['Int']>>>;
  expiresOn?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  mobileWidths?: Maybe<Array<Maybe<Scalars['Int']>>>;
  place: Scalars['String'];
  publishOn?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Int']>;
  tabletWidths?: Maybe<Array<Maybe<Scalars['Int']>>>;
  widgets?: Maybe<Array<DashboardConfigWidget>>;
};

export type DashboardConfigCarousselWidgetItemCallToAction = {
  __typename?: 'DashboardConfigCarousselWidgetItemCallToAction';
  text?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type DashboardConfigCarousselWidgetItemCallToActionInput = {
  text?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type DashboardConfigCarousselWidgetItemCaption = {
  __typename?: 'DashboardConfigCarousselWidgetItemCaption';
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  subtitle?: Maybe<Array<Maybe<TextByLanguage>>>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type DashboardConfigCarousselWidgetItemCaptionInput = {
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  subtitle?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type DashboardConfigFilter = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  places?: InputMaybe<Array<Scalars['String']>>;
  widgetIds?: InputMaybe<Array<Scalars['String']>>;
  widgetTypes?: InputMaybe<Array<Scalars['String']>>;
};

export type DashboardConfigSocialFeed = InstagramFeed | TwitterFeed;

export type DashboardConfigWidget = {
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  roles?: Maybe<Array<Scalars['String']>>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetActivity = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetActivity';
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  goal?: Maybe<DashboardConfigWidgetActivityGoal>;
  history?: Maybe<DashboardConfigWidgetActivityHistory>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  roles?: Maybe<Array<Scalars['String']>>;
  summary?: Maybe<DashboardConfigWidgetActivitySummary>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetActivityGoal = {
  __typename?: 'DashboardConfigWidgetActivityGoal';
  unit?: Maybe<Scalars['String']>;
  unitType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type DashboardConfigWidgetActivityGoalInput = {
  unit?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type DashboardConfigWidgetActivityHistory = {
  __typename?: 'DashboardConfigWidgetActivityHistory';
  aggregation?: Maybe<Scalars['String']>;
  chartType?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};

export type DashboardConfigWidgetActivityHistoryInput = {
  aggregation?: InputMaybe<Scalars['String']>;
  chartType?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
};

export type DashboardConfigWidgetActivityInput = {
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  goal?: InputMaybe<DashboardConfigWidgetActivityGoalInput>;
  history?: InputMaybe<DashboardConfigWidgetActivityHistoryInput>;
  id: Scalars['String'];
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  summary?: InputMaybe<DashboardConfigWidgetActivitySummaryInput>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetActivitySummary = {
  __typename?: 'DashboardConfigWidgetActivitySummary';
  algorithm?: Maybe<Scalars['String']>;
  algorithmDisplayType?: Maybe<Scalars['String']>;
};

export type DashboardConfigWidgetActivitySummaryInput = {
  algorithm?: InputMaybe<Scalars['String']>;
  algorithmDisplayType?: InputMaybe<Scalars['String']>;
};

export type DashboardConfigWidgetBackground = {
  __typename?: 'DashboardConfigWidgetBackground';
  alt?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type DashboardConfigWidgetBackgroundInput = {
  alt?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type DashboardConfigWidgetCaroussel = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetCaroussel';
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  interval?: Maybe<Scalars['String']>;
  items?: Maybe<Array<DashboardConfigWidgetCarousselItem>>;
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  roles?: Maybe<Array<Scalars['String']>>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetCarousselInput = {
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  interval?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<DashboardConfigWidgetCarousselItemInput>>;
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetCarousselItem = {
  __typename?: 'DashboardConfigWidgetCarousselItem';
  background?: Maybe<DashboardConfigWidgetBackground>;
  callToAction?: Maybe<DashboardConfigCarousselWidgetItemCallToAction>;
  caption?: Maybe<DashboardConfigCarousselWidgetItemCaption>;
  interval?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  typeId?: Maybe<Scalars['String']>;
  url?: Maybe<DashboardConfigWidgetUrl>;
};

export type DashboardConfigWidgetCarousselItemInput = {
  background?: InputMaybe<DashboardConfigWidgetBackgroundInput>;
  callToAction?: InputMaybe<DashboardConfigCarousselWidgetItemCallToActionInput>;
  caption?: InputMaybe<DashboardConfigCarousselWidgetItemCaptionInput>;
  interval?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  typeId?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<DashboardConfigWidgetUrlInput>;
};

export type DashboardConfigWidgetChallenge = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetChallenge';
  challengeIds?: Maybe<Array<Scalars['String']>>;
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  displayType?: Maybe<Scalars['String']>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  paging?: Maybe<DashboardConfigWidgetPaging>;
  roles?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<DashboardConfigWidgetSort>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetChallengeInput = {
  challengeIds?: InputMaybe<Array<Scalars['String']>>;
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  displayType?: InputMaybe<Scalars['String']>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  paging?: InputMaybe<DashboardConfigWidgetPagingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  sort?: InputMaybe<DashboardConfigWidgetSortInput>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetChallengeProgress = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetChallengeProgress';
  challengeId: Scalars['String'];
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  displayType?: Maybe<Scalars['String']>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  roles?: Maybe<Array<Scalars['String']>>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetChallengeProgressInput = {
  challengeId?: InputMaybe<Scalars['String']>;
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  displayType?: InputMaybe<Scalars['String']>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetChallengeVisualisation = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetChallengeVisualisation';
  challengeId: Scalars['String'];
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  roles?: Maybe<Array<Scalars['String']>>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
  visualisationId: Scalars['String'];
};

export type DashboardConfigWidgetChallengeVisualisationInput = {
  challengeId: Scalars['String'];
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
  visualisationId: Scalars['String'];
};

export type DashboardConfigWidgetCommunity = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetCommunity';
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  disableInviteAbility?: Maybe<Scalars['Boolean']>;
  disableNewUsersView?: Maybe<Scalars['Boolean']>;
  disableUsersCount?: Maybe<Scalars['Boolean']>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  roles?: Maybe<Array<Scalars['String']>>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetCommunityInput = {
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  disableInviteAbility?: InputMaybe<Scalars['Boolean']>;
  disableNewUsersView?: InputMaybe<Scalars['Boolean']>;
  disableUsersCount?: InputMaybe<Scalars['Boolean']>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetContent = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetContent';
  contentIds?: Maybe<Array<Scalars['String']>>;
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  displayType?: Maybe<Scalars['String']>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  paging?: Maybe<DashboardConfigWidgetPaging>;
  roles?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<DashboardConfigWidgetSort>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetContentInput = {
  contentIds?: InputMaybe<Array<Scalars['String']>>;
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  displayType?: InputMaybe<Scalars['String']>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  paging?: InputMaybe<DashboardConfigWidgetPagingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  sort?: InputMaybe<DashboardConfigWidgetSortInput>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetEvent = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetEvent';
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  displayType?: Maybe<Scalars['String']>;
  eventIds?: Maybe<Array<Scalars['String']>>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  paging?: Maybe<DashboardConfigWidgetPaging>;
  roles?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<DashboardConfigWidgetSort>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetEventInput = {
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  displayType?: InputMaybe<Scalars['String']>;
  eventIds?: InputMaybe<Array<Scalars['String']>>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  paging?: InputMaybe<DashboardConfigWidgetPagingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  sort?: InputMaybe<DashboardConfigWidgetSortInput>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetGallery = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetGallery';
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  displayType?: Maybe<Scalars['String']>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  galleryIds?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  roles?: Maybe<Array<Scalars['String']>>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetGalleryInput = {
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  displayType?: InputMaybe<Scalars['String']>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  galleryIds?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetGeneric = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetGeneric';
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  roles?: Maybe<Array<Scalars['String']>>;
  subType?: Maybe<Scalars['String']>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetGenericInput = {
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  subType?: InputMaybe<Scalars['String']>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetPaging = {
  __typename?: 'DashboardConfigWidgetPaging';
  enabled?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type DashboardConfigWidgetPagingInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type DashboardConfigWidgetPopup = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetPopup';
  callToActionText?: Maybe<Array<Maybe<TextByLanguage>>>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  roles?: Maybe<Array<Scalars['String']>>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type DashboardConfigWidgetPopupInput = {
  callToActionText?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type DashboardConfigWidgetRendering = {
  __typename?: 'DashboardConfigWidgetRendering';
  column: Scalars['Int'];
  sequence: Scalars['Int'];
  visible: Scalars['Boolean'];
};

export type DashboardConfigWidgetRenderingInput = {
  column: Scalars['Int'];
  sequence: Scalars['Int'];
  visible: Scalars['Boolean'];
};

export type DashboardConfigWidgetSocial = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetSocial';
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  paging?: Maybe<DashboardConfigWidgetPaging>;
  roles?: Maybe<Array<Scalars['String']>>;
  socialTypes: Array<Scalars['String']>;
  sort?: Maybe<DashboardConfigWidgetSort>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetSocialInput = {
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  paging?: InputMaybe<DashboardConfigWidgetPagingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  socialTypes: Array<Scalars['String']>;
  sort?: InputMaybe<DashboardConfigWidgetSortInput>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetSort = {
  __typename?: 'DashboardConfigWidgetSort';
  field: Scalars['String'];
  order: Scalars['String'];
};

export type DashboardConfigWidgetSortInput = {
  field: Scalars['String'];
  order: Scalars['String'];
};

export type DashboardConfigWidgetStatistics = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetStatistics';
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  roles?: Maybe<Array<Scalars['String']>>;
  statistics: Array<DashboardConfigWidgetStatisticsStatistic>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetStatisticsInput = {
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  statistics?: InputMaybe<Array<DashboardConfigWidgetStatisticsStatisticInput>>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type DashboardConfigWidgetStatisticsStatistic = {
  __typename?: 'DashboardConfigWidgetStatisticsStatistic';
  aggregateBy: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  statisticType: Scalars['String'];
  subProperty?: Maybe<Scalars['String']>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type DashboardConfigWidgetStatisticsStatisticInput = {
  aggregateBy: Scalars['String'];
  icon?: InputMaybe<Scalars['String']>;
  statisticType: Scalars['String'];
  subProperty?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type DashboardConfigWidgetUrl = {
  __typename?: 'DashboardConfigWidgetUrl';
  target?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type DashboardConfigWidgetUrlInput = {
  target?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type DashboardConfigWidgetVideo = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetVideo';
  caption?: Maybe<Array<Maybe<TextByLanguage>>>;
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  roles?: Maybe<Array<Scalars['String']>>;
  source?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Array<Maybe<TextByLanguage>>>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
  video: Array<Maybe<TextByLanguage>>;
};

export type DashboardConfigWidgetVideoInput = {
  caption?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
  video?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type DashboardConfigWidgetWrapper = DashboardConfigWidget & {
  __typename?: 'DashboardConfigWidgetWrapper';
  desktop?: Maybe<DashboardConfigWidgetRendering>;
  desktopWidths?: Maybe<Array<Maybe<Scalars['Int']>>>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: Maybe<DashboardConfigWidgetRendering>;
  mobileWidths?: Maybe<Array<Maybe<Scalars['Int']>>>;
  roles?: Maybe<Array<Scalars['String']>>;
  tablet?: Maybe<DashboardConfigWidgetRendering>;
  tabletWidths?: Maybe<Array<Maybe<Scalars['Int']>>>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: Scalars['String'];
  widgetIds: Array<Scalars['String']>;
};

export type DashboardConfigWidgetWrapperInput = {
  desktop?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  desktopWidths?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mobile?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  mobileWidths?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tablet?: InputMaybe<DashboardConfigWidgetRenderingInput>;
  tabletWidths?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
  widgetIds?: InputMaybe<Array<Scalars['String']>>;
};

export type Event = {
  __typename?: 'Event';
  activityTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  chronoraceEventId?: Maybe<Scalars['Float']>;
  commentCount: Scalars['Int'];
  comments: Array<EventComment>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  disableComments?: Maybe<Scalars['Boolean']>;
  displayTimezone?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  enabledLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
  end?: Maybe<Scalars['Float']>;
  expiresOn?: Maybe<Scalars['Float']>;
  galleries: Array<EventGallery>;
  galleryCount: Scalars['Int'];
  groupIds?: Maybe<Array<Scalars['String']>>;
  hideInList?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  likeCount: Scalars['Int'];
  likes: Array<EventLike>;
  organizator?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<Maybe<EventProjectDetails>>>;
  publishedOn?: Maybe<Scalars['Float']>;
  registration?: Maybe<EventRegistration>;
  start?: Maybe<Scalars['Float']>;
  subEvents?: Maybe<Array<Maybe<SubEvent>>>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  url?: Maybe<Scalars['String']>;
  withAdvancedMode?: Maybe<Scalars['Boolean']>;
};

export type EventComment = Comment & {
  __typename?: 'EventComment';
  comment: Scalars['String'];
  createdAt: Scalars['Float'];
  deleted: Scalars['Boolean'];
  event: Event;
  id: Scalars['String'];
  moderated: Scalars['Boolean'];
  parentId?: Maybe<Scalars['String']>;
  reported: Scalars['Boolean'];
  subComments: Array<SubComment>;
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type EventFilter = {
  enabledLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  end?: InputMaybe<Scalars['Float']>;
  endsAfter?: InputMaybe<Scalars['Float']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  groupId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isChronorace?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Float']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textSearch?: InputMaybe<Scalars['String']>;
  textSearchLocale?: InputMaybe<Scalars['String']>;
};

export type EventGallery = Gallery & {
  __typename?: 'EventGallery';
  commentCount: Scalars['Int'];
  comments: Array<GalleryComment>;
  createdOn?: Maybe<Scalars['Float']>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  event?: Maybe<Event>;
  expiresOn?: Maybe<Scalars['Float']>;
  featured?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  images: Array<GalleryImage>;
  isDraft?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  likes: Array<GalleryLike>;
  preview?: Maybe<Array<Maybe<TextByLanguage>>>;
  publishOn?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags: Array<GalleryTag>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['String']>;
};


export type EventGalleryImagesArgs = {
  filter?: InputMaybe<GalleryImageFilter>;
};

export type EventGroup = {
  __typename?: 'EventGroup';
  color?: Maybe<Scalars['String']>;
  dontAllowSubEventIntersection?: Maybe<Scalars['Boolean']>;
  eventIds?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name: Array<TextByLanguage>;
  subscriptionsCount: Scalars['Int'];
};

export type EventGroupFilter = {
  id?: InputMaybe<Scalars['String']>;
};

export type EventHistory = {
  __typename?: 'EventHistory';
  action: Scalars['String'];
  createdAt?: Maybe<Scalars['Float']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['String']>;
  eventParticipation?: Maybe<EventParticipant>;
  id: Scalars['String'];
  originEvent?: Maybe<Event>;
  originEventId?: Maybe<Scalars['String']>;
  projectDetails?: Maybe<Array<EventProjectDetails>>;
  user?: Maybe<User>;
};

export type EventHistoryFilter = {
  actions?: InputMaybe<Array<Scalars['String']>>;
  eventIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['Float']>;
};

export type EventJourney = Journey & {
  __typename?: 'EventJourney';
  childJourneys?: Maybe<Array<Journey>>;
  coachType: Scalars['String'];
  comingSoon: Scalars['Boolean'];
  content: Array<JourneyContent>;
  cost?: Maybe<JourneyCost>;
  discounts?: Maybe<Array<JourneyDiscount>>;
  enabledLocales?: Maybe<Array<Scalars['String']>>;
  event: EventJourneyEvent;
  expiresOn?: Maybe<Scalars['Float']>;
  hideInList?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  participants: Scalars['Int'];
  publishOn?: Maybe<Scalars['Float']>;
  registration: JourneyRegistration;
  roles?: Maybe<Array<Scalars['String']>>;
  sequence: Scalars['Int'];
  subTitle: Array<TextByLanguage>;
  tagIds: Array<Scalars['String']>;
  tags: Array<JourneyTag>;
  title: Array<TextByLanguage>;
  type: Scalars['String'];
};


export type EventJourneyChildJourneysArgs = {
  filter?: InputMaybe<ChildJourneySubFilter>;
};

export type EventJourneyCreateInput = {
  coachType: Scalars['String'];
  comingSoon?: InputMaybe<Scalars['Boolean']>;
  content: Array<JourneyContentInput>;
  cost?: InputMaybe<JourneyCostInput>;
  discounts?: InputMaybe<Array<JourneyDiscountInput>>;
  enabledLocales?: InputMaybe<Array<Scalars['String']>>;
  event: EventJourneyEventInput;
  expiresOn?: InputMaybe<Scalars['Float']>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  imageUrl: Scalars['String'];
  parentId?: InputMaybe<Scalars['String']>;
  publishOn?: InputMaybe<Scalars['Float']>;
  registration: JourneyRegistrationInput;
  roles?: InputMaybe<Array<Scalars['String']>>;
  sequence: Scalars['Int'];
  subTitle: Array<TextByLanguageInput>;
  tagIds: Array<Scalars['String']>;
  title: Array<TextByLanguageInput>;
  type: Scalars['String'];
};

export type EventJourneyEvent = {
  __typename?: 'EventJourneyEvent';
  cost?: Maybe<JourneyCost>;
  date: Scalars['Float'];
  description: Array<TextByLanguage>;
  detailedLocation: Array<TextByLanguage>;
  distance?: Maybe<Scalars['Float']>;
  location: Array<TextByLanguage>;
  position: EventJourneyPosition;
  title: Array<TextByLanguage>;
};

export type EventJourneyEventInput = {
  cost?: InputMaybe<JourneyCostInput>;
  date: Scalars['Float'];
  description: Array<TextByLanguageInput>;
  detailedLocation: Array<TextByLanguageInput>;
  distance?: InputMaybe<Scalars['Float']>;
  location: Array<TextByLanguageInput>;
  position: EventJourneyPositionInput;
  title: Array<TextByLanguageInput>;
};

export type EventJourneyPosition = {
  __typename?: 'EventJourneyPosition';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type EventJourneyPositionInput = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type EventJourneyUpdateInput = {
  coachType?: InputMaybe<Scalars['String']>;
  comingSoon?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<JourneyContentInput>>>;
  cost?: InputMaybe<JourneyCostInput>;
  discounts?: InputMaybe<Array<JourneyDiscountInput>>;
  enabledLocales?: InputMaybe<Array<Scalars['String']>>;
  event?: InputMaybe<EventJourneyEventInput>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  publishOn?: InputMaybe<Scalars['Float']>;
  registration?: InputMaybe<JourneyRegistrationInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  sequence?: InputMaybe<Scalars['Int']>;
  subTitle?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type EventLike = Like & {
  __typename?: 'EventLike';
  event?: Maybe<Event>;
  id: Scalars['String'];
  likedOn: Scalars['Float'];
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type EventParticipant = {
  __typename?: 'EventParticipant';
  approved?: Maybe<Scalars['Boolean']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['String']>;
  formData?: Maybe<Scalars['JSON']>;
  onWaitingList?: Maybe<Scalars['Boolean']>;
  participatedOn?: Maybe<Scalars['Float']>;
  registrationComplete?: Maybe<Scalars['Boolean']>;
  subEvent?: Maybe<SubEvent>;
  subEventId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type EventParticipantFilter = {
  eventId: Scalars['String'];
  subEventIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EventProjectDetails = {
  __typename?: 'EventProjectDetails';
  daysToFinalEditReminder?: Maybe<Scalars['Int']>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  featured?: Maybe<Scalars['Boolean']>;
  formSubscriptionEnabled?: Maybe<Scalars['Boolean']>;
  formTemplateIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  formTemplates?: Maybe<Array<Maybe<FormTemplate>>>;
  participants?: Maybe<Scalars['Int']>;
  participantsOnWaitingList?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['String']>;
  registration?: Maybe<EventProjectDetailsRegistration>;
  reminders?: Maybe<Array<Maybe<Scalars['String']>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  subEvents?: Maybe<Array<Maybe<SubEventProjectDetails>>>;
  subscriptionEnabled?: Maybe<Scalars['Boolean']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<EventTag>>>;
  viewParticipantCount?: Maybe<Scalars['Boolean']>;
  viewParticipants?: Maybe<Scalars['Boolean']>;
  viewWaitingList?: Maybe<Scalars['Boolean']>;
  viewWaitingListCount?: Maybe<Scalars['Boolean']>;
  waitingListEnabled?: Maybe<Scalars['Boolean']>;
  withAdvancedMode?: Maybe<Scalars['Boolean']>;
};

export type EventProjectDetailsInput = {
  daysToFinalEditReminder?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  formSubscriptionEnabled?: InputMaybe<Scalars['Boolean']>;
  formTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectId?: InputMaybe<Scalars['String']>;
  registration?: InputMaybe<EventProjectDetailsRegistrationInput>;
  reminders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subEvents?: InputMaybe<Array<InputMaybe<SubEventProjectDetailsInput>>>;
  subscriptionEnabled?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  viewParticipantCount?: InputMaybe<Scalars['Boolean']>;
  viewParticipants?: InputMaybe<Scalars['Boolean']>;
  viewWaitingList?: InputMaybe<Scalars['Boolean']>;
  viewWaitingListCount?: InputMaybe<Scalars['Boolean']>;
  waitingListEnabled?: InputMaybe<Scalars['Boolean']>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
};

export type EventProjectDetailsRegistration = {
  __typename?: 'EventProjectDetailsRegistration';
  end?: Maybe<Scalars['Float']>;
  start?: Maybe<Scalars['Float']>;
};

export type EventProjectDetailsRegistrationInput = {
  end?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
};

export type EventRegistration = {
  __typename?: 'EventRegistration';
  disableUnregistration?: Maybe<Scalars['Boolean']>;
  end?: Maybe<Scalars['Float']>;
  start?: Maybe<Scalars['Float']>;
};

export type EventRegistrationInput = {
  disableUnregistration?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
};

export type EventTag = {
  __typename?: 'EventTag';
  color: Scalars['String'];
  description?: Maybe<Array<TextByLanguage>>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  project: Project;
  title: Array<TextByLanguage>;
};

export type Flow = {
  __typename?: 'Flow';
  end?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  reminderDaysDelay?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Float']>;
  steps?: Maybe<Array<FlowStep>>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type FlowInput = {
  end?: InputMaybe<Scalars['Float']>;
  projectId: Scalars['String'];
  reminderDaysDelay?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Float']>;
  steps?: InputMaybe<Array<FlowStepInput>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type FlowStep = {
  __typename?: 'FlowStep';
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type: FlowStepTypes;
  typeIds: Array<Scalars['String']>;
};

export type FlowStepInput = {
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: FlowStepTypes;
  typeIds: Array<Scalars['String']>;
};

export enum FlowStepTypes {
  Article = 'article',
  Challenge = 'challenge',
  Content = 'content',
  Event = 'event',
  Typeform = 'typeform'
}

export type FlowsFilter = {
  flowId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
};

export type FormElement = {
  __typename?: 'FormElement';
  defaultValue?: Maybe<Scalars['String']>;
  extensions?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['Int']>;
  maxFileSize?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  options?: Maybe<Array<Maybe<FormElementOption>>>;
  property?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  sequence?: Maybe<Scalars['Int']>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type?: Maybe<Scalars['String']>;
};

export type FormElementInput = {
  defaultValue?: InputMaybe<Scalars['String']>;
  extensions?: InputMaybe<Scalars['String']>;
  max?: InputMaybe<Scalars['Int']>;
  maxFileSize?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Array<InputMaybe<FormElementOptionInput>>>;
  property?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sequence?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type FormElementOption = {
  __typename?: 'FormElementOption';
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  value?: Maybe<Scalars['String']>;
};

export type FormElementOptionInput = {
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  value?: InputMaybe<Scalars['String']>;
};

export type FormTemplate = {
  __typename?: 'FormTemplate';
  elements?: Maybe<Array<Maybe<FormElement>>>;
  errorMessages?: Maybe<Array<Maybe<TextByLanguage>>>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type?: Maybe<Scalars['String']>;
};

export type FormTemplateFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type: Scalars['String'];
};

export type FormTemplateInput = {
  elements?: InputMaybe<Array<InputMaybe<FormElementInput>>>;
  errorMessages?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type Gallery = {
  commentCount: Scalars['Int'];
  comments: Array<GalleryComment>;
  createdOn?: Maybe<Scalars['Float']>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  expiresOn?: Maybe<Scalars['Float']>;
  featured?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  images: Array<GalleryImage>;
  isDraft?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  likes: Array<GalleryLike>;
  preview?: Maybe<Array<Maybe<TextByLanguage>>>;
  publishOn?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags: Array<GalleryTag>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['String']>;
};


export type GalleryImagesArgs = {
  filter?: InputMaybe<GalleryImageFilter>;
};

export type GalleryComment = Comment & {
  __typename?: 'GalleryComment';
  comment: Scalars['String'];
  createdAt: Scalars['Float'];
  deleted: Scalars['Boolean'];
  gallery: Gallery;
  id: Scalars['String'];
  moderated: Scalars['Boolean'];
  parentId?: Maybe<Scalars['String']>;
  reported: Scalars['Boolean'];
  subComments: Array<SubComment>;
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type GalleryFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GalleryImage = {
  __typename?: 'GalleryImage';
  commentCount: Scalars['Int'];
  comments: Array<GalleryImageComment>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  embedUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  likeCount: Scalars['Int'];
  likes: Array<GalleryImageLike>;
  reported?: Maybe<Scalars['Boolean']>;
  reportedBy?: Maybe<Array<GalleryImageReportedUser>>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type GalleryImageComment = Comment & {
  __typename?: 'GalleryImageComment';
  comment: Scalars['String'];
  createdAt: Scalars['Float'];
  deleted: Scalars['Boolean'];
  galleryImage: GalleryImage;
  id: Scalars['String'];
  moderated: Scalars['Boolean'];
  parentId?: Maybe<Scalars['String']>;
  reported: Scalars['Boolean'];
  subComments: Array<SubComment>;
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type GalleryImageFilter = {
  onlyReported?: InputMaybe<Scalars['Boolean']>;
};

export type GalleryImageLike = Like & {
  __typename?: 'GalleryImageLike';
  galleryImage?: Maybe<GalleryImage>;
  id: Scalars['String'];
  likedOn: Scalars['Float'];
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type GalleryImageReportedUser = {
  __typename?: 'GalleryImageReportedUser';
  reportedOn: Scalars['Float'];
  userId: Scalars['String'];
};

export type GalleryLike = Like & {
  __typename?: 'GalleryLike';
  gallery?: Maybe<Gallery>;
  id: Scalars['String'];
  likedOn: Scalars['Float'];
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type GalleryTag = {
  __typename?: 'GalleryTag';
  color: Scalars['String'];
  description: Array<TextByLanguage>;
  id: Scalars['String'];
  image: Scalars['String'];
  title: Array<TextByLanguage>;
};

export type GalleryTagFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GenericGallery = Gallery & {
  __typename?: 'GenericGallery';
  commentCount: Scalars['Int'];
  comments: Array<GalleryComment>;
  createdOn?: Maybe<Scalars['Float']>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  expiresOn?: Maybe<Scalars['Float']>;
  featured?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  images: Array<GalleryImage>;
  isDraft?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  likes: Array<GalleryLike>;
  preview?: Maybe<Array<Maybe<TextByLanguage>>>;
  publishOn?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags: Array<GalleryTag>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  type?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['String']>;
};


export type GenericGalleryImagesArgs = {
  filter?: InputMaybe<GalleryImageFilter>;
};

export type ImpersonateData = {
  __typename?: 'ImpersonateData';
  applicationUrl: Scalars['String'];
};

export type InstagramFeed = {
  __typename?: 'InstagramFeed';
  date?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  media?: Maybe<Array<Maybe<InstagramMedia>>>;
  sourceUrl?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<InstagramUser>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type InstagramFeedFilter = {
  search?: InputMaybe<Scalars['String']>;
};

export type InstagramMedia = {
  __typename?: 'InstagramMedia';
  height?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type InstagramUser = {
  __typename?: 'InstagramUser';
  avatar?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Journey = {
  childJourneys?: Maybe<Array<Journey>>;
  coachType: Scalars['String'];
  comingSoon: Scalars['Boolean'];
  content: Array<JourneyContent>;
  cost?: Maybe<JourneyCost>;
  discounts?: Maybe<Array<JourneyDiscount>>;
  enabledLocales?: Maybe<Array<Scalars['String']>>;
  expiresOn?: Maybe<Scalars['Float']>;
  hideInList?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  participants: Scalars['Int'];
  publishOn?: Maybe<Scalars['Float']>;
  registration: JourneyRegistration;
  roles?: Maybe<Array<Scalars['String']>>;
  sequence: Scalars['Int'];
  subTitle: Array<TextByLanguage>;
  tagIds: Array<Scalars['String']>;
  tags: Array<JourneyTag>;
  title: Array<TextByLanguage>;
  type: Scalars['String'];
};


export type JourneyChildJourneysArgs = {
  filter?: InputMaybe<ChildJourneySubFilter>;
};

export type JourneyContent = {
  __typename?: 'JourneyContent';
  description: Array<TextByLanguage>;
  imageCaption?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  subTitle: Array<TextByLanguage>;
  title: Array<TextByLanguage>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type JourneyContentInput = {
  description: Array<TextByLanguageInput>;
  imageCaption?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  subTitle: Array<TextByLanguageInput>;
  title: Array<TextByLanguageInput>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type JourneyCost = {
  __typename?: 'JourneyCost';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  description: Array<TextByLanguage>;
  title: Array<TextByLanguage>;
};

export type JourneyCostInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  description: Array<TextByLanguageInput>;
  title: Array<TextByLanguageInput>;
};

export type JourneyDiscount = {
  __typename?: 'JourneyDiscount';
  amount?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
};

export type JourneyDiscountInput = {
  amount?: InputMaybe<Scalars['Float']>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Scalars['String']>;
};

export type JourneyFilter = {
  coachTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledLocales?: InputMaybe<Array<Scalars['String']>>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textSearch?: InputMaybe<Scalars['String']>;
  textSearchLocale?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type JourneyParticipation = {
  __typename?: 'JourneyParticipation';
  checkupParticipations?: Maybe<Array<Maybe<CheckupParticipation>>>;
  id: Scalars['String'];
  isPaid: Scalars['Boolean'];
  journey?: Maybe<Journey>;
  noShow?: Maybe<JourneyParticipationNoShow>;
  paidOn?: Maybe<Scalars['Float']>;
  participatedOn: Scalars['Float'];
  payments: Array<Payment>;
  progress: Scalars['Float'];
  trainingPlanPdf?: Maybe<Scalars['String']>;
  trainingPlanPdfs?: Maybe<Array<Maybe<JourneyParticipationTrainingPdf>>>;
  user?: Maybe<User>;
  voucherUsage?: Maybe<JourneyVoucherUsage>;
};

export type JourneyParticipationFilter = {
  from?: InputMaybe<Scalars['Float']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  journeyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  to?: InputMaybe<Scalars['Float']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userSearch?: InputMaybe<Scalars['String']>;
};

export type JourneyParticipationNoShow = {
  __typename?: 'JourneyParticipationNoShow';
  comment?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
};

export type JourneyParticipationNoShowInput = {
  comment?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type JourneyParticipationTrainingPdf = {
  __typename?: 'JourneyParticipationTrainingPdf';
  end?: Maybe<Scalars['Float']>;
  pdf?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Float']>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type JourneyParticipationTrainingPdfInput = {
  end?: InputMaybe<Scalars['Float']>;
  pdf?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type JourneyRegistration = {
  __typename?: 'JourneyRegistration';
  enableMaxParticipants?: Maybe<Scalars['Boolean']>;
  enableUltimateManualPaymentPeriod?: Maybe<Scalars['Boolean']>;
  enableUltimateTime?: Maybe<Scalars['Boolean']>;
  maxParticipants?: Maybe<Scalars['Int']>;
  newRoles?: Maybe<Array<Scalars['String']>>;
  ultimateManualPaymentPeriod?: Maybe<Scalars['String']>;
  ultimateTime?: Maybe<Scalars['Float']>;
  voucherRequired?: Maybe<Scalars['Boolean']>;
};

export type JourneyRegistrationInput = {
  enableMaxParticipants?: InputMaybe<Scalars['Boolean']>;
  enableUltimateManualPaymentPeriod?: InputMaybe<Scalars['Boolean']>;
  enableUltimateTime?: InputMaybe<Scalars['Boolean']>;
  maxParticipants?: InputMaybe<Scalars['Int']>;
  newRoles?: InputMaybe<Array<Scalars['String']>>;
  ultimateManualPaymentPeriod?: InputMaybe<Scalars['String']>;
  ultimateTime?: InputMaybe<Scalars['Float']>;
  voucherRequired?: InputMaybe<Scalars['Boolean']>;
};

export type JourneyTag = {
  __typename?: 'JourneyTag';
  color: Scalars['String'];
  description: Array<TextByLanguage>;
  id: Scalars['String'];
  image: Scalars['String'];
  title: Array<TextByLanguage>;
};

export type JourneyTagFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type JourneyVoucherUsage = VoucherUsage & {
  __typename?: 'JourneyVoucherUsage';
  createdOn: Scalars['Float'];
  id: Scalars['String'];
  journey: Journey;
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
  voucher: Voucher;
  voucherId: Scalars['String'];
};

export type KcalPerHour = {
  __typename?: 'KcalPerHour';
  activity: Scalars['String'];
  kcalPerHour: Scalars['Float'];
};

export type KcalPerHourInput = {
  activity: Scalars['String'];
  kcalPerHour: Scalars['Float'];
};

export type Like = {
  id: Scalars['String'];
  likedOn: Scalars['Float'];
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type LikeFilter = {
  type?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['String']>;
};

export type LoginData = {
  __typename?: 'LoginData';
  confirmCodeChallengeId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['String']>;
  profile?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type MailConfig = {
  __typename?: 'MailConfig';
  enabledTemplates?: Maybe<Array<MailConfigEnabledTemplate>>;
  mailEngine?: Maybe<MailEngine>;
};

export type MailConfigEnabledTemplate = {
  __typename?: 'MailConfigEnabledTemplate';
  enabled: Scalars['Boolean'];
  type: Scalars['String'];
};

export type MailConfigEnabledTemplateInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type MailConfigInput = {
  enabledTemplates?: InputMaybe<Array<MailConfigEnabledTemplateInput>>;
  mailEngine?: InputMaybe<Scalars['MailEngineInput']>;
};

export type MailEngine = {
  type: Scalars['String'];
};

export type MailEngineCampaignMonitor = MailEngine & {
  __typename?: 'MailEngineCampaignMonitor';
  apiKey: Scalars['String'];
  type: Scalars['String'];
};

export type MailEngineCampaignMonitorInput = {
  apiKey: Scalars['String'];
  type: Scalars['String'];
};

export type MailEngineSendgrid = MailEngine & {
  __typename?: 'MailEngineSendgrid';
  apiKey: Scalars['String'];
  type: Scalars['String'];
};

export type MailEngineSendgridInput = {
  apiKey: Scalars['String'];
  type: Scalars['String'];
};

export type MailTemplate = {
  __typename?: 'MailTemplate';
  attachments?: Maybe<Array<MailTemplateAttachment>>;
  body?: Maybe<Array<TextByLanguage>>;
  copy?: Maybe<MailTemplateCopy>;
  id: Scalars['String'];
  optional?: Maybe<Scalars['Boolean']>;
  preformattingData?: Maybe<Array<MailTemplatePreformatting>>;
  subTemplates?: Maybe<Array<MailTemplateSubTemplate>>;
  subject?: Maybe<Array<TextByLanguage>>;
  type?: Maybe<Scalars['String']>;
};

export type MailTemplateAttachment = {
  type: Scalars['String'];
};

export type MailTemplateAttachmentIcs = MailTemplateAttachment & {
  __typename?: 'MailTemplateAttachmentIcs';
  fileName?: Maybe<Scalars['String']>;
  mapping?: Maybe<Array<MailTemplateAttachmentIcsMapping>>;
  method?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type MailTemplateAttachmentIcsInput = {
  fileName?: InputMaybe<Scalars['String']>;
  mapping?: InputMaybe<Array<InputMaybe<MailTemplateAttachmentIcsMappingInput>>>;
  method?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type MailTemplateAttachmentIcsMapping = {
  __typename?: 'MailTemplateAttachmentIcsMapping';
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  key: Scalars['String'];
  latitude?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MailTemplateAttachmentIcsMappingInput = {
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  key: Scalars['String'];
  latitude?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type MailTemplateCopy = {
  __typename?: 'MailTemplateCopy';
  bcc?: Maybe<Array<MailTemplateCopyEmail>>;
  cc?: Maybe<Array<Maybe<MailTemplateCopyEmail>>>;
};

export type MailTemplateCopyEmail = {
  __typename?: 'MailTemplateCopyEmail';
  email: Scalars['String'];
};

export type MailTemplateCopyEmailInput = {
  email: Scalars['String'];
};

export type MailTemplateCopyInput = {
  bcc?: InputMaybe<Array<InputMaybe<MailTemplateCopyEmailInput>>>;
  cc?: InputMaybe<Array<InputMaybe<MailTemplateCopyEmailInput>>>;
};

export type MailTemplateFilter = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  mailTemplateSearch?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type MailTemplatePreformatting = {
  __typename?: 'MailTemplatePreformatting';
  key?: Maybe<Scalars['String']>;
  records?: Maybe<Array<MailTemplatePreformattingRecord>>;
};

export type MailTemplatePreformattingInput = {
  key?: InputMaybe<Scalars['String']>;
  records?: InputMaybe<Array<InputMaybe<MailTemplatePreformattingRecordInput>>>;
};

export type MailTemplatePreformattingRecord = {
  __typename?: 'MailTemplatePreformattingRecord';
  formatting?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['String']>;
  resultProperty?: Maybe<Scalars['String']>;
};

export type MailTemplatePreformattingRecordInput = {
  formatting?: InputMaybe<Scalars['String']>;
  property?: InputMaybe<Scalars['String']>;
  resultProperty?: InputMaybe<Scalars['String']>;
};

export type MailTemplateSubTemplate = {
  __typename?: 'MailTemplateSubTemplate';
  body?: Maybe<Array<TextByLanguage>>;
  name?: Maybe<Scalars['String']>;
};

export type MailTemplateSubTemplateInput = {
  body?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type Paging = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type PasswordUser = {
  __typename?: 'PasswordUser';
  emailValidated: Scalars['Boolean'];
};

export type Payment = {
  __typename?: 'Payment';
  createdOn: Scalars['Float'];
  id: Scalars['String'];
  lastStatus: PaymentStatus;
  paymentMethod: Scalars['String'];
  statusses: Array<PaymentStatus>;
  type: Scalars['String'];
  typeId?: Maybe<Scalars['String']>;
  user: User;
  userId: Scalars['String'];
};

export type PaymentConfig = {
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  paymentProvider: Scalars['String'];
  types: Array<Scalars['String']>;
};

export type PaymentConfigFilter = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  paymentProvider?: InputMaybe<Scalars['String']>;
};

export type PaymentConfigMollie = PaymentConfig & {
  __typename?: 'PaymentConfigMollie';
  apiKey?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  paymentProvider: Scalars['String'];
  types: Array<Scalars['String']>;
};

export type PaymentConfigMollieInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  paymentProvider: Scalars['String'];
  types: Array<Scalars['String']>;
};

export type PaymentFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PaymentStatus = {
  __typename?: 'PaymentStatus';
  date: Scalars['Float'];
  source: Scalars['String'];
  status: Scalars['String'];
};

export type PersonalJourney = Journey & {
  __typename?: 'PersonalJourney';
  childJourneys?: Maybe<Array<Journey>>;
  coachType: Scalars['String'];
  comingSoon: Scalars['Boolean'];
  content: Array<JourneyContent>;
  cost?: Maybe<JourneyCost>;
  discounts?: Maybe<Array<JourneyDiscount>>;
  duration: PersonalJourneyDuration;
  enabledLocales?: Maybe<Array<Scalars['String']>>;
  expiresOn?: Maybe<Scalars['Float']>;
  hideInList?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  participants: Scalars['Int'];
  publishOn?: Maybe<Scalars['Float']>;
  registration: JourneyRegistration;
  roles?: Maybe<Array<Scalars['String']>>;
  sequence: Scalars['Int'];
  subTitle: Array<TextByLanguage>;
  tagIds: Array<Scalars['String']>;
  tags: Array<JourneyTag>;
  title: Array<TextByLanguage>;
  type: Scalars['String'];
};


export type PersonalJourneyChildJourneysArgs = {
  filter?: InputMaybe<ChildJourneySubFilter>;
};

export type PersonalJourneyCreateInput = {
  coachType: Scalars['String'];
  comingSoon?: InputMaybe<Scalars['Boolean']>;
  content: Array<JourneyContentInput>;
  cost?: InputMaybe<JourneyCostInput>;
  discounts?: InputMaybe<Array<JourneyDiscountInput>>;
  duration: PersonalJourneyDurationInput;
  enabledLocales?: InputMaybe<Array<Scalars['String']>>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  imageUrl: Scalars['String'];
  parentId?: InputMaybe<Scalars['String']>;
  publishOn?: InputMaybe<Scalars['Float']>;
  registration: JourneyRegistrationInput;
  roles?: InputMaybe<Array<Scalars['String']>>;
  sequence: Scalars['Int'];
  subTitle: Array<TextByLanguageInput>;
  tagIds: Array<Scalars['String']>;
  title: Array<TextByLanguageInput>;
  type: Scalars['String'];
};

export type PersonalJourneyDuration = {
  __typename?: 'PersonalJourneyDuration';
  duration: Scalars['Int'];
  unitType: Scalars['String'];
};

export type PersonalJourneyDurationInput = {
  duration: Scalars['Int'];
  unitType: Scalars['String'];
};

export type PersonalJourneyUpdateInput = {
  coachType?: InputMaybe<Scalars['String']>;
  comingSoon?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<JourneyContentInput>>>;
  cost?: InputMaybe<JourneyCostInput>;
  discounts?: InputMaybe<Array<JourneyDiscountInput>>;
  duration?: InputMaybe<PersonalJourneyDurationInput>;
  enabledLocales?: InputMaybe<Array<Scalars['String']>>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  publishOn?: InputMaybe<Scalars['Float']>;
  registration?: InputMaybe<JourneyRegistrationInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  sequence?: InputMaybe<Scalars['Int']>;
  subTitle?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};

export type ProfileFields = {
  __typename?: 'ProfileFields';
  label?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type ProfileFieldsInput = {
  label?: InputMaybe<Scalars['String']>;
  list?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  required?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type Project = {
  __typename?: 'Project';
  applications?: Maybe<Array<Application>>;
  contactEmail?: Maybe<Array<ProjectContactEmail>>;
  defaultLocale?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identities?: Maybe<Array<Scalars['String']>>;
  jwtValidDuration?: Maybe<Scalars['String']>;
  mailConfig?: Maybe<MailConfig>;
  mailHeader?: Maybe<ProjectMailHeader>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<ProjectPasswordRequirement>;
  private?: Maybe<Scalars['Boolean']>;
  requireEmailValidation?: Maybe<Scalars['Boolean']>;
  useWhiteListing?: Maybe<Scalars['Boolean']>;
  userDisplayConfig?: Maybe<UserDisplayConfiguration>;
  userSearchConfig?: Maybe<UserSearchConfiguration>;
};

export type ProjectConfig = {
  __typename?: 'ProjectConfig';
  data: Scalars['JSON'];
  id: Scalars['String'];
  place: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectConfigHistory = {
  __typename?: 'ProjectConfigHistory';
  action: Scalars['String'];
  configId: Scalars['String'];
  data?: Maybe<ProjectConfig>;
  date: Scalars['Float'];
  userId?: Maybe<Scalars['String']>;
};

export type ProjectConfigInput = {
  data: Scalars['JSON'];
  place: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectContactEmail = {
  __typename?: 'ProjectContactEmail';
  email: Scalars['String'];
  type: Scalars['String'];
};

export type ProjectContactEmailInput = {
  email: Scalars['String'];
  type: Scalars['String'];
};

export type ProjectMailHeader = {
  __typename?: 'ProjectMailHeader';
  fromEmail: Scalars['String'];
  fromName?: Maybe<Scalars['String']>;
  replyEmail?: Maybe<Scalars['String']>;
  replyName?: Maybe<Scalars['String']>;
};

export type ProjectMailHeaderInput = {
  fromEmail: Scalars['String'];
  fromName?: InputMaybe<Scalars['String']>;
  replyEmail?: InputMaybe<Scalars['String']>;
  replyName?: InputMaybe<Scalars['String']>;
};

export type ProjectPasswordRequirement = {
  __typename?: 'ProjectPasswordRequirement';
  allowedSpecialCharacters: Array<Scalars['String']>;
  lockOut: ProjectPasswordRequirementLockout;
  minLength: Scalars['Int'];
  requireLetter: Scalars['Boolean'];
  requireLowerCase: Scalars['Boolean'];
  requireNumber: Scalars['Boolean'];
  requireOldPassword: Scalars['Boolean'];
  requireSpecialCharacter: Scalars['Boolean'];
  requireUpperCase: Scalars['Boolean'];
};

export type ProjectPasswordRequirementInput = {
  allowedSpecialCharacters?: InputMaybe<Array<Scalars['String']>>;
  lockOut?: InputMaybe<ProjectPasswordRequirementLockoutInput>;
  minLength?: InputMaybe<Scalars['Int']>;
  requireLetter?: InputMaybe<Scalars['Boolean']>;
  requireLowerCase?: InputMaybe<Scalars['Boolean']>;
  requireNumber?: InputMaybe<Scalars['Boolean']>;
  requireOldPassword?: InputMaybe<Scalars['Boolean']>;
  requireSpecialCharacter?: InputMaybe<Scalars['Boolean']>;
  requireUpperCase?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectPasswordRequirementLockout = {
  __typename?: 'ProjectPasswordRequirementLockout';
  attempts: Scalars['Int'];
  enabled: Scalars['Boolean'];
  time: Scalars['Int'];
};

export type ProjectPasswordRequirementLockoutInput = {
  attempts?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  time?: InputMaybe<Scalars['Int']>;
};

export type Provider = {
  __typename?: 'Provider';
  enabled?: Maybe<Scalars['Boolean']>;
  provider?: Maybe<Scalars['String']>;
  syncedOn?: Maybe<Scalars['Float']>;
};

export type ProviderActivity = {
  __typename?: 'ProviderActivity';
  activity?: Maybe<Scalars['String']>;
  calories?: Maybe<Scalars['Int']>;
  distance?: Maybe<Scalars['Float']>;
  end?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  segmentId?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Float']>;
  steps?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ReportingConfig = {
  __typename?: 'ReportingConfig';
  cachingKeyType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  ttl?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type ReportingConfigFilter = {
  cachingKeyType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  projectId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ReportingConfigInput = {
  cachingKeyType?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  ttl?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type Role = {
  __typename?: 'Role';
  application?: Maybe<Application>;
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  project?: Maybe<Project>;
};

export type RootMutation = {
  __typename?: 'RootMutation';
  addAmbassador: Ambassador;
  addAmbassadorConfig: AmbassadorConfig;
  addAmbassadorTag: AmbassadorTag;
  addArticle: Article;
  addArticleVouchers: Success;
  addChallenge: Challenge;
  addChallengeTag: ChallengeTag;
  addChallengeTeam: ChallengeTeam;
  addCheckupLocation: CheckupLocation;
  addCheckupLocationAvailability: CheckupLocationAvailability;
  addCompany: Company;
  addContent: Content;
  addContentTag: ContentTag;
  addCreditConfig: CreditConfig;
  addDashboardConfiguration: DashboardConfig;
  addEvent: Event;
  addEventGroup: EventGroup;
  addEventTag: EventTag;
  addFormTemplate: FormTemplate;
  addGallery: Gallery;
  addGalleryImage: GalleryImage;
  addGalleryTag: GalleryTag;
  addJourney: Journey;
  addJourneyTag: JourneyTag;
  addMailConfig: MailConfig;
  addMailTemplate: MailTemplate;
  addReportingConfig: ReportingConfig;
  addRole: Role;
  addSocialFilterWord: SocialFilterWord;
  addSocialTag: SocialTag;
  addTranslation: Translation;
  addUser: User;
  addUserProfileRoleConfig: UserProfileRoleConfig;
  addUserWhiteList: UserWhiteList;
  addVoucher: Voucher;
  banFromChallengeTeam: ChallengeTeam;
  changeVisibleInstagramFeed: InstagramFeed;
  changeVisibleTwitterFeed: TwitterFeed;
  consumeConfirmCode: LoginData;
  copyEvent: Array<Event>;
  createFlow: Flow;
  createPaymentConfig: PaymentConfig;
  createProject: Project;
  createProjectConfig: ProjectConfig;
  createUserCreditTransaction: Success;
  deleteFlow: Success;
  deletePaymentConfig: Success;
  exportChallengeParticipation: Success;
  exportChallengeParticipationFormConditionData: Success;
  exportEventParticipation: Success;
  exportJourneyParticipation: Success;
  exportUsers: Success;
  exportVoucher: Success;
  impersonateUser: ImpersonateData;
  login: LoginData;
  logout: Success;
  regenerateConfirmCode: ConfirmCodeChallenge;
  registerUser: LoginData;
  removeAmbassador: Success;
  removeAmbassadorConfig: Success;
  removeAmbassadorTag: Success;
  removeArticle: Success;
  removeArticleVouchers: Success;
  removeChallenge: Success;
  removeChallengeParticipation: Success;
  removeChallengeTag: Success;
  removeChallengeTeam: Success;
  removeCheckupLocation: Success;
  removeCheckupLocationAvailability: Success;
  removeCheckupParticipation: Success;
  removeComment: Success;
  removeCompany: Success;
  removeContent: Success;
  removeContentTag: Success;
  removeCreditConfig: Success;
  removeDashboardConfiguration: Success;
  removeEvent: Success;
  removeEventGroup: Success;
  removeEventParticipation: Success;
  removeEventTag: Success;
  removeFormTemplate: Success;
  removeFromChallengeTeam: ChallengeTeam;
  removeGallery: Success;
  removeGalleryImage: Success;
  removeGalleryTag: Success;
  removeJourney: Success;
  removeJourneyParticipation: Success;
  removeJourneyTag: Success;
  removeLike: Success;
  removeMailConfig: Success;
  removeMailTemplate: Success;
  removeProjectConfig: Success;
  removeProviderActivity: Success;
  removeReportingConfig: Success;
  removeRole: Success;
  removeSocialFilterWord: Success;
  removeSocialTag: Success;
  removeTranslation: Success;
  removeUser: Success;
  removeUserProfileRoleConfig: Success;
  removeUserWhiteList: Success;
  removeUsers: Success;
  removeVoucher: Success;
  requestResetPassword: Success;
  requestValidateEmail: Success;
  resyncChallenge: Success;
  resyncProvider: Success;
  sendChallengeMilestoneEmail: Success;
  unlinkProvider: Success;
  updateAmbassador: Ambassador;
  updateAmbassadorConfig: AmbassadorConfig;
  updateAmbassadorTag: AmbassadorTag;
  updateArticle: Article;
  updateChallenge: Challenge;
  updateChallengeTag: ChallengeTag;
  updateChallengeTeam: ChallengeTeam;
  updateCheckupLocation: CheckupLocation;
  updateCheckupLocationAvailability: CheckupLocationAvailability;
  updateCheckupParticipation: CheckupParticipation;
  updateComment: Comment;
  updateCompany: Company;
  updateContent: Content;
  updateContentTag: ContentTag;
  updateCreditConfig: CreditConfig;
  updateDashboardConfiguration: DashboardConfig;
  updateEvent: Event;
  updateEventApproval: EventParticipant;
  updateEventGroup: EventGroup;
  updateEventParticipantRegistrationFormCompletionStatus: EventParticipant;
  updateEventTag: EventTag;
  updateFlow: Flow;
  updateFormTemplate: FormTemplate;
  updateGallery: Gallery;
  updateGalleryImage: GalleryImage;
  updateGalleryTag: GalleryTag;
  updateJourney: Journey;
  updateJourneyParticipation: JourneyParticipation;
  updateJourneyTag: JourneyTag;
  updateMailConfig: MailConfig;
  updateMailTemplate: MailTemplate;
  updatePasswordUser: Success;
  updatePayment: Payment;
  updatePaymentConfig: PaymentConfig;
  updateProject: Project;
  updateProjectConfig: ProjectConfig;
  updateReportingConfig: ReportingConfig;
  updateRole: Role;
  updateSocialFilterWord: SocialFilterWord;
  updateSocialTag: SocialTag;
  updateTranslation: Translation;
  updateUser: User;
  updateUserProfileRoleConfig: UserProfileRoleConfig;
  updateUserWhiteList: UserWhiteList;
  updateVoucher: Voucher;
  validateEmail: Success;
};


export type RootMutationAddAmbassadorArgs = {
  activityTypes?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  image?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  place?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  userId?: InputMaybe<Scalars['String']>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationAddAmbassadorConfigArgs = {
  ambassadorIntro?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  caption?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  heroImage?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<AmbassadorConfigImageInput>;
  intro?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  place?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  sequence?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  visibility?: InputMaybe<AmbassadorConfigVisibilityInput>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationAddAmbassadorTagArgs = {
  color: Scalars['String'];
  description: Array<TextByLanguageInput>;
  image: Scalars['String'];
  title: Array<TextByLanguageInput>;
};


export type RootMutationAddArticleArgs = {
  articleNumber: Scalars['String'];
  availableStock: Scalars['Int'];
  contentsIds?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  currentStock: Scalars['Int'];
  description: Array<TextByLanguageInput>;
  expiresOn: Scalars['Float'];
  image: Scalars['String'];
  instructions?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  isDraft: Scalars['Boolean'];
  orderRestrictions?: InputMaybe<ArticleOrderRestrictionsInput>;
  price: Scalars['Int'];
  priority?: InputMaybe<Scalars['Int']>;
  publishOn: Scalars['Float'];
  roles: Array<Scalars['String']>;
  title: Array<TextByLanguageInput>;
  type: Scalars['String'];
  vouchers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RootMutationAddArticleVouchersArgs = {
  id: Scalars['String'];
  vouchers: Array<Scalars['String']>;
};


export type RootMutationAddChallengeArgs = {
  activityMultipliers?: InputMaybe<ChallengeActivityMultipliersInput>;
  activityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoParticipationEnabled?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Array<InputMaybe<Scalars['ChallengeConditionInput']>>>;
  conditionsInOrder?: InputMaybe<Scalars['Boolean']>;
  contentsIds?: InputMaybe<Array<Scalars['String']>>;
  data?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  difficultyLevel?: InputMaybe<Scalars['Int']>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<ChallengeDurationInput>;
  enabledLocales?: InputMaybe<Array<Scalars['String']>>;
  endless?: InputMaybe<ChallengeEndlessInput>;
  exceedConditionLimit?: InputMaybe<Scalars['Boolean']>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  hideProgressInDetails?: InputMaybe<Scalars['Boolean']>;
  hideProgressInInsights?: InputMaybe<Scalars['Boolean']>;
  hideProgressInList?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  milestones?: InputMaybe<Array<InputMaybe<ChallengeMilestoneInput>>>;
  participationProfileRequirements?: InputMaybe<Array<ChallengeProfileFieldsInput>>;
  payment?: InputMaybe<ChallengePaymentInput>;
  priority?: InputMaybe<Scalars['Int']>;
  publishedOn?: InputMaybe<Scalars['Float']>;
  registration?: InputMaybe<ChallengeRegistrationInput>;
  rewards?: InputMaybe<ChallengeRewardsInput>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  superDates?: InputMaybe<SuperDatesInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  team?: InputMaybe<ChallengeTeamConfigInput>;
  teamPropertyValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tieBreaker?: InputMaybe<ChallengeTieBreakerInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  totals?: InputMaybe<ChallengeTotalsInput>;
  ultimateSyncTime?: InputMaybe<Scalars['Float']>;
  viewCompletedParticipants?: InputMaybe<Scalars['Boolean']>;
  viewParticipantCount?: InputMaybe<Scalars['Boolean']>;
  viewParticipants?: InputMaybe<Scalars['Boolean']>;
  viewTeamCount?: InputMaybe<Scalars['Boolean']>;
  visualisations?: InputMaybe<Array<InputMaybe<Scalars['ChallengeVisualisationInput']>>>;
  visualizeType?: InputMaybe<Scalars['String']>;
  voucherConfiguration?: InputMaybe<ChallengeVoucherConfigurationInput>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationAddChallengeTagArgs = {
  color: Scalars['String'];
  description: Array<TextByLanguageInput>;
  image: Scalars['String'];
  title: Array<TextByLanguageInput>;
};


export type RootMutationAddChallengeTeamArgs = {
  captainUserId?: InputMaybe<Scalars['String']>;
  challengeId: Scalars['String'];
  contentId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<TextByLanguageInput>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  profileValue?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};


export type RootMutationAddCheckupLocationArgs = {
  cost: CheckupLocationCostInput;
  location: Scalars['String'];
  position: CheckupLocationPositionInput;
  title: Array<TextByLanguageInput>;
};


export type RootMutationAddCheckupLocationAvailabilityArgs = {
  checkupLocationId: Scalars['String'];
  coachId: Scalars['String'];
  coachType: Scalars['String'];
  cost: CheckupLocationAvailabilityCostInput;
  from: Scalars['Float'];
  to: Scalars['Float'];
};


export type RootMutationAddCompanyArgs = {
  avatar?: InputMaybe<Scalars['String']>;
  brandColor?: InputMaybe<Scalars['String']>;
  coach?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  connect?: InputMaybe<CompanyConnectInput>;
  hasSupport?: InputMaybe<Scalars['Boolean']>;
  introMessage?: InputMaybe<Array<TextByLanguageInput>>;
  introTitle?: InputMaybe<Array<TextByLanguageInput>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  limitRegistrations: Scalars['Boolean'];
  logo?: InputMaybe<Scalars['String']>;
  maxRegistrations: Scalars['Int'];
  name: Scalars['String'];
  profileRequirements?: InputMaybe<Array<ProfileFieldsInput>>;
  projectId: Scalars['String'];
  role: Scalars['String'];
  team?: InputMaybe<CompanyTeamInput>;
};


export type RootMutationAddContentArgs = {
  attachments: Array<Scalars['ContentAttachmentInput']>;
  content: Array<TextByLanguageInput>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  enabledLocales?: InputMaybe<Array<Scalars['String']>>;
  expiresOn: Scalars['Float'];
  featured?: InputMaybe<Scalars['Boolean']>;
  imageUrl: Scalars['String'];
  isAdvancedMode?: InputMaybe<Scalars['Boolean']>;
  isDraft: Scalars['Boolean'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  preview: Array<TextByLanguageInput>;
  publishOn: Scalars['Float'];
  relatedWith?: InputMaybe<Array<ContentRelatedObjectInput>>;
  roles: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  title: Array<TextByLanguageInput>;
  type: Scalars['String'];
  url: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type RootMutationAddContentTagArgs = {
  color: Scalars['String'];
  description: Array<TextByLanguageInput>;
  image: Scalars['String'];
  title: Array<TextByLanguageInput>;
};


export type RootMutationAddCreditConfigArgs = {
  creditConfig: CreditConfigInput;
  projectId: Scalars['String'];
};


export type RootMutationAddDashboardConfigurationArgs = {
  background?: InputMaybe<DashboardConfigWidgetBackgroundInput>;
  desktopWidths?: InputMaybe<Array<Scalars['Int']>>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  mobileWidths?: InputMaybe<Array<Scalars['Int']>>;
  place: Scalars['String'];
  publishOn?: InputMaybe<Scalars['Float']>;
  sequence?: InputMaybe<Scalars['Int']>;
  tabletWidths?: InputMaybe<Array<Scalars['Int']>>;
  widgets?: InputMaybe<Array<InputMaybe<Scalars['DashboardConfigWidgetInput']>>>;
};


export type RootMutationAddEventArgs = {
  activityTypes: Array<Scalars['String']>;
  chronoraceEventId?: InputMaybe<Scalars['Float']>;
  description: Array<TextByLanguageInput>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  displayTimezone?: InputMaybe<Scalars['String']>;
  enabledLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  end: Scalars['Float'];
  expiresOn: Scalars['Float'];
  groupId?: InputMaybe<Scalars['String']>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  image: Scalars['String'];
  organizator: Scalars['String'];
  projects: Array<EventProjectDetailsInput>;
  publishedOn: Scalars['Float'];
  registration: EventRegistrationInput;
  start: Scalars['Float'];
  subEvents: Array<SubEventInput>;
  title: Array<TextByLanguageInput>;
  url: Scalars['String'];
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationAddEventGroupArgs = {
  color?: InputMaybe<Scalars['String']>;
  dontAllowSubEventIntersection?: InputMaybe<Scalars['Boolean']>;
  eventIds?: InputMaybe<Array<Scalars['String']>>;
  name: Array<TextByLanguageInput>;
  projectId?: InputMaybe<Scalars['String']>;
  subscriptionsCount: Scalars['Int'];
};


export type RootMutationAddEventTagArgs = {
  color: Scalars['String'];
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  image?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  title: Array<TextByLanguageInput>;
};


export type RootMutationAddFormTemplateArgs = {
  elements: Array<FormElementInput>;
  errorMessages: Array<TextByLanguageInput>;
  projectId?: InputMaybe<Scalars['String']>;
  title: Array<TextByLanguageInput>;
  type: Scalars['String'];
};


export type RootMutationAddGalleryArgs = {
  description: Array<TextByLanguageInput>;
  expiresOn: Scalars['Float'];
  featured?: InputMaybe<Scalars['Boolean']>;
  isDraft: Scalars['Boolean'];
  preview: Array<TextByLanguageInput>;
  publishOn: Scalars['Float'];
  roles: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  title: Array<TextByLanguageInput>;
  type: Scalars['String'];
  typeId?: InputMaybe<Scalars['String']>;
};


export type RootMutationAddGalleryImageArgs = {
  description: Array<TextByLanguageInput>;
  embedUrl?: InputMaybe<Scalars['String']>;
  galleryId: Scalars['String'];
  reported?: InputMaybe<Scalars['Boolean']>;
  title: Array<TextByLanguageInput>;
  url?: InputMaybe<Scalars['String']>;
};


export type RootMutationAddGalleryTagArgs = {
  color: Scalars['String'];
  description: Array<TextByLanguageInput>;
  image: Scalars['String'];
  title: Array<TextByLanguageInput>;
};


export type RootMutationAddJourneyArgs = {
  journey: Scalars['JourneyCreateInput'];
};


export type RootMutationAddJourneyTagArgs = {
  color: Scalars['String'];
  description: Array<TextByLanguageInput>;
  image: Scalars['String'];
  title: Array<TextByLanguageInput>;
};


export type RootMutationAddMailConfigArgs = {
  mailConfig: MailConfigInput;
  projectId: Scalars['String'];
};


export type RootMutationAddMailTemplateArgs = {
  attachments: Array<Scalars['MailTemplateAttachmentInput']>;
  body: Array<TextByLanguageInput>;
  copy: MailTemplateCopyInput;
  optional: Scalars['Boolean'];
  preformattingData: Array<MailTemplatePreformattingInput>;
  subTemplates: Array<MailTemplateSubTemplateInput>;
  subject: Array<TextByLanguageInput>;
  type: Scalars['String'];
};


export type RootMutationAddReportingConfigArgs = {
  reportingConfig: ReportingConfigInput;
};


export type RootMutationAddRoleArgs = {
  applicationId: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};


export type RootMutationAddSocialFilterWordArgs = {
  word: Scalars['String'];
};


export type RootMutationAddSocialTagArgs = {
  tag: Scalars['String'];
};


export type RootMutationAddTranslationArgs = {
  key: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  translations: Array<TextByLanguageInput>;
};


export type RootMutationAddUserArgs = {
  applications?: InputMaybe<Array<InputMaybe<UserApplicationInput>>>;
  avatar?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<Array<InputMaybe<Scalars['UserNotificationInput']>>>;
  policies?: InputMaybe<Array<UserPolicyInput>>;
  privacy?: InputMaybe<UserPrivacyInput>;
  profile?: InputMaybe<Scalars['JSON']>;
  projectId: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
};


export type RootMutationAddUserProfileRoleConfigArgs = {
  enabled: Scalars['Boolean'];
  field: Scalars['String'];
  projectId: Scalars['String'];
  removeRoles: Scalars['Boolean'];
  roleMapping: Array<UserProfileRoleConfigMappingInput>;
};


export type RootMutationAddUserWhiteListArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  group: Scalars['String'];
  projectId: Scalars['String'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  whitelist: Array<Scalars['String']>;
};


export type RootMutationAddVoucherArgs = {
  assignments: Array<VoucherAssignmentInput>;
  code: Scalars['String'];
  discount?: InputMaybe<VoucherDiscountInput>;
  enableVoucherPeriod: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  enabledMaxUsage: Scalars['Boolean'];
  enabledMaxUsagePerUser: Scalars['Boolean'];
  enabledOn: Array<VoucherEnabledOnInput>;
  maxUsage: Scalars['Int'];
  maxUsagePerUser: Scalars['Int'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  voucherEnd?: InputMaybe<Scalars['Float']>;
  voucherStart?: InputMaybe<Scalars['Float']>;
};


export type RootMutationBanFromChallengeTeamArgs = {
  teamId: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationChangeVisibleInstagramFeedArgs = {
  id: Scalars['String'];
  visible: Scalars['Boolean'];
};


export type RootMutationChangeVisibleTwitterFeedArgs = {
  id: Scalars['String'];
  visible: Scalars['Boolean'];
};


export type RootMutationConsumeConfirmCodeArgs = {
  confirmCode: Scalars['String'];
  confirmCodeChallengeId: Scalars['String'];
};


export type RootMutationCopyEventArgs = {
  dates: Array<Scalars['Float']>;
  id: Scalars['String'];
};


export type RootMutationCreateFlowArgs = {
  flowInput: FlowInput;
};


export type RootMutationCreatePaymentConfigArgs = {
  paymentConfig: Scalars['PaymentConfigInput'];
};


export type RootMutationCreateProjectArgs = {
  contactEmail: Array<ProjectContactEmailInput>;
  defaultLocale: Scalars['String'];
  identities: Array<Scalars['String']>;
  jwtValidDuration: Scalars['String'];
  mailHeader: ProjectMailHeaderInput;
  name: Scalars['String'];
  password: ProjectPasswordRequirementInput;
  private: Scalars['Boolean'];
  requireEmailValidation: Scalars['Boolean'];
  useWhiteListing: Scalars['Boolean'];
};


export type RootMutationCreateProjectConfigArgs = {
  data: Scalars['JSON'];
  place: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
};


export type RootMutationCreateUserCreditTransactionArgs = {
  amount: Scalars['Float'];
  type: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationDeleteFlowArgs = {
  flowId: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
};


export type RootMutationDeletePaymentConfigArgs = {
  id: Scalars['String'];
};


export type RootMutationExportChallengeParticipationArgs = {
  filter?: InputMaybe<ChallengeParticipantFilter>;
  format?: InputMaybe<Scalars['String']>;
};


export type RootMutationExportChallengeParticipationFormConditionDataArgs = {
  filter?: InputMaybe<ChallengeParticipantFormConditionDataFilter>;
  format?: InputMaybe<Scalars['String']>;
};


export type RootMutationExportEventParticipationArgs = {
  filter?: InputMaybe<EventParticipantFilter>;
  format?: InputMaybe<Scalars['String']>;
};


export type RootMutationExportJourneyParticipationArgs = {
  filter?: InputMaybe<JourneyParticipationFilter>;
  format?: InputMaybe<Scalars['String']>;
};


export type RootMutationExportUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  format: Scalars['String'];
};


export type RootMutationExportVoucherArgs = {
  filter?: InputMaybe<VoucherFilter>;
  format?: InputMaybe<Scalars['String']>;
};


export type RootMutationImpersonateUserArgs = {
  applicationId: Scalars['String'];
  projectId: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type RootMutationRegenerateConfirmCodeArgs = {
  confirmCodeChallengeId: Scalars['String'];
};


export type RootMutationRegisterUserArgs = {
  applicationUrl: Scalars['String'];
  companyCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  friendReferralCode?: InputMaybe<Scalars['String']>;
  inviteCode?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  profile?: InputMaybe<UserUpdateInput>;
  voucherCode?: InputMaybe<Scalars['String']>;
};


export type RootMutationRemoveAmbassadorArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveAmbassadorConfigArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveAmbassadorTagArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveArticleArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveArticleVouchersArgs = {
  deleteAllVouchers?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  vouchers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RootMutationRemoveChallengeArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveChallengeParticipationArgs = {
  challengeId: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationRemoveChallengeTagArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveChallengeTeamArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveCheckupLocationArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveCheckupLocationAvailabilityArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveCheckupParticipationArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveCommentArgs = {
  id: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationRemoveCompanyArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveContentArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveContentTagArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveCreditConfigArgs = {
  projectId: Scalars['String'];
};


export type RootMutationRemoveDashboardConfigurationArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveEventArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveEventGroupArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveEventParticipationArgs = {
  eventId: Scalars['String'];
  subEventId: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationRemoveEventTagArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveFormTemplateArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveFromChallengeTeamArgs = {
  teamId: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationRemoveGalleryArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveGalleryImageArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveGalleryTagArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveJourneyArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveJourneyParticipationArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveJourneyTagArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveLikeArgs = {
  type: Scalars['String'];
  typeId: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationRemoveMailConfigArgs = {
  projectId: Scalars['String'];
};


export type RootMutationRemoveMailTemplateArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveProjectConfigArgs = {
  configId: Scalars['String'];
};


export type RootMutationRemoveProviderActivityArgs = {
  id: Scalars['String'];
  segmentId: Scalars['String'];
};


export type RootMutationRemoveReportingConfigArgs = {
  id: Scalars['String'];
};


export type RootMutationRemoveRoleArgs = {
  applicationId: Scalars['String'];
  projectId: Scalars['String'];
  roleId: Scalars['String'];
};


export type RootMutationRemoveSocialFilterWordArgs = {
  word: Scalars['String'];
};


export type RootMutationRemoveSocialTagArgs = {
  tag: Scalars['String'];
};


export type RootMutationRemoveTranslationArgs = {
  id: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
};


export type RootMutationRemoveUserArgs = {
  anonymize: Scalars['Boolean'];
  id: Scalars['String'];
};


export type RootMutationRemoveUserProfileRoleConfigArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type RootMutationRemoveUserWhiteListArgs = {
  group: Scalars['String'];
  projectId: Scalars['String'];
};


export type RootMutationRemoveUsersArgs = {
  anonymize: Scalars['Boolean'];
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RootMutationRemoveVoucherArgs = {
  id: Scalars['String'];
};


export type RootMutationRequestResetPasswordArgs = {
  email: Scalars['String'];
  projectId: Scalars['String'];
};


export type RootMutationRequestValidateEmailArgs = {
  email: Scalars['String'];
};


export type RootMutationResyncChallengeArgs = {
  id: Scalars['String'];
};


export type RootMutationResyncProviderArgs = {
  from?: InputMaybe<Scalars['Float']>;
  provider?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['Float']>;
  userId: Scalars['String'];
};


export type RootMutationSendChallengeMilestoneEmailArgs = {
  challengeId: Scalars['String'];
  milestoneId: Scalars['String'];
};


export type RootMutationUnlinkProviderArgs = {
  provider: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationUpdateAmbassadorArgs = {
  activityTypes?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  place: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  userId?: InputMaybe<Scalars['String']>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationUpdateAmbassadorConfigArgs = {
  ambassadorIntro?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  caption?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  heroImage?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  image?: InputMaybe<AmbassadorConfigImageInput>;
  intro?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  place?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  sequence?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  visibility?: InputMaybe<AmbassadorConfigVisibilityInput>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationUpdateAmbassadorTagArgs = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};


export type RootMutationUpdateArticleArgs = {
  articleNumber?: InputMaybe<Scalars['String']>;
  availableStock?: InputMaybe<Scalars['Int']>;
  contentsIds?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  currentStock?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  instructions?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  orderRestrictions?: InputMaybe<ArticleOrderRestrictionsInput>;
  price?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
  publishOn?: InputMaybe<Scalars['Float']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type?: InputMaybe<Scalars['String']>;
  vouchers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RootMutationUpdateChallengeArgs = {
  activityMultipliers?: InputMaybe<ChallengeActivityMultipliersInput>;
  activityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoParticipationEnabled?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Array<InputMaybe<Scalars['ChallengeConditionInput']>>>;
  conditionsInOrder?: InputMaybe<Scalars['Boolean']>;
  contentsIds?: InputMaybe<Array<Scalars['String']>>;
  data?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  difficultyLevel?: InputMaybe<Scalars['Int']>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<ChallengeDurationInput>;
  enabledLocales?: InputMaybe<Array<Scalars['String']>>;
  endless?: InputMaybe<ChallengeEndlessInput>;
  exceedConditionLimit?: InputMaybe<Scalars['Boolean']>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  hideProgressInDetails?: InputMaybe<Scalars['Boolean']>;
  hideProgressInInsights?: InputMaybe<Scalars['Boolean']>;
  hideProgressInList?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  milestones?: InputMaybe<Array<InputMaybe<ChallengeMilestoneInput>>>;
  participationProfileRequirements?: InputMaybe<Array<ChallengeProfileFieldsInput>>;
  payment?: InputMaybe<ChallengePaymentInput>;
  priority?: InputMaybe<Scalars['Int']>;
  publishedOn?: InputMaybe<Scalars['Float']>;
  registration?: InputMaybe<ChallengeRegistrationInput>;
  rewards?: InputMaybe<ChallengeRewardsInput>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  superDates?: InputMaybe<SuperDatesInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  team?: InputMaybe<ChallengeTeamConfigInput>;
  tieBreaker?: InputMaybe<ChallengeTieBreakerInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  totals?: InputMaybe<ChallengeTotalsInput>;
  ultimateSyncTime?: InputMaybe<Scalars['Float']>;
  viewCompletedParticipants?: InputMaybe<Scalars['Boolean']>;
  viewParticipantCount?: InputMaybe<Scalars['Boolean']>;
  viewParticipants?: InputMaybe<Scalars['Boolean']>;
  viewTeamCount?: InputMaybe<Scalars['Boolean']>;
  visualisations?: InputMaybe<Array<InputMaybe<Scalars['ChallengeVisualisationInput']>>>;
  visualizeType?: InputMaybe<Scalars['String']>;
  voucherConfiguration?: InputMaybe<ChallengeVoucherConfigurationInput>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationUpdateChallengeTagArgs = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};


export type RootMutationUpdateChallengeTeamArgs = {
  captainUserId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<TextByLanguageInput>>;
  id: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  profileValue?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type RootMutationUpdateCheckupLocationArgs = {
  cost?: InputMaybe<CheckupLocationCostInput>;
  id: Scalars['String'];
  location?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<CheckupLocationPositionInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};


export type RootMutationUpdateCheckupLocationAvailabilityArgs = {
  checkupLocationId?: InputMaybe<Scalars['String']>;
  coachId?: InputMaybe<Scalars['String']>;
  coachType?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<CheckupLocationAvailabilityCostInput>;
  from?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  to?: InputMaybe<Scalars['Float']>;
};


export type RootMutationUpdateCheckupParticipationArgs = {
  checkupResultPdf?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type RootMutationUpdateCommentArgs = {
  id: Scalars['String'];
  moderated?: InputMaybe<Scalars['Boolean']>;
  reported?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationUpdateCompanyArgs = {
  avatar?: InputMaybe<Scalars['String']>;
  brandColor?: InputMaybe<Scalars['String']>;
  coach?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  connect?: InputMaybe<CompanyConnectInput>;
  hasSupport?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  introMessage?: InputMaybe<Array<TextByLanguageInput>>;
  introTitle?: InputMaybe<Array<TextByLanguageInput>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  limitRegistrations?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  maxRegistrations?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  profileRequirements?: InputMaybe<Array<ProfileFieldsInput>>;
  projectId: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<CompanyTeamInput>;
};


export type RootMutationUpdateContentArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ContentAttachmentInput']>>>;
  content?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  enabledLocales?: InputMaybe<Array<Scalars['String']>>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  isAdvancedMode?: InputMaybe<Scalars['Boolean']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  preview?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  publishOn?: InputMaybe<Scalars['Float']>;
  relatedWith?: InputMaybe<Array<ContentRelatedObjectInput>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type RootMutationUpdateContentTagArgs = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};


export type RootMutationUpdateCreditConfigArgs = {
  creditConfig: CreditConfigInput;
  projectId: Scalars['String'];
};


export type RootMutationUpdateDashboardConfigurationArgs = {
  background?: InputMaybe<DashboardConfigWidgetBackgroundInput>;
  desktopWidths?: InputMaybe<Array<Scalars['Int']>>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  mobileWidths?: InputMaybe<Array<Scalars['Int']>>;
  place?: InputMaybe<Scalars['String']>;
  publishOn?: InputMaybe<Scalars['Float']>;
  sequence?: InputMaybe<Scalars['Int']>;
  tabletWidths?: InputMaybe<Array<Scalars['Int']>>;
  widgets?: InputMaybe<Array<InputMaybe<Scalars['DashboardConfigWidgetInput']>>>;
};


export type RootMutationUpdateEventArgs = {
  activityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  chronoraceEventId?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  displayTimezone?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Float']>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  groupId?: InputMaybe<Scalars['String']>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  organizator?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<InputMaybe<EventProjectDetailsInput>>>;
  publishedOn?: InputMaybe<Scalars['Float']>;
  registration?: InputMaybe<EventRegistrationInput>;
  start?: InputMaybe<Scalars['Float']>;
  subEvents?: InputMaybe<Array<InputMaybe<SubEventInput>>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  url?: InputMaybe<Scalars['String']>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationUpdateEventApprovalArgs = {
  approved: Scalars['Boolean'];
  eventId: Scalars['String'];
  subEventId: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationUpdateEventGroupArgs = {
  color?: InputMaybe<Scalars['String']>;
  dontAllowSubEventIntersection?: InputMaybe<Scalars['Boolean']>;
  eventIds?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name: Array<TextByLanguageInput>;
  projectId?: InputMaybe<Scalars['String']>;
  subscriptionsCount: Scalars['Int'];
};


export type RootMutationUpdateEventParticipantRegistrationFormCompletionStatusArgs = {
  eventId: Scalars['String'];
  registrationCompleted: Scalars['Boolean'];
  subEventId: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationUpdateEventTagArgs = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};


export type RootMutationUpdateFlowArgs = {
  flowId: Scalars['String'];
  flowInput: FlowInput;
};


export type RootMutationUpdateFormTemplateArgs = {
  elements?: InputMaybe<Array<InputMaybe<FormElementInput>>>;
  errorMessages?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type: Scalars['String'];
};


export type RootMutationUpdateGalleryArgs = {
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isDraft?: InputMaybe<Scalars['Boolean']>;
  preview?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  publishOn?: InputMaybe<Scalars['Float']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  type?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['String']>;
};


export type RootMutationUpdateGalleryImageArgs = {
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  embedUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  reported?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  url?: InputMaybe<Scalars['String']>;
};


export type RootMutationUpdateGalleryTagArgs = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};


export type RootMutationUpdateJourneyArgs = {
  id: Scalars['String'];
  journey: Scalars['JourneyUpdateInput'];
};


export type RootMutationUpdateJourneyParticipationArgs = {
  id: Scalars['String'];
  noShow?: InputMaybe<JourneyParticipationNoShowInput>;
  trainingPlanPdf?: InputMaybe<Scalars['String']>;
  trainingPlanPdfs?: InputMaybe<Array<InputMaybe<JourneyParticipationTrainingPdfInput>>>;
};


export type RootMutationUpdateJourneyTagArgs = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};


export type RootMutationUpdateMailConfigArgs = {
  mailConfig: MailConfigInput;
  projectId: Scalars['String'];
};


export type RootMutationUpdateMailTemplateArgs = {
  attachments?: InputMaybe<Array<Scalars['MailTemplateAttachmentInput']>>;
  body?: InputMaybe<Array<TextByLanguageInput>>;
  copy?: InputMaybe<MailTemplateCopyInput>;
  id: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  preformattingData?: InputMaybe<Array<MailTemplatePreformattingInput>>;
  subTemplates?: InputMaybe<Array<MailTemplateSubTemplateInput>>;
  subject?: InputMaybe<Array<TextByLanguageInput>>;
  type?: InputMaybe<Scalars['String']>;
};


export type RootMutationUpdatePasswordUserArgs = {
  emailValidated: Scalars['Boolean'];
  projectId: Scalars['String'];
  userId: Scalars['String'];
};


export type RootMutationUpdatePaymentArgs = {
  id: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};


export type RootMutationUpdatePaymentConfigArgs = {
  id: Scalars['String'];
  paymentConfig: Scalars['PaymentConfigInput'];
};


export type RootMutationUpdateProjectArgs = {
  contactEmail?: InputMaybe<Array<ProjectContactEmailInput>>;
  defaultLocale?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  identities?: InputMaybe<Array<Scalars['String']>>;
  jwtValidDuration?: InputMaybe<Scalars['String']>;
  mailHeader?: InputMaybe<ProjectMailHeaderInput>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<ProjectPasswordRequirementInput>;
  private?: InputMaybe<Scalars['Boolean']>;
  requireEmailValidation?: InputMaybe<Scalars['Boolean']>;
  useWhiteListing?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationUpdateProjectConfigArgs = {
  configId?: InputMaybe<Scalars['String']>;
  data: Scalars['JSON'];
};


export type RootMutationUpdateReportingConfigArgs = {
  id: Scalars['String'];
  reportingConfig: ReportingConfigInput;
};


export type RootMutationUpdateRoleArgs = {
  applicationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type RootMutationUpdateSocialFilterWordArgs = {
  newWord: Scalars['String'];
  oldWord: Scalars['String'];
};


export type RootMutationUpdateSocialTagArgs = {
  newTag: Scalars['String'];
  oldTag: Scalars['String'];
};


export type RootMutationUpdateTranslationArgs = {
  id: Scalars['String'];
  key?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};


export type RootMutationUpdateUserArgs = {
  applications?: InputMaybe<Array<InputMaybe<UserApplicationInput>>>;
  avatar?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<Array<InputMaybe<Scalars['UserNotificationInput']>>>;
  policies?: InputMaybe<Array<UserPolicyInput>>;
  privacy?: InputMaybe<UserPrivacyInput>;
  profile?: InputMaybe<Scalars['JSON']>;
  projectId: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
};


export type RootMutationUpdateUserProfileRoleConfigArgs = {
  enabled: Scalars['Boolean'];
  field: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  removeRoles: Scalars['Boolean'];
  roleMapping: Array<UserProfileRoleConfigMappingInput>;
};


export type RootMutationUpdateUserWhiteListArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  group: Scalars['String'];
  projectId: Scalars['String'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  whitelist: Array<Scalars['String']>;
};


export type RootMutationUpdateVoucherArgs = {
  assignments?: InputMaybe<Array<InputMaybe<VoucherAssignmentInput>>>;
  code?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<VoucherDiscountInput>;
  enableVoucherPeriod?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  enabledMaxUsage?: InputMaybe<Scalars['Boolean']>;
  enabledMaxUsagePerUser?: InputMaybe<Scalars['Boolean']>;
  enabledOn?: InputMaybe<Array<InputMaybe<VoucherEnabledOnInput>>>;
  id: Scalars['String'];
  maxUsage?: InputMaybe<Scalars['Int']>;
  maxUsagePerUser?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  voucherEnd?: InputMaybe<Scalars['Float']>;
  voucherStart?: InputMaybe<Scalars['Float']>;
};


export type RootMutationValidateEmailArgs = {
  userId: Scalars['String'];
};

export type RootQuery = {
  __typename?: 'RootQuery';
  ambassadorConfigCount: Scalars['Int'];
  ambassadorConfigs: Array<AmbassadorConfig>;
  ambassadorCount: Scalars['Int'];
  ambassadorTagCount: Scalars['Int'];
  ambassadorTags: Array<AmbassadorTag>;
  ambassadors: Array<Ambassador>;
  applications: Array<Application>;
  articleCount: Scalars['Int'];
  articleOrderCount: Scalars['Int'];
  articleOrders: Array<ArticleOrder>;
  articles: Array<Article>;
  challengeCount: Scalars['Int'];
  challengeParticipantCount: Scalars['Int'];
  challengeParticipants: Array<ChallengeParticipant>;
  challengeTagCount: Scalars['Int'];
  challengeTags: Array<ChallengeTag>;
  challengeTeamCount: Scalars['Int'];
  challengeTeams: Array<ChallengeTeam>;
  challenges: Array<Challenge>;
  checkupLocationAvailabilities: Array<CheckupLocationAvailability>;
  checkupLocationAvailabilityCount: Scalars['Int'];
  checkupLocationCount: Scalars['Int'];
  checkupLocations: Array<CheckupLocation>;
  checkupParticipationCount: Scalars['Int'];
  checkupParticipations: Array<CheckupParticipation>;
  chronoRaceEvents: Array<ChronoRaceEvent>;
  commentCount: Scalars['Int'];
  comments: Array<Comment>;
  companies: Array<Maybe<Company>>;
  companyCount: Scalars['Int'];
  contentCount: Scalars['Int'];
  contentTagCount: Scalars['Int'];
  contentTags: Array<ContentTag>;
  contents: Array<Content>;
  creditConfigCount: Scalars['Int'];
  creditConfigs: Array<CreditConfig>;
  dashboardConfigurationCount: Scalars['Int'];
  dashboardConfigurations: Array<DashboardConfig>;
  eventCount: Scalars['Int'];
  eventGroupCount: Scalars['Int'];
  eventGroups: Array<EventGroup>;
  eventHistories: Array<EventHistory>;
  eventHistoryCount: Scalars['Int'];
  eventParticipantCount: Scalars['Int'];
  eventParticipants: Array<EventParticipant>;
  eventTags: Array<EventTag>;
  events: Array<Event>;
  flows: Array<Flow>;
  flowsCount: Scalars['Int'];
  formTemplates: Array<Maybe<FormTemplate>>;
  galleries: Array<Gallery>;
  galleryCount: Scalars['Int'];
  galleryTagCount: Scalars['Int'];
  galleryTags: Array<GalleryTag>;
  health: Success;
  instagramFeed: Array<InstagramFeed>;
  instagramFeedCount: Scalars['Int'];
  journeyCount: Scalars['Int'];
  journeyParticipationCount: Scalars['Int'];
  journeyParticipations: Array<JourneyParticipation>;
  journeyTagCount: Scalars['Int'];
  journeyTags: Array<JourneyTag>;
  journeys: Array<Journey>;
  likeCount: Scalars['Int'];
  likes: Array<Like>;
  mailConfigs: Array<MailConfig>;
  mailTemplates: Array<MailTemplate>;
  mailTemplatesCount: Scalars['Int'];
  paymentConfigCount: Scalars['Int'];
  paymentConfigs: Array<PaymentConfig>;
  paymentCount: Scalars['Int'];
  payments: Array<Payment>;
  profile: User;
  projectConfig: ProjectConfig;
  projectConfigHistory: Array<ProjectConfigHistory>;
  projectConfigs: Array<ProjectConfig>;
  projects: Array<Project>;
  providerActivities: Array<ProviderActivity>;
  reportingConfigCount: Scalars['Int'];
  reportingConfigs: Array<ReportingConfig>;
  session: Session;
  socialFilterWords: Array<SocialFilterWord>;
  socialTags: Array<SocialTag>;
  translationCount: Scalars['Int'];
  translations: Array<Translation>;
  twitterFeed: Array<TwitterFeed>;
  twitterFeedCount: Scalars['Int'];
  userActivities: Array<UserActivity>;
  userCount: Scalars['Int'];
  userFriendAcceptedInvites: Array<UserFriendAcceptedInvite>;
  userFriendInvites: Array<UserFriendInvite>;
  userFriendReferrals: Array<UserFriendReferral>;
  userProfileRoleConfigCount: Scalars['Int'];
  userProfileRoleConfigs: Array<UserProfileRoleConfig>;
  userWhiteLists: Array<UserWhiteList>;
  users: Array<User>;
  voucherCount: Scalars['Int'];
  voucherUsageCount: Scalars['Int'];
  voucherUsages: Array<VoucherUsage>;
  vouchers: Array<Voucher>;
};


export type RootQueryAmbassadorConfigCountArgs = {
  filter?: InputMaybe<AmbassadorConfigFilter>;
};


export type RootQueryAmbassadorConfigsArgs = {
  filter?: InputMaybe<AmbassadorConfigFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryAmbassadorCountArgs = {
  filter?: InputMaybe<AmbassadorFilter>;
};


export type RootQueryAmbassadorsArgs = {
  filter?: InputMaybe<AmbassadorFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryArticleCountArgs = {
  filter?: InputMaybe<ArticleFilter>;
};


export type RootQueryArticleOrderCountArgs = {
  filter?: InputMaybe<ArticleOrderFilter>;
};


export type RootQueryArticleOrdersArgs = {
  filter?: InputMaybe<ArticleOrderFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryArticlesArgs = {
  filter?: InputMaybe<ArticleFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryChallengeCountArgs = {
  filter?: InputMaybe<ChallengeFilter>;
};


export type RootQueryChallengeParticipantCountArgs = {
  filter: ChallengeParticipantFilter;
};


export type RootQueryChallengeParticipantsArgs = {
  filter: ChallengeParticipantFilter;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryChallengeTeamCountArgs = {
  filter?: InputMaybe<ChallengeTeamFilter>;
};


export type RootQueryChallengeTeamsArgs = {
  filter?: InputMaybe<ChallengeTeamFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryChallengesArgs = {
  filter?: InputMaybe<ChallengeFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryCheckupLocationAvailabilitiesArgs = {
  filter?: InputMaybe<CheckupLocationAvailabilityFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryCheckupLocationAvailabilityCountArgs = {
  filter?: InputMaybe<CheckupLocationAvailabilityFilter>;
};


export type RootQueryCheckupLocationCountArgs = {
  filter?: InputMaybe<CheckupLocationFilter>;
};


export type RootQueryCheckupLocationsArgs = {
  filter?: InputMaybe<CheckupLocationFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryCheckupParticipationCountArgs = {
  filter?: InputMaybe<CheckupParticipationFilter>;
};


export type RootQueryCheckupParticipationsArgs = {
  filter?: InputMaybe<CheckupParticipationFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryChronoRaceEventsArgs = {
  filter?: InputMaybe<ChronoRaceEventFilter>;
};


export type RootQueryCommentCountArgs = {
  filter?: InputMaybe<CommentFilter>;
};


export type RootQueryCommentsArgs = {
  filter?: InputMaybe<CommentFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryCompaniesArgs = {
  filter?: InputMaybe<CompanyFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryCompanyCountArgs = {
  filter?: InputMaybe<CompanyFilter>;
};


export type RootQueryContentCountArgs = {
  filter?: InputMaybe<ContentFilter>;
};


export type RootQueryContentsArgs = {
  filter?: InputMaybe<ContentFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryDashboardConfigurationCountArgs = {
  filter?: InputMaybe<DashboardConfigFilter>;
};


export type RootQueryDashboardConfigurationsArgs = {
  filter?: InputMaybe<DashboardConfigFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryEventCountArgs = {
  filter?: InputMaybe<EventFilter>;
};


export type RootQueryEventGroupCountArgs = {
  filter?: InputMaybe<EventGroupFilter>;
};


export type RootQueryEventGroupsArgs = {
  filter?: InputMaybe<EventGroupFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryEventHistoriesArgs = {
  filter: EventHistoryFilter;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryEventHistoryCountArgs = {
  filter: EventHistoryFilter;
};


export type RootQueryEventParticipantCountArgs = {
  filter: EventParticipantFilter;
};


export type RootQueryEventParticipantsArgs = {
  filter: EventParticipantFilter;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryEventsArgs = {
  filter?: InputMaybe<EventFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryFlowsArgs = {
  filter?: InputMaybe<FlowsFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryFlowsCountArgs = {
  filter?: InputMaybe<FlowsFilter>;
};


export type RootQueryFormTemplatesArgs = {
  filter: FormTemplateFilter;
};


export type RootQueryGalleriesArgs = {
  filter?: InputMaybe<GalleryFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryGalleryCountArgs = {
  filter?: InputMaybe<GalleryFilter>;
};


export type RootQueryGalleryTagCountArgs = {
  filter?: InputMaybe<GalleryTagFilter>;
};


export type RootQueryGalleryTagsArgs = {
  filter?: InputMaybe<GalleryTagFilter>;
};


export type RootQueryInstagramFeedArgs = {
  filter?: InputMaybe<InstagramFeedFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryInstagramFeedCountArgs = {
  filter?: InputMaybe<InstagramFeedFilter>;
};


export type RootQueryJourneyCountArgs = {
  filter?: InputMaybe<JourneyFilter>;
};


export type RootQueryJourneyParticipationCountArgs = {
  filter?: InputMaybe<JourneyParticipationFilter>;
};


export type RootQueryJourneyParticipationsArgs = {
  filter?: InputMaybe<JourneyParticipationFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryJourneyTagCountArgs = {
  filter?: InputMaybe<JourneyTagFilter>;
};


export type RootQueryJourneyTagsArgs = {
  filter?: InputMaybe<JourneyTagFilter>;
};


export type RootQueryJourneysArgs = {
  filter?: InputMaybe<JourneyFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryLikeCountArgs = {
  filter?: InputMaybe<LikeFilter>;
};


export type RootQueryLikesArgs = {
  filter?: InputMaybe<LikeFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryMailTemplatesArgs = {
  filter?: InputMaybe<MailTemplateFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryMailTemplatesCountArgs = {
  filter?: InputMaybe<MailTemplateFilter>;
};


export type RootQueryPaymentConfigCountArgs = {
  filter?: InputMaybe<PaymentConfigFilter>;
};


export type RootQueryPaymentConfigsArgs = {
  filter?: InputMaybe<PaymentConfigFilter>;
};


export type RootQueryPaymentCountArgs = {
  filter?: InputMaybe<PaymentFilter>;
};


export type RootQueryPaymentsArgs = {
  filter?: InputMaybe<PaymentFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryProjectConfigArgs = {
  configId?: InputMaybe<Scalars['String']>;
};


export type RootQueryProjectConfigHistoryArgs = {
  configId: Scalars['String'];
  paging?: InputMaybe<Paging>;
};


export type RootQueryProjectConfigsArgs = {
  configIds?: InputMaybe<Array<Scalars['String']>>;
  paging?: InputMaybe<Paging>;
  places?: InputMaybe<Array<Scalars['String']>>;
  projectId?: InputMaybe<Scalars['String']>;
};


export type RootQueryProviderActivitiesArgs = {
  date: Scalars['Float'];
  userId: Scalars['String'];
};


export type RootQueryReportingConfigCountArgs = {
  filter?: InputMaybe<ReportingConfigFilter>;
};


export type RootQueryReportingConfigsArgs = {
  filter?: InputMaybe<ReportingConfigFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryTranslationCountArgs = {
  filter?: InputMaybe<TranslationFilter>;
};


export type RootQueryTranslationsArgs = {
  filter?: InputMaybe<TranslationFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryTwitterFeedArgs = {
  filter?: InputMaybe<TwitterFeedFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryTwitterFeedCountArgs = {
  filter?: InputMaybe<TwitterFeedFilter>;
};


export type RootQueryUserActivitiesArgs = {
  filter: UserActivitiesFilter;
};


export type RootQueryUserCountArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type RootQueryUserFriendAcceptedInvitesArgs = {
  filter?: InputMaybe<UserFriendAcceptedInvitesFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryUserFriendInvitesArgs = {
  filter?: InputMaybe<UserFriendInvitesFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryUserFriendReferralsArgs = {
  filter?: InputMaybe<UserFriendReferralsFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryUserProfileRoleConfigCountArgs = {
  filter?: InputMaybe<UserProfileRoleConfigFilter>;
};


export type RootQueryUserProfileRoleConfigsArgs = {
  filter?: InputMaybe<UserProfileRoleConfigFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryUserWhiteListsArgs = {
  filter?: InputMaybe<UserWhiteListFilter>;
};


export type RootQueryUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryVoucherCountArgs = {
  filter?: InputMaybe<VoucherFilter>;
};


export type RootQueryVoucherUsageCountArgs = {
  filter?: InputMaybe<VoucherUsageFilter>;
};


export type RootQueryVoucherUsagesArgs = {
  filter?: InputMaybe<VoucherUsageFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};


export type RootQueryVouchersArgs = {
  filter?: InputMaybe<VoucherFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
};

export type Session = {
  __typename?: 'Session';
  expiresOn: Scalars['Float'];
  projectId: Scalars['String'];
  roles: Array<Scalars['String']>;
  userId: Scalars['String'];
};

export type SocialFilterWord = {
  __typename?: 'SocialFilterWord';
  word?: Maybe<Scalars['String']>;
};

export type SocialTag = {
  __typename?: 'SocialTag';
  tag?: Maybe<Scalars['String']>;
};

export type Sort = {
  field?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
};

export type SubComment = {
  __typename?: 'SubComment';
  comment: Scalars['String'];
  createdAt: Scalars['Float'];
  deleted: Scalars['Boolean'];
  id: Scalars['String'];
  moderated: Scalars['Boolean'];
  parentId?: Maybe<Scalars['String']>;
  reported: Scalars['Boolean'];
  type: Scalars['String'];
  typeId: Scalars['String'];
  user?: Maybe<User>;
  userId: Scalars['String'];
};

export type SubEvent = {
  __typename?: 'SubEvent';
  chronoraceSubEventId?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type SubEventInput = {
  chronoraceSubEventId?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['Float']>;
  endDate?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type SubEventProjectDetails = {
  __typename?: 'SubEventProjectDetails';
  id?: Maybe<Scalars['String']>;
  maxParticipants?: Maybe<Scalars['Int']>;
  maxParticipantsDisabled?: Maybe<Scalars['Boolean']>;
  participantOffset?: Maybe<Scalars['Int']>;
  participants?: Maybe<Scalars['Int']>;
  participantsOnWaitingList?: Maybe<Scalars['Int']>;
  participationFull?: Maybe<Scalars['Boolean']>;
  subscriptionEnabled?: Maybe<Scalars['Boolean']>;
};

export type SubEventProjectDetailsInput = {
  id?: InputMaybe<Scalars['String']>;
  maxParticipants?: InputMaybe<Scalars['Int']>;
  maxParticipantsDisabled?: InputMaybe<Scalars['Boolean']>;
  participantOffset?: InputMaybe<Scalars['Int']>;
  participationFull?: InputMaybe<Scalars['Boolean']>;
  subscriptionEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type Success = {
  __typename?: 'Success';
  success: Scalars['Boolean'];
};

export type SuperDates = {
  __typename?: 'SuperDates';
  dates?: Maybe<Array<SuperDatesRange>>;
  description?: Maybe<Array<Maybe<TextByLanguage>>>;
  multiplier?: Maybe<Scalars['Float']>;
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
};

export type SuperDatesInput = {
  dates?: InputMaybe<Array<SuperDatesRangeInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
  multiplier?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>>>;
};

export type SuperDatesRange = {
  __typename?: 'SuperDatesRange';
  from: Scalars['Float'];
  multiplier?: Maybe<Scalars['Float']>;
  to: Scalars['Float'];
};

export type SuperDatesRangeInput = {
  from: Scalars['Float'];
  multiplier?: InputMaybe<Scalars['Float']>;
  to: Scalars['Float'];
};

export type TextByLanguage = {
  __typename?: 'TextByLanguage';
  language?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type TextByLanguageInput = {
  language?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Translation = {
  __typename?: 'Translation';
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  key: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  translations: Array<Maybe<TextByLanguage>>;
};

export type TranslationFilter = {
  default?: InputMaybe<Scalars['Boolean']>;
  includeDefault?: InputMaybe<Scalars['Boolean']>;
  keyPart?: InputMaybe<Scalars['String']>;
  keyValueSearch?: InputMaybe<TranslationKeyValueSearch>;
  keys?: InputMaybe<Array<Scalars['String']>>;
  projectId?: InputMaybe<Scalars['String']>;
};

export type TranslationKeyValueSearch = {
  language?: InputMaybe<Scalars['String']>;
  search: Scalars['String'];
};

export type TwitterFeed = {
  __typename?: 'TwitterFeed';
  date?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  sourceUrl?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  text?: Maybe<Scalars['String']>;
  user?: Maybe<TwitterUser>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type TwitterFeedFilter = {
  search?: InputMaybe<Scalars['String']>;
};

export type TwitterUser = {
  __typename?: 'TwitterUser';
  avatar?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  applications?: Maybe<Array<Maybe<Application>>>;
  avatar?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  createdAt: Scalars['Float'];
  creditStatistics?: Maybe<UserCreditStatistics>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<Scalars['String']>>>;
  invitedBy?: Maybe<UserFriendAcceptedInvite>;
  invitedFriends: Array<UserFriendAcceptedInvite>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['Float']>;
  locale?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  notifications: Array<UserNotification>;
  passwordUser?: Maybe<PasswordUser>;
  policies?: Maybe<Array<UserPolicy>>;
  privacy: UserPrivacy;
  profile?: Maybe<Scalars['JSON']>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  referrals: Array<UserFriendReferral>;
  referredBy?: Maybe<User>;
  registeredOn?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['String']>;
};

export type UserActivitiesFilter = {
  from: Scalars['Float'];
  to: Scalars['Float'];
  userId: Scalars['String'];
};

export type UserActivity = {
  __typename?: 'UserActivity';
  calories: Scalars['Int'];
  creditsEarned: Scalars['Float'];
  date: Scalars['Float'];
  distance: Scalars['Int'];
  duration: Scalars['Int'];
  elevation: Scalars['Int'];
  steps: Scalars['Int'];
  workoutCalories: Scalars['Int'];
  workoutCount: Scalars['Int'];
  workoutDistance: Scalars['Int'];
  workoutDuration: Scalars['Int'];
  workoutElevation: Scalars['Int'];
  workoutSteps: Scalars['Int'];
  workouts: Array<UserActivityWorkout>;
};

export type UserActivityWorkout = {
  __typename?: 'UserActivityWorkout';
  activity: Scalars['String'];
  calories: Scalars['Int'];
  creditsEarned: Scalars['Float'];
  detailedActivity?: Maybe<Scalars['String']>;
  distance: Scalars['Int'];
  duration: Scalars['Int'];
  elevation: Scalars['Int'];
  end: Scalars['Float'];
  id?: Maybe<Scalars['String']>;
  manual: Scalars['Boolean'];
  providers: Array<Scalars['String']>;
  start: Scalars['Float'];
  steps: Scalars['Int'];
};

export type UserApplicationFilter = {
  applicationId?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
  withoutRole?: InputMaybe<Scalars['Boolean']>;
};

export type UserApplicationInput = {
  id?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UserCreditStatistics = {
  __typename?: 'UserCreditStatistics';
  balance: Scalars['Float'];
  earned: Scalars['Float'];
  spended: Scalars['Float'];
};

export type UserDisplayConfiguration = {
  __typename?: 'UserDisplayConfiguration';
  allowForAnonymous: Scalars['Boolean'];
  allowedUserFields: Array<Scalars['String']>;
};

export type UserEmailContentNotification = {
  __typename?: 'UserEmailContentNotification';
  tags: Array<ContentTag>;
  type: Scalars['String'];
};

export type UserEmailContentNotificationInput = {
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
};

export type UserEmailNotification = UserNotification & {
  __typename?: 'UserEmailNotification';
  content: Array<UserEmailContentNotification>;
  contentUpdate: Scalars['Boolean'];
  type: Scalars['String'];
  weeklyUpdate: Scalars['Boolean'];
};

export type UserEmailNotificationInput = {
  content: Array<UserEmailContentNotificationInput>;
  contentUpdate: Scalars['Boolean'];
  type: Scalars['String'];
  weeklyUpdate: Scalars['Boolean'];
};

export type UserFilter = {
  applications?: InputMaybe<Array<InputMaybe<UserApplicationFilter>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userSearch?: InputMaybe<Scalars['String']>;
};

export type UserFriendAcceptedInvite = {
  __typename?: 'UserFriendAcceptedInvite';
  acceptedOn?: Maybe<Scalars['Float']>;
  invitee?: Maybe<User>;
  user?: Maybe<User>;
};

export type UserFriendAcceptedInvitesFilter = {
  acceptedAfter?: InputMaybe<Scalars['Float']>;
  acceptedBefore?: InputMaybe<Scalars['Float']>;
  invitedId?: InputMaybe<Scalars['String']>;
  inviteeId?: InputMaybe<Scalars['String']>;
};

export type UserFriendInvite = {
  __typename?: 'UserFriendInvite';
  code?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type UserFriendInvitesFilter = {
  email?: InputMaybe<Scalars['String']>;
  invitedAfter?: InputMaybe<Scalars['Float']>;
  invitedBefore?: InputMaybe<Scalars['Float']>;
  inviteeId?: InputMaybe<Scalars['String']>;
};

export type UserFriendReferral = {
  __typename?: 'UserFriendReferral';
  referralCode?: Maybe<Scalars['String']>;
  referredBy?: Maybe<User>;
  referredOn?: Maybe<Scalars['Float']>;
  user?: Maybe<User>;
};

export type UserFriendReferralsFilter = {
  code?: InputMaybe<Scalars['String']>;
  referred?: InputMaybe<Scalars['String']>;
  referredAfter?: InputMaybe<Scalars['Float']>;
  referredBefore?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UserNotification = {
  type: Scalars['String'];
};

export type UserPolicy = {
  __typename?: 'UserPolicy';
  acceptedOn: Scalars['Float'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type UserPolicyInput = {
  acceptedOn: Scalars['Float'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type UserPrivacy = {
  __typename?: 'UserPrivacy';
  nickname?: Maybe<Scalars['String']>;
  publicDisplayNameType: Scalars['String'];
  showActivities: Scalars['Boolean'];
  showAsNewMember: Scalars['Boolean'];
};

export type UserPrivacyInput = {
  nickname?: InputMaybe<Scalars['String']>;
  publicDisplayNameType: Scalars['String'];
  showActivities: Scalars['Boolean'];
  showAsNewMember: Scalars['Boolean'];
};

export type UserProfileRoleConfig = {
  __typename?: 'UserProfileRoleConfig';
  enabled: Scalars['Boolean'];
  field: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  removeRoles: Scalars['Boolean'];
  roleMapping: Array<UserProfileRoleConfigMapping>;
};

export type UserProfileRoleConfigFilter = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type UserProfileRoleConfigMapping = {
  __typename?: 'UserProfileRoleConfigMapping';
  roles: Array<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type UserProfileRoleConfigMappingInput = {
  roles: Array<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type UserSearchConfiguration = {
  __typename?: 'UserSearchConfiguration';
  allowForAnonymous: Scalars['Boolean'];
  allowedUserFields: Array<Scalars['String']>;
};

export type UserUpdateInput = {
  avatar?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  policies?: InputMaybe<Array<UserPolicyInput>>;
  profile?: InputMaybe<Scalars['JSON']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UserWhiteList = {
  __typename?: 'UserWhiteList';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  whitelist?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UserWhiteListFilter = {
  group?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
};

export type Voucher = {
  __typename?: 'Voucher';
  assignments: Array<VoucherAssignment>;
  code: Scalars['String'];
  discount?: Maybe<VoucherDiscount>;
  enableVoucherPeriod: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  enabledMaxUsage: Scalars['Boolean'];
  enabledMaxUsagePerUser: Scalars['Boolean'];
  enabledOn: Array<VoucherEnabledOn>;
  id: Scalars['String'];
  maxUsage: Scalars['Int'];
  maxUsagePerUser: Scalars['Int'];
  title?: Maybe<Array<Maybe<TextByLanguage>>>;
  usageCount: Scalars['Int'];
  voucherEnd?: Maybe<Scalars['Float']>;
  voucherStart?: Maybe<Scalars['Float']>;
};

export type VoucherAssignment = {
  __typename?: 'VoucherAssignment';
  credits?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
};

export type VoucherAssignmentInput = {
  credits?: InputMaybe<Scalars['Float']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type VoucherDiscount = {
  __typename?: 'VoucherDiscount';
  amount: Scalars['Float'];
  type: Scalars['String'];
};

export type VoucherDiscountInput = {
  amount: Scalars['Float'];
  type: Scalars['String'];
};

export type VoucherEnabledOn = {
  __typename?: 'VoucherEnabledOn';
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  type: Scalars['String'];
};

export type VoucherEnabledOnInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type: Scalars['String'];
};

export type VoucherFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textSearch?: InputMaybe<Scalars['String']>;
  textSearchLocale?: InputMaybe<Scalars['String']>;
};

export type VoucherUsage = {
  createdOn: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
  typeId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
  voucher: Voucher;
  voucherId: Scalars['String'];
};

export type VoucherUsageFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userSearch?: InputMaybe<Scalars['String']>;
  voucherIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GetProviderActivitiesQueryVariables = Exact<{
  userId: Scalars['String'];
  date: Scalars['Float'];
}>;


export type GetProviderActivitiesQuery = { __typename?: 'RootQuery', providerActivities: Array<{ __typename?: 'ProviderActivity', id?: string | null, segmentId?: string | null, start?: number | null, end?: number | null, source?: string | null, activity?: string | null, steps?: number | null, distance?: number | null, calories?: number | null }> };

export type GetUserActivitiesQueryVariables = Exact<{
  filter: UserActivitiesFilter;
}>;


export type GetUserActivitiesQuery = { __typename?: 'RootQuery', userActivities: Array<{ __typename?: 'UserActivity', date: number, calories: number, distance: number, steps: number, duration: number, elevation: number, workoutCalories: number, workoutDistance: number, workoutSteps: number, workoutDuration: number, workoutElevation: number, workoutCount: number, creditsEarned: number, workouts: Array<{ __typename?: 'UserActivityWorkout', id?: string | null, start: number, end: number, activity: string, detailedActivity?: string | null, providers: Array<string>, calories: number, distance: number, steps: number, duration: number, elevation: number, manual: boolean, creditsEarned: number }> }> };

export type RemoveProviderActivityMutationVariables = Exact<{
  id: Scalars['String'];
  segmentId: Scalars['String'];
}>;


export type RemoveProviderActivityMutation = { __typename?: 'RootMutation', removeProviderActivity: { __typename?: 'Success', success: boolean } };

export type AddAmbassadorMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  info?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  image?: InputMaybe<Scalars['String']>;
  activityTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddAmbassadorMutation = { __typename?: 'RootMutation', addAmbassador: { __typename?: 'Ambassador', id: string, createdOn?: number | null, userId?: string | null, place: string, image?: string | null, activityTypes?: Array<string> | null, withAdvancedMode?: boolean | null, tags?: Array<{ __typename?: 'AmbassadorTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, info?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } };

export type AddAmbassadorConfigMutationVariables = Exact<{
  place?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<AmbassadorConfigImageInput>;
  visibility?: InputMaybe<AmbassadorConfigVisibilityInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  preview?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  intro?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  ambassadorIntro?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  caption?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  heroImage?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddAmbassadorConfigMutation = { __typename?: 'RootMutation', addAmbassadorConfig: { __typename?: 'AmbassadorConfig', id: string, place: string, heroImage?: string | null, sequence?: number | null, withAdvancedMode?: boolean | null, image?: { __typename?: 'AmbassadorConfigImage', size?: string | null, shape?: string | null } | null, visibility?: { __typename?: 'AmbassadorConfigVisibility', icons?: boolean | null, name?: boolean | null, info?: boolean | null } | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, intro?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, ambassadorIntro?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, caption?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } };

export type AddAmbassadorTagMutationVariables = Exact<{
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  description: Array<TextByLanguageInput> | TextByLanguageInput;
  image: Scalars['String'];
  color: Scalars['String'];
}>;


export type AddAmbassadorTagMutation = { __typename?: 'RootMutation', addAmbassadorTag: { __typename?: 'AmbassadorTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type AmbassadorFragment = { __typename?: 'Ambassador', id: string, createdOn?: number | null, userId?: string | null, place: string, image?: string | null, activityTypes?: Array<string> | null, withAdvancedMode?: boolean | null, tags?: Array<{ __typename?: 'AmbassadorTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, info?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null };

export type AmbassadorConfigFragment = { __typename?: 'AmbassadorConfig', id: string, place: string, heroImage?: string | null, sequence?: number | null, withAdvancedMode?: boolean | null, image?: { __typename?: 'AmbassadorConfigImage', size?: string | null, shape?: string | null } | null, visibility?: { __typename?: 'AmbassadorConfigVisibility', icons?: boolean | null, name?: boolean | null, info?: boolean | null } | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, intro?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, ambassadorIntro?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, caption?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null };

export type AmbassadorTagFragment = { __typename?: 'AmbassadorTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> };

export type GetAmbassadorConfigCountQueryVariables = Exact<{
  filter?: InputMaybe<AmbassadorConfigFilter>;
}>;


export type GetAmbassadorConfigCountQuery = { __typename?: 'RootQuery', ambassadorConfigCount: number };

export type GetAmbassadorConfigsQueryVariables = Exact<{
  filter?: InputMaybe<AmbassadorConfigFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetAmbassadorConfigsQuery = { __typename?: 'RootQuery', ambassadorConfigs: Array<{ __typename?: 'AmbassadorConfig', id: string, place: string, heroImage?: string | null, sequence?: number | null, withAdvancedMode?: boolean | null, image?: { __typename?: 'AmbassadorConfigImage', size?: string | null, shape?: string | null } | null, visibility?: { __typename?: 'AmbassadorConfigVisibility', icons?: boolean | null, name?: boolean | null, info?: boolean | null } | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, intro?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, ambassadorIntro?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, caption?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> };

export type GetAmbassadorTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAmbassadorTagsQuery = { __typename?: 'RootQuery', ambassadorTags: Array<{ __typename?: 'AmbassadorTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> };

export type GetAmbassadorsQueryVariables = Exact<{
  filter?: InputMaybe<AmbassadorFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetAmbassadorsQuery = { __typename?: 'RootQuery', ambassadors: Array<{ __typename?: 'Ambassador', id: string, createdOn?: number | null, userId?: string | null, place: string, image?: string | null, activityTypes?: Array<string> | null, withAdvancedMode?: boolean | null, tags?: Array<{ __typename?: 'AmbassadorTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, info?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> };

export type RemoveAmbassadorMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveAmbassadorMutation = { __typename?: 'RootMutation', removeAmbassador: { __typename?: 'Success', success: boolean } };

export type RemoveAmbassadorConfigMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveAmbassadorConfigMutation = { __typename?: 'RootMutation', removeAmbassadorConfig: { __typename?: 'Success', success: boolean } };

export type RemoveAmbassadorTagMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveAmbassadorTagMutation = { __typename?: 'RootMutation', removeAmbassadorTag: { __typename?: 'Success', success: boolean } };

export type UpdateAmbassadorMutationVariables = Exact<{
  id: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  info?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  image?: InputMaybe<Scalars['String']>;
  activityTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  place: Scalars['String'];
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateAmbassadorMutation = { __typename?: 'RootMutation', updateAmbassador: { __typename?: 'Ambassador', id: string, createdOn?: number | null, userId?: string | null, place: string, image?: string | null, activityTypes?: Array<string> | null, withAdvancedMode?: boolean | null, tags?: Array<{ __typename?: 'AmbassadorTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, info?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } };

export type UpdateAmbassadorConfigMutationVariables = Exact<{
  id: Scalars['String'];
  place?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<AmbassadorConfigImageInput>;
  visibility?: InputMaybe<AmbassadorConfigVisibilityInput>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  preview?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  intro?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  ambassadorIntro?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  caption?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  heroImage?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateAmbassadorConfigMutation = { __typename?: 'RootMutation', updateAmbassadorConfig: { __typename?: 'AmbassadorConfig', id: string, place: string, heroImage?: string | null, sequence?: number | null, withAdvancedMode?: boolean | null, image?: { __typename?: 'AmbassadorConfigImage', size?: string | null, shape?: string | null } | null, visibility?: { __typename?: 'AmbassadorConfigVisibility', icons?: boolean | null, name?: boolean | null, info?: boolean | null } | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, intro?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, ambassadorIntro?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, caption?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } };

export type UpdateAmbassadorTagMutationVariables = Exact<{
  id: Scalars['String'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  image?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
}>;


export type UpdateAmbassadorTagMutation = { __typename?: 'RootMutation', updateAmbassadorTag: { __typename?: 'AmbassadorTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type ApplicationFragment = { __typename?: 'Application', id: string, name: string, project: { __typename?: 'Project', id?: string | null, name?: string | null }, roles: Array<{ __typename?: 'Role', id: string, name: string, description: string }> };

export type AddArticleMutationVariables = Exact<{
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  description: Array<TextByLanguageInput> | TextByLanguageInput;
  articleNumber: Scalars['String'];
  image: Scalars['String'];
  price: Scalars['Int'];
  currentStock: Scalars['Int'];
  availableStock: Scalars['Int'];
  orderRestrictions?: InputMaybe<ArticleOrderRestrictionsInput>;
  instructions?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  vouchers?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  publishOn: Scalars['Float'];
  expiresOn: Scalars['Float'];
  priority?: InputMaybe<Scalars['Int']>;
  isDraft: Scalars['Boolean'];
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  roles: Array<Scalars['String']> | Scalars['String'];
  type: Scalars['String'];
  contentsIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AddArticleMutation = { __typename?: 'RootMutation', addArticle: { __typename?: 'Article', id: string, image: string, price: number, currentStock: number, availableStock: number, articleNumber: string, publishOn?: number | null, expiresOn?: number | null, priority?: number | null, isDraft?: boolean | null, countries?: Array<string | null> | null, roles?: Array<string | null> | null, type: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null>, orderRestrictions?: { __typename?: 'ArticleOrderRestrictions', enableMaxItemsPerPerson?: boolean | null, maxItemsPerPerson?: number | null, enableMaxItemsPeriod?: boolean | null, maxItemsPeriod?: string | null } | null, voucher?: { __typename?: 'ArticleVoucher', instruction?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, vouchers?: Array<{ __typename?: 'ArticleVoucherItem', code: string, used: boolean, userId?: string | null, orderId?: string | null } | null> | null } | null, relatedContents?: Array<{ __typename?: 'Content', id: string }> | null } };

export type AddArticleVouchersMutationVariables = Exact<{
  id: Scalars['String'];
  vouchers: Array<Scalars['String']> | Scalars['String'];
}>;


export type AddArticleVouchersMutation = { __typename?: 'RootMutation', addArticleVouchers: { __typename?: 'Success', success: boolean } };

export type ArticleFragment = { __typename?: 'Article', id: string, image: string, price: number, currentStock: number, availableStock: number, articleNumber: string, publishOn?: number | null, expiresOn?: number | null, priority?: number | null, isDraft?: boolean | null, countries?: Array<string | null> | null, roles?: Array<string | null> | null, type: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null>, orderRestrictions?: { __typename?: 'ArticleOrderRestrictions', enableMaxItemsPerPerson?: boolean | null, maxItemsPerPerson?: number | null, enableMaxItemsPeriod?: boolean | null, maxItemsPeriod?: string | null } | null, voucher?: { __typename?: 'ArticleVoucher', instruction?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, vouchers?: Array<{ __typename?: 'ArticleVoucherItem', code: string, used: boolean, userId?: string | null, orderId?: string | null } | null> | null } | null, relatedContents?: Array<{ __typename?: 'Content', id: string }> | null };

export type ArticleOveviewFragment = { __typename?: 'Article', id: string, image: string, price: number, priority?: number | null, currentStock: number, expiresOn?: number | null, publishOn?: number | null, isDraft?: boolean | null, type: string, thirdParty?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> };

export type GetArticleCountQueryVariables = Exact<{
  filter?: InputMaybe<ArticleFilter>;
}>;


export type GetArticleCountQuery = { __typename?: 'RootQuery', articleCount: number };

export type GetArticlesQueryVariables = Exact<{
  filter?: InputMaybe<ArticleFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetArticlesQuery = { __typename?: 'RootQuery', articles: Array<{ __typename?: 'Article', thirdParty?: string | null, id: string, image: string, price: number, currentStock: number, availableStock: number, articleNumber: string, publishOn?: number | null, expiresOn?: number | null, priority?: number | null, isDraft?: boolean | null, countries?: Array<string | null> | null, roles?: Array<string | null> | null, type: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null>, orderRestrictions?: { __typename?: 'ArticleOrderRestrictions', enableMaxItemsPerPerson?: boolean | null, maxItemsPerPerson?: number | null, enableMaxItemsPeriod?: boolean | null, maxItemsPeriod?: string | null } | null, voucher?: { __typename?: 'ArticleVoucher', instruction?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, vouchers?: Array<{ __typename?: 'ArticleVoucherItem', code: string, used: boolean, userId?: string | null, orderId?: string | null } | null> | null } | null, relatedContents?: Array<{ __typename?: 'Content', id: string }> | null }> };

export type GetArticlesOverviewQueryVariables = Exact<{
  filter?: InputMaybe<ArticleFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetArticlesOverviewQuery = { __typename?: 'RootQuery', articles: Array<{ __typename?: 'Article', thirdParty?: string | null, id: string, image: string, price: number, priority?: number | null, currentStock: number, expiresOn?: number | null, publishOn?: number | null, isDraft?: boolean | null, type: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> }> };

export type RemoveArticleMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveArticleMutation = { __typename?: 'RootMutation', removeArticle: { __typename?: 'Success', success: boolean } };

export type RemoveArticleVouchersMutationVariables = Exact<{
  id: Scalars['String'];
  vouchers?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  deleteAllVouchers?: InputMaybe<Scalars['Boolean']>;
}>;


export type RemoveArticleVouchersMutation = { __typename?: 'RootMutation', removeArticleVouchers: { __typename?: 'Success', success: boolean } };

export type UpdateArticleMutationVariables = Exact<{
  id: Scalars['String'];
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  description: Array<TextByLanguageInput> | TextByLanguageInput;
  articleNumber: Scalars['String'];
  image: Scalars['String'];
  price: Scalars['Int'];
  currentStock: Scalars['Int'];
  availableStock: Scalars['Int'];
  orderRestrictions?: InputMaybe<ArticleOrderRestrictionsInput>;
  instructions?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  vouchers?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  publishOn: Scalars['Float'];
  expiresOn: Scalars['Float'];
  priority?: InputMaybe<Scalars['Int']>;
  isDraft: Scalars['Boolean'];
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  roles: Array<Scalars['String']> | Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  contentsIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateArticleMutation = { __typename?: 'RootMutation', updateArticle: { __typename?: 'Article', id: string, image: string, price: number, currentStock: number, availableStock: number, articleNumber: string, publishOn?: number | null, expiresOn?: number | null, priority?: number | null, isDraft?: boolean | null, countries?: Array<string | null> | null, roles?: Array<string | null> | null, type: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null>, orderRestrictions?: { __typename?: 'ArticleOrderRestrictions', enableMaxItemsPerPerson?: boolean | null, maxItemsPerPerson?: number | null, enableMaxItemsPeriod?: boolean | null, maxItemsPeriod?: string | null } | null, voucher?: { __typename?: 'ArticleVoucher', instruction?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, vouchers?: Array<{ __typename?: 'ArticleVoucherItem', code: string, used: boolean, userId?: string | null, orderId?: string | null } | null> | null } | null, relatedContents?: Array<{ __typename?: 'Content', id: string }> | null } };

export type AddChallengeMutationVariables = Exact<{
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  subtitle?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  rewards?: InputMaybe<ChallengeRewardsInput>;
  difficultyLevel?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<ChallengeDurationInput>;
  registration?: InputMaybe<ChallengeRegistrationInput>;
  activityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tieBreaker?: InputMaybe<ChallengeTieBreakerInput>;
  conditionsInOrder?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Array<InputMaybe<Scalars['ChallengeConditionInput']>> | InputMaybe<Scalars['ChallengeConditionInput']>>;
  ultimateSyncTime?: InputMaybe<Scalars['Float']>;
  milestones?: InputMaybe<Array<InputMaybe<ChallengeMilestoneInput>> | InputMaybe<ChallengeMilestoneInput>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  publishedOn?: InputMaybe<Scalars['Float']>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  visualizeType?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  team?: InputMaybe<ChallengeTeamConfigInput>;
  endless?: InputMaybe<ChallengeEndlessInput>;
  exceedConditionLimit?: InputMaybe<Scalars['Boolean']>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  hideProgressInList?: InputMaybe<Scalars['Boolean']>;
  hideProgressInDetails?: InputMaybe<Scalars['Boolean']>;
  hideProgressInInsights?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  payment?: InputMaybe<ChallengePaymentInput>;
  totals?: InputMaybe<ChallengeTotalsInput>;
  visualisations?: InputMaybe<Array<InputMaybe<Scalars['ChallengeVisualisationInput']>> | InputMaybe<Scalars['ChallengeVisualisationInput']>>;
  teamPropertyValues?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  viewParticipants?: InputMaybe<Scalars['Boolean']>;
  viewParticipantCount?: InputMaybe<Scalars['Boolean']>;
  viewCompletedParticipants?: InputMaybe<Scalars['Boolean']>;
  viewTeamCount?: InputMaybe<Scalars['Boolean']>;
  voucherConfiguration?: InputMaybe<ChallengeVoucherConfigurationInput>;
  enabledLocales?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  participationProfileRequirements?: InputMaybe<Array<ChallengeProfileFieldsInput> | ChallengeProfileFieldsInput>;
  data?: InputMaybe<Scalars['JSON']>;
  contentsIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  superDates?: InputMaybe<SuperDatesInput>;
  autoParticipationEnabled?: InputMaybe<Scalars['Boolean']>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
  activityMultipliers?: InputMaybe<ChallengeActivityMultipliersInput>;
}>;


export type AddChallengeMutation = { __typename?: 'RootMutation', addChallenge: { __typename?: 'Challenge', id: string, enabledLocales?: Array<string> | null, imageUrl?: string | null, difficultyLevel?: number | null, activityTypes?: Array<string | null> | null, conditionsInOrder?: boolean | null, ultimateSyncTime?: number | null, featured?: boolean | null, publishedOn?: number | null, expiresOn?: number | null, visualizeType?: string | null, roles?: Array<string | null> | null, exceedConditionLimit?: boolean | null, hideInList?: boolean | null, hideProgressInList?: boolean | null, hideProgressInDetails?: boolean | null, hideProgressInInsights?: boolean | null, priority?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, viewCompletedParticipants?: boolean | null, viewTeamCount?: boolean | null, data?: any | null, autoParticipationEnabled?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, rewards?: { __typename?: 'ChallengeRewards', credits?: number | null, prizes?: Array<{ __typename?: 'ChallengePrize', imageUrl?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null, duration?: { __typename?: 'ChallengeDuration', start?: number | null, end?: number | null } | null, registration?: { __typename?: 'ChallengeRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, participateOnStart?: boolean | null } | null, tieBreaker?: { __typename?: 'ChallengeTieBreaker', active?: boolean | null, forAllTeamMembers?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, question1?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, question2?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, conditions?: Array<{ __typename?: 'ChallengeActivityCondition', activities?: Array<string | null> | null, value?: number | null, unitType?: string | null, unit?: string | null, id?: string | null, sequence?: number | null, type?: string | null, startTime?: number | null, endTime?: number | null, credits?: number | null, inOneGo?: { __typename?: 'ChallengeConditionInOneGo', enabled?: boolean | null, repeat?: number | null } | null, timespan?: { __typename?: 'ChallengeConditionTimespan', enabled?: boolean | null, value?: number | null, unit?: string | null } | null, repeated?: { __typename?: 'ChallengeConditionRepeat', enabled?: boolean | null, value?: number | null, sequential?: boolean | null } | null, blockManualActivities?: { __typename?: 'ChallengeConditionBlockManualActivities', enabled: boolean } | null } | { __typename?: 'ChallengeFormCondition', image?: string | null, id?: string | null, sequence?: number | null, type?: string | null, startTime?: number | null, endTime?: number | null, credits?: number | null, formTemplate?: { __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, milestones?: Array<{ __typename?: 'ChallengeMilestone', id?: string | null, percentage?: number | null, conditionId?: string | null, imageUrl?: string | null, notificationsEnabled?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, email?: { __typename?: 'ChallengeMilestoneEmail', subject?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, body?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null } | null> | null, team?: { __typename?: 'ChallengeTeamConfig', enabled?: boolean | null, fixedTeams?: boolean | null, profileProperty?: string | null, maxMembers?: number | null, inviteCodeEnabled?: boolean | null } | null, endless?: { __typename?: 'ChallengeEndless', enabled?: boolean | null, activityTypes?: Array<string | null> | null, unitType?: string | null, rankingAlgorithm?: string | null } | null, payment?: { __typename?: 'ChallengePayment', enabled?: boolean | null, action?: string | null, payAmount?: number | null, freeCredits?: number | null, overwriteDefinitions?: Array<{ __typename?: 'ChallengePaymentOverwriteDefinition', id?: string | null, roles?: Array<string | null> | null, action?: string | null, payAmount?: number | null, freeCredits?: number | null } | null> | null } | null, totals?: { __typename?: 'ChallengeTotals', distanceVisible?: boolean | null, distanceUnit?: string | null, durationVisible?: boolean | null, durationUnit?: string | null, stepsVisible?: boolean | null, caloriesVisible?: boolean | null, caloriesUnit?: string | null, elevationVisible?: boolean | null, elevationUnit?: string | null, creditsEarnedVisible?: boolean | null, workoutsVisible?: boolean | null } | null, visualisations?: Array<{ __typename?: 'ChallengeVisualisation', id?: string | null, type?: string | null, place?: string | null, dataType?: string | null, clickable?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, conditions?: Array<{ __typename?: 'ChallengeConditionBarVisualisation', colors?: Array<string | null> | null, currentValue?: boolean | null, endValue?: boolean | null, numberOfItems?: number | null, order?: string | null, conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundBarVisualisation', image?: string | null, color?: string | null, height?: string | null } | null, label?: { __typename?: 'ChallengeConditionBarLabelVisualisation', backgroundColor?: string | null, limitCharacters?: boolean | null, textDirection?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null } | { __typename?: 'ChallengeConditionGridVisualisation', order?: string | null, conditionId?: string | null, columns?: Array<{ __typename?: 'ChallengeConditionGridColumnVisualisation', columnType?: string | null, conditionId?: string | null, profileProperty?: string | null, header?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, header?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, item?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, rowLabel?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, right?: string | null, bottom?: string | null } | null, images?: { __typename?: 'ChallengeConditionGridImagesVisualisation', notStarted?: string | null, inProgress?: string | null, success?: string | null } | null } | { __typename?: 'ChallengeConditionInfoblockVisualisation', conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null, infoblock?: { __typename?: 'ChallengeConditionInfoblockCurrentDayConditionVisualisation', type?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null, conditionLabels?: Array<{ __typename?: 'ChallengeConditionInfoblockConditionLabelVisualisation', conditionId?: string | null, text?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | { __typename?: 'ChallengeConditionInfoblockCurrentDayGoalVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | { __typename?: 'ChallengeConditionInfoblockNextDayGoalVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | { __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, value?: { __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedValueVisualisation', font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | null } | { __typename?: 'ChallengeConditionLeaderboardVisualisation', numberOfItems?: number | null, medalImages?: Array<string | null> | null, minWidth?: string | null, availableUnitTypeRankings?: Array<string> | null, conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null, header?: { __typename?: 'ChallengeConditionLeaderboardHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, item?: { __typename?: 'ChallengeConditionLeaderboardItemVisualisation', color?: string | null, transparent?: number | null, unit?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null, top?: { __typename?: 'ChallengeConditionLeaderboardTopItemVisualisation', count?: number | null, color?: string | null } | null } | null, columns?: Array<{ __typename?: 'ChallengeConditionLeaderboardColumnVisualisation', profileProperty?: string | null, filterEnabled?: boolean | null, header?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | { __typename?: 'ChallengeConditionTimelineVisualisation', foregroundImage?: string | null, backgroundImage?: string | null, splitterImage?: string | null, successImage?: string | null, conditionId?: string | null, banner?: { __typename?: 'ChallengeConditionTimelineBannerVisualisation', backgroundColor?: string | null, goal?: { __typename?: 'ChallengeConditionTimelineBannerGoalVisualisation', image?: string | null, currentValue?: boolean | null, endValue?: boolean | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, repeater?: { __typename?: 'ChallengeConditionTimelineBannerRepeaterVisualisation', image?: string | null, repeat?: number | null, currentFont?: { __typename?: 'ChallengeConditionFontVisualisation', size?: string | null, family?: string | null, color?: string | null } | null, totalFont?: { __typename?: 'ChallengeConditionFontVisualisation', size?: string | null, family?: string | null, color?: string | null } | null } | null, counters?: Array<{ __typename?: 'ChallengeConditionTimelineBannerCounterVisualisation', image?: string | null, unitType?: string | null, activityTypes?: Array<string | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null> | null } | null, flag?: { __typename?: 'ChallengeConditionTimelineFlagVisualisation', image?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'ChallengeTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> | null, voucherConfiguration?: { __typename?: 'ChallengeVoucherConfiguration', required: boolean, url?: string | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, participationProfileRequirements?: Array<{ __typename?: 'ChallengeProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null, relatedContents?: Array<{ __typename?: 'Content', id: string }> | null, superDates?: { __typename?: 'SuperDates', multiplier?: number | null, dates?: Array<{ __typename?: 'SuperDatesRange', from: number, to: number, multiplier?: number | null }> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, activityMultipliers?: { __typename?: 'ChallengeActivityMultipliers', walking?: number | null, running?: number | null, swimming?: number | null, workout?: number | null, cycling?: number | null } | null } };

export type AddChallengeTagMutationVariables = Exact<{
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  description: Array<TextByLanguageInput> | TextByLanguageInput;
  image: Scalars['String'];
  color: Scalars['String'];
}>;


export type AddChallengeTagMutation = { __typename?: 'RootMutation', addChallengeTag: { __typename?: 'ChallengeTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type AddChallengeTeamMutationVariables = Exact<{
  title: Scalars['String'];
  challengeId: Scalars['String'];
  profileValue?: InputMaybe<Scalars['String']>;
  captainUserId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<TextByLanguageInput> | TextByLanguageInput>;
  imageUrl?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
}>;


export type AddChallengeTeamMutation = { __typename?: 'RootMutation', addChallengeTeam: { __typename?: 'ChallengeTeam', id?: string | null, title?: string | null, profileValue?: string | null, captainUserId?: string | null, memberCount?: number | null, memberIds?: Array<string | null> | null, imageUrl?: string | null, contentId?: string | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } };

export type BanFromChallengeTeamMutationVariables = Exact<{
  teamId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type BanFromChallengeTeamMutation = { __typename?: 'RootMutation', banFromChallengeTeam: { __typename?: 'ChallengeTeam', id?: string | null } };

export type ChallengeFragment = { __typename?: 'Challenge', id: string, enabledLocales?: Array<string> | null, imageUrl?: string | null, difficultyLevel?: number | null, activityTypes?: Array<string | null> | null, conditionsInOrder?: boolean | null, ultimateSyncTime?: number | null, featured?: boolean | null, publishedOn?: number | null, expiresOn?: number | null, visualizeType?: string | null, roles?: Array<string | null> | null, exceedConditionLimit?: boolean | null, hideInList?: boolean | null, hideProgressInList?: boolean | null, hideProgressInDetails?: boolean | null, hideProgressInInsights?: boolean | null, priority?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, viewCompletedParticipants?: boolean | null, viewTeamCount?: boolean | null, data?: any | null, autoParticipationEnabled?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, rewards?: { __typename?: 'ChallengeRewards', credits?: number | null, prizes?: Array<{ __typename?: 'ChallengePrize', imageUrl?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null, duration?: { __typename?: 'ChallengeDuration', start?: number | null, end?: number | null } | null, registration?: { __typename?: 'ChallengeRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, participateOnStart?: boolean | null } | null, tieBreaker?: { __typename?: 'ChallengeTieBreaker', active?: boolean | null, forAllTeamMembers?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, question1?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, question2?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, conditions?: Array<{ __typename?: 'ChallengeActivityCondition', activities?: Array<string | null> | null, value?: number | null, unitType?: string | null, unit?: string | null, id?: string | null, sequence?: number | null, type?: string | null, startTime?: number | null, endTime?: number | null, credits?: number | null, inOneGo?: { __typename?: 'ChallengeConditionInOneGo', enabled?: boolean | null, repeat?: number | null } | null, timespan?: { __typename?: 'ChallengeConditionTimespan', enabled?: boolean | null, value?: number | null, unit?: string | null } | null, repeated?: { __typename?: 'ChallengeConditionRepeat', enabled?: boolean | null, value?: number | null, sequential?: boolean | null } | null, blockManualActivities?: { __typename?: 'ChallengeConditionBlockManualActivities', enabled: boolean } | null } | { __typename?: 'ChallengeFormCondition', image?: string | null, id?: string | null, sequence?: number | null, type?: string | null, startTime?: number | null, endTime?: number | null, credits?: number | null, formTemplate?: { __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, milestones?: Array<{ __typename?: 'ChallengeMilestone', id?: string | null, percentage?: number | null, conditionId?: string | null, imageUrl?: string | null, notificationsEnabled?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, email?: { __typename?: 'ChallengeMilestoneEmail', subject?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, body?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null } | null> | null, team?: { __typename?: 'ChallengeTeamConfig', enabled?: boolean | null, fixedTeams?: boolean | null, profileProperty?: string | null, maxMembers?: number | null, inviteCodeEnabled?: boolean | null } | null, endless?: { __typename?: 'ChallengeEndless', enabled?: boolean | null, activityTypes?: Array<string | null> | null, unitType?: string | null, rankingAlgorithm?: string | null } | null, payment?: { __typename?: 'ChallengePayment', enabled?: boolean | null, action?: string | null, payAmount?: number | null, freeCredits?: number | null, overwriteDefinitions?: Array<{ __typename?: 'ChallengePaymentOverwriteDefinition', id?: string | null, roles?: Array<string | null> | null, action?: string | null, payAmount?: number | null, freeCredits?: number | null } | null> | null } | null, totals?: { __typename?: 'ChallengeTotals', distanceVisible?: boolean | null, distanceUnit?: string | null, durationVisible?: boolean | null, durationUnit?: string | null, stepsVisible?: boolean | null, caloriesVisible?: boolean | null, caloriesUnit?: string | null, elevationVisible?: boolean | null, elevationUnit?: string | null, creditsEarnedVisible?: boolean | null, workoutsVisible?: boolean | null } | null, visualisations?: Array<{ __typename?: 'ChallengeVisualisation', id?: string | null, type?: string | null, place?: string | null, dataType?: string | null, clickable?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, conditions?: Array<{ __typename?: 'ChallengeConditionBarVisualisation', colors?: Array<string | null> | null, currentValue?: boolean | null, endValue?: boolean | null, numberOfItems?: number | null, order?: string | null, conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundBarVisualisation', image?: string | null, color?: string | null, height?: string | null } | null, label?: { __typename?: 'ChallengeConditionBarLabelVisualisation', backgroundColor?: string | null, limitCharacters?: boolean | null, textDirection?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null } | { __typename?: 'ChallengeConditionGridVisualisation', order?: string | null, conditionId?: string | null, columns?: Array<{ __typename?: 'ChallengeConditionGridColumnVisualisation', columnType?: string | null, conditionId?: string | null, profileProperty?: string | null, header?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, header?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, item?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, rowLabel?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, right?: string | null, bottom?: string | null } | null, images?: { __typename?: 'ChallengeConditionGridImagesVisualisation', notStarted?: string | null, inProgress?: string | null, success?: string | null } | null } | { __typename?: 'ChallengeConditionInfoblockVisualisation', conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null, infoblock?: { __typename?: 'ChallengeConditionInfoblockCurrentDayConditionVisualisation', type?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null, conditionLabels?: Array<{ __typename?: 'ChallengeConditionInfoblockConditionLabelVisualisation', conditionId?: string | null, text?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | { __typename?: 'ChallengeConditionInfoblockCurrentDayGoalVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | { __typename?: 'ChallengeConditionInfoblockNextDayGoalVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | { __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, value?: { __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedValueVisualisation', font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | null } | { __typename?: 'ChallengeConditionLeaderboardVisualisation', numberOfItems?: number | null, medalImages?: Array<string | null> | null, minWidth?: string | null, availableUnitTypeRankings?: Array<string> | null, conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null, header?: { __typename?: 'ChallengeConditionLeaderboardHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, item?: { __typename?: 'ChallengeConditionLeaderboardItemVisualisation', color?: string | null, transparent?: number | null, unit?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null, top?: { __typename?: 'ChallengeConditionLeaderboardTopItemVisualisation', count?: number | null, color?: string | null } | null } | null, columns?: Array<{ __typename?: 'ChallengeConditionLeaderboardColumnVisualisation', profileProperty?: string | null, filterEnabled?: boolean | null, header?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | { __typename?: 'ChallengeConditionTimelineVisualisation', foregroundImage?: string | null, backgroundImage?: string | null, splitterImage?: string | null, successImage?: string | null, conditionId?: string | null, banner?: { __typename?: 'ChallengeConditionTimelineBannerVisualisation', backgroundColor?: string | null, goal?: { __typename?: 'ChallengeConditionTimelineBannerGoalVisualisation', image?: string | null, currentValue?: boolean | null, endValue?: boolean | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, repeater?: { __typename?: 'ChallengeConditionTimelineBannerRepeaterVisualisation', image?: string | null, repeat?: number | null, currentFont?: { __typename?: 'ChallengeConditionFontVisualisation', size?: string | null, family?: string | null, color?: string | null } | null, totalFont?: { __typename?: 'ChallengeConditionFontVisualisation', size?: string | null, family?: string | null, color?: string | null } | null } | null, counters?: Array<{ __typename?: 'ChallengeConditionTimelineBannerCounterVisualisation', image?: string | null, unitType?: string | null, activityTypes?: Array<string | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null> | null } | null, flag?: { __typename?: 'ChallengeConditionTimelineFlagVisualisation', image?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'ChallengeTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> | null, voucherConfiguration?: { __typename?: 'ChallengeVoucherConfiguration', required: boolean, url?: string | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, participationProfileRequirements?: Array<{ __typename?: 'ChallengeProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null, relatedContents?: Array<{ __typename?: 'Content', id: string }> | null, superDates?: { __typename?: 'SuperDates', multiplier?: number | null, dates?: Array<{ __typename?: 'SuperDatesRange', from: number, to: number, multiplier?: number | null }> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, activityMultipliers?: { __typename?: 'ChallengeActivityMultipliers', walking?: number | null, running?: number | null, swimming?: number | null, workout?: number | null, cycling?: number | null } | null };

export type ChallengeBasicFragment = { __typename?: 'Challenge', id: string, activityTypes?: Array<string | null> | null, roles?: Array<string | null> | null, autoParticipationEnabled?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, duration?: { __typename?: 'ChallengeDuration', start?: number | null, end?: number | null } | null, visualisations?: Array<{ __typename?: 'ChallengeVisualisation', id?: string | null, type?: string | null } | null> | null, team?: { __typename?: 'ChallengeTeamConfig', enabled?: boolean | null, fixedTeams?: boolean | null } | null, voucherConfiguration?: { __typename?: 'ChallengeVoucherConfiguration', required: boolean, url?: string | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null };

type ChallengeCondition_ChallengeActivityCondition_Fragment = { __typename?: 'ChallengeActivityCondition', activities?: Array<string | null> | null, value?: number | null, unitType?: string | null, unit?: string | null, id?: string | null, sequence?: number | null, type?: string | null, startTime?: number | null, endTime?: number | null, credits?: number | null, inOneGo?: { __typename?: 'ChallengeConditionInOneGo', enabled?: boolean | null, repeat?: number | null } | null, timespan?: { __typename?: 'ChallengeConditionTimespan', enabled?: boolean | null, value?: number | null, unit?: string | null } | null, repeated?: { __typename?: 'ChallengeConditionRepeat', enabled?: boolean | null, value?: number | null, sequential?: boolean | null } | null, blockManualActivities?: { __typename?: 'ChallengeConditionBlockManualActivities', enabled: boolean } | null };

type ChallengeCondition_ChallengeFormCondition_Fragment = { __typename?: 'ChallengeFormCondition', image?: string | null, id?: string | null, sequence?: number | null, type?: string | null, startTime?: number | null, endTime?: number | null, credits?: number | null, formTemplate?: { __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type ChallengeConditionFragment = ChallengeCondition_ChallengeActivityCondition_Fragment | ChallengeCondition_ChallengeFormCondition_Fragment;

export type ChallengeMilestoneFragment = { __typename?: 'ChallengeMilestone', id?: string | null, percentage?: number | null, conditionId?: string | null, imageUrl?: string | null, notificationsEnabled?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, email?: { __typename?: 'ChallengeMilestoneEmail', subject?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, body?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null };

export type ChallengeTagFragment = { __typename?: 'ChallengeTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> };

export type ChallengeTeamFragment = { __typename?: 'ChallengeTeam', id?: string | null, title?: string | null, profileValue?: string | null, captainUserId?: string | null, memberCount?: number | null, memberIds?: Array<string | null> | null, imageUrl?: string | null, contentId?: string | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null };

export type ChallengeVisualisationFragment = { __typename?: 'ChallengeVisualisation', id?: string | null, type?: string | null, place?: string | null, dataType?: string | null, clickable?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, conditions?: Array<{ __typename?: 'ChallengeConditionBarVisualisation', colors?: Array<string | null> | null, currentValue?: boolean | null, endValue?: boolean | null, numberOfItems?: number | null, order?: string | null, conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundBarVisualisation', image?: string | null, color?: string | null, height?: string | null } | null, label?: { __typename?: 'ChallengeConditionBarLabelVisualisation', backgroundColor?: string | null, limitCharacters?: boolean | null, textDirection?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null } | { __typename?: 'ChallengeConditionGridVisualisation', order?: string | null, conditionId?: string | null, columns?: Array<{ __typename?: 'ChallengeConditionGridColumnVisualisation', columnType?: string | null, conditionId?: string | null, profileProperty?: string | null, header?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, header?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, item?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, rowLabel?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, right?: string | null, bottom?: string | null } | null, images?: { __typename?: 'ChallengeConditionGridImagesVisualisation', notStarted?: string | null, inProgress?: string | null, success?: string | null } | null } | { __typename?: 'ChallengeConditionInfoblockVisualisation', conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null, infoblock?: { __typename?: 'ChallengeConditionInfoblockCurrentDayConditionVisualisation', type?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null, conditionLabels?: Array<{ __typename?: 'ChallengeConditionInfoblockConditionLabelVisualisation', conditionId?: string | null, text?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | { __typename?: 'ChallengeConditionInfoblockCurrentDayGoalVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | { __typename?: 'ChallengeConditionInfoblockNextDayGoalVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | { __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, value?: { __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedValueVisualisation', font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | null } | { __typename?: 'ChallengeConditionLeaderboardVisualisation', numberOfItems?: number | null, medalImages?: Array<string | null> | null, minWidth?: string | null, availableUnitTypeRankings?: Array<string> | null, conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null, header?: { __typename?: 'ChallengeConditionLeaderboardHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, item?: { __typename?: 'ChallengeConditionLeaderboardItemVisualisation', color?: string | null, transparent?: number | null, unit?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null, top?: { __typename?: 'ChallengeConditionLeaderboardTopItemVisualisation', count?: number | null, color?: string | null } | null } | null, columns?: Array<{ __typename?: 'ChallengeConditionLeaderboardColumnVisualisation', profileProperty?: string | null, filterEnabled?: boolean | null, header?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | { __typename?: 'ChallengeConditionTimelineVisualisation', foregroundImage?: string | null, backgroundImage?: string | null, splitterImage?: string | null, successImage?: string | null, conditionId?: string | null, banner?: { __typename?: 'ChallengeConditionTimelineBannerVisualisation', backgroundColor?: string | null, goal?: { __typename?: 'ChallengeConditionTimelineBannerGoalVisualisation', image?: string | null, currentValue?: boolean | null, endValue?: boolean | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, repeater?: { __typename?: 'ChallengeConditionTimelineBannerRepeaterVisualisation', image?: string | null, repeat?: number | null, currentFont?: { __typename?: 'ChallengeConditionFontVisualisation', size?: string | null, family?: string | null, color?: string | null } | null, totalFont?: { __typename?: 'ChallengeConditionFontVisualisation', size?: string | null, family?: string | null, color?: string | null } | null } | null, counters?: Array<{ __typename?: 'ChallengeConditionTimelineBannerCounterVisualisation', image?: string | null, unitType?: string | null, activityTypes?: Array<string | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null> | null } | null, flag?: { __typename?: 'ChallengeConditionTimelineFlagVisualisation', image?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | null> | null };

export type ExportChallengeParticipationMutationVariables = Exact<{
  filter: ChallengeParticipantFilter;
  format?: InputMaybe<Scalars['String']>;
}>;


export type ExportChallengeParticipationMutation = { __typename?: 'RootMutation', exportChallengeParticipation: { __typename?: 'Success', success: boolean } };

export type ExportChallengeParticipationFormConditionDataMutationVariables = Exact<{
  filter: ChallengeParticipantFormConditionDataFilter;
  format?: InputMaybe<Scalars['String']>;
}>;


export type ExportChallengeParticipationFormConditionDataMutation = { __typename?: 'RootMutation', exportChallengeParticipationFormConditionData: { __typename?: 'Success', success: boolean } };

export type GetChallengeCountQueryVariables = Exact<{
  filter?: InputMaybe<ChallengeFilter>;
}>;


export type GetChallengeCountQuery = { __typename?: 'RootQuery', challengeCount: number };

export type GetChallengeParticipantCountQueryVariables = Exact<{
  filter: ChallengeParticipantFilter;
}>;


export type GetChallengeParticipantCountQuery = { __typename?: 'RootQuery', challengeParticipantCount: number };

export type GetChallengeParticipantsQueryVariables = Exact<{
  filter: ChallengeParticipantFilter;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetChallengeParticipantsQuery = { __typename?: 'RootQuery', challengeParticipants: Array<{ __typename?: 'ChallengeParticipant', id: string, userId: string, createdOn?: number | null, progress?: number | null, user: { __typename?: 'User', id: string, email: string, avatar?: string | null, givenName?: string | null, familyName?: string | null, locale?: string | null, locked?: boolean | null, lastLogin?: number | null, registeredOn?: number | null, profile?: any | null, company?: { __typename?: 'Company', name: string } | null }, team?: { __typename?: 'ChallengeTeam', id?: string | null, title?: string | null, progress?: number | null } | null, challenge: { __typename?: 'Challenge', id: string, autoParticipationEnabled?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }, tieBreakerAnswers?: { __typename?: 'ChallengeParticipantTieBreakerAnswers', answer1: string, answer2: string } | null }> };

export type GetChallengeTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChallengeTagsQuery = { __typename?: 'RootQuery', challengeTags: Array<{ __typename?: 'ChallengeTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> };

export type GetChallengeTeamCountQueryVariables = Exact<{
  filter?: InputMaybe<ChallengeTeamFilter>;
}>;


export type GetChallengeTeamCountQuery = { __typename?: 'RootQuery', challengeTeamCount: number };

export type GetChallengeTeamsQueryVariables = Exact<{
  filter?: InputMaybe<ChallengeTeamFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetChallengeTeamsQuery = { __typename?: 'RootQuery', challengeTeams: Array<{ __typename?: 'ChallengeTeam', id?: string | null, title?: string | null, profileValue?: string | null, captainUserId?: string | null, memberCount?: number | null, memberIds?: Array<string | null> | null, imageUrl?: string | null, contentId?: string | null, captainUser?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null, displayName?: string | null } | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, members?: Array<{ __typename?: 'User', avatar?: string | null, displayName?: string | null, id: string, email: string, lastLogin?: number | null, registeredOn?: number | null } | null> | null }> };

export type GetChallengeTitlesQueryVariables = Exact<{
  filter?: InputMaybe<ChallengeFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetChallengeTitlesQuery = { __typename?: 'RootQuery', challenges: Array<{ __typename?: 'Challenge', id: string, visualisations?: Array<{ __typename?: 'ChallengeVisualisation', id?: string | null, type?: string | null } | null> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> };

export type GetChallengesBasicQueryVariables = Exact<{
  filter?: InputMaybe<ChallengeFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetChallengesBasicQuery = { __typename?: 'RootQuery', challenges: Array<{ __typename?: 'Challenge', id: string, activityTypes?: Array<string | null> | null, roles?: Array<string | null> | null, autoParticipationEnabled?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, duration?: { __typename?: 'ChallengeDuration', start?: number | null, end?: number | null } | null, visualisations?: Array<{ __typename?: 'ChallengeVisualisation', id?: string | null, type?: string | null } | null> | null, team?: { __typename?: 'ChallengeTeamConfig', enabled?: boolean | null, fixedTeams?: boolean | null } | null, voucherConfiguration?: { __typename?: 'ChallengeVoucherConfiguration', required: boolean, url?: string | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null }> };

export type GetChallengesDetailQueryVariables = Exact<{
  filter?: InputMaybe<ChallengeFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetChallengesDetailQuery = { __typename?: 'RootQuery', challenges: Array<{ __typename?: 'Challenge', id: string, enabledLocales?: Array<string> | null, imageUrl?: string | null, difficultyLevel?: number | null, activityTypes?: Array<string | null> | null, conditionsInOrder?: boolean | null, ultimateSyncTime?: number | null, featured?: boolean | null, publishedOn?: number | null, expiresOn?: number | null, visualizeType?: string | null, roles?: Array<string | null> | null, exceedConditionLimit?: boolean | null, hideInList?: boolean | null, hideProgressInList?: boolean | null, hideProgressInDetails?: boolean | null, hideProgressInInsights?: boolean | null, priority?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, viewCompletedParticipants?: boolean | null, viewTeamCount?: boolean | null, data?: any | null, autoParticipationEnabled?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, rewards?: { __typename?: 'ChallengeRewards', credits?: number | null, prizes?: Array<{ __typename?: 'ChallengePrize', imageUrl?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null, duration?: { __typename?: 'ChallengeDuration', start?: number | null, end?: number | null } | null, registration?: { __typename?: 'ChallengeRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, participateOnStart?: boolean | null } | null, tieBreaker?: { __typename?: 'ChallengeTieBreaker', active?: boolean | null, forAllTeamMembers?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, question1?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, question2?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, conditions?: Array<{ __typename?: 'ChallengeActivityCondition', activities?: Array<string | null> | null, value?: number | null, unitType?: string | null, unit?: string | null, id?: string | null, sequence?: number | null, type?: string | null, startTime?: number | null, endTime?: number | null, credits?: number | null, inOneGo?: { __typename?: 'ChallengeConditionInOneGo', enabled?: boolean | null, repeat?: number | null } | null, timespan?: { __typename?: 'ChallengeConditionTimespan', enabled?: boolean | null, value?: number | null, unit?: string | null } | null, repeated?: { __typename?: 'ChallengeConditionRepeat', enabled?: boolean | null, value?: number | null, sequential?: boolean | null } | null, blockManualActivities?: { __typename?: 'ChallengeConditionBlockManualActivities', enabled: boolean } | null } | { __typename?: 'ChallengeFormCondition', image?: string | null, id?: string | null, sequence?: number | null, type?: string | null, startTime?: number | null, endTime?: number | null, credits?: number | null, formTemplate?: { __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, milestones?: Array<{ __typename?: 'ChallengeMilestone', id?: string | null, percentage?: number | null, conditionId?: string | null, imageUrl?: string | null, notificationsEnabled?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, email?: { __typename?: 'ChallengeMilestoneEmail', subject?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, body?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null } | null> | null, team?: { __typename?: 'ChallengeTeamConfig', enabled?: boolean | null, fixedTeams?: boolean | null, profileProperty?: string | null, maxMembers?: number | null, inviteCodeEnabled?: boolean | null } | null, endless?: { __typename?: 'ChallengeEndless', enabled?: boolean | null, activityTypes?: Array<string | null> | null, unitType?: string | null, rankingAlgorithm?: string | null } | null, payment?: { __typename?: 'ChallengePayment', enabled?: boolean | null, action?: string | null, payAmount?: number | null, freeCredits?: number | null, overwriteDefinitions?: Array<{ __typename?: 'ChallengePaymentOverwriteDefinition', id?: string | null, roles?: Array<string | null> | null, action?: string | null, payAmount?: number | null, freeCredits?: number | null } | null> | null } | null, totals?: { __typename?: 'ChallengeTotals', distanceVisible?: boolean | null, distanceUnit?: string | null, durationVisible?: boolean | null, durationUnit?: string | null, stepsVisible?: boolean | null, caloriesVisible?: boolean | null, caloriesUnit?: string | null, elevationVisible?: boolean | null, elevationUnit?: string | null, creditsEarnedVisible?: boolean | null, workoutsVisible?: boolean | null } | null, visualisations?: Array<{ __typename?: 'ChallengeVisualisation', id?: string | null, type?: string | null, place?: string | null, dataType?: string | null, clickable?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, conditions?: Array<{ __typename?: 'ChallengeConditionBarVisualisation', colors?: Array<string | null> | null, currentValue?: boolean | null, endValue?: boolean | null, numberOfItems?: number | null, order?: string | null, conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundBarVisualisation', image?: string | null, color?: string | null, height?: string | null } | null, label?: { __typename?: 'ChallengeConditionBarLabelVisualisation', backgroundColor?: string | null, limitCharacters?: boolean | null, textDirection?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null } | { __typename?: 'ChallengeConditionGridVisualisation', order?: string | null, conditionId?: string | null, columns?: Array<{ __typename?: 'ChallengeConditionGridColumnVisualisation', columnType?: string | null, conditionId?: string | null, profileProperty?: string | null, header?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, header?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, item?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, rowLabel?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, right?: string | null, bottom?: string | null } | null, images?: { __typename?: 'ChallengeConditionGridImagesVisualisation', notStarted?: string | null, inProgress?: string | null, success?: string | null } | null } | { __typename?: 'ChallengeConditionInfoblockVisualisation', conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null, infoblock?: { __typename?: 'ChallengeConditionInfoblockCurrentDayConditionVisualisation', type?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null, conditionLabels?: Array<{ __typename?: 'ChallengeConditionInfoblockConditionLabelVisualisation', conditionId?: string | null, text?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | { __typename?: 'ChallengeConditionInfoblockCurrentDayGoalVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | { __typename?: 'ChallengeConditionInfoblockNextDayGoalVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | { __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, value?: { __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedValueVisualisation', font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | null } | { __typename?: 'ChallengeConditionLeaderboardVisualisation', numberOfItems?: number | null, medalImages?: Array<string | null> | null, minWidth?: string | null, availableUnitTypeRankings?: Array<string> | null, conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null, header?: { __typename?: 'ChallengeConditionLeaderboardHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, item?: { __typename?: 'ChallengeConditionLeaderboardItemVisualisation', color?: string | null, transparent?: number | null, unit?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null, top?: { __typename?: 'ChallengeConditionLeaderboardTopItemVisualisation', count?: number | null, color?: string | null } | null } | null, columns?: Array<{ __typename?: 'ChallengeConditionLeaderboardColumnVisualisation', profileProperty?: string | null, filterEnabled?: boolean | null, header?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | { __typename?: 'ChallengeConditionTimelineVisualisation', foregroundImage?: string | null, backgroundImage?: string | null, splitterImage?: string | null, successImage?: string | null, conditionId?: string | null, banner?: { __typename?: 'ChallengeConditionTimelineBannerVisualisation', backgroundColor?: string | null, goal?: { __typename?: 'ChallengeConditionTimelineBannerGoalVisualisation', image?: string | null, currentValue?: boolean | null, endValue?: boolean | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, repeater?: { __typename?: 'ChallengeConditionTimelineBannerRepeaterVisualisation', image?: string | null, repeat?: number | null, currentFont?: { __typename?: 'ChallengeConditionFontVisualisation', size?: string | null, family?: string | null, color?: string | null } | null, totalFont?: { __typename?: 'ChallengeConditionFontVisualisation', size?: string | null, family?: string | null, color?: string | null } | null } | null, counters?: Array<{ __typename?: 'ChallengeConditionTimelineBannerCounterVisualisation', image?: string | null, unitType?: string | null, activityTypes?: Array<string | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null> | null } | null, flag?: { __typename?: 'ChallengeConditionTimelineFlagVisualisation', image?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'ChallengeTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> | null, voucherConfiguration?: { __typename?: 'ChallengeVoucherConfiguration', required: boolean, url?: string | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, participationProfileRequirements?: Array<{ __typename?: 'ChallengeProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null, relatedContents?: Array<{ __typename?: 'Content', id: string }> | null, superDates?: { __typename?: 'SuperDates', multiplier?: number | null, dates?: Array<{ __typename?: 'SuperDatesRange', from: number, to: number, multiplier?: number | null }> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, activityMultipliers?: { __typename?: 'ChallengeActivityMultipliers', walking?: number | null, running?: number | null, swimming?: number | null, workout?: number | null, cycling?: number | null } | null }> };

export type RemoveChallengeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveChallengeMutation = { __typename?: 'RootMutation', removeChallenge: { __typename?: 'Success', success: boolean } };

export type RemoveChallengeParticipationMutationVariables = Exact<{
  userId: Scalars['String'];
  challengeId: Scalars['String'];
}>;


export type RemoveChallengeParticipationMutation = { __typename?: 'RootMutation', removeChallengeParticipation: { __typename?: 'Success', success: boolean } };

export type RemoveChallengeTagMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveChallengeTagMutation = { __typename?: 'RootMutation', removeChallengeTag: { __typename?: 'Success', success: boolean } };

export type RemoveChallengeTeamMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveChallengeTeamMutation = { __typename?: 'RootMutation', removeChallengeTeam: { __typename?: 'Success', success: boolean } };

export type RemoveFromChallengeTeamMutationVariables = Exact<{
  teamId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type RemoveFromChallengeTeamMutation = { __typename?: 'RootMutation', removeFromChallengeTeam: { __typename?: 'ChallengeTeam', id?: string | null } };

export type ResyncChallengeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResyncChallengeMutation = { __typename?: 'RootMutation', resyncChallenge: { __typename?: 'Success', success: boolean } };

export type SendMilestoneEmailMutationVariables = Exact<{
  challengeId: Scalars['String'];
  milestoneId: Scalars['String'];
}>;


export type SendMilestoneEmailMutation = { __typename?: 'RootMutation', sendChallengeMilestoneEmail: { __typename?: 'Success', success: boolean } };

export type UpdateChallengeMutationVariables = Exact<{
  id: Scalars['String'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  subtitle?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  rewards?: InputMaybe<ChallengeRewardsInput>;
  difficultyLevel?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<ChallengeDurationInput>;
  registration?: InputMaybe<ChallengeRegistrationInput>;
  activityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tieBreaker?: InputMaybe<ChallengeTieBreakerInput>;
  conditionsInOrder?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Array<InputMaybe<Scalars['ChallengeConditionInput']>> | InputMaybe<Scalars['ChallengeConditionInput']>>;
  ultimateSyncTime?: InputMaybe<Scalars['Float']>;
  milestones?: InputMaybe<Array<InputMaybe<ChallengeMilestoneInput>> | InputMaybe<ChallengeMilestoneInput>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  publishedOn?: InputMaybe<Scalars['Float']>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  visualizeType?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  team?: InputMaybe<ChallengeTeamConfigInput>;
  endless?: InputMaybe<ChallengeEndlessInput>;
  exceedConditionLimit?: InputMaybe<Scalars['Boolean']>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  hideProgressInList?: InputMaybe<Scalars['Boolean']>;
  hideProgressInDetails?: InputMaybe<Scalars['Boolean']>;
  hideProgressInInsights?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  payment?: InputMaybe<ChallengePaymentInput>;
  totals?: InputMaybe<ChallengeTotalsInput>;
  visualisations?: InputMaybe<Array<InputMaybe<Scalars['ChallengeVisualisationInput']>> | InputMaybe<Scalars['ChallengeVisualisationInput']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  viewParticipants?: InputMaybe<Scalars['Boolean']>;
  viewParticipantCount?: InputMaybe<Scalars['Boolean']>;
  viewTeamCount?: InputMaybe<Scalars['Boolean']>;
  viewCompletedParticipants?: InputMaybe<Scalars['Boolean']>;
  voucherConfiguration?: InputMaybe<ChallengeVoucherConfigurationInput>;
  enabledLocales?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  participationProfileRequirements?: InputMaybe<Array<ChallengeProfileFieldsInput> | ChallengeProfileFieldsInput>;
  data?: InputMaybe<Scalars['JSON']>;
  contentsIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  superDates?: InputMaybe<SuperDatesInput>;
  autoParticipationEnabled?: InputMaybe<Scalars['Boolean']>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
  activityMultipliers?: InputMaybe<ChallengeActivityMultipliersInput>;
}>;


export type UpdateChallengeMutation = { __typename?: 'RootMutation', updateChallenge: { __typename?: 'Challenge', id: string, enabledLocales?: Array<string> | null, imageUrl?: string | null, difficultyLevel?: number | null, activityTypes?: Array<string | null> | null, conditionsInOrder?: boolean | null, ultimateSyncTime?: number | null, featured?: boolean | null, publishedOn?: number | null, expiresOn?: number | null, visualizeType?: string | null, roles?: Array<string | null> | null, exceedConditionLimit?: boolean | null, hideInList?: boolean | null, hideProgressInList?: boolean | null, hideProgressInDetails?: boolean | null, hideProgressInInsights?: boolean | null, priority?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, viewCompletedParticipants?: boolean | null, viewTeamCount?: boolean | null, data?: any | null, autoParticipationEnabled?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, rewards?: { __typename?: 'ChallengeRewards', credits?: number | null, prizes?: Array<{ __typename?: 'ChallengePrize', imageUrl?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null, duration?: { __typename?: 'ChallengeDuration', start?: number | null, end?: number | null } | null, registration?: { __typename?: 'ChallengeRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, participateOnStart?: boolean | null } | null, tieBreaker?: { __typename?: 'ChallengeTieBreaker', active?: boolean | null, forAllTeamMembers?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, question1?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, question2?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, conditions?: Array<{ __typename?: 'ChallengeActivityCondition', activities?: Array<string | null> | null, value?: number | null, unitType?: string | null, unit?: string | null, id?: string | null, sequence?: number | null, type?: string | null, startTime?: number | null, endTime?: number | null, credits?: number | null, inOneGo?: { __typename?: 'ChallengeConditionInOneGo', enabled?: boolean | null, repeat?: number | null } | null, timespan?: { __typename?: 'ChallengeConditionTimespan', enabled?: boolean | null, value?: number | null, unit?: string | null } | null, repeated?: { __typename?: 'ChallengeConditionRepeat', enabled?: boolean | null, value?: number | null, sequential?: boolean | null } | null, blockManualActivities?: { __typename?: 'ChallengeConditionBlockManualActivities', enabled: boolean } | null } | { __typename?: 'ChallengeFormCondition', image?: string | null, id?: string | null, sequence?: number | null, type?: string | null, startTime?: number | null, endTime?: number | null, credits?: number | null, formTemplate?: { __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, milestones?: Array<{ __typename?: 'ChallengeMilestone', id?: string | null, percentage?: number | null, conditionId?: string | null, imageUrl?: string | null, notificationsEnabled?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, email?: { __typename?: 'ChallengeMilestoneEmail', subject?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, body?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null } | null> | null, team?: { __typename?: 'ChallengeTeamConfig', enabled?: boolean | null, fixedTeams?: boolean | null, profileProperty?: string | null, maxMembers?: number | null, inviteCodeEnabled?: boolean | null } | null, endless?: { __typename?: 'ChallengeEndless', enabled?: boolean | null, activityTypes?: Array<string | null> | null, unitType?: string | null, rankingAlgorithm?: string | null } | null, payment?: { __typename?: 'ChallengePayment', enabled?: boolean | null, action?: string | null, payAmount?: number | null, freeCredits?: number | null, overwriteDefinitions?: Array<{ __typename?: 'ChallengePaymentOverwriteDefinition', id?: string | null, roles?: Array<string | null> | null, action?: string | null, payAmount?: number | null, freeCredits?: number | null } | null> | null } | null, totals?: { __typename?: 'ChallengeTotals', distanceVisible?: boolean | null, distanceUnit?: string | null, durationVisible?: boolean | null, durationUnit?: string | null, stepsVisible?: boolean | null, caloriesVisible?: boolean | null, caloriesUnit?: string | null, elevationVisible?: boolean | null, elevationUnit?: string | null, creditsEarnedVisible?: boolean | null, workoutsVisible?: boolean | null } | null, visualisations?: Array<{ __typename?: 'ChallengeVisualisation', id?: string | null, type?: string | null, place?: string | null, dataType?: string | null, clickable?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, conditions?: Array<{ __typename?: 'ChallengeConditionBarVisualisation', colors?: Array<string | null> | null, currentValue?: boolean | null, endValue?: boolean | null, numberOfItems?: number | null, order?: string | null, conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundBarVisualisation', image?: string | null, color?: string | null, height?: string | null } | null, label?: { __typename?: 'ChallengeConditionBarLabelVisualisation', backgroundColor?: string | null, limitCharacters?: boolean | null, textDirection?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null } | { __typename?: 'ChallengeConditionGridVisualisation', order?: string | null, conditionId?: string | null, columns?: Array<{ __typename?: 'ChallengeConditionGridColumnVisualisation', columnType?: string | null, conditionId?: string | null, profileProperty?: string | null, header?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, header?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, item?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, rowLabel?: { __typename?: 'ChallengeConditionGridHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, right?: string | null, bottom?: string | null } | null, images?: { __typename?: 'ChallengeConditionGridImagesVisualisation', notStarted?: string | null, inProgress?: string | null, success?: string | null } | null } | { __typename?: 'ChallengeConditionInfoblockVisualisation', conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null, infoblock?: { __typename?: 'ChallengeConditionInfoblockCurrentDayConditionVisualisation', type?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null, conditionLabels?: Array<{ __typename?: 'ChallengeConditionInfoblockConditionLabelVisualisation', conditionId?: string | null, text?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | { __typename?: 'ChallengeConditionInfoblockCurrentDayGoalVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | { __typename?: 'ChallengeConditionInfoblockNextDayGoalVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | { __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedVisualisation', type?: string | null, title?: { __typename?: 'ChallengeConditionInfoblockTitleVisualisation', label?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, value?: { __typename?: 'ChallengeConditionInfoblockParticipantCountAllConditionsCompletedValueVisualisation', font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | null } | { __typename?: 'ChallengeConditionLeaderboardVisualisation', numberOfItems?: number | null, medalImages?: Array<string | null> | null, minWidth?: string | null, availableUnitTypeRankings?: Array<string> | null, conditionId?: string | null, background?: { __typename?: 'ChallengeConditionBackgroundVisualisation', image?: string | null, color?: string | null } | null, margin?: { __typename?: 'ChallengeConditionMarginVisualisation', top?: string | null, left?: string | null, bottom?: string | null, right?: string | null } | null, header?: { __typename?: 'ChallengeConditionLeaderboardHeaderVisualisation', color?: string | null, transparent?: number | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, item?: { __typename?: 'ChallengeConditionLeaderboardItemVisualisation', color?: string | null, transparent?: number | null, unit?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null, top?: { __typename?: 'ChallengeConditionLeaderboardTopItemVisualisation', count?: number | null, color?: string | null } | null } | null, columns?: Array<{ __typename?: 'ChallengeConditionLeaderboardColumnVisualisation', profileProperty?: string | null, filterEnabled?: boolean | null, header?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | { __typename?: 'ChallengeConditionTimelineVisualisation', foregroundImage?: string | null, backgroundImage?: string | null, splitterImage?: string | null, successImage?: string | null, conditionId?: string | null, banner?: { __typename?: 'ChallengeConditionTimelineBannerVisualisation', backgroundColor?: string | null, goal?: { __typename?: 'ChallengeConditionTimelineBannerGoalVisualisation', image?: string | null, currentValue?: boolean | null, endValue?: boolean | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null, repeater?: { __typename?: 'ChallengeConditionTimelineBannerRepeaterVisualisation', image?: string | null, repeat?: number | null, currentFont?: { __typename?: 'ChallengeConditionFontVisualisation', size?: string | null, family?: string | null, color?: string | null } | null, totalFont?: { __typename?: 'ChallengeConditionFontVisualisation', size?: string | null, family?: string | null, color?: string | null } | null } | null, counters?: Array<{ __typename?: 'ChallengeConditionTimelineBannerCounterVisualisation', image?: string | null, unitType?: string | null, activityTypes?: Array<string | null> | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null> | null } | null, flag?: { __typename?: 'ChallengeConditionTimelineFlagVisualisation', image?: string | null, font?: { __typename?: 'ChallengeConditionFontVisualisation', family?: string | null, size?: string | null, color?: string | null } | null } | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'ChallengeTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> | null, voucherConfiguration?: { __typename?: 'ChallengeVoucherConfiguration', required: boolean, url?: string | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, participationProfileRequirements?: Array<{ __typename?: 'ChallengeProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null, relatedContents?: Array<{ __typename?: 'Content', id: string }> | null, superDates?: { __typename?: 'SuperDates', multiplier?: number | null, dates?: Array<{ __typename?: 'SuperDatesRange', from: number, to: number, multiplier?: number | null }> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, activityMultipliers?: { __typename?: 'ChallengeActivityMultipliers', walking?: number | null, running?: number | null, swimming?: number | null, workout?: number | null, cycling?: number | null } | null } };

export type UpdateChallengeTagMutationVariables = Exact<{
  id: Scalars['String'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  image?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
}>;


export type UpdateChallengeTagMutation = { __typename?: 'RootMutation', updateChallengeTag: { __typename?: 'ChallengeTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type UpdateChallengeTeamMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
  profileValue?: InputMaybe<Scalars['String']>;
  captainUserId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<TextByLanguageInput> | TextByLanguageInput>;
  imageUrl?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateChallengeTeamMutation = { __typename?: 'RootMutation', updateChallengeTeam: { __typename?: 'ChallengeTeam', id?: string | null, title?: string | null, profileValue?: string | null, captainUserId?: string | null, memberCount?: number | null, memberIds?: Array<string | null> | null, imageUrl?: string | null, contentId?: string | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } };

export type UpdateChallengeTeamCaptainMutationVariables = Exact<{
  id: Scalars['String'];
  captainUserId: Scalars['String'];
}>;


export type UpdateChallengeTeamCaptainMutation = { __typename?: 'RootMutation', updateChallengeTeam: { __typename?: 'ChallengeTeam', id?: string | null } };

export type AddCheckupLocationAvailabilityMutationVariables = Exact<{
  from: Scalars['Float'];
  to: Scalars['Float'];
  coachId: Scalars['String'];
  checkupLocationId: Scalars['String'];
  cost: CheckupLocationAvailabilityCostInput;
  coachType: Scalars['String'];
}>;


export type AddCheckupLocationAvailabilityMutation = { __typename?: 'RootMutation', addCheckupLocationAvailability: { __typename?: 'CheckupLocationAvailability', id: string, from: number, to: number, free: boolean, coachId: string, checkupLocationId: string, coachType: string, coach: { __typename?: 'User', id: string, displayName?: string | null, givenName?: string | null, familyName?: string | null }, checkupLocation: { __typename?: 'CheckupLocation', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } } };

export type CheckupLocationAvailabilityFragment = { __typename?: 'CheckupLocationAvailability', id: string, from: number, to: number, free: boolean, coachId: string, checkupLocationId: string, coachType: string, coach: { __typename?: 'User', id: string, displayName?: string | null, givenName?: string | null, familyName?: string | null }, checkupLocation: { __typename?: 'CheckupLocation', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type CheckupParticipationFragment = { __typename?: 'CheckupParticipation', id: string, journeyId?: string | null, checkupLocationId: string, userId?: string | null, checkupResultPdf?: string | null, checkupStart: number, checkupEnd: number, bookedOn: number, isPaid: boolean, paidOn?: number | null, journey?: { __typename?: 'EventJourney', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | { __typename?: 'PersonalJourney', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null, checkupLocation: { __typename?: 'CheckupLocation', id: string, location: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }, user?: { __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null } | null, payments: Array<{ __typename?: 'Payment', id: string, paymentMethod: string, type: string, lastStatus: { __typename?: 'PaymentStatus', status: string } }> };

export type GetCheckupLocationAvailabilitiesQueryVariables = Exact<{
  filter?: InputMaybe<CheckupLocationAvailabilityFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetCheckupLocationAvailabilitiesQuery = { __typename?: 'RootQuery', checkupLocationAvailabilities: Array<{ __typename?: 'CheckupLocationAvailability', id: string, from: number, to: number, free: boolean, coachId: string, checkupLocationId: string, coachType: string, coach: { __typename?: 'User', id: string, displayName?: string | null, givenName?: string | null, familyName?: string | null }, checkupLocation: { __typename?: 'CheckupLocation', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } }> };

export type GetCheckupLocationAvailabilityCountQueryVariables = Exact<{
  filter?: InputMaybe<CheckupLocationAvailabilityFilter>;
}>;


export type GetCheckupLocationAvailabilityCountQuery = { __typename?: 'RootQuery', checkupLocationAvailabilityCount: number };

export type GetCheckupLocationCountQueryVariables = Exact<{
  filter?: InputMaybe<CheckupLocationFilter>;
}>;


export type GetCheckupLocationCountQuery = { __typename?: 'RootQuery', checkupLocationCount: number };

export type GetCheckupLocationsQueryVariables = Exact<{
  filter?: InputMaybe<CheckupLocationFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetCheckupLocationsQuery = { __typename?: 'RootQuery', checkupLocations: Array<{ __typename?: 'CheckupLocation', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> };

export type GetCheckupParticipationCountQueryVariables = Exact<{
  filter?: InputMaybe<CheckupParticipationFilter>;
}>;


export type GetCheckupParticipationCountQuery = { __typename?: 'RootQuery', checkupParticipationCount: number };

export type GetCheckupParticipationsQueryVariables = Exact<{
  filter?: InputMaybe<CheckupParticipationFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetCheckupParticipationsQuery = { __typename?: 'RootQuery', checkupParticipations: Array<{ __typename?: 'CheckupParticipation', id: string, journeyId?: string | null, checkupLocationId: string, userId?: string | null, checkupResultPdf?: string | null, checkupStart: number, checkupEnd: number, bookedOn: number, isPaid: boolean, paidOn?: number | null, journey?: { __typename?: 'EventJourney', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | { __typename?: 'PersonalJourney', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null, checkupLocation: { __typename?: 'CheckupLocation', id: string, location: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }, user?: { __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null } | null, payments: Array<{ __typename?: 'Payment', id: string, paymentMethod: string, type: string, lastStatus: { __typename?: 'PaymentStatus', status: string } }> }> };

export type RemoveCheckupLocationAvailabilityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveCheckupLocationAvailabilityMutation = { __typename?: 'RootMutation', removeCheckupLocationAvailability: { __typename?: 'Success', success: boolean } };

export type UpdateCheckupLocationAvailabilityMutationVariables = Exact<{
  id: Scalars['String'];
  from?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['Float']>;
  coachId?: InputMaybe<Scalars['String']>;
  checkupLocationId?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<CheckupLocationAvailabilityCostInput>;
  coachType?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCheckupLocationAvailabilityMutation = { __typename?: 'RootMutation', updateCheckupLocationAvailability: { __typename?: 'CheckupLocationAvailability', id: string, from: number, to: number, free: boolean, coachId: string, checkupLocationId: string, coachType: string, coach: { __typename?: 'User', id: string, displayName?: string | null, givenName?: string | null, familyName?: string | null }, checkupLocation: { __typename?: 'CheckupLocation', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } } };

type Comment_AmbassadorComment_Fragment = { __typename?: 'AmbassadorComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> };

type Comment_ChallengeComment_Fragment = { __typename?: 'ChallengeComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> };

type Comment_ContentComment_Fragment = { __typename?: 'ContentComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> };

type Comment_EventComment_Fragment = { __typename?: 'EventComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> };

type Comment_GalleryComment_Fragment = { __typename?: 'GalleryComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> };

type Comment_GalleryImageComment_Fragment = { __typename?: 'GalleryImageComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> };

export type CommentFragment = Comment_AmbassadorComment_Fragment | Comment_ChallengeComment_Fragment | Comment_ContentComment_Fragment | Comment_EventComment_Fragment | Comment_GalleryComment_Fragment | Comment_GalleryImageComment_Fragment;

export type GetCommentCountQueryVariables = Exact<{
  filter?: InputMaybe<CommentFilter>;
}>;


export type GetCommentCountQuery = { __typename?: 'RootQuery', commentCount: number };

export type GetCommentsQueryVariables = Exact<{
  filter?: InputMaybe<CommentFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetCommentsQuery = { __typename?: 'RootQuery', comments: Array<{ __typename?: 'AmbassadorComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> } | { __typename?: 'ChallengeComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> } | { __typename?: 'ContentComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> } | { __typename?: 'EventComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> } | { __typename?: 'GalleryComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> } | { __typename?: 'GalleryImageComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> }> };

export type RemoveCommentMutationVariables = Exact<{
  id: Scalars['String'];
  userId: Scalars['String'];
}>;


export type RemoveCommentMutation = { __typename?: 'RootMutation', removeComment: { __typename?: 'Success', success: boolean } };

export type UpdateCommentMutationVariables = Exact<{
  id: Scalars['String'];
  reported?: InputMaybe<Scalars['Boolean']>;
  moderated?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCommentMutation = { __typename?: 'RootMutation', updateComment: { __typename?: 'AmbassadorComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> } | { __typename?: 'ChallengeComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> } | { __typename?: 'ContentComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> } | { __typename?: 'EventComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> } | { __typename?: 'GalleryComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> } | { __typename?: 'GalleryImageComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null }, subComments: Array<{ __typename?: 'SubComment', id: string, type: string, typeId: string, userId: string, comment: string, reported: boolean, moderated: boolean, deleted: boolean, parentId?: string | null, user?: { __typename?: 'User', id: string, avatar?: string | null, displayName?: string | null } | null }> } };

export type CompanyFragment = { __typename?: 'Company', id: string, name: string, code: string, role: string, limitRegistrations: boolean, maxRegistrations: number, logo?: string | null, coach?: string | null, brandColor?: string | null, languages?: Array<string> | null, hasSupport?: boolean | null, project: { __typename?: 'Project', id?: string | null, name?: string | null }, introMessage?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, introTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, team?: { __typename?: 'CompanyTeam', picture?: string | null, selectPicture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectSubtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, connect?: { __typename?: 'CompanyConnect', picture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, profileRequirements?: Array<{ __typename?: 'ProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null };

export type AddCompanyMutationVariables = Exact<{
  projectId: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  role: Scalars['String'];
  limitRegistrations: Scalars['Boolean'];
  maxRegistrations: Scalars['Int'];
  hasSupport?: InputMaybe<Scalars['Boolean']>;
  coach?: InputMaybe<Scalars['String']>;
  brandColor?: InputMaybe<Scalars['String']>;
  connect?: InputMaybe<CompanyConnectInput>;
  team?: InputMaybe<CompanyTeamInput>;
  languages?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  introMessage?: InputMaybe<Array<TextByLanguageInput> | TextByLanguageInput>;
  introTitle?: InputMaybe<Array<TextByLanguageInput> | TextByLanguageInput>;
  logo?: InputMaybe<Scalars['String']>;
  profileRequirements?: InputMaybe<Array<ProfileFieldsInput> | ProfileFieldsInput>;
}>;


export type AddCompanyMutation = { __typename?: 'RootMutation', addCompany: { __typename?: 'Company', id: string, name: string, code: string, role: string, limitRegistrations: boolean, maxRegistrations: number, logo?: string | null, coach?: string | null, brandColor?: string | null, languages?: Array<string> | null, hasSupport?: boolean | null, project: { __typename?: 'Project', id?: string | null, name?: string | null }, introMessage?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, introTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, team?: { __typename?: 'CompanyTeam', picture?: string | null, selectPicture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectSubtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, connect?: { __typename?: 'CompanyConnect', picture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, profileRequirements?: Array<{ __typename?: 'ProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null } };

export type GetCompaniesQueryVariables = Exact<{
  filter?: InputMaybe<CompanyFilter>;
}>;


export type GetCompaniesQuery = { __typename?: 'RootQuery', companies: Array<{ __typename?: 'Company', id: string, name: string, code: string, role: string, limitRegistrations: boolean, maxRegistrations: number, logo?: string | null, coach?: string | null, brandColor?: string | null, languages?: Array<string> | null, hasSupport?: boolean | null, project: { __typename?: 'Project', id?: string | null, name?: string | null }, introMessage?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, introTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, team?: { __typename?: 'CompanyTeam', picture?: string | null, selectPicture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectSubtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, connect?: { __typename?: 'CompanyConnect', picture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, profileRequirements?: Array<{ __typename?: 'ProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null } | null> };

export type RemoveCompanyMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveCompanyMutation = { __typename?: 'RootMutation', removeCompany: { __typename?: 'Success', success: boolean } };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['String'];
  projectId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  limitRegistrations?: InputMaybe<Scalars['Boolean']>;
  maxRegistrations?: InputMaybe<Scalars['Int']>;
  hasSupport?: InputMaybe<Scalars['Boolean']>;
  coach?: InputMaybe<Scalars['String']>;
  brandColor?: InputMaybe<Scalars['String']>;
  connect?: InputMaybe<CompanyConnectInput>;
  team?: InputMaybe<CompanyTeamInput>;
  languages?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  introMessage?: InputMaybe<Array<TextByLanguageInput> | TextByLanguageInput>;
  introTitle?: InputMaybe<Array<TextByLanguageInput> | TextByLanguageInput>;
  logo?: InputMaybe<Scalars['String']>;
  profileRequirements?: InputMaybe<Array<ProfileFieldsInput> | ProfileFieldsInput>;
}>;


export type UpdateCompanyMutation = { __typename?: 'RootMutation', updateCompany: { __typename?: 'Company', id: string, name: string, code: string, role: string, limitRegistrations: boolean, maxRegistrations: number, logo?: string | null, coach?: string | null, brandColor?: string | null, languages?: Array<string> | null, hasSupport?: boolean | null, project: { __typename?: 'Project', id?: string | null, name?: string | null }, introMessage?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, introTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, team?: { __typename?: 'CompanyTeam', picture?: string | null, selectPicture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectSubtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, connect?: { __typename?: 'CompanyConnect', picture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, profileRequirements?: Array<{ __typename?: 'ProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null } };

export type ConsumeConfirmCodeMutationVariables = Exact<{
  confirmCodeChallengeId: Scalars['String'];
  confirmCode: Scalars['String'];
}>;


export type ConsumeConfirmCodeMutation = { __typename?: 'RootMutation', consumeConfirmCode: { __typename?: 'LoginData', jwtToken?: string | null, confirmCodeChallengeId?: string | null, userId?: string | null, profile?: { __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null, email: string } | null } };

export type AddContentMutationVariables = Exact<{
  type: Scalars['String'];
  isPublic: Scalars['Boolean'];
  publishOn: Scalars['Float'];
  expiresOn: Scalars['Float'];
  isDraft: Scalars['Boolean'];
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  content: Array<TextByLanguageInput> | TextByLanguageInput;
  preview: Array<TextByLanguageInput> | TextByLanguageInput;
  imageUrl: Scalars['String'];
  url: Scalars['String'];
  roles: Array<Scalars['String']> | Scalars['String'];
  tags: Array<Scalars['String']> | Scalars['String'];
  attachments: Array<Scalars['ContentAttachmentInput']> | Scalars['ContentAttachmentInput'];
  featured?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
  enabledLocales: Array<Scalars['String']> | Scalars['String'];
  disableComments?: InputMaybe<Scalars['Boolean']>;
  isAdvancedMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddContentMutation = { __typename?: 'RootMutation', addContent: { __typename?: 'Content', id: string, type?: string | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, isPublic?: boolean | null, imageUrl?: string | null, url?: string | null, roles?: Array<string | null> | null, userId?: string | null, featured?: boolean | null, enabledLocales: Array<string>, disableComments?: boolean | null, isAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, content?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, tags: Array<{ __typename?: 'ContentTag', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, attachments: Array<{ __typename?: 'ContentImageAttachment', url: string, type: string }> } };

export type AddContentTagMutationVariables = Exact<{
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  description: Array<TextByLanguageInput> | TextByLanguageInput;
  image: Scalars['String'];
  color: Scalars['String'];
}>;


export type AddContentTagMutation = { __typename?: 'RootMutation', addContentTag: { __typename?: 'ContentTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type ContentFragment = { __typename?: 'Content', id: string, type?: string | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, isPublic?: boolean | null, imageUrl?: string | null, url?: string | null, roles?: Array<string | null> | null, userId?: string | null, featured?: boolean | null, enabledLocales: Array<string>, disableComments?: boolean | null, isAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, content?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, tags: Array<{ __typename?: 'ContentTag', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, attachments: Array<{ __typename?: 'ContentImageAttachment', url: string, type: string }> };

export type ContentTagFragment = { __typename?: 'ContentTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> };

export type GetContentCountQueryVariables = Exact<{
  filter?: InputMaybe<ContentFilter>;
}>;


export type GetContentCountQuery = { __typename?: 'RootQuery', contentCount: number };

export type GetContentTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentTagsQuery = { __typename?: 'RootQuery', contentTags: Array<{ __typename?: 'ContentTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> };

export type GetContentTitlesQueryVariables = Exact<{
  filter?: InputMaybe<ContentFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetContentTitlesQuery = { __typename?: 'RootQuery', contents: Array<{ __typename?: 'Content', id: string, publishOn?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> };

export type GetContentsQueryVariables = Exact<{
  filter?: InputMaybe<ContentFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetContentsQuery = { __typename?: 'RootQuery', contents: Array<{ __typename?: 'Content', id: string, type?: string | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, isPublic?: boolean | null, imageUrl?: string | null, url?: string | null, roles?: Array<string | null> | null, userId?: string | null, featured?: boolean | null, enabledLocales: Array<string>, disableComments?: boolean | null, isAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, content?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, tags: Array<{ __typename?: 'ContentTag', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, attachments: Array<{ __typename?: 'ContentImageAttachment', url: string, type: string }> }> };

export type RemoveContentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveContentMutation = { __typename?: 'RootMutation', removeContent: { __typename?: 'Success', success: boolean } };

export type RemoveContentTagMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveContentTagMutation = { __typename?: 'RootMutation', removeContentTag: { __typename?: 'Success', success: boolean } };

export type UpdateContentMutationVariables = Exact<{
  id: Scalars['String'];
  isPublic: Scalars['Boolean'];
  type?: InputMaybe<Scalars['String']>;
  publishOn?: InputMaybe<Scalars['Float']>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  content?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  preview?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ContentAttachmentInput']>> | InputMaybe<Scalars['ContentAttachmentInput']>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
  enabledLocales: Array<Scalars['String']> | Scalars['String'];
  disableComments?: InputMaybe<Scalars['Boolean']>;
  isAdvancedMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateContentMutation = { __typename?: 'RootMutation', updateContent: { __typename?: 'Content', id: string, type?: string | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, isPublic?: boolean | null, imageUrl?: string | null, url?: string | null, roles?: Array<string | null> | null, userId?: string | null, featured?: boolean | null, enabledLocales: Array<string>, disableComments?: boolean | null, isAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, content?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, tags: Array<{ __typename?: 'ContentTag', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, attachments: Array<{ __typename?: 'ContentImageAttachment', url: string, type: string }> } };

export type UpdateContentTagMutationVariables = Exact<{
  id: Scalars['String'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  image?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
}>;


export type UpdateContentTagMutation = { __typename?: 'RootMutation', updateContentTag: { __typename?: 'ContentTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type AddCreditConfigMutationVariables = Exact<{
  projectId: Scalars['String'];
  creditConfig: CreditConfigInput;
}>;


export type AddCreditConfigMutation = { __typename?: 'RootMutation', addCreditConfig: { __typename?: 'CreditConfig', capping?: Array<{ __typename?: 'CreditConfigCapping', capping?: number | null, types?: Array<string> | null }> | null, types?: Array<{ __typename?: 'CreditConfigTypeActivityV1', roundCredits: boolean, creditsDecimals: number, clientFactor: number, creditsPerStep: number, version: string, type: string, enabled?: boolean | null, activityConversions?: Array<{ __typename?: 'ActivityConversion', activity: string, creditsPerKm: number, kcalPerHour: number }> | null } | { __typename?: 'CreditConfigTypeActivityV2', roundCredits: boolean, creditsDecimals: number, creditsPerKcal: number, creditsPerStep: number, manualCreditsPerKcal: number, manualCreditsPerStep: number, version: string, type: string, enabled?: boolean | null } | { __typename?: 'CreditConfigTypeActivityV3', creditsPerKcal: number, hoursPerStep: number, kcalPerHourForSteps: number, version: string, type: string, enabled?: boolean | null, kcalPerHour?: Array<{ __typename?: 'KcalPerHour', activity: string, kcalPerHour: number }> | null } | { __typename?: 'CreditConfigTypeGeneric', credits: number, version: string, type: string, enabled?: boolean | null }> | null, collectionPeriod?: { __typename?: 'CreditConfigCollectionPeriod', from: number, to: number } | null, spentCreditsLimit?: { __typename?: 'CreditConfigSpentCreditsLimit', value: number, countForLastXDays?: number | null, countInCollectionPeriod?: boolean | null } | null } };

export type CreditConfigFragment = { __typename?: 'CreditConfig', capping?: Array<{ __typename?: 'CreditConfigCapping', capping?: number | null, types?: Array<string> | null }> | null, types?: Array<{ __typename?: 'CreditConfigTypeActivityV1', roundCredits: boolean, creditsDecimals: number, clientFactor: number, creditsPerStep: number, version: string, type: string, enabled?: boolean | null, activityConversions?: Array<{ __typename?: 'ActivityConversion', activity: string, creditsPerKm: number, kcalPerHour: number }> | null } | { __typename?: 'CreditConfigTypeActivityV2', roundCredits: boolean, creditsDecimals: number, creditsPerKcal: number, creditsPerStep: number, manualCreditsPerKcal: number, manualCreditsPerStep: number, version: string, type: string, enabled?: boolean | null } | { __typename?: 'CreditConfigTypeActivityV3', creditsPerKcal: number, hoursPerStep: number, kcalPerHourForSteps: number, version: string, type: string, enabled?: boolean | null, kcalPerHour?: Array<{ __typename?: 'KcalPerHour', activity: string, kcalPerHour: number }> | null } | { __typename?: 'CreditConfigTypeGeneric', credits: number, version: string, type: string, enabled?: boolean | null }> | null, collectionPeriod?: { __typename?: 'CreditConfigCollectionPeriod', from: number, to: number } | null, spentCreditsLimit?: { __typename?: 'CreditConfigSpentCreditsLimit', value: number, countForLastXDays?: number | null, countInCollectionPeriod?: boolean | null } | null };

export type GetCreditConfigCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditConfigCountQuery = { __typename?: 'RootQuery', creditConfigCount: number };

export type GetCreditConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditConfigsQuery = { __typename?: 'RootQuery', creditConfigs: Array<{ __typename?: 'CreditConfig', capping?: Array<{ __typename?: 'CreditConfigCapping', capping?: number | null, types?: Array<string> | null }> | null, types?: Array<{ __typename?: 'CreditConfigTypeActivityV1', roundCredits: boolean, creditsDecimals: number, clientFactor: number, creditsPerStep: number, version: string, type: string, enabled?: boolean | null, activityConversions?: Array<{ __typename?: 'ActivityConversion', activity: string, creditsPerKm: number, kcalPerHour: number }> | null } | { __typename?: 'CreditConfigTypeActivityV2', roundCredits: boolean, creditsDecimals: number, creditsPerKcal: number, creditsPerStep: number, manualCreditsPerKcal: number, manualCreditsPerStep: number, version: string, type: string, enabled?: boolean | null } | { __typename?: 'CreditConfigTypeActivityV3', creditsPerKcal: number, hoursPerStep: number, kcalPerHourForSteps: number, version: string, type: string, enabled?: boolean | null, kcalPerHour?: Array<{ __typename?: 'KcalPerHour', activity: string, kcalPerHour: number }> | null } | { __typename?: 'CreditConfigTypeGeneric', credits: number, version: string, type: string, enabled?: boolean | null }> | null, collectionPeriod?: { __typename?: 'CreditConfigCollectionPeriod', from: number, to: number } | null, spentCreditsLimit?: { __typename?: 'CreditConfigSpentCreditsLimit', value: number, countForLastXDays?: number | null, countInCollectionPeriod?: boolean | null } | null }> };

export type UpdateCreditConfigMutationVariables = Exact<{
  projectId: Scalars['String'];
  creditConfig: CreditConfigInput;
}>;


export type UpdateCreditConfigMutation = { __typename?: 'RootMutation', updateCreditConfig: { __typename?: 'CreditConfig', capping?: Array<{ __typename?: 'CreditConfigCapping', capping?: number | null, types?: Array<string> | null }> | null, types?: Array<{ __typename?: 'CreditConfigTypeActivityV1', roundCredits: boolean, creditsDecimals: number, clientFactor: number, creditsPerStep: number, version: string, type: string, enabled?: boolean | null, activityConversions?: Array<{ __typename?: 'ActivityConversion', activity: string, creditsPerKm: number, kcalPerHour: number }> | null } | { __typename?: 'CreditConfigTypeActivityV2', roundCredits: boolean, creditsDecimals: number, creditsPerKcal: number, creditsPerStep: number, manualCreditsPerKcal: number, manualCreditsPerStep: number, version: string, type: string, enabled?: boolean | null } | { __typename?: 'CreditConfigTypeActivityV3', creditsPerKcal: number, hoursPerStep: number, kcalPerHourForSteps: number, version: string, type: string, enabled?: boolean | null, kcalPerHour?: Array<{ __typename?: 'KcalPerHour', activity: string, kcalPerHour: number }> | null } | { __typename?: 'CreditConfigTypeGeneric', credits: number, version: string, type: string, enabled?: boolean | null }> | null, collectionPeriod?: { __typename?: 'CreditConfigCollectionPeriod', from: number, to: number } | null, spentCreditsLimit?: { __typename?: 'CreditConfigSpentCreditsLimit', value: number, countForLastXDays?: number | null, countInCollectionPeriod?: boolean | null } | null } };

export type AddDashboardConfigurationMutationVariables = Exact<{
  place: Scalars['String'];
  desktopWidths?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  tabletWidths?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  mobileWidths?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  widgets?: InputMaybe<Array<InputMaybe<Scalars['DashboardConfigWidgetInput']>> | InputMaybe<Scalars['DashboardConfigWidgetInput']>>;
  publishOn?: InputMaybe<Scalars['Float']>;
  sequence?: InputMaybe<Scalars['Int']>;
  background?: InputMaybe<DashboardConfigWidgetBackgroundInput>;
  expiresOn?: InputMaybe<Scalars['Float']>;
}>;


export type AddDashboardConfigurationMutation = { __typename?: 'RootMutation', addDashboardConfiguration: { __typename?: 'DashboardConfig', id: string, place: string } };

export type GetDashboardsQueryVariables = Exact<{
  filter?: InputMaybe<DashboardConfigFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetDashboardsQuery = { __typename?: 'RootQuery', dashboardConfigurations: Array<{ __typename?: 'DashboardConfig', id: string, place: string, desktopWidths?: Array<number | null> | null, tabletWidths?: Array<number | null> | null, mobileWidths?: Array<number | null> | null, publishOn?: number | null, expiresOn?: number | null, sequence?: number | null, widgets?: Array<{ __typename?: 'DashboardConfigWidgetActivity', id: string, type: string, roles?: Array<string> | null, fullWidth?: boolean | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, goal?: { __typename?: 'DashboardConfigWidgetActivityGoal', unitType?: string | null, unit?: string | null, value?: number | null } | null, history?: { __typename?: 'DashboardConfigWidgetActivityHistory', duration?: string | null, aggregation?: string | null, chartType?: string | null } | null, summary?: { __typename?: 'DashboardConfigWidgetActivitySummary', algorithm?: string | null, algorithmDisplayType?: string | null } | null } | { __typename?: 'DashboardConfigWidgetCaroussel', id: string, type: string, fullWidth?: boolean | null, interval?: string | null, roles?: Array<string> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, items?: Array<{ __typename?: 'DashboardConfigWidgetCarousselItem', type: string, typeId?: string | null, url?: { __typename?: 'DashboardConfigWidgetUrl', url: string, target?: string | null } | null, background?: { __typename?: 'DashboardConfigWidgetBackground', url?: string | null, color?: string | null, alt?: string | null } | null, caption?: { __typename?: 'DashboardConfigCarousselWidgetItemCaption', title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, callToAction?: { __typename?: 'DashboardConfigCarousselWidgetItemCallToAction', text?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null }> | null } | { __typename?: 'DashboardConfigWidgetChallenge', id: string, roles?: Array<string> | null, type: string, challengeIds?: Array<string> | null, displayType?: string | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, paging?: { __typename?: 'DashboardConfigWidgetPaging', enabled?: boolean | null, type?: string | null, size?: number | null } | null, sort?: { __typename?: 'DashboardConfigWidgetSort', field: string, order: string } | null } | { __typename?: 'DashboardConfigWidgetChallengeProgress' } | { __typename?: 'DashboardConfigWidgetChallengeVisualisation', id: string, type: string, roles?: Array<string> | null, challengeId: string, visualisationId: string, fullWidth?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null } | { __typename?: 'DashboardConfigWidgetCommunity', id: string, type: string, roles?: Array<string> | null, fullWidth?: boolean | null, disableNewUsersView?: boolean | null, disableUsersCount?: boolean | null, disableInviteAbility?: boolean | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | { __typename?: 'DashboardConfigWidgetContent', id: string, roles?: Array<string> | null, type: string, contentIds?: Array<string> | null, displayType?: string | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, paging?: { __typename?: 'DashboardConfigWidgetPaging', enabled?: boolean | null, type?: string | null, size?: number | null } | null, sort?: { __typename?: 'DashboardConfigWidgetSort', field: string, order: string } | null } | { __typename?: 'DashboardConfigWidgetEvent', id: string, roles?: Array<string> | null, type: string, eventIds?: Array<string> | null, displayType?: string | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, paging?: { __typename?: 'DashboardConfigWidgetPaging', enabled?: boolean | null, type?: string | null, size?: number | null } | null, sort?: { __typename?: 'DashboardConfigWidgetSort', field: string, order: string } | null } | { __typename?: 'DashboardConfigWidgetGallery' } | { __typename?: 'DashboardConfigWidgetGeneric', id: string, type: string, roles?: Array<string> | null, subType?: string | null, fullWidth?: boolean | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | { __typename?: 'DashboardConfigWidgetPopup', id: string, type: string, roles?: Array<string> | null, fullWidth?: boolean | null, url?: string | null, image?: string | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, callToActionText?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | { __typename?: 'DashboardConfigWidgetSocial', id: string, type: string, roles?: Array<string> | null, socialTypes: Array<string>, tags?: Array<string> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, paging?: { __typename?: 'DashboardConfigWidgetPaging', enabled?: boolean | null, type?: string | null, size?: number | null } | null, sort?: { __typename?: 'DashboardConfigWidgetSort', field: string, order: string } | null } | { __typename?: 'DashboardConfigWidgetStatistics', id: string, type: string, roles?: Array<string> | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, statistics: Array<{ __typename?: 'DashboardConfigWidgetStatisticsStatistic', icon?: string | null, statisticType: string, aggregateBy: string, subProperty?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> } | { __typename?: 'DashboardConfigWidgetVideo', id: string, roles?: Array<string> | null, type: string, fullWidth?: boolean | null, desktop?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, tablet?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, mobile?: { __typename?: 'DashboardConfigWidgetRendering', column: number, sequence: number, visible: boolean } | null, video: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, subTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, caption?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | { __typename?: 'DashboardConfigWidgetWrapper' }> | null }> };

export type GetDashboardsOverviewQueryVariables = Exact<{
  filter?: InputMaybe<DashboardConfigFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetDashboardsOverviewQuery = { __typename?: 'RootQuery', dashboardConfigurations: Array<{ __typename?: 'DashboardConfig', id: string, desktopWidths?: Array<number | null> | null, tabletWidths?: Array<number | null> | null, mobileWidths?: Array<number | null> | null, sequence?: number | null, place: string, publishOn?: number | null, expiresOn?: number | null }> };

export type GetDashboardsOverviewCountQueryVariables = Exact<{
  filter?: InputMaybe<DashboardConfigFilter>;
}>;


export type GetDashboardsOverviewCountQuery = { __typename?: 'RootQuery', dashboardConfigurationCount: number };

export type RemoveDashboardConfigurationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveDashboardConfigurationMutation = { __typename?: 'RootMutation', removeDashboardConfiguration: { __typename?: 'Success', success: boolean } };

export type UpdateDashboardConfigurationMutationVariables = Exact<{
  id: Scalars['String'];
  place?: InputMaybe<Scalars['String']>;
  desktopWidths?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  tabletWidths?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  mobileWidths?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  widgets?: InputMaybe<Array<InputMaybe<Scalars['DashboardConfigWidgetInput']>> | InputMaybe<Scalars['DashboardConfigWidgetInput']>>;
  publishOn?: InputMaybe<Scalars['Float']>;
  sequence?: InputMaybe<Scalars['Int']>;
  background?: InputMaybe<DashboardConfigWidgetBackgroundInput>;
  expiresOn?: InputMaybe<Scalars['Float']>;
}>;


export type UpdateDashboardConfigurationMutation = { __typename?: 'RootMutation', updateDashboardConfiguration: { __typename?: 'DashboardConfig', id: string, place: string } };

export type AddEventMutationVariables = Exact<{
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  description: Array<TextByLanguageInput> | TextByLanguageInput;
  start: Scalars['Float'];
  end: Scalars['Float'];
  url: Scalars['String'];
  organizator: Scalars['String'];
  publishedOn: Scalars['Float'];
  expiresOn: Scalars['Float'];
  registration: EventRegistrationInput;
  image: Scalars['String'];
  chronoraceEventId?: InputMaybe<Scalars['Float']>;
  activityTypes: Array<Scalars['String']> | Scalars['String'];
  hideInList?: InputMaybe<Scalars['Boolean']>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  subEvents: Array<SubEventInput> | SubEventInput;
  projects: Array<EventProjectDetailsInput> | EventProjectDetailsInput;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddEventMutation = { __typename?: 'RootMutation', addEvent: { __typename?: 'Event', id: string, editable?: boolean | null, start?: number | null, end?: number | null, url?: string | null, organizator?: string | null, publishedOn?: number | null, expiresOn?: number | null, image?: string | null, chronoraceEventId?: number | null, activityTypes?: Array<string | null> | null, hideInList?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, registration?: { __typename?: 'EventRegistration', start?: number | null, end?: number | null, disableUnregistration?: boolean | null } | null, subEvents?: Array<{ __typename?: 'SubEvent', id?: string | null, sequence?: number | null, date?: number | null, endDate?: number | null, info?: string | null, chronoraceSubEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, projects?: Array<{ __typename?: 'EventProjectDetails', projectId?: string | null, subscriptionEnabled?: boolean | null, formSubscriptionEnabled?: boolean | null, formTemplateIds?: Array<string | null> | null, roles?: Array<string | null> | null, tagIds?: Array<string | null> | null, participants?: number | null, participantsOnWaitingList?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, waitingListEnabled?: boolean | null, reminders?: Array<string | null> | null, daysToFinalEditReminder?: number | null, featured?: boolean | null, withAdvancedMode?: boolean | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, formTemplates?: Array<{ __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } } | null> | null, registration?: { __typename?: 'EventProjectDetailsRegistration', start?: number | null, end?: number | null } | null, subEvents?: Array<{ __typename?: 'SubEventProjectDetails', id?: string | null, subscriptionEnabled?: boolean | null, participants?: number | null, maxParticipantsDisabled?: boolean | null, participantsOnWaitingList?: number | null, maxParticipants?: number | null, participationFull?: boolean | null, participantOffset?: number | null } | null> | null } | null> | null } };

export type AddEventTagMutationVariables = Exact<{
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  color: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
}>;


export type AddEventTagMutation = { __typename?: 'RootMutation', addEventTag: { __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } } };

export type ChronoRaceEventFragment = { __typename?: 'ChronoRaceEvent', id?: number | null, start?: number | null, end?: number | null, country?: string | null, location?: string | null, title?: string | null, registrationAllowed?: boolean | null, eventCode?: number | null, subEvents?: Array<{ __typename?: 'ChronoRaceSubEvent', id?: number | null, title?: string | null } | null> | null };

export type CopyEventMutationVariables = Exact<{
  id: Scalars['String'];
  dates: Array<Scalars['Float']> | Scalars['Float'];
}>;


export type CopyEventMutation = { __typename?: 'RootMutation', copyEvent: Array<{ __typename?: 'Event', id: string, editable?: boolean | null, start?: number | null, end?: number | null, url?: string | null, organizator?: string | null, publishedOn?: number | null, expiresOn?: number | null, image?: string | null, chronoraceEventId?: number | null, activityTypes?: Array<string | null> | null, hideInList?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, registration?: { __typename?: 'EventRegistration', start?: number | null, end?: number | null, disableUnregistration?: boolean | null } | null, subEvents?: Array<{ __typename?: 'SubEvent', id?: string | null, sequence?: number | null, date?: number | null, endDate?: number | null, info?: string | null, chronoraceSubEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, projects?: Array<{ __typename?: 'EventProjectDetails', projectId?: string | null, subscriptionEnabled?: boolean | null, formSubscriptionEnabled?: boolean | null, formTemplateIds?: Array<string | null> | null, roles?: Array<string | null> | null, tagIds?: Array<string | null> | null, participants?: number | null, participantsOnWaitingList?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, waitingListEnabled?: boolean | null, reminders?: Array<string | null> | null, daysToFinalEditReminder?: number | null, featured?: boolean | null, withAdvancedMode?: boolean | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, formTemplates?: Array<{ __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } } | null> | null, registration?: { __typename?: 'EventProjectDetailsRegistration', start?: number | null, end?: number | null } | null, subEvents?: Array<{ __typename?: 'SubEventProjectDetails', id?: string | null, subscriptionEnabled?: boolean | null, participants?: number | null, maxParticipantsDisabled?: boolean | null, participantsOnWaitingList?: number | null, maxParticipants?: number | null, participationFull?: boolean | null, participantOffset?: number | null } | null> | null } | null> | null }> };

export type EventFragment = { __typename?: 'Event', id: string, editable?: boolean | null, start?: number | null, end?: number | null, url?: string | null, organizator?: string | null, publishedOn?: number | null, expiresOn?: number | null, image?: string | null, chronoraceEventId?: number | null, activityTypes?: Array<string | null> | null, hideInList?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, registration?: { __typename?: 'EventRegistration', start?: number | null, end?: number | null, disableUnregistration?: boolean | null } | null, subEvents?: Array<{ __typename?: 'SubEvent', id?: string | null, sequence?: number | null, date?: number | null, endDate?: number | null, info?: string | null, chronoraceSubEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, projects?: Array<{ __typename?: 'EventProjectDetails', projectId?: string | null, subscriptionEnabled?: boolean | null, formSubscriptionEnabled?: boolean | null, formTemplateIds?: Array<string | null> | null, roles?: Array<string | null> | null, tagIds?: Array<string | null> | null, participants?: number | null, participantsOnWaitingList?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, waitingListEnabled?: boolean | null, reminders?: Array<string | null> | null, daysToFinalEditReminder?: number | null, featured?: boolean | null, withAdvancedMode?: boolean | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, formTemplates?: Array<{ __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } } | null> | null, registration?: { __typename?: 'EventProjectDetailsRegistration', start?: number | null, end?: number | null } | null, subEvents?: Array<{ __typename?: 'SubEventProjectDetails', id?: string | null, subscriptionEnabled?: boolean | null, participants?: number | null, maxParticipantsDisabled?: boolean | null, participantsOnWaitingList?: number | null, maxParticipants?: number | null, participationFull?: boolean | null, participantOffset?: number | null } | null> | null } | null> | null };

export type EventParticipantFragment = { __typename?: 'EventParticipant', eventId?: string | null, subEventId?: string | null, userId?: string | null, approved?: boolean | null, participatedOn?: number | null, registrationComplete?: boolean | null, onWaitingList?: boolean | null, formData?: any | null, event?: { __typename?: 'Event', id: string, editable?: boolean | null, start?: number | null, end?: number | null, url?: string | null, organizator?: string | null, publishedOn?: number | null, expiresOn?: number | null, image?: string | null, chronoraceEventId?: number | null, activityTypes?: Array<string | null> | null, hideInList?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, registration?: { __typename?: 'EventRegistration', start?: number | null, end?: number | null, disableUnregistration?: boolean | null } | null, subEvents?: Array<{ __typename?: 'SubEvent', id?: string | null, sequence?: number | null, date?: number | null, endDate?: number | null, info?: string | null, chronoraceSubEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, projects?: Array<{ __typename?: 'EventProjectDetails', projectId?: string | null, subscriptionEnabled?: boolean | null, formSubscriptionEnabled?: boolean | null, formTemplateIds?: Array<string | null> | null, roles?: Array<string | null> | null, tagIds?: Array<string | null> | null, participants?: number | null, participantsOnWaitingList?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, waitingListEnabled?: boolean | null, reminders?: Array<string | null> | null, daysToFinalEditReminder?: number | null, featured?: boolean | null, withAdvancedMode?: boolean | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, formTemplates?: Array<{ __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } } | null> | null, registration?: { __typename?: 'EventProjectDetailsRegistration', start?: number | null, end?: number | null } | null, subEvents?: Array<{ __typename?: 'SubEventProjectDetails', id?: string | null, subscriptionEnabled?: boolean | null, participants?: number | null, maxParticipantsDisabled?: boolean | null, participantsOnWaitingList?: number | null, maxParticipants?: number | null, participationFull?: boolean | null, participantOffset?: number | null } | null> | null } | null> | null } | null, subEvent?: { __typename?: 'SubEvent', id?: string | null, sequence?: number | null, date?: number | null, endDate?: number | null, info?: string | null, chronoraceSubEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, user?: { __typename?: 'User', id: string, email: string, avatar?: string | null, givenName?: string | null, familyName?: string | null, locale?: string | null, locked?: boolean | null, lastLogin?: number | null, registeredOn?: number | null, profile?: any | null, company?: { __typename?: 'Company', name: string } | null } | null };

export type EventTagFragment = { __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } };

export type ExportEventParticipationMutationVariables = Exact<{
  filter?: InputMaybe<EventParticipantFilter>;
  format?: InputMaybe<Scalars['String']>;
}>;


export type ExportEventParticipationMutation = { __typename?: 'RootMutation', exportEventParticipation: { __typename?: 'Success', success: boolean } };

export type GetChronoRaceEventsQueryVariables = Exact<{
  filter?: InputMaybe<ChronoRaceEventFilter>;
}>;


export type GetChronoRaceEventsQuery = { __typename?: 'RootQuery', chronoRaceEvents: Array<{ __typename?: 'ChronoRaceEvent', id?: number | null, start?: number | null, end?: number | null, country?: string | null, location?: string | null, title?: string | null, registrationAllowed?: boolean | null, eventCode?: number | null, subEvents?: Array<{ __typename?: 'ChronoRaceSubEvent', id?: number | null, title?: string | null } | null> | null }> };

export type GetEventCountQueryVariables = Exact<{
  filter?: InputMaybe<EventFilter>;
}>;


export type GetEventCountQuery = { __typename?: 'RootQuery', eventCount: number };

export type GetEventParticipantsQueryVariables = Exact<{
  filter: EventParticipantFilter;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetEventParticipantsQuery = { __typename?: 'RootQuery', eventParticipants: Array<{ __typename?: 'EventParticipant', eventId?: string | null, subEventId?: string | null, userId?: string | null, approved?: boolean | null, participatedOn?: number | null, registrationComplete?: boolean | null, onWaitingList?: boolean | null, formData?: any | null, event?: { __typename?: 'Event', id: string, editable?: boolean | null, start?: number | null, end?: number | null, url?: string | null, organizator?: string | null, publishedOn?: number | null, expiresOn?: number | null, image?: string | null, chronoraceEventId?: number | null, activityTypes?: Array<string | null> | null, hideInList?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, registration?: { __typename?: 'EventRegistration', start?: number | null, end?: number | null, disableUnregistration?: boolean | null } | null, subEvents?: Array<{ __typename?: 'SubEvent', id?: string | null, sequence?: number | null, date?: number | null, endDate?: number | null, info?: string | null, chronoraceSubEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, projects?: Array<{ __typename?: 'EventProjectDetails', projectId?: string | null, subscriptionEnabled?: boolean | null, formSubscriptionEnabled?: boolean | null, formTemplateIds?: Array<string | null> | null, roles?: Array<string | null> | null, tagIds?: Array<string | null> | null, participants?: number | null, participantsOnWaitingList?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, waitingListEnabled?: boolean | null, reminders?: Array<string | null> | null, daysToFinalEditReminder?: number | null, featured?: boolean | null, withAdvancedMode?: boolean | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, formTemplates?: Array<{ __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } } | null> | null, registration?: { __typename?: 'EventProjectDetailsRegistration', start?: number | null, end?: number | null } | null, subEvents?: Array<{ __typename?: 'SubEventProjectDetails', id?: string | null, subscriptionEnabled?: boolean | null, participants?: number | null, maxParticipantsDisabled?: boolean | null, participantsOnWaitingList?: number | null, maxParticipants?: number | null, participationFull?: boolean | null, participantOffset?: number | null } | null> | null } | null> | null } | null, subEvent?: { __typename?: 'SubEvent', id?: string | null, sequence?: number | null, date?: number | null, endDate?: number | null, info?: string | null, chronoraceSubEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, user?: { __typename?: 'User', id: string, email: string, avatar?: string | null, givenName?: string | null, familyName?: string | null, locale?: string | null, locked?: boolean | null, lastLogin?: number | null, registeredOn?: number | null, profile?: any | null, company?: { __typename?: 'Company', name: string } | null } | null }> };

export type GetEventTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventTagsQuery = { __typename?: 'RootQuery', eventTags: Array<{ __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } }> };

export type GetEventTitlesQueryVariables = Exact<{
  filter?: InputMaybe<EventFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetEventTitlesQuery = { __typename?: 'RootQuery', events: Array<{ __typename?: 'Event', id: string, start?: number | null, end?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> };

export type GetEventsQueryVariables = Exact<{
  filter: EventFilter;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetEventsQuery = { __typename?: 'RootQuery', events: Array<{ __typename?: 'Event', id: string, editable?: boolean | null, start?: number | null, end?: number | null, url?: string | null, organizator?: string | null, publishedOn?: number | null, expiresOn?: number | null, image?: string | null, chronoraceEventId?: number | null, activityTypes?: Array<string | null> | null, hideInList?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, registration?: { __typename?: 'EventRegistration', start?: number | null, end?: number | null, disableUnregistration?: boolean | null } | null, subEvents?: Array<{ __typename?: 'SubEvent', id?: string | null, sequence?: number | null, date?: number | null, endDate?: number | null, info?: string | null, chronoraceSubEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, projects?: Array<{ __typename?: 'EventProjectDetails', projectId?: string | null, subscriptionEnabled?: boolean | null, formSubscriptionEnabled?: boolean | null, formTemplateIds?: Array<string | null> | null, roles?: Array<string | null> | null, tagIds?: Array<string | null> | null, participants?: number | null, participantsOnWaitingList?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, waitingListEnabled?: boolean | null, reminders?: Array<string | null> | null, daysToFinalEditReminder?: number | null, featured?: boolean | null, withAdvancedMode?: boolean | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, formTemplates?: Array<{ __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } } | null> | null, registration?: { __typename?: 'EventProjectDetailsRegistration', start?: number | null, end?: number | null } | null, subEvents?: Array<{ __typename?: 'SubEventProjectDetails', id?: string | null, subscriptionEnabled?: boolean | null, participants?: number | null, maxParticipantsDisabled?: boolean | null, participantsOnWaitingList?: number | null, maxParticipants?: number | null, participationFull?: boolean | null, participantOffset?: number | null } | null> | null } | null> | null }> };

export type GetEventsOverviewQueryVariables = Exact<{
  filter?: InputMaybe<EventFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetEventsOverviewQuery = { __typename?: 'RootQuery', events: Array<{ __typename?: 'Event', id: string, start?: number | null, end?: number | null, url?: string | null, publishedOn?: number | null, chronoraceEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, registration?: { __typename?: 'EventRegistration', start?: number | null, end?: number | null } | null, projects?: Array<{ __typename?: 'EventProjectDetails', projectId?: string | null, participants?: number | null, roles?: Array<string | null> | null } | null> | null }> };

export type RemoveEventMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveEventMutation = { __typename?: 'RootMutation', removeEvent: { __typename?: 'Success', success: boolean } };

export type RemoveEventParticipationMutationVariables = Exact<{
  userId: Scalars['String'];
  eventId: Scalars['String'];
  subEventId: Scalars['String'];
}>;


export type RemoveEventParticipationMutation = { __typename?: 'RootMutation', removeEventParticipation: { __typename?: 'Success', success: boolean } };

export type RemoveEventTagMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveEventTagMutation = { __typename?: 'RootMutation', removeEventTag: { __typename?: 'Success', success: boolean } };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['String'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  start?: InputMaybe<Scalars['Float']>;
  end?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
  organizator?: InputMaybe<Scalars['String']>;
  publishedOn?: InputMaybe<Scalars['Float']>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  registration?: InputMaybe<EventRegistrationInput>;
  image?: InputMaybe<Scalars['String']>;
  chronoraceEventId?: InputMaybe<Scalars['Float']>;
  activityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  hideInList?: InputMaybe<Scalars['Boolean']>;
  disableComments?: InputMaybe<Scalars['Boolean']>;
  subEvents?: InputMaybe<Array<InputMaybe<SubEventInput>> | InputMaybe<SubEventInput>>;
  projects?: InputMaybe<Array<InputMaybe<EventProjectDetailsInput>> | InputMaybe<EventProjectDetailsInput>>;
  withAdvancedMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateEventMutation = { __typename?: 'RootMutation', updateEvent: { __typename?: 'Event', id: string, editable?: boolean | null, start?: number | null, end?: number | null, url?: string | null, organizator?: string | null, publishedOn?: number | null, expiresOn?: number | null, image?: string | null, chronoraceEventId?: number | null, activityTypes?: Array<string | null> | null, hideInList?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, registration?: { __typename?: 'EventRegistration', start?: number | null, end?: number | null, disableUnregistration?: boolean | null } | null, subEvents?: Array<{ __typename?: 'SubEvent', id?: string | null, sequence?: number | null, date?: number | null, endDate?: number | null, info?: string | null, chronoraceSubEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, projects?: Array<{ __typename?: 'EventProjectDetails', projectId?: string | null, subscriptionEnabled?: boolean | null, formSubscriptionEnabled?: boolean | null, formTemplateIds?: Array<string | null> | null, roles?: Array<string | null> | null, tagIds?: Array<string | null> | null, participants?: number | null, participantsOnWaitingList?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, waitingListEnabled?: boolean | null, reminders?: Array<string | null> | null, daysToFinalEditReminder?: number | null, featured?: boolean | null, withAdvancedMode?: boolean | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, formTemplates?: Array<{ __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } } | null> | null, registration?: { __typename?: 'EventProjectDetailsRegistration', start?: number | null, end?: number | null } | null, subEvents?: Array<{ __typename?: 'SubEventProjectDetails', id?: string | null, subscriptionEnabled?: boolean | null, participants?: number | null, maxParticipantsDisabled?: boolean | null, participantsOnWaitingList?: number | null, maxParticipants?: number | null, participationFull?: boolean | null, participantOffset?: number | null } | null> | null } | null> | null } };

export type UpdateEventApprovalMutationVariables = Exact<{
  userId: Scalars['String'];
  eventId: Scalars['String'];
  subEventId: Scalars['String'];
  approved: Scalars['Boolean'];
}>;


export type UpdateEventApprovalMutation = { __typename?: 'RootMutation', updateEventApproval: { __typename?: 'EventParticipant', eventId?: string | null, subEventId?: string | null, userId?: string | null, approved?: boolean | null, participatedOn?: number | null, registrationComplete?: boolean | null, onWaitingList?: boolean | null, formData?: any | null, event?: { __typename?: 'Event', id: string, editable?: boolean | null, start?: number | null, end?: number | null, url?: string | null, organizator?: string | null, publishedOn?: number | null, expiresOn?: number | null, image?: string | null, chronoraceEventId?: number | null, activityTypes?: Array<string | null> | null, hideInList?: boolean | null, disableComments?: boolean | null, withAdvancedMode?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, registration?: { __typename?: 'EventRegistration', start?: number | null, end?: number | null, disableUnregistration?: boolean | null } | null, subEvents?: Array<{ __typename?: 'SubEvent', id?: string | null, sequence?: number | null, date?: number | null, endDate?: number | null, info?: string | null, chronoraceSubEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null, projects?: Array<{ __typename?: 'EventProjectDetails', projectId?: string | null, subscriptionEnabled?: boolean | null, formSubscriptionEnabled?: boolean | null, formTemplateIds?: Array<string | null> | null, roles?: Array<string | null> | null, tagIds?: Array<string | null> | null, participants?: number | null, participantsOnWaitingList?: number | null, viewParticipants?: boolean | null, viewParticipantCount?: boolean | null, waitingListEnabled?: boolean | null, reminders?: Array<string | null> | null, daysToFinalEditReminder?: number | null, featured?: boolean | null, withAdvancedMode?: boolean | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, formTemplates?: Array<{ __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null> | null, tags?: Array<{ __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } } | null> | null, registration?: { __typename?: 'EventProjectDetailsRegistration', start?: number | null, end?: number | null } | null, subEvents?: Array<{ __typename?: 'SubEventProjectDetails', id?: string | null, subscriptionEnabled?: boolean | null, participants?: number | null, maxParticipantsDisabled?: boolean | null, participantsOnWaitingList?: number | null, maxParticipants?: number | null, participationFull?: boolean | null, participantOffset?: number | null } | null> | null } | null> | null } | null, subEvent?: { __typename?: 'SubEvent', id?: string | null, sequence?: number | null, date?: number | null, endDate?: number | null, info?: string | null, chronoraceSubEventId?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null, user?: { __typename?: 'User', id: string, email: string, avatar?: string | null, givenName?: string | null, familyName?: string | null, locale?: string | null, locked?: boolean | null, lastLogin?: number | null, registeredOn?: number | null, profile?: any | null, company?: { __typename?: 'Company', name: string } | null } | null } };

export type UpdateEventTagMutationVariables = Exact<{
  id: Scalars['String'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  image?: InputMaybe<Scalars['String']>;
}>;


export type UpdateEventTagMutation = { __typename?: 'RootMutation', updateEventTag: { __typename?: 'EventTag', id: string, color: string, image?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, project: { __typename?: 'Project', id?: string | null } } };

export type AddEventGroupMutationVariables = Exact<{
  name: Array<TextByLanguageInput> | TextByLanguageInput;
  subscriptionsCount: Scalars['Int'];
  eventIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  dontAllowSubEventIntersection?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddEventGroupMutation = { __typename?: 'RootMutation', addEventGroup: { __typename?: 'EventGroup', id: string, subscriptionsCount: number, color?: string | null, eventIds?: Array<string> | null, dontAllowSubEventIntersection?: boolean | null, name: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type EventGroupFragment = { __typename?: 'EventGroup', id: string, subscriptionsCount: number, color?: string | null, eventIds?: Array<string> | null, dontAllowSubEventIntersection?: boolean | null, name: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> };

export type GetEventGroupCountQueryVariables = Exact<{
  filter?: InputMaybe<EventGroupFilter>;
}>;


export type GetEventGroupCountQuery = { __typename?: 'RootQuery', eventGroupCount: number };

export type GetEventGroupsQueryVariables = Exact<{
  filter?: InputMaybe<EventGroupFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetEventGroupsQuery = { __typename?: 'RootQuery', eventGroups: Array<{ __typename?: 'EventGroup', id: string, subscriptionsCount: number, color?: string | null, eventIds?: Array<string> | null, dontAllowSubEventIntersection?: boolean | null, name: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> };

export type RemoveEventGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveEventGroupMutation = { __typename?: 'RootMutation', removeEventGroup: { __typename?: 'Success', success: boolean } };

export type UpdateEventGroupMutationVariables = Exact<{
  id: Scalars['String'];
  name: Array<TextByLanguageInput> | TextByLanguageInput;
  subscriptionsCount: Scalars['Int'];
  eventIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  dontAllowSubEventIntersection?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateEventGroupMutation = { __typename?: 'RootMutation', updateEventGroup: { __typename?: 'EventGroup', id: string, subscriptionsCount: number, color?: string | null, eventIds?: Array<string> | null, dontAllowSubEventIntersection?: boolean | null, name: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type AddFlowMutationVariables = Exact<{
  flowInput: FlowInput;
}>;


export type AddFlowMutation = { __typename?: 'RootMutation', createFlow: { __typename?: 'Flow', id: string, projectId: string, start?: number | null, end?: number | null, reminderDaysDelay?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, steps?: Array<{ __typename?: 'FlowStep', id: number, icon?: string | null, type: FlowStepTypes, typeIds: Array<string>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> | null } };

export type FlowFragment = { __typename?: 'Flow', id: string, projectId: string, start?: number | null, end?: number | null, reminderDaysDelay?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, steps?: Array<{ __typename?: 'FlowStep', id: number, icon?: string | null, type: FlowStepTypes, typeIds: Array<string>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> | null };

export type GetFlowsQueryVariables = Exact<{
  filter?: InputMaybe<FlowsFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetFlowsQuery = { __typename?: 'RootQuery', flows: Array<{ __typename?: 'Flow', id: string, projectId: string, start?: number | null, end?: number | null, reminderDaysDelay?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, steps?: Array<{ __typename?: 'FlowStep', id: number, icon?: string | null, type: FlowStepTypes, typeIds: Array<string>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> | null }> };

export type GetFlowsCountQueryVariables = Exact<{
  filter?: InputMaybe<FlowsFilter>;
}>;


export type GetFlowsCountQuery = { __typename?: 'RootQuery', flowsCount: number };

export type RemoveFlowMutationVariables = Exact<{
  flowId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type RemoveFlowMutation = { __typename?: 'RootMutation', deleteFlow: { __typename?: 'Success', success: boolean } };

export type UpdateFlowMutationVariables = Exact<{
  flowId: Scalars['String'];
  flowInput: FlowInput;
}>;


export type UpdateFlowMutation = { __typename?: 'RootMutation', updateFlow: { __typename?: 'Flow', id: string, projectId: string, start?: number | null, end?: number | null, reminderDaysDelay?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, steps?: Array<{ __typename?: 'FlowStep', id: number, icon?: string | null, type: FlowStepTypes, typeIds: Array<string>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> | null } };

export type FormTemplateFragment = { __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null };

export type AddFormTemplateMutationVariables = Exact<{
  type: Scalars['String'];
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  errorMessages: Array<TextByLanguageInput> | TextByLanguageInput;
  elements: Array<FormElementInput> | FormElementInput;
}>;


export type AddFormTemplateMutation = { __typename?: 'RootMutation', addFormTemplate: { __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } };

export type GetFormTemplatesQueryVariables = Exact<{
  filter: FormTemplateFilter;
}>;


export type GetFormTemplatesQuery = { __typename?: 'RootQuery', formTemplates: Array<{ __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } | null> };

export type GetFormTemplatesOverviewQueryVariables = Exact<{
  filter: FormTemplateFilter;
}>;


export type GetFormTemplatesOverviewQuery = { __typename?: 'RootQuery', formTemplates: Array<{ __typename?: 'FormTemplate', id: string, projectId: string, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> };

export type RemoveFormTemplateMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveFormTemplateMutation = { __typename?: 'RootMutation', removeFormTemplate: { __typename?: 'Success', success: boolean } };

export type UpdateFormTemplateMutationVariables = Exact<{
  id: Scalars['String'];
  type: Scalars['String'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  errorMessages?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  elements: Array<FormElementInput> | FormElementInput;
}>;


export type UpdateFormTemplateMutation = { __typename?: 'RootMutation', updateFormTemplate: { __typename?: 'FormTemplate', id: string, type?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, errorMessages?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, elements?: Array<{ __typename?: 'FormElement', sequence?: number | null, type?: string | null, property?: string | null, defaultValue?: string | null, required?: boolean | null, min?: number | null, max?: number | null, extensions?: string | null, maxFileSize?: number | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, options?: Array<{ __typename?: 'FormElementOption', value?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | null> | null } | null> | null } };

export type AddGalleryMutationVariables = Exact<{
  type: Scalars['String'];
  typeId?: InputMaybe<Scalars['String']>;
  publishOn: Scalars['Float'];
  expiresOn: Scalars['Float'];
  isDraft: Scalars['Boolean'];
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  preview: Array<TextByLanguageInput> | TextByLanguageInput;
  description: Array<TextByLanguageInput> | TextByLanguageInput;
  roles: Array<Scalars['String']> | Scalars['String'];
  tags: Array<Scalars['String']> | Scalars['String'];
  featured?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddGalleryMutation = { __typename?: 'RootMutation', addGallery: { __typename?: 'ChallengeGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> } | { __typename?: 'ContentGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> } | { __typename?: 'EventGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> } | { __typename?: 'GenericGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }>, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } };

export type AddGalleryImageMutationVariables = Exact<{
  galleryId: Scalars['String'];
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  description: Array<TextByLanguageInput> | TextByLanguageInput;
  url?: InputMaybe<Scalars['String']>;
  embedUrl?: InputMaybe<Scalars['String']>;
}>;


export type AddGalleryImageMutation = { __typename?: 'RootMutation', addGalleryImage: { __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null } };

export type AddGalleryTagMutationVariables = Exact<{
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  description: Array<TextByLanguageInput> | TextByLanguageInput;
  image: Scalars['String'];
  color: Scalars['String'];
}>;


export type AddGalleryTagMutation = { __typename?: 'RootMutation', addGalleryTag: { __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

type Gallery_ChallengeGallery_Fragment = { __typename?: 'ChallengeGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> };

type Gallery_ContentGallery_Fragment = { __typename?: 'ContentGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> };

type Gallery_EventGallery_Fragment = { __typename?: 'EventGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> };

type Gallery_GenericGallery_Fragment = { __typename?: 'GenericGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }>, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null };

export type GalleryFragment = Gallery_ChallengeGallery_Fragment | Gallery_ContentGallery_Fragment | Gallery_EventGallery_Fragment | Gallery_GenericGallery_Fragment;

export type GalleryImageFragment = { __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null };

export type GalleryTagFragment = { __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> };

export type GetGalleriesQueryVariables = Exact<{
  filter?: InputMaybe<GalleryFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetGalleriesQuery = { __typename?: 'RootQuery', galleries: Array<{ __typename?: 'ChallengeGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> } | { __typename?: 'ContentGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> } | { __typename?: 'EventGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> } | { __typename?: 'GenericGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }>, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> };

export type GetGalleriesOverviewQueryVariables = Exact<{
  filter?: InputMaybe<GalleryFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetGalleriesOverviewQuery = { __typename?: 'RootQuery', galleries: Array<{ __typename?: 'ChallengeGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | { __typename?: 'ContentGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | { __typename?: 'EventGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } | { __typename?: 'GenericGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> };

export type GetGalleriesOverviewCountQueryVariables = Exact<{
  filter?: InputMaybe<GalleryFilter>;
}>;


export type GetGalleriesOverviewCountQuery = { __typename?: 'RootQuery', galleryCount: number };

export type GetGalleryTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGalleryTagsQuery = { __typename?: 'RootQuery', galleryTags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> };

export type RemoveGalleryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveGalleryMutation = { __typename?: 'RootMutation', removeGallery: { __typename?: 'Success', success: boolean } };

export type RemoveGalleryImageMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveGalleryImageMutation = { __typename?: 'RootMutation', removeGalleryImage: { __typename?: 'Success', success: boolean } };

export type RemoveGalleryTagMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveGalleryTagMutation = { __typename?: 'RootMutation', removeGalleryTag: { __typename?: 'Success', success: boolean } };

export type UpdateGalleryMutationVariables = Exact<{
  id: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['String']>;
  publishOn?: InputMaybe<Scalars['Float']>;
  expiresOn?: InputMaybe<Scalars['Float']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  preview?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  featured?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateGalleryMutation = { __typename?: 'RootMutation', updateGallery: { __typename?: 'ChallengeGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> } | { __typename?: 'ContentGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> } | { __typename?: 'EventGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }> } | { __typename?: 'GenericGallery', id: string, type?: string | null, typeId?: string | null, createdOn?: number | null, publishOn?: number | null, expiresOn?: number | null, isDraft?: boolean | null, featured?: boolean | null, roles?: Array<string | null> | null, tags: Array<{ __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, images: Array<{ __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null }>, preview?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } };

export type UpdateGalleryImageMutationVariables = Exact<{
  id: Scalars['String'];
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  description: Array<TextByLanguageInput> | TextByLanguageInput;
  url?: InputMaybe<Scalars['String']>;
  embedUrl?: InputMaybe<Scalars['String']>;
  reported?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateGalleryImageMutation = { __typename?: 'RootMutation', updateGalleryImage: { __typename?: 'GalleryImage', id: string, url?: string | null, embedUrl?: string | null, userId?: string | null, reported?: boolean | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, description?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null, reportedBy?: Array<{ __typename?: 'GalleryImageReportedUser', userId: string, reportedOn: number }> | null } };

export type UpdateGalleryTagMutationVariables = Exact<{
  id: Scalars['String'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  image?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
}>;


export type UpdateGalleryTagMutation = { __typename?: 'RootMutation', updateGalleryTag: { __typename?: 'GalleryTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type AddJourneyMutationVariables = Exact<{
  journey: Scalars['JourneyCreateInput'];
}>;


export type AddJourneyMutation = { __typename?: 'RootMutation', addJourney: { __typename?: 'EventJourney', id: string, type: string, participants: number, sequence: number, imageUrl: string, tagIds: Array<string>, coachType: string, comingSoon: boolean, hideInList?: boolean | null, publishOn?: number | null, expiresOn?: number | null, enabledLocales?: Array<string> | null, event: { __typename?: 'EventJourneyEvent', date: number, distance?: number | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, location: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, detailedLocation: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, position: { __typename?: 'EventJourneyPosition', latitude?: number | null, longitude?: number | null }, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null }, discounts?: Array<{ __typename?: 'JourneyDiscount', amount?: number | null, roles?: Array<string> | null, type?: string | null }> | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, tags: Array<{ __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null, registration: { __typename?: 'JourneyRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, voucherRequired?: boolean | null, newRoles?: Array<string> | null }, content: Array<{ __typename?: 'JourneyContent', type?: string | null, imageUrl?: string | null, imageCaption?: string | null, url?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> } | { __typename?: 'PersonalJourney', id: string, type: string, participants: number, sequence: number, imageUrl: string, tagIds: Array<string>, coachType: string, comingSoon: boolean, hideInList?: boolean | null, publishOn?: number | null, expiresOn?: number | null, enabledLocales?: Array<string> | null, duration: { __typename?: 'PersonalJourneyDuration', duration: number, unitType: string }, discounts?: Array<{ __typename?: 'JourneyDiscount', amount?: number | null, roles?: Array<string> | null, type?: string | null }> | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, tags: Array<{ __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null, registration: { __typename?: 'JourneyRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, voucherRequired?: boolean | null, newRoles?: Array<string> | null }, content: Array<{ __typename?: 'JourneyContent', type?: string | null, imageUrl?: string | null, imageCaption?: string | null, url?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> } };

export type AddJourneyTagMutationVariables = Exact<{
  title: Array<TextByLanguageInput> | TextByLanguageInput;
  description: Array<TextByLanguageInput> | TextByLanguageInput;
  image: Scalars['String'];
  color: Scalars['String'];
}>;


export type AddJourneyTagMutation = { __typename?: 'RootMutation', addJourneyTag: { __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type CostFragment = { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> };

export type GetJourneyCountQueryVariables = Exact<{
  filter?: InputMaybe<JourneyFilter>;
}>;


export type GetJourneyCountQuery = { __typename?: 'RootQuery', journeyCount: number };

export type GetJourneyTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJourneyTagsQuery = { __typename?: 'RootQuery', journeyTags: Array<{ __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> };

export type GetJourneysQueryVariables = Exact<{
  filter?: InputMaybe<JourneyFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetJourneysQuery = { __typename?: 'RootQuery', journeys: Array<{ __typename?: 'EventJourney', id: string, type: string, participants: number, sequence: number, imageUrl: string, tagIds: Array<string>, coachType: string, comingSoon: boolean, hideInList?: boolean | null, publishOn?: number | null, expiresOn?: number | null, enabledLocales?: Array<string> | null, event: { __typename?: 'EventJourneyEvent', date: number, distance?: number | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, location: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, detailedLocation: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, position: { __typename?: 'EventJourneyPosition', latitude?: number | null, longitude?: number | null }, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null }, discounts?: Array<{ __typename?: 'JourneyDiscount', amount?: number | null, roles?: Array<string> | null, type?: string | null }> | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, tags: Array<{ __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null, registration: { __typename?: 'JourneyRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, voucherRequired?: boolean | null, newRoles?: Array<string> | null }, content: Array<{ __typename?: 'JourneyContent', type?: string | null, imageUrl?: string | null, imageCaption?: string | null, url?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> } | { __typename?: 'PersonalJourney', id: string, type: string, participants: number, sequence: number, imageUrl: string, tagIds: Array<string>, coachType: string, comingSoon: boolean, hideInList?: boolean | null, publishOn?: number | null, expiresOn?: number | null, enabledLocales?: Array<string> | null, duration: { __typename?: 'PersonalJourneyDuration', duration: number, unitType: string }, discounts?: Array<{ __typename?: 'JourneyDiscount', amount?: number | null, roles?: Array<string> | null, type?: string | null }> | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, tags: Array<{ __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null, registration: { __typename?: 'JourneyRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, voucherRequired?: boolean | null, newRoles?: Array<string> | null }, content: Array<{ __typename?: 'JourneyContent', type?: string | null, imageUrl?: string | null, imageCaption?: string | null, url?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> }> };

type Journey_EventJourney_Fragment = { __typename?: 'EventJourney', id: string, type: string, participants: number, sequence: number, imageUrl: string, tagIds: Array<string>, coachType: string, comingSoon: boolean, hideInList?: boolean | null, publishOn?: number | null, expiresOn?: number | null, enabledLocales?: Array<string> | null, event: { __typename?: 'EventJourneyEvent', date: number, distance?: number | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, location: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, detailedLocation: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, position: { __typename?: 'EventJourneyPosition', latitude?: number | null, longitude?: number | null }, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null }, discounts?: Array<{ __typename?: 'JourneyDiscount', amount?: number | null, roles?: Array<string> | null, type?: string | null }> | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, tags: Array<{ __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null, registration: { __typename?: 'JourneyRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, voucherRequired?: boolean | null, newRoles?: Array<string> | null }, content: Array<{ __typename?: 'JourneyContent', type?: string | null, imageUrl?: string | null, imageCaption?: string | null, url?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> };

type Journey_PersonalJourney_Fragment = { __typename?: 'PersonalJourney', id: string, type: string, participants: number, sequence: number, imageUrl: string, tagIds: Array<string>, coachType: string, comingSoon: boolean, hideInList?: boolean | null, publishOn?: number | null, expiresOn?: number | null, enabledLocales?: Array<string> | null, duration: { __typename?: 'PersonalJourneyDuration', duration: number, unitType: string }, discounts?: Array<{ __typename?: 'JourneyDiscount', amount?: number | null, roles?: Array<string> | null, type?: string | null }> | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, tags: Array<{ __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null, registration: { __typename?: 'JourneyRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, voucherRequired?: boolean | null, newRoles?: Array<string> | null }, content: Array<{ __typename?: 'JourneyContent', type?: string | null, imageUrl?: string | null, imageCaption?: string | null, url?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> };

export type JourneyFragment = Journey_EventJourney_Fragment | Journey_PersonalJourney_Fragment;

export type JourneyTagFragment = { __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> };

export type RemoveJourneyMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveJourneyMutation = { __typename?: 'RootMutation', removeJourney: { __typename?: 'Success', success: boolean } };

export type RemoveJourneyTagMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveJourneyTagMutation = { __typename?: 'RootMutation', removeJourneyTag: { __typename?: 'Success', success: boolean } };

export type UpdateJourneyMutationVariables = Exact<{
  id: Scalars['String'];
  journey: Scalars['JourneyUpdateInput'];
}>;


export type UpdateJourneyMutation = { __typename?: 'RootMutation', updateJourney: { __typename?: 'EventJourney', id: string, type: string, participants: number, sequence: number, imageUrl: string, tagIds: Array<string>, coachType: string, comingSoon: boolean, hideInList?: boolean | null, publishOn?: number | null, expiresOn?: number | null, enabledLocales?: Array<string> | null, event: { __typename?: 'EventJourneyEvent', date: number, distance?: number | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, location: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, detailedLocation: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, position: { __typename?: 'EventJourneyPosition', latitude?: number | null, longitude?: number | null }, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null }, discounts?: Array<{ __typename?: 'JourneyDiscount', amount?: number | null, roles?: Array<string> | null, type?: string | null }> | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, tags: Array<{ __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null, registration: { __typename?: 'JourneyRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, voucherRequired?: boolean | null, newRoles?: Array<string> | null }, content: Array<{ __typename?: 'JourneyContent', type?: string | null, imageUrl?: string | null, imageCaption?: string | null, url?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> } | { __typename?: 'PersonalJourney', id: string, type: string, participants: number, sequence: number, imageUrl: string, tagIds: Array<string>, coachType: string, comingSoon: boolean, hideInList?: boolean | null, publishOn?: number | null, expiresOn?: number | null, enabledLocales?: Array<string> | null, duration: { __typename?: 'PersonalJourneyDuration', duration: number, unitType: string }, discounts?: Array<{ __typename?: 'JourneyDiscount', amount?: number | null, roles?: Array<string> | null, type?: string | null }> | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, tags: Array<{ __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }>, cost?: { __typename?: 'JourneyCost', amount: number, currency: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } | null, registration: { __typename?: 'JourneyRegistration', enableUltimateTime?: boolean | null, ultimateTime?: number | null, enableMaxParticipants?: boolean | null, maxParticipants?: number | null, voucherRequired?: boolean | null, newRoles?: Array<string> | null }, content: Array<{ __typename?: 'JourneyContent', type?: string | null, imageUrl?: string | null, imageCaption?: string | null, url?: string | null, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, subTitle: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> } };

export type UpdateJourneyTagMutationVariables = Exact<{
  id: Scalars['String'];
  title?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  description?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
  image?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
}>;


export type UpdateJourneyTagMutation = { __typename?: 'RootMutation', updateJourneyTag: { __typename?: 'JourneyTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'RootMutation', login: { __typename?: 'LoginData', jwtToken?: string | null, confirmCodeChallengeId?: string | null, userId?: string | null, profile?: { __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null, email: string } | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'RootMutation', logout: { __typename?: 'Success', success: boolean } };

export type NotificationFragment = { __typename?: 'UserEmailNotification', weeklyUpdate: boolean, contentUpdate: boolean, type: string, content: Array<{ __typename?: 'UserEmailContentNotification', type: string, tags: Array<{ __typename?: 'ContentTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> }> };

export type GetOrdersQueryVariables = Exact<{
  filter?: InputMaybe<ArticleOrderFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetOrdersQuery = { __typename?: 'RootQuery', articleOrders: Array<{ __typename?: 'ArticleOrder', id: string, orders: Array<{ __typename?: 'ArticleOrderItem', amount: number, article: { __typename?: 'Article', id: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> } }>, user: { __typename?: 'User', id: string, email: string } }> };

export type GetOrdersCountQueryVariables = Exact<{
  filter?: InputMaybe<ArticleOrderFilter>;
}>;


export type GetOrdersCountQuery = { __typename?: 'RootQuery', articleOrderCount: number };

export type ProjectFragment = { __typename?: 'Project', id?: string | null, name?: string | null };

export type AddRoleMutationVariables = Exact<{
  id: Scalars['String'];
  projectId: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  applicationId: Scalars['String'];
}>;


export type AddRoleMutation = { __typename?: 'RootMutation', addRole: { __typename?: 'Role', id: string, name: string } };

export type GetApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplicationsQuery = { __typename?: 'RootQuery', applications: Array<{ __typename?: 'Application', id: string, name: string, project: { __typename?: 'Project', id?: string | null, name?: string | null }, roles: Array<{ __typename?: 'Role', id: string, name: string, description: string }> }> };

export type GetProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsQuery = { __typename?: 'RootQuery', projects: Array<{ __typename?: 'Project', id?: string | null, name?: string | null }> };

export type RemoveRoleMutationVariables = Exact<{
  roleId: Scalars['String'];
  applicationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type RemoveRoleMutation = { __typename?: 'RootMutation', removeRole: { __typename?: 'Success', success: boolean } };

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['String'];
  projectId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  applicationId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateRoleMutation = { __typename?: 'RootMutation', updateRole: { __typename?: 'Role', id: string, name: string } };

export type CreateProjectConfigMutationVariables = Exact<{
  place: Scalars['String'];
  data: Scalars['JSON'];
}>;


export type CreateProjectConfigMutation = { __typename?: 'RootMutation', createProjectConfig: { __typename?: 'ProjectConfig', id: string, place: string, data: any } };

export type DeleteProjectConfigMutationVariables = Exact<{
  configId: Scalars['String'];
}>;


export type DeleteProjectConfigMutation = { __typename?: 'RootMutation', removeProjectConfig: { __typename?: 'Success', success: boolean } };

export type GetProjectConfigsQueryVariables = Exact<{
  places?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  paging?: InputMaybe<Paging>;
}>;


export type GetProjectConfigsQuery = { __typename?: 'RootQuery', projectConfigs: Array<{ __typename?: 'ProjectConfig', id: string, place: string, data: any }> };

export type ProjectConfigFragment = { __typename?: 'ProjectConfig', id: string, place: string, data: any };

export type UpdateProjectConfigMutationVariables = Exact<{
  configId: Scalars['String'];
  data: Scalars['JSON'];
}>;


export type UpdateProjectConfigMutation = { __typename?: 'RootMutation', updateProjectConfig: { __typename?: 'ProjectConfig', id: string, place: string, data: any } };

export type UnlinkProviderMutationVariables = Exact<{
  userId: Scalars['String'];
  provider: Scalars['String'];
}>;


export type UnlinkProviderMutation = { __typename?: 'RootMutation', unlinkProvider: { __typename?: 'Success', success: boolean } };

export type RegenerateConfirmCodeMutationVariables = Exact<{
  confirmCodeChallengeId: Scalars['String'];
}>;


export type RegenerateConfirmCodeMutation = { __typename?: 'RootMutation', regenerateConfirmCode: { __typename?: 'ConfirmCodeChallenge', confirmCodeChallengeId?: string | null } };

export type GetSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionQuery = { __typename?: 'RootQuery', session: { __typename?: 'Session', expiresOn: number, projectId: string, userId: string, roles: Array<string> } };

export type AddSocialFilterWordMutationVariables = Exact<{
  word: Scalars['String'];
}>;


export type AddSocialFilterWordMutation = { __typename?: 'RootMutation', addSocialFilterWord: { __typename?: 'SocialFilterWord', word?: string | null } };

export type AddSocialTagMutationVariables = Exact<{
  tag: Scalars['String'];
}>;


export type AddSocialTagMutation = { __typename?: 'RootMutation', addSocialTag: { __typename?: 'SocialTag', tag?: string | null } };

export type ChangeVisibleInstagramFeedMutationVariables = Exact<{
  id: Scalars['String'];
  visible: Scalars['Boolean'];
}>;


export type ChangeVisibleInstagramFeedMutation = { __typename?: 'RootMutation', changeVisibleInstagramFeed: { __typename?: 'InstagramFeed', id: string, visible?: boolean | null, tags?: Array<string | null> | null, date?: number | null, sourceUrl?: string | null, text?: string | null, type?: string | null, user?: { __typename?: 'InstagramUser', id?: string | null, name?: string | null, avatar?: string | null } | null, media?: Array<{ __typename?: 'InstagramMedia', type?: string | null, url?: string | null, width?: number | null, height?: number | null } | null> | null } };

export type ChangeVisibleTwitterFeedMutationVariables = Exact<{
  id: Scalars['String'];
  visible: Scalars['Boolean'];
}>;


export type ChangeVisibleTwitterFeedMutation = { __typename?: 'RootMutation', changeVisibleTwitterFeed: { __typename?: 'TwitterFeed', id: string, visible?: boolean | null, tags?: Array<string | null> | null, date?: number | null, sourceUrl?: string | null, text?: string | null, user?: { __typename?: 'TwitterUser', id?: string | null, name?: string | null, fullname?: string | null, avatar?: string | null } | null } };

export type GetInstagramFeedQueryVariables = Exact<{
  filter?: InputMaybe<InstagramFeedFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetInstagramFeedQuery = { __typename?: 'RootQuery', instagramFeed: Array<{ __typename?: 'InstagramFeed', id: string, visible?: boolean | null, tags?: Array<string | null> | null, date?: number | null, sourceUrl?: string | null, text?: string | null, type?: string | null, user?: { __typename?: 'InstagramUser', id?: string | null, name?: string | null, avatar?: string | null } | null, media?: Array<{ __typename?: 'InstagramMedia', type?: string | null, url?: string | null, width?: number | null, height?: number | null } | null> | null }> };

export type GetInstagramFeedCountQueryVariables = Exact<{
  filter?: InputMaybe<InstagramFeedFilter>;
}>;


export type GetInstagramFeedCountQuery = { __typename?: 'RootQuery', instagramFeedCount: number };

export type GetSocialFilterWordsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSocialFilterWordsQuery = { __typename?: 'RootQuery', socialFilterWords: Array<{ __typename?: 'SocialFilterWord', word?: string | null }> };

export type GetSocialTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSocialTagsQuery = { __typename?: 'RootQuery', socialTags: Array<{ __typename?: 'SocialTag', tag?: string | null }> };

export type GetTwitterFeedQueryVariables = Exact<{
  filter?: InputMaybe<TwitterFeedFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetTwitterFeedQuery = { __typename?: 'RootQuery', twitterFeed: Array<{ __typename?: 'TwitterFeed', id: string, visible?: boolean | null, tags?: Array<string | null> | null, date?: number | null, sourceUrl?: string | null, text?: string | null, user?: { __typename?: 'TwitterUser', id?: string | null, name?: string | null, fullname?: string | null, avatar?: string | null } | null }> };

export type GetTwitterFeedCountQueryVariables = Exact<{
  filter?: InputMaybe<TwitterFeedFilter>;
}>;


export type GetTwitterFeedCountQuery = { __typename?: 'RootQuery', twitterFeedCount: number };

export type InstagramFeedFragment = { __typename?: 'InstagramFeed', id: string, visible?: boolean | null, tags?: Array<string | null> | null, date?: number | null, sourceUrl?: string | null, text?: string | null, type?: string | null, user?: { __typename?: 'InstagramUser', id?: string | null, name?: string | null, avatar?: string | null } | null, media?: Array<{ __typename?: 'InstagramMedia', type?: string | null, url?: string | null, width?: number | null, height?: number | null } | null> | null };

export type RemoveSocialFilterWordMutationVariables = Exact<{
  word: Scalars['String'];
}>;


export type RemoveSocialFilterWordMutation = { __typename?: 'RootMutation', removeSocialFilterWord: { __typename?: 'Success', success: boolean } };

export type RemoveSocialTagMutationVariables = Exact<{
  tag: Scalars['String'];
}>;


export type RemoveSocialTagMutation = { __typename?: 'RootMutation', removeSocialTag: { __typename?: 'Success', success: boolean } };

export type SocialFilterWordFragment = { __typename?: 'SocialFilterWord', word?: string | null };

export type SocialTagFragment = { __typename?: 'SocialTag', tag?: string | null };

export type TwitterFeedFragment = { __typename?: 'TwitterFeed', id: string, visible?: boolean | null, tags?: Array<string | null> | null, date?: number | null, sourceUrl?: string | null, text?: string | null, user?: { __typename?: 'TwitterUser', id?: string | null, name?: string | null, fullname?: string | null, avatar?: string | null } | null };

export type UpdateSocialFilterWordMutationVariables = Exact<{
  oldWord: Scalars['String'];
  newWord: Scalars['String'];
}>;


export type UpdateSocialFilterWordMutation = { __typename?: 'RootMutation', updateSocialFilterWord: { __typename?: 'SocialFilterWord', word?: string | null } };

export type UpdateSocialTagMutationVariables = Exact<{
  oldTag: Scalars['String'];
  newTag: Scalars['String'];
}>;


export type UpdateSocialTagMutation = { __typename?: 'RootMutation', updateSocialTag: { __typename?: 'SocialTag', tag?: string | null } };

export type TextByLanguageFragment = { __typename?: 'TextByLanguage', language?: string | null, text?: string | null };

export type AddTranslationMutationVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  translations: Array<TextByLanguageInput> | TextByLanguageInput;
}>;


export type AddTranslationMutation = { __typename?: 'RootMutation', addTranslation: { __typename?: 'Translation', id: string, projectId?: string | null, key: string, default?: boolean | null, translations: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> } };

export type GetTranslationCountQueryVariables = Exact<{
  filter: TranslationFilter;
}>;


export type GetTranslationCountQuery = { __typename?: 'RootQuery', translationCount: number };

export type GetTranslationsQueryVariables = Exact<{
  filter: TranslationFilter;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetTranslationsQuery = { __typename?: 'RootQuery', translations: Array<{ __typename?: 'Translation', id: string, projectId?: string | null, key: string, default?: boolean | null, translations: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> }> };

export type RemoveTranslationMutationVariables = Exact<{
  id: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
}>;


export type RemoveTranslationMutation = { __typename?: 'RootMutation', removeTranslation: { __typename?: 'Success', success: boolean } };

export type UpdateTranslationMutationVariables = Exact<{
  id: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>>;
}>;


export type UpdateTranslationMutation = { __typename?: 'RootMutation', updateTranslation: { __typename?: 'Translation', id: string, projectId?: string | null, key: string, default?: boolean | null, translations: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> } };

export type UserFragment = { __typename?: 'User', id: string, email: string, locale?: string | null, avatar?: string | null, locked?: boolean | null, givenName?: string | null, familyName?: string | null, createdAt: number, profile?: any | null, displayName?: string | null, timezone?: string | null, lastLogin?: number | null, registeredOn?: number | null, company?: { __typename?: 'Company', id: string, name: string, code: string, role: string, limitRegistrations: boolean, maxRegistrations: number, logo?: string | null, coach?: string | null, brandColor?: string | null, languages?: Array<string> | null, hasSupport?: boolean | null, project: { __typename?: 'Project', id?: string | null, name?: string | null }, introMessage?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, introTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, team?: { __typename?: 'CompanyTeam', picture?: string | null, selectPicture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectSubtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, connect?: { __typename?: 'CompanyConnect', picture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, profileRequirements?: Array<{ __typename?: 'ProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null } | null, privacy: { __typename?: 'UserPrivacy', publicDisplayNameType: string, nickname?: string | null, showActivities: boolean, showAsNewMember: boolean }, notifications: Array<{ __typename?: 'UserEmailNotification', weeklyUpdate: boolean, contentUpdate: boolean, type: string, content: Array<{ __typename?: 'UserEmailContentNotification', type: string, tags: Array<{ __typename?: 'ContentTag', id: string, color: string, image: string, title: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }>, description: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> }> }> }>, providers?: Array<{ __typename?: 'Provider', provider?: string | null, syncedOn?: number | null, enabled?: boolean | null } | null> | null, applications?: Array<{ __typename?: 'Application', id: string, name: string, project: { __typename?: 'Project', id?: string | null, name?: string | null }, roles: Array<{ __typename?: 'Role', id: string, name: string, description: string }> } | null> | null };

export type AddUserMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Scalars['JSON']>;
  privacy?: InputMaybe<UserPrivacyInput>;
  notifications?: InputMaybe<Array<InputMaybe<Scalars['UserNotificationInput']>> | InputMaybe<Scalars['UserNotificationInput']>>;
  timezone?: InputMaybe<Scalars['String']>;
  applications?: InputMaybe<Array<InputMaybe<UserApplicationInput>> | InputMaybe<UserApplicationInput>>;
  projectId: Scalars['String'];
}>;


export type AddUserMutation = { __typename?: 'RootMutation', addUser: { __typename?: 'User', id: string, email: string, locale?: string | null, avatar?: string | null, locked?: boolean | null, givenName?: string | null, familyName?: string | null, createdAt: number, profile?: any | null, displayName?: string | null, timezone?: string | null, identities?: Array<string | null> | null, lastLogin?: number | null, registeredOn?: number | null, company?: { __typename?: 'Company', id: string, name: string, code: string, role: string, limitRegistrations: boolean, maxRegistrations: number, logo?: string | null, coach?: string | null, brandColor?: string | null, languages?: Array<string> | null, hasSupport?: boolean | null, project: { __typename?: 'Project', id?: string | null, name?: string | null }, introMessage?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, introTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, team?: { __typename?: 'CompanyTeam', picture?: string | null, selectPicture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectSubtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, connect?: { __typename?: 'CompanyConnect', picture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, profileRequirements?: Array<{ __typename?: 'ProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null } | null, privacy: { __typename?: 'UserPrivacy', publicDisplayNameType: string, nickname?: string | null, showActivities: boolean, showAsNewMember: boolean }, passwordUser?: { __typename?: 'PasswordUser', emailValidated: boolean } | null, providers?: Array<{ __typename?: 'Provider', provider?: string | null, enabled?: boolean | null, syncedOn?: number | null } | null> | null, applications?: Array<{ __typename?: 'Application', id: string, name: string, project: { __typename?: 'Project', id?: string | null, name?: string | null }, roles: Array<{ __typename?: 'Role', id: string, name: string, description: string }> } | null> | null } };

export type AddUserWhiteListMutationVariables = Exact<{
  projectId: Scalars['String'];
  group: Scalars['String'];
  whitelist: Array<Scalars['String']> | Scalars['String'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type AddUserWhiteListMutation = { __typename?: 'RootMutation', addUserWhiteList: { __typename?: 'UserWhiteList', projectId?: string | null, group?: string | null, whitelist?: Array<string | null> | null, roles?: Array<string | null> | null, companyId?: string | null } };

export type CreateUserCreditTransactionMutationVariables = Exact<{
  userId: Scalars['String'];
  amount: Scalars['Float'];
  type: Scalars['String'];
}>;


export type CreateUserCreditTransactionMutation = { __typename?: 'RootMutation', createUserCreditTransaction: { __typename?: 'Success', success: boolean } };

export type GetUserCountQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
}>;


export type GetUserCountQuery = { __typename?: 'RootQuery', userCount: number };

export type GetUserCreditStatisticsQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
}>;


export type GetUserCreditStatisticsQuery = { __typename?: 'RootQuery', users: Array<{ __typename?: 'User', creditStatistics?: { __typename?: 'UserCreditStatistics', balance: number, earned: number, spended: number } | null }> };

export type GetUserWhiteListsQueryVariables = Exact<{
  filter?: InputMaybe<UserWhiteListFilter>;
}>;


export type GetUserWhiteListsQuery = { __typename?: 'RootQuery', userWhiteLists: Array<{ __typename?: 'UserWhiteList', projectId?: string | null, group?: string | null, whitelist?: Array<string | null> | null, roles?: Array<string | null> | null, companyId?: string | null }> };

export type GetUsersQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetUsersQuery = { __typename?: 'RootQuery', users: Array<{ __typename?: 'User', id: string, email: string, locale?: string | null, avatar?: string | null, locked?: boolean | null, givenName?: string | null, familyName?: string | null, createdAt: number, profile?: any | null, displayName?: string | null, timezone?: string | null, identities?: Array<string | null> | null, lastLogin?: number | null, registeredOn?: number | null, company?: { __typename?: 'Company', id: string, name: string, code: string, role: string, limitRegistrations: boolean, maxRegistrations: number, logo?: string | null, coach?: string | null, brandColor?: string | null, languages?: Array<string> | null, hasSupport?: boolean | null, project: { __typename?: 'Project', id?: string | null, name?: string | null }, introMessage?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, introTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, team?: { __typename?: 'CompanyTeam', picture?: string | null, selectPicture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectSubtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, connect?: { __typename?: 'CompanyConnect', picture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, profileRequirements?: Array<{ __typename?: 'ProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null } | null, privacy: { __typename?: 'UserPrivacy', publicDisplayNameType: string, nickname?: string | null, showActivities: boolean, showAsNewMember: boolean }, passwordUser?: { __typename?: 'PasswordUser', emailValidated: boolean } | null, providers?: Array<{ __typename?: 'Provider', provider?: string | null, enabled?: boolean | null, syncedOn?: number | null } | null> | null, applications?: Array<{ __typename?: 'Application', id: string, name: string, project: { __typename?: 'Project', id?: string | null, name?: string | null }, roles: Array<{ __typename?: 'Role', id: string, name: string, description: string }> } | null> | null }> };

export type GetUsersDataToExportQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  sort?: InputMaybe<Sort>;
}>;


export type GetUsersDataToExportQuery = { __typename?: 'RootQuery', users: Array<{ __typename?: 'User', id: string, email: string, givenName?: string | null, familyName?: string | null, locale?: string | null, lastLogin?: number | null, registeredOn?: number | null, profile?: any | null, applications?: Array<{ __typename?: 'Application', name: string, roles: Array<{ __typename?: 'Role', id: string, name: string }> } | null> | null, providers?: Array<{ __typename?: 'Provider', provider?: string | null, enabled?: boolean | null } | null> | null }> };

export type GetUsersLightQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetUsersLightQuery = { __typename?: 'RootQuery', users: Array<{ __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null }> };

export type GetUsersOverviewQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetUsersOverviewQuery = { __typename?: 'RootQuery', users: Array<{ __typename?: 'User', id: string, email: string, displayName?: string | null, givenName?: string | null, familyName?: string | null, avatar?: string | null, locked?: boolean | null, lastLogin?: number | null, providers?: Array<{ __typename?: 'Provider', provider?: string | null } | null> | null, applications?: Array<{ __typename?: 'Application', name: string, roles: Array<{ __typename?: 'Role', id: string, name: string }>, project: { __typename?: 'Project', id?: string | null, name?: string | null } } | null> | null }> };

export type ImpersonateUserMutationVariables = Exact<{
  userId: Scalars['String'];
  applicationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type ImpersonateUserMutation = { __typename?: 'RootMutation', impersonateUser: { __typename?: 'ImpersonateData', applicationUrl: string } };

export type RemoveUserMutationVariables = Exact<{
  id: Scalars['String'];
  anonymize: Scalars['Boolean'];
}>;


export type RemoveUserMutation = { __typename?: 'RootMutation', removeUser: { __typename?: 'Success', success: boolean } };

export type RemoveUserWhiteListMutationVariables = Exact<{
  group: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type RemoveUserWhiteListMutation = { __typename?: 'RootMutation', removeUserWhiteList: { __typename?: 'Success', success: boolean } };

export type RemoveUsersMutationVariables = Exact<{
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  anonymize: Scalars['Boolean'];
}>;


export type RemoveUsersMutation = { __typename?: 'RootMutation', removeUsers: { __typename?: 'Success', success: boolean } };

export type RequestValidateEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestValidateEmailMutation = { __typename?: 'RootMutation', requestValidateEmail: { __typename?: 'Success', success: boolean } };

export type ResyncProviderMutationVariables = Exact<{
  userId: Scalars['String'];
  provider?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['Float']>;
}>;


export type ResyncProviderMutation = { __typename?: 'RootMutation', resyncProvider: { __typename?: 'Success', success: boolean } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Scalars['JSON']>;
  privacy?: InputMaybe<UserPrivacyInput>;
  notifications?: InputMaybe<Array<InputMaybe<Scalars['UserNotificationInput']>> | InputMaybe<Scalars['UserNotificationInput']>>;
  timezone?: InputMaybe<Scalars['String']>;
  applications?: InputMaybe<Array<InputMaybe<UserApplicationInput>> | InputMaybe<UserApplicationInput>>;
  projectId: Scalars['String'];
  locked?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateUserMutation = { __typename?: 'RootMutation', updateUser: { __typename?: 'User', id: string, email: string, locale?: string | null, avatar?: string | null, locked?: boolean | null, givenName?: string | null, familyName?: string | null, createdAt: number, profile?: any | null, displayName?: string | null, timezone?: string | null, identities?: Array<string | null> | null, lastLogin?: number | null, registeredOn?: number | null, company?: { __typename?: 'Company', id: string, name: string, code: string, role: string, limitRegistrations: boolean, maxRegistrations: number, logo?: string | null, coach?: string | null, brandColor?: string | null, languages?: Array<string> | null, hasSupport?: boolean | null, project: { __typename?: 'Project', id?: string | null, name?: string | null }, introMessage?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, introTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, team?: { __typename?: 'CompanyTeam', picture?: string | null, selectPicture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectSubtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, connect?: { __typename?: 'CompanyConnect', picture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, profileRequirements?: Array<{ __typename?: 'ProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null } | null, privacy: { __typename?: 'UserPrivacy', publicDisplayNameType: string, nickname?: string | null, showActivities: boolean, showAsNewMember: boolean }, passwordUser?: { __typename?: 'PasswordUser', emailValidated: boolean } | null, providers?: Array<{ __typename?: 'Provider', provider?: string | null, enabled?: boolean | null, syncedOn?: number | null } | null> | null, applications?: Array<{ __typename?: 'Application', id: string, name: string, project: { __typename?: 'Project', id?: string | null, name?: string | null }, roles: Array<{ __typename?: 'Role', id: string, name: string, description: string }> } | null> | null } };

export type UpdateUserWhiteListMutationVariables = Exact<{
  projectId: Scalars['String'];
  group: Scalars['String'];
  whitelist: Array<Scalars['String']> | Scalars['String'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserWhiteListMutation = { __typename?: 'RootMutation', updateUserWhiteList: { __typename?: 'UserWhiteList', projectId?: string | null, group?: string | null, whitelist?: Array<string | null> | null, roles?: Array<string | null> | null, companyId?: string | null } };

export type UserDetailFragment = { __typename?: 'User', id: string, email: string, locale?: string | null, avatar?: string | null, locked?: boolean | null, givenName?: string | null, familyName?: string | null, createdAt: number, profile?: any | null, displayName?: string | null, timezone?: string | null, identities?: Array<string | null> | null, lastLogin?: number | null, registeredOn?: number | null, company?: { __typename?: 'Company', id: string, name: string, code: string, role: string, limitRegistrations: boolean, maxRegistrations: number, logo?: string | null, coach?: string | null, brandColor?: string | null, languages?: Array<string> | null, hasSupport?: boolean | null, project: { __typename?: 'Project', id?: string | null, name?: string | null }, introMessage?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, introTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, team?: { __typename?: 'CompanyTeam', picture?: string | null, selectPicture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectTitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, selectSubtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, connect?: { __typename?: 'CompanyConnect', picture?: string | null, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null, subtitle?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null }> | null } | null, profileRequirements?: Array<{ __typename?: 'ProfileFields', type: string, name: string, label?: string | null, list?: Array<string> | null, required?: boolean | null }> | null } | null, privacy: { __typename?: 'UserPrivacy', publicDisplayNameType: string, nickname?: string | null, showActivities: boolean, showAsNewMember: boolean }, passwordUser?: { __typename?: 'PasswordUser', emailValidated: boolean } | null, providers?: Array<{ __typename?: 'Provider', provider?: string | null, enabled?: boolean | null, syncedOn?: number | null } | null> | null, applications?: Array<{ __typename?: 'Application', id: string, name: string, project: { __typename?: 'Project', id?: string | null, name?: string | null }, roles: Array<{ __typename?: 'Role', id: string, name: string, description: string }> } | null> | null };

export type UserWhiteListFragment = { __typename?: 'UserWhiteList', projectId?: string | null, group?: string | null, whitelist?: Array<string | null> | null, roles?: Array<string | null> | null, companyId?: string | null };

export type ValidateEmailMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ValidateEmailMutation = { __typename?: 'RootMutation', validateEmail: { __typename?: 'Success', success: boolean } };

export type AddVoucherMutationVariables = Exact<{
  code: Scalars['String'];
  enabled: Scalars['Boolean'];
  maxUsage: Scalars['Int'];
  maxUsagePerUser: Scalars['Int'];
  assignments: Array<VoucherAssignmentInput> | VoucherAssignmentInput;
  discount?: InputMaybe<VoucherDiscountInput>;
  enableVoucherPeriod: Scalars['Boolean'];
  enabledMaxUsage: Scalars['Boolean'];
  enabledMaxUsagePerUser: Scalars['Boolean'];
  enabledOn: Array<VoucherEnabledOnInput> | VoucherEnabledOnInput;
  title: Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>;
  voucherEnd: Scalars['Float'];
  voucherStart: Scalars['Float'];
}>;


export type AddVoucherMutation = { __typename?: 'RootMutation', addVoucher: { __typename?: 'Voucher', id: string, code: string, enabled: boolean, maxUsage: number, maxUsagePerUser: number, enableVoucherPeriod: boolean, enabledMaxUsage: boolean, enabledMaxUsagePerUser: boolean, usageCount: number, voucherEnd?: number | null, voucherStart?: number | null, assignments: Array<{ __typename?: 'VoucherAssignment', credits?: number | null, roles?: Array<string | null> | null, type?: string | null }>, discount?: { __typename?: 'VoucherDiscount', amount: number, type: string } | null, enabledOn: Array<{ __typename?: 'VoucherEnabledOn', ids?: Array<string | null> | null, type: string }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } };

export type ExportVoucherMutationVariables = Exact<{
  format: Scalars['String'];
  filter?: InputMaybe<VoucherFilter>;
}>;


export type ExportVoucherMutation = { __typename?: 'RootMutation', exportVoucher: { __typename?: 'Success', success: boolean } };

export type GetVoucherCountQueryVariables = Exact<{
  filter?: InputMaybe<VoucherFilter>;
}>;


export type GetVoucherCountQuery = { __typename?: 'RootQuery', voucherCount: number };

export type GetVouchersQueryVariables = Exact<{
  filter?: InputMaybe<VoucherFilter>;
  paging?: InputMaybe<Paging>;
  sort?: InputMaybe<Sort>;
}>;


export type GetVouchersQuery = { __typename?: 'RootQuery', vouchers: Array<{ __typename?: 'Voucher', id: string, code: string, enabled: boolean, maxUsage: number, maxUsagePerUser: number, enableVoucherPeriod: boolean, enabledMaxUsage: boolean, enabledMaxUsagePerUser: boolean, usageCount: number, voucherEnd?: number | null, voucherStart?: number | null, assignments: Array<{ __typename?: 'VoucherAssignment', credits?: number | null, roles?: Array<string | null> | null, type?: string | null }>, discount?: { __typename?: 'VoucherDiscount', amount: number, type: string } | null, enabledOn: Array<{ __typename?: 'VoucherEnabledOn', ids?: Array<string | null> | null, type: string }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null }> };

export type RemoveVoucherMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveVoucherMutation = { __typename?: 'RootMutation', removeVoucher: { __typename?: 'Success', success: boolean } };

export type UpdateVoucherMutationVariables = Exact<{
  id: Scalars['String'];
  code: Scalars['String'];
  enabled: Scalars['Boolean'];
  maxUsage: Scalars['Int'];
  maxUsagePerUser: Scalars['Int'];
  assignments: Array<VoucherAssignmentInput> | VoucherAssignmentInput;
  discount?: InputMaybe<VoucherDiscountInput>;
  enableVoucherPeriod: Scalars['Boolean'];
  enabledMaxUsage: Scalars['Boolean'];
  enabledMaxUsagePerUser: Scalars['Boolean'];
  enabledOn: Array<VoucherEnabledOnInput> | VoucherEnabledOnInput;
  title: Array<InputMaybe<TextByLanguageInput>> | InputMaybe<TextByLanguageInput>;
  voucherEnd: Scalars['Float'];
  voucherStart: Scalars['Float'];
}>;


export type UpdateVoucherMutation = { __typename?: 'RootMutation', updateVoucher: { __typename?: 'Voucher', id: string, code: string, enabled: boolean, maxUsage: number, maxUsagePerUser: number, enableVoucherPeriod: boolean, enabledMaxUsage: boolean, enabledMaxUsagePerUser: boolean, usageCount: number, voucherEnd?: number | null, voucherStart?: number | null, assignments: Array<{ __typename?: 'VoucherAssignment', credits?: number | null, roles?: Array<string | null> | null, type?: string | null }>, discount?: { __typename?: 'VoucherDiscount', amount: number, type: string } | null, enabledOn: Array<{ __typename?: 'VoucherEnabledOn', ids?: Array<string | null> | null, type: string }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null } };

export type VoucherFragment = { __typename?: 'Voucher', id: string, code: string, enabled: boolean, maxUsage: number, maxUsagePerUser: number, enableVoucherPeriod: boolean, enabledMaxUsage: boolean, enabledMaxUsagePerUser: boolean, usageCount: number, voucherEnd?: number | null, voucherStart?: number | null, assignments: Array<{ __typename?: 'VoucherAssignment', credits?: number | null, roles?: Array<string | null> | null, type?: string | null }>, discount?: { __typename?: 'VoucherDiscount', amount: number, type: string } | null, enabledOn: Array<{ __typename?: 'VoucherEnabledOn', ids?: Array<string | null> | null, type: string }>, title?: Array<{ __typename?: 'TextByLanguage', language?: string | null, text?: string | null } | null> | null };


export type GetProviderActivitiesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProviderActivitiesQuery, GetProviderActivitiesQueryVariables>
    } & TChildProps;
export function withGetProviderActivities<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProviderActivitiesQuery,
  GetProviderActivitiesQueryVariables,
  GetProviderActivitiesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProviderActivitiesQuery, GetProviderActivitiesQueryVariables, GetProviderActivitiesProps<TChildProps, TDataName>>(Operations.getProviderActivities, {
      alias: 'getProviderActivities',
      ...operationOptions
    });
};

/**
 * __useGetProviderActivitiesQuery__
 *
 * To run a query within a React component, call `useGetProviderActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderActivitiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetProviderActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetProviderActivitiesQuery, GetProviderActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderActivitiesQuery, GetProviderActivitiesQueryVariables>(Operations.getProviderActivities, options);
      }
export function useGetProviderActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderActivitiesQuery, GetProviderActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderActivitiesQuery, GetProviderActivitiesQueryVariables>(Operations.getProviderActivities, options);
        }
export type GetProviderActivitiesQueryHookResult = ReturnType<typeof useGetProviderActivitiesQuery>;
export type GetProviderActivitiesLazyQueryHookResult = ReturnType<typeof useGetProviderActivitiesLazyQuery>;
export type GetProviderActivitiesQueryResult = ApolloReactCommon.QueryResult<GetProviderActivitiesQuery, GetProviderActivitiesQueryVariables>;
export function refetchGetProviderActivitiesQuery(variables: GetProviderActivitiesQueryVariables) {
      return { query: Operations.getProviderActivities, variables: variables }
    }
export type GetUserActivitiesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserActivitiesQuery, GetUserActivitiesQueryVariables>
    } & TChildProps;
export function withGetUserActivities<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserActivitiesQuery,
  GetUserActivitiesQueryVariables,
  GetUserActivitiesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserActivitiesQuery, GetUserActivitiesQueryVariables, GetUserActivitiesProps<TChildProps, TDataName>>(Operations.getUserActivities, {
      alias: 'getUserActivities',
      ...operationOptions
    });
};

/**
 * __useGetUserActivitiesQuery__
 *
 * To run a query within a React component, call `useGetUserActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActivitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUserActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetUserActivitiesQuery, GetUserActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserActivitiesQuery, GetUserActivitiesQueryVariables>(Operations.getUserActivities, options);
      }
export function useGetUserActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserActivitiesQuery, GetUserActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserActivitiesQuery, GetUserActivitiesQueryVariables>(Operations.getUserActivities, options);
        }
export type GetUserActivitiesQueryHookResult = ReturnType<typeof useGetUserActivitiesQuery>;
export type GetUserActivitiesLazyQueryHookResult = ReturnType<typeof useGetUserActivitiesLazyQuery>;
export type GetUserActivitiesQueryResult = ApolloReactCommon.QueryResult<GetUserActivitiesQuery, GetUserActivitiesQueryVariables>;
export function refetchGetUserActivitiesQuery(variables: GetUserActivitiesQueryVariables) {
      return { query: Operations.getUserActivities, variables: variables }
    }
export type RemoveProviderActivityProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveProviderActivityMutation, RemoveProviderActivityMutationVariables>
    } & TChildProps;
export function withRemoveProviderActivity<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveProviderActivityMutation,
  RemoveProviderActivityMutationVariables,
  RemoveProviderActivityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveProviderActivityMutation, RemoveProviderActivityMutationVariables, RemoveProviderActivityProps<TChildProps, TDataName>>(Operations.removeProviderActivity, {
      alias: 'removeProviderActivity',
      ...operationOptions
    });
};

/**
 * __useRemoveProviderActivityMutation__
 *
 * To run a mutation, you first call `useRemoveProviderActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProviderActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProviderActivityMutation, { data, loading, error }] = useRemoveProviderActivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useRemoveProviderActivityMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProviderActivityMutation, RemoveProviderActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProviderActivityMutation, RemoveProviderActivityMutationVariables>(Operations.removeProviderActivity, options);
      }
export type RemoveProviderActivityMutationHookResult = ReturnType<typeof useRemoveProviderActivityMutation>;
export type RemoveProviderActivityMutationResult = ApolloReactCommon.MutationResult<RemoveProviderActivityMutation>;
export type RemoveProviderActivityMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveProviderActivityMutation, RemoveProviderActivityMutationVariables>;
export type AddAmbassadorProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddAmbassadorMutation, AddAmbassadorMutationVariables>
    } & TChildProps;
export function withAddAmbassador<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddAmbassadorMutation,
  AddAmbassadorMutationVariables,
  AddAmbassadorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddAmbassadorMutation, AddAmbassadorMutationVariables, AddAmbassadorProps<TChildProps, TDataName>>(Operations.addAmbassador, {
      alias: 'addAmbassador',
      ...operationOptions
    });
};

/**
 * __useAddAmbassadorMutation__
 *
 * To run a mutation, you first call `useAddAmbassadorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAmbassadorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAmbassadorMutation, { data, loading, error }] = useAddAmbassadorMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      tags: // value for 'tags'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      info: // value for 'info'
 *      image: // value for 'image'
 *      activityTypes: // value for 'activityTypes'
 *      place: // value for 'place'
 *      withAdvancedMode: // value for 'withAdvancedMode'
 *   },
 * });
 */
export function useAddAmbassadorMutation(baseOptions?: Apollo.MutationHookOptions<AddAmbassadorMutation, AddAmbassadorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAmbassadorMutation, AddAmbassadorMutationVariables>(Operations.addAmbassador, options);
      }
export type AddAmbassadorMutationHookResult = ReturnType<typeof useAddAmbassadorMutation>;
export type AddAmbassadorMutationResult = ApolloReactCommon.MutationResult<AddAmbassadorMutation>;
export type AddAmbassadorMutationOptions = ApolloReactCommon.BaseMutationOptions<AddAmbassadorMutation, AddAmbassadorMutationVariables>;
export type AddAmbassadorConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddAmbassadorConfigMutation, AddAmbassadorConfigMutationVariables>
    } & TChildProps;
export function withAddAmbassadorConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddAmbassadorConfigMutation,
  AddAmbassadorConfigMutationVariables,
  AddAmbassadorConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddAmbassadorConfigMutation, AddAmbassadorConfigMutationVariables, AddAmbassadorConfigProps<TChildProps, TDataName>>(Operations.addAmbassadorConfig, {
      alias: 'addAmbassadorConfig',
      ...operationOptions
    });
};

/**
 * __useAddAmbassadorConfigMutation__
 *
 * To run a mutation, you first call `useAddAmbassadorConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAmbassadorConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAmbassadorConfigMutation, { data, loading, error }] = useAddAmbassadorConfigMutation({
 *   variables: {
 *      place: // value for 'place'
 *      image: // value for 'image'
 *      visibility: // value for 'visibility'
 *      title: // value for 'title'
 *      preview: // value for 'preview'
 *      description: // value for 'description'
 *      intro: // value for 'intro'
 *      ambassadorIntro: // value for 'ambassadorIntro'
 *      caption: // value for 'caption'
 *      heroImage: // value for 'heroImage'
 *      sequence: // value for 'sequence'
 *      withAdvancedMode: // value for 'withAdvancedMode'
 *   },
 * });
 */
export function useAddAmbassadorConfigMutation(baseOptions?: Apollo.MutationHookOptions<AddAmbassadorConfigMutation, AddAmbassadorConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAmbassadorConfigMutation, AddAmbassadorConfigMutationVariables>(Operations.addAmbassadorConfig, options);
      }
export type AddAmbassadorConfigMutationHookResult = ReturnType<typeof useAddAmbassadorConfigMutation>;
export type AddAmbassadorConfigMutationResult = ApolloReactCommon.MutationResult<AddAmbassadorConfigMutation>;
export type AddAmbassadorConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<AddAmbassadorConfigMutation, AddAmbassadorConfigMutationVariables>;
export type AddAmbassadorTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddAmbassadorTagMutation, AddAmbassadorTagMutationVariables>
    } & TChildProps;
export function withAddAmbassadorTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddAmbassadorTagMutation,
  AddAmbassadorTagMutationVariables,
  AddAmbassadorTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddAmbassadorTagMutation, AddAmbassadorTagMutationVariables, AddAmbassadorTagProps<TChildProps, TDataName>>(Operations.addAmbassadorTag, {
      alias: 'addAmbassadorTag',
      ...operationOptions
    });
};

/**
 * __useAddAmbassadorTagMutation__
 *
 * To run a mutation, you first call `useAddAmbassadorTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAmbassadorTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAmbassadorTagMutation, { data, loading, error }] = useAddAmbassadorTagMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useAddAmbassadorTagMutation(baseOptions?: Apollo.MutationHookOptions<AddAmbassadorTagMutation, AddAmbassadorTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAmbassadorTagMutation, AddAmbassadorTagMutationVariables>(Operations.addAmbassadorTag, options);
      }
export type AddAmbassadorTagMutationHookResult = ReturnType<typeof useAddAmbassadorTagMutation>;
export type AddAmbassadorTagMutationResult = ApolloReactCommon.MutationResult<AddAmbassadorTagMutation>;
export type AddAmbassadorTagMutationOptions = ApolloReactCommon.BaseMutationOptions<AddAmbassadorTagMutation, AddAmbassadorTagMutationVariables>;
export type GetAmbassadorConfigCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAmbassadorConfigCountQuery, GetAmbassadorConfigCountQueryVariables>
    } & TChildProps;
export function withGetAmbassadorConfigCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAmbassadorConfigCountQuery,
  GetAmbassadorConfigCountQueryVariables,
  GetAmbassadorConfigCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAmbassadorConfigCountQuery, GetAmbassadorConfigCountQueryVariables, GetAmbassadorConfigCountProps<TChildProps, TDataName>>(Operations.getAmbassadorConfigCount, {
      alias: 'getAmbassadorConfigCount',
      ...operationOptions
    });
};

/**
 * __useGetAmbassadorConfigCountQuery__
 *
 * To run a query within a React component, call `useGetAmbassadorConfigCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmbassadorConfigCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmbassadorConfigCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAmbassadorConfigCountQuery(baseOptions?: Apollo.QueryHookOptions<GetAmbassadorConfigCountQuery, GetAmbassadorConfigCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmbassadorConfigCountQuery, GetAmbassadorConfigCountQueryVariables>(Operations.getAmbassadorConfigCount, options);
      }
export function useGetAmbassadorConfigCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmbassadorConfigCountQuery, GetAmbassadorConfigCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmbassadorConfigCountQuery, GetAmbassadorConfigCountQueryVariables>(Operations.getAmbassadorConfigCount, options);
        }
export type GetAmbassadorConfigCountQueryHookResult = ReturnType<typeof useGetAmbassadorConfigCountQuery>;
export type GetAmbassadorConfigCountLazyQueryHookResult = ReturnType<typeof useGetAmbassadorConfigCountLazyQuery>;
export type GetAmbassadorConfigCountQueryResult = ApolloReactCommon.QueryResult<GetAmbassadorConfigCountQuery, GetAmbassadorConfigCountQueryVariables>;
export function refetchGetAmbassadorConfigCountQuery(variables?: GetAmbassadorConfigCountQueryVariables) {
      return { query: Operations.getAmbassadorConfigCount, variables: variables }
    }
export type GetAmbassadorConfigsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAmbassadorConfigsQuery, GetAmbassadorConfigsQueryVariables>
    } & TChildProps;
export function withGetAmbassadorConfigs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAmbassadorConfigsQuery,
  GetAmbassadorConfigsQueryVariables,
  GetAmbassadorConfigsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAmbassadorConfigsQuery, GetAmbassadorConfigsQueryVariables, GetAmbassadorConfigsProps<TChildProps, TDataName>>(Operations.getAmbassadorConfigs, {
      alias: 'getAmbassadorConfigs',
      ...operationOptions
    });
};

/**
 * __useGetAmbassadorConfigsQuery__
 *
 * To run a query within a React component, call `useGetAmbassadorConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmbassadorConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmbassadorConfigsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAmbassadorConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetAmbassadorConfigsQuery, GetAmbassadorConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmbassadorConfigsQuery, GetAmbassadorConfigsQueryVariables>(Operations.getAmbassadorConfigs, options);
      }
export function useGetAmbassadorConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmbassadorConfigsQuery, GetAmbassadorConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmbassadorConfigsQuery, GetAmbassadorConfigsQueryVariables>(Operations.getAmbassadorConfigs, options);
        }
export type GetAmbassadorConfigsQueryHookResult = ReturnType<typeof useGetAmbassadorConfigsQuery>;
export type GetAmbassadorConfigsLazyQueryHookResult = ReturnType<typeof useGetAmbassadorConfigsLazyQuery>;
export type GetAmbassadorConfigsQueryResult = ApolloReactCommon.QueryResult<GetAmbassadorConfigsQuery, GetAmbassadorConfigsQueryVariables>;
export function refetchGetAmbassadorConfigsQuery(variables?: GetAmbassadorConfigsQueryVariables) {
      return { query: Operations.getAmbassadorConfigs, variables: variables }
    }
export type GetAmbassadorTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAmbassadorTagsQuery, GetAmbassadorTagsQueryVariables>
    } & TChildProps;
export function withGetAmbassadorTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAmbassadorTagsQuery,
  GetAmbassadorTagsQueryVariables,
  GetAmbassadorTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAmbassadorTagsQuery, GetAmbassadorTagsQueryVariables, GetAmbassadorTagsProps<TChildProps, TDataName>>(Operations.getAmbassadorTags, {
      alias: 'getAmbassadorTags',
      ...operationOptions
    });
};

/**
 * __useGetAmbassadorTagsQuery__
 *
 * To run a query within a React component, call `useGetAmbassadorTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmbassadorTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmbassadorTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAmbassadorTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetAmbassadorTagsQuery, GetAmbassadorTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmbassadorTagsQuery, GetAmbassadorTagsQueryVariables>(Operations.getAmbassadorTags, options);
      }
export function useGetAmbassadorTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmbassadorTagsQuery, GetAmbassadorTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmbassadorTagsQuery, GetAmbassadorTagsQueryVariables>(Operations.getAmbassadorTags, options);
        }
export type GetAmbassadorTagsQueryHookResult = ReturnType<typeof useGetAmbassadorTagsQuery>;
export type GetAmbassadorTagsLazyQueryHookResult = ReturnType<typeof useGetAmbassadorTagsLazyQuery>;
export type GetAmbassadorTagsQueryResult = ApolloReactCommon.QueryResult<GetAmbassadorTagsQuery, GetAmbassadorTagsQueryVariables>;
export function refetchGetAmbassadorTagsQuery(variables?: GetAmbassadorTagsQueryVariables) {
      return { query: Operations.getAmbassadorTags, variables: variables }
    }
export type GetAmbassadorsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAmbassadorsQuery, GetAmbassadorsQueryVariables>
    } & TChildProps;
export function withGetAmbassadors<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAmbassadorsQuery,
  GetAmbassadorsQueryVariables,
  GetAmbassadorsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAmbassadorsQuery, GetAmbassadorsQueryVariables, GetAmbassadorsProps<TChildProps, TDataName>>(Operations.getAmbassadors, {
      alias: 'getAmbassadors',
      ...operationOptions
    });
};

/**
 * __useGetAmbassadorsQuery__
 *
 * To run a query within a React component, call `useGetAmbassadorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmbassadorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmbassadorsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAmbassadorsQuery(baseOptions?: Apollo.QueryHookOptions<GetAmbassadorsQuery, GetAmbassadorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmbassadorsQuery, GetAmbassadorsQueryVariables>(Operations.getAmbassadors, options);
      }
export function useGetAmbassadorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmbassadorsQuery, GetAmbassadorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmbassadorsQuery, GetAmbassadorsQueryVariables>(Operations.getAmbassadors, options);
        }
export type GetAmbassadorsQueryHookResult = ReturnType<typeof useGetAmbassadorsQuery>;
export type GetAmbassadorsLazyQueryHookResult = ReturnType<typeof useGetAmbassadorsLazyQuery>;
export type GetAmbassadorsQueryResult = ApolloReactCommon.QueryResult<GetAmbassadorsQuery, GetAmbassadorsQueryVariables>;
export function refetchGetAmbassadorsQuery(variables?: GetAmbassadorsQueryVariables) {
      return { query: Operations.getAmbassadors, variables: variables }
    }
export type RemoveAmbassadorProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveAmbassadorMutation, RemoveAmbassadorMutationVariables>
    } & TChildProps;
export function withRemoveAmbassador<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveAmbassadorMutation,
  RemoveAmbassadorMutationVariables,
  RemoveAmbassadorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveAmbassadorMutation, RemoveAmbassadorMutationVariables, RemoveAmbassadorProps<TChildProps, TDataName>>(Operations.removeAmbassador, {
      alias: 'removeAmbassador',
      ...operationOptions
    });
};

/**
 * __useRemoveAmbassadorMutation__
 *
 * To run a mutation, you first call `useRemoveAmbassadorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAmbassadorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAmbassadorMutation, { data, loading, error }] = useRemoveAmbassadorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAmbassadorMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAmbassadorMutation, RemoveAmbassadorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAmbassadorMutation, RemoveAmbassadorMutationVariables>(Operations.removeAmbassador, options);
      }
export type RemoveAmbassadorMutationHookResult = ReturnType<typeof useRemoveAmbassadorMutation>;
export type RemoveAmbassadorMutationResult = ApolloReactCommon.MutationResult<RemoveAmbassadorMutation>;
export type RemoveAmbassadorMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveAmbassadorMutation, RemoveAmbassadorMutationVariables>;
export type RemoveAmbassadorConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveAmbassadorConfigMutation, RemoveAmbassadorConfigMutationVariables>
    } & TChildProps;
export function withRemoveAmbassadorConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveAmbassadorConfigMutation,
  RemoveAmbassadorConfigMutationVariables,
  RemoveAmbassadorConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveAmbassadorConfigMutation, RemoveAmbassadorConfigMutationVariables, RemoveAmbassadorConfigProps<TChildProps, TDataName>>(Operations.removeAmbassadorConfig, {
      alias: 'removeAmbassadorConfig',
      ...operationOptions
    });
};

/**
 * __useRemoveAmbassadorConfigMutation__
 *
 * To run a mutation, you first call `useRemoveAmbassadorConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAmbassadorConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAmbassadorConfigMutation, { data, loading, error }] = useRemoveAmbassadorConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAmbassadorConfigMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAmbassadorConfigMutation, RemoveAmbassadorConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAmbassadorConfigMutation, RemoveAmbassadorConfigMutationVariables>(Operations.removeAmbassadorConfig, options);
      }
export type RemoveAmbassadorConfigMutationHookResult = ReturnType<typeof useRemoveAmbassadorConfigMutation>;
export type RemoveAmbassadorConfigMutationResult = ApolloReactCommon.MutationResult<RemoveAmbassadorConfigMutation>;
export type RemoveAmbassadorConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveAmbassadorConfigMutation, RemoveAmbassadorConfigMutationVariables>;
export type RemoveAmbassadorTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveAmbassadorTagMutation, RemoveAmbassadorTagMutationVariables>
    } & TChildProps;
export function withRemoveAmbassadorTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveAmbassadorTagMutation,
  RemoveAmbassadorTagMutationVariables,
  RemoveAmbassadorTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveAmbassadorTagMutation, RemoveAmbassadorTagMutationVariables, RemoveAmbassadorTagProps<TChildProps, TDataName>>(Operations.removeAmbassadorTag, {
      alias: 'removeAmbassadorTag',
      ...operationOptions
    });
};

/**
 * __useRemoveAmbassadorTagMutation__
 *
 * To run a mutation, you first call `useRemoveAmbassadorTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAmbassadorTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAmbassadorTagMutation, { data, loading, error }] = useRemoveAmbassadorTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAmbassadorTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAmbassadorTagMutation, RemoveAmbassadorTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAmbassadorTagMutation, RemoveAmbassadorTagMutationVariables>(Operations.removeAmbassadorTag, options);
      }
export type RemoveAmbassadorTagMutationHookResult = ReturnType<typeof useRemoveAmbassadorTagMutation>;
export type RemoveAmbassadorTagMutationResult = ApolloReactCommon.MutationResult<RemoveAmbassadorTagMutation>;
export type RemoveAmbassadorTagMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveAmbassadorTagMutation, RemoveAmbassadorTagMutationVariables>;
export type UpdateAmbassadorProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateAmbassadorMutation, UpdateAmbassadorMutationVariables>
    } & TChildProps;
export function withUpdateAmbassador<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateAmbassadorMutation,
  UpdateAmbassadorMutationVariables,
  UpdateAmbassadorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateAmbassadorMutation, UpdateAmbassadorMutationVariables, UpdateAmbassadorProps<TChildProps, TDataName>>(Operations.updateAmbassador, {
      alias: 'updateAmbassador',
      ...operationOptions
    });
};

/**
 * __useUpdateAmbassadorMutation__
 *
 * To run a mutation, you first call `useUpdateAmbassadorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmbassadorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmbassadorMutation, { data, loading, error }] = useUpdateAmbassadorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      tags: // value for 'tags'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      info: // value for 'info'
 *      image: // value for 'image'
 *      activityTypes: // value for 'activityTypes'
 *      place: // value for 'place'
 *      withAdvancedMode: // value for 'withAdvancedMode'
 *   },
 * });
 */
export function useUpdateAmbassadorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmbassadorMutation, UpdateAmbassadorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAmbassadorMutation, UpdateAmbassadorMutationVariables>(Operations.updateAmbassador, options);
      }
export type UpdateAmbassadorMutationHookResult = ReturnType<typeof useUpdateAmbassadorMutation>;
export type UpdateAmbassadorMutationResult = ApolloReactCommon.MutationResult<UpdateAmbassadorMutation>;
export type UpdateAmbassadorMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAmbassadorMutation, UpdateAmbassadorMutationVariables>;
export type UpdateAmbassadorConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateAmbassadorConfigMutation, UpdateAmbassadorConfigMutationVariables>
    } & TChildProps;
export function withUpdateAmbassadorConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateAmbassadorConfigMutation,
  UpdateAmbassadorConfigMutationVariables,
  UpdateAmbassadorConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateAmbassadorConfigMutation, UpdateAmbassadorConfigMutationVariables, UpdateAmbassadorConfigProps<TChildProps, TDataName>>(Operations.updateAmbassadorConfig, {
      alias: 'updateAmbassadorConfig',
      ...operationOptions
    });
};

/**
 * __useUpdateAmbassadorConfigMutation__
 *
 * To run a mutation, you first call `useUpdateAmbassadorConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmbassadorConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmbassadorConfigMutation, { data, loading, error }] = useUpdateAmbassadorConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      place: // value for 'place'
 *      image: // value for 'image'
 *      visibility: // value for 'visibility'
 *      title: // value for 'title'
 *      preview: // value for 'preview'
 *      description: // value for 'description'
 *      intro: // value for 'intro'
 *      ambassadorIntro: // value for 'ambassadorIntro'
 *      caption: // value for 'caption'
 *      heroImage: // value for 'heroImage'
 *      sequence: // value for 'sequence'
 *      withAdvancedMode: // value for 'withAdvancedMode'
 *   },
 * });
 */
export function useUpdateAmbassadorConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmbassadorConfigMutation, UpdateAmbassadorConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAmbassadorConfigMutation, UpdateAmbassadorConfigMutationVariables>(Operations.updateAmbassadorConfig, options);
      }
export type UpdateAmbassadorConfigMutationHookResult = ReturnType<typeof useUpdateAmbassadorConfigMutation>;
export type UpdateAmbassadorConfigMutationResult = ApolloReactCommon.MutationResult<UpdateAmbassadorConfigMutation>;
export type UpdateAmbassadorConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAmbassadorConfigMutation, UpdateAmbassadorConfigMutationVariables>;
export type UpdateAmbassadorTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateAmbassadorTagMutation, UpdateAmbassadorTagMutationVariables>
    } & TChildProps;
export function withUpdateAmbassadorTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateAmbassadorTagMutation,
  UpdateAmbassadorTagMutationVariables,
  UpdateAmbassadorTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateAmbassadorTagMutation, UpdateAmbassadorTagMutationVariables, UpdateAmbassadorTagProps<TChildProps, TDataName>>(Operations.updateAmbassadorTag, {
      alias: 'updateAmbassadorTag',
      ...operationOptions
    });
};

/**
 * __useUpdateAmbassadorTagMutation__
 *
 * To run a mutation, you first call `useUpdateAmbassadorTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmbassadorTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmbassadorTagMutation, { data, loading, error }] = useUpdateAmbassadorTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useUpdateAmbassadorTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmbassadorTagMutation, UpdateAmbassadorTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAmbassadorTagMutation, UpdateAmbassadorTagMutationVariables>(Operations.updateAmbassadorTag, options);
      }
export type UpdateAmbassadorTagMutationHookResult = ReturnType<typeof useUpdateAmbassadorTagMutation>;
export type UpdateAmbassadorTagMutationResult = ApolloReactCommon.MutationResult<UpdateAmbassadorTagMutation>;
export type UpdateAmbassadorTagMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAmbassadorTagMutation, UpdateAmbassadorTagMutationVariables>;
export type AddArticleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddArticleMutation, AddArticleMutationVariables>
    } & TChildProps;
export function withAddArticle<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddArticleMutation,
  AddArticleMutationVariables,
  AddArticleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddArticleMutation, AddArticleMutationVariables, AddArticleProps<TChildProps, TDataName>>(Operations.addArticle, {
      alias: 'addArticle',
      ...operationOptions
    });
};

/**
 * __useAddArticleMutation__
 *
 * To run a mutation, you first call `useAddArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addArticleMutation, { data, loading, error }] = useAddArticleMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      articleNumber: // value for 'articleNumber'
 *      image: // value for 'image'
 *      price: // value for 'price'
 *      currentStock: // value for 'currentStock'
 *      availableStock: // value for 'availableStock'
 *      orderRestrictions: // value for 'orderRestrictions'
 *      instructions: // value for 'instructions'
 *      vouchers: // value for 'vouchers'
 *      publishOn: // value for 'publishOn'
 *      expiresOn: // value for 'expiresOn'
 *      priority: // value for 'priority'
 *      isDraft: // value for 'isDraft'
 *      countries: // value for 'countries'
 *      roles: // value for 'roles'
 *      type: // value for 'type'
 *      contentsIds: // value for 'contentsIds'
 *   },
 * });
 */
export function useAddArticleMutation(baseOptions?: Apollo.MutationHookOptions<AddArticleMutation, AddArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddArticleMutation, AddArticleMutationVariables>(Operations.addArticle, options);
      }
export type AddArticleMutationHookResult = ReturnType<typeof useAddArticleMutation>;
export type AddArticleMutationResult = ApolloReactCommon.MutationResult<AddArticleMutation>;
export type AddArticleMutationOptions = ApolloReactCommon.BaseMutationOptions<AddArticleMutation, AddArticleMutationVariables>;
export type AddArticleVouchersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddArticleVouchersMutation, AddArticleVouchersMutationVariables>
    } & TChildProps;
export function withAddArticleVouchers<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddArticleVouchersMutation,
  AddArticleVouchersMutationVariables,
  AddArticleVouchersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddArticleVouchersMutation, AddArticleVouchersMutationVariables, AddArticleVouchersProps<TChildProps, TDataName>>(Operations.addArticleVouchers, {
      alias: 'addArticleVouchers',
      ...operationOptions
    });
};

/**
 * __useAddArticleVouchersMutation__
 *
 * To run a mutation, you first call `useAddArticleVouchersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddArticleVouchersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addArticleVouchersMutation, { data, loading, error }] = useAddArticleVouchersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vouchers: // value for 'vouchers'
 *   },
 * });
 */
export function useAddArticleVouchersMutation(baseOptions?: Apollo.MutationHookOptions<AddArticleVouchersMutation, AddArticleVouchersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddArticleVouchersMutation, AddArticleVouchersMutationVariables>(Operations.addArticleVouchers, options);
      }
export type AddArticleVouchersMutationHookResult = ReturnType<typeof useAddArticleVouchersMutation>;
export type AddArticleVouchersMutationResult = ApolloReactCommon.MutationResult<AddArticleVouchersMutation>;
export type AddArticleVouchersMutationOptions = ApolloReactCommon.BaseMutationOptions<AddArticleVouchersMutation, AddArticleVouchersMutationVariables>;
export type GetArticleCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetArticleCountQuery, GetArticleCountQueryVariables>
    } & TChildProps;
export function withGetArticleCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetArticleCountQuery,
  GetArticleCountQueryVariables,
  GetArticleCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetArticleCountQuery, GetArticleCountQueryVariables, GetArticleCountProps<TChildProps, TDataName>>(Operations.getArticleCount, {
      alias: 'getArticleCount',
      ...operationOptions
    });
};

/**
 * __useGetArticleCountQuery__
 *
 * To run a query within a React component, call `useGetArticleCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetArticleCountQuery(baseOptions?: Apollo.QueryHookOptions<GetArticleCountQuery, GetArticleCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleCountQuery, GetArticleCountQueryVariables>(Operations.getArticleCount, options);
      }
export function useGetArticleCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleCountQuery, GetArticleCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleCountQuery, GetArticleCountQueryVariables>(Operations.getArticleCount, options);
        }
export type GetArticleCountQueryHookResult = ReturnType<typeof useGetArticleCountQuery>;
export type GetArticleCountLazyQueryHookResult = ReturnType<typeof useGetArticleCountLazyQuery>;
export type GetArticleCountQueryResult = ApolloReactCommon.QueryResult<GetArticleCountQuery, GetArticleCountQueryVariables>;
export function refetchGetArticleCountQuery(variables?: GetArticleCountQueryVariables) {
      return { query: Operations.getArticleCount, variables: variables }
    }
export type GetArticlesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetArticlesQuery, GetArticlesQueryVariables>
    } & TChildProps;
export function withGetArticles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetArticlesQuery,
  GetArticlesQueryVariables,
  GetArticlesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetArticlesQuery, GetArticlesQueryVariables, GetArticlesProps<TChildProps, TDataName>>(Operations.getArticles, {
      alias: 'getArticles',
      ...operationOptions
    });
};

/**
 * __useGetArticlesQuery__
 *
 * To run a query within a React component, call `useGetArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticlesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetArticlesQuery(baseOptions?: Apollo.QueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticlesQuery, GetArticlesQueryVariables>(Operations.getArticles, options);
      }
export function useGetArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticlesQuery, GetArticlesQueryVariables>(Operations.getArticles, options);
        }
export type GetArticlesQueryHookResult = ReturnType<typeof useGetArticlesQuery>;
export type GetArticlesLazyQueryHookResult = ReturnType<typeof useGetArticlesLazyQuery>;
export type GetArticlesQueryResult = ApolloReactCommon.QueryResult<GetArticlesQuery, GetArticlesQueryVariables>;
export function refetchGetArticlesQuery(variables?: GetArticlesQueryVariables) {
      return { query: Operations.getArticles, variables: variables }
    }
export type GetArticlesOverviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetArticlesOverviewQuery, GetArticlesOverviewQueryVariables>
    } & TChildProps;
export function withGetArticlesOverview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetArticlesOverviewQuery,
  GetArticlesOverviewQueryVariables,
  GetArticlesOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetArticlesOverviewQuery, GetArticlesOverviewQueryVariables, GetArticlesOverviewProps<TChildProps, TDataName>>(Operations.getArticlesOverview, {
      alias: 'getArticlesOverview',
      ...operationOptions
    });
};

/**
 * __useGetArticlesOverviewQuery__
 *
 * To run a query within a React component, call `useGetArticlesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticlesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticlesOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetArticlesOverviewQuery(baseOptions?: Apollo.QueryHookOptions<GetArticlesOverviewQuery, GetArticlesOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticlesOverviewQuery, GetArticlesOverviewQueryVariables>(Operations.getArticlesOverview, options);
      }
export function useGetArticlesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticlesOverviewQuery, GetArticlesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticlesOverviewQuery, GetArticlesOverviewQueryVariables>(Operations.getArticlesOverview, options);
        }
export type GetArticlesOverviewQueryHookResult = ReturnType<typeof useGetArticlesOverviewQuery>;
export type GetArticlesOverviewLazyQueryHookResult = ReturnType<typeof useGetArticlesOverviewLazyQuery>;
export type GetArticlesOverviewQueryResult = ApolloReactCommon.QueryResult<GetArticlesOverviewQuery, GetArticlesOverviewQueryVariables>;
export function refetchGetArticlesOverviewQuery(variables?: GetArticlesOverviewQueryVariables) {
      return { query: Operations.getArticlesOverview, variables: variables }
    }
export type RemoveArticleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveArticleMutation, RemoveArticleMutationVariables>
    } & TChildProps;
export function withRemoveArticle<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveArticleMutation,
  RemoveArticleMutationVariables,
  RemoveArticleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveArticleMutation, RemoveArticleMutationVariables, RemoveArticleProps<TChildProps, TDataName>>(Operations.removeArticle, {
      alias: 'removeArticle',
      ...operationOptions
    });
};

/**
 * __useRemoveArticleMutation__
 *
 * To run a mutation, you first call `useRemoveArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeArticleMutation, { data, loading, error }] = useRemoveArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveArticleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveArticleMutation, RemoveArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveArticleMutation, RemoveArticleMutationVariables>(Operations.removeArticle, options);
      }
export type RemoveArticleMutationHookResult = ReturnType<typeof useRemoveArticleMutation>;
export type RemoveArticleMutationResult = ApolloReactCommon.MutationResult<RemoveArticleMutation>;
export type RemoveArticleMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveArticleMutation, RemoveArticleMutationVariables>;
export type RemoveArticleVouchersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveArticleVouchersMutation, RemoveArticleVouchersMutationVariables>
    } & TChildProps;
export function withRemoveArticleVouchers<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveArticleVouchersMutation,
  RemoveArticleVouchersMutationVariables,
  RemoveArticleVouchersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveArticleVouchersMutation, RemoveArticleVouchersMutationVariables, RemoveArticleVouchersProps<TChildProps, TDataName>>(Operations.removeArticleVouchers, {
      alias: 'removeArticleVouchers',
      ...operationOptions
    });
};

/**
 * __useRemoveArticleVouchersMutation__
 *
 * To run a mutation, you first call `useRemoveArticleVouchersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveArticleVouchersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeArticleVouchersMutation, { data, loading, error }] = useRemoveArticleVouchersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vouchers: // value for 'vouchers'
 *      deleteAllVouchers: // value for 'deleteAllVouchers'
 *   },
 * });
 */
export function useRemoveArticleVouchersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveArticleVouchersMutation, RemoveArticleVouchersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveArticleVouchersMutation, RemoveArticleVouchersMutationVariables>(Operations.removeArticleVouchers, options);
      }
export type RemoveArticleVouchersMutationHookResult = ReturnType<typeof useRemoveArticleVouchersMutation>;
export type RemoveArticleVouchersMutationResult = ApolloReactCommon.MutationResult<RemoveArticleVouchersMutation>;
export type RemoveArticleVouchersMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveArticleVouchersMutation, RemoveArticleVouchersMutationVariables>;
export type UpdateArticleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateArticleMutation, UpdateArticleMutationVariables>
    } & TChildProps;
export function withUpdateArticle<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateArticleMutation,
  UpdateArticleMutationVariables,
  UpdateArticleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateArticleMutation, UpdateArticleMutationVariables, UpdateArticleProps<TChildProps, TDataName>>(Operations.updateArticle, {
      alias: 'updateArticle',
      ...operationOptions
    });
};

/**
 * __useUpdateArticleMutation__
 *
 * To run a mutation, you first call `useUpdateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticleMutation, { data, loading, error }] = useUpdateArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      articleNumber: // value for 'articleNumber'
 *      image: // value for 'image'
 *      price: // value for 'price'
 *      currentStock: // value for 'currentStock'
 *      availableStock: // value for 'availableStock'
 *      orderRestrictions: // value for 'orderRestrictions'
 *      instructions: // value for 'instructions'
 *      vouchers: // value for 'vouchers'
 *      publishOn: // value for 'publishOn'
 *      expiresOn: // value for 'expiresOn'
 *      priority: // value for 'priority'
 *      isDraft: // value for 'isDraft'
 *      countries: // value for 'countries'
 *      roles: // value for 'roles'
 *      type: // value for 'type'
 *      contentsIds: // value for 'contentsIds'
 *   },
 * });
 */
export function useUpdateArticleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticleMutation, UpdateArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticleMutation, UpdateArticleMutationVariables>(Operations.updateArticle, options);
      }
export type UpdateArticleMutationHookResult = ReturnType<typeof useUpdateArticleMutation>;
export type UpdateArticleMutationResult = ApolloReactCommon.MutationResult<UpdateArticleMutation>;
export type UpdateArticleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArticleMutation, UpdateArticleMutationVariables>;
export type AddChallengeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddChallengeMutation, AddChallengeMutationVariables>
    } & TChildProps;
export function withAddChallenge<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddChallengeMutation,
  AddChallengeMutationVariables,
  AddChallengeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddChallengeMutation, AddChallengeMutationVariables, AddChallengeProps<TChildProps, TDataName>>(Operations.addChallenge, {
      alias: 'addChallenge',
      ...operationOptions
    });
};

/**
 * __useAddChallengeMutation__
 *
 * To run a mutation, you first call `useAddChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChallengeMutation, { data, loading, error }] = useAddChallengeMutation({
 *   variables: {
 *      title: // value for 'title'
 *      subtitle: // value for 'subtitle'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      rewards: // value for 'rewards'
 *      difficultyLevel: // value for 'difficultyLevel'
 *      duration: // value for 'duration'
 *      registration: // value for 'registration'
 *      activityTypes: // value for 'activityTypes'
 *      tieBreaker: // value for 'tieBreaker'
 *      conditionsInOrder: // value for 'conditionsInOrder'
 *      conditions: // value for 'conditions'
 *      ultimateSyncTime: // value for 'ultimateSyncTime'
 *      milestones: // value for 'milestones'
 *      featured: // value for 'featured'
 *      publishedOn: // value for 'publishedOn'
 *      expiresOn: // value for 'expiresOn'
 *      visualizeType: // value for 'visualizeType'
 *      roles: // value for 'roles'
 *      team: // value for 'team'
 *      endless: // value for 'endless'
 *      exceedConditionLimit: // value for 'exceedConditionLimit'
 *      hideInList: // value for 'hideInList'
 *      hideProgressInList: // value for 'hideProgressInList'
 *      hideProgressInDetails: // value for 'hideProgressInDetails'
 *      hideProgressInInsights: // value for 'hideProgressInInsights'
 *      priority: // value for 'priority'
 *      payment: // value for 'payment'
 *      totals: // value for 'totals'
 *      visualisations: // value for 'visualisations'
 *      teamPropertyValues: // value for 'teamPropertyValues'
 *      tags: // value for 'tags'
 *      viewParticipants: // value for 'viewParticipants'
 *      viewParticipantCount: // value for 'viewParticipantCount'
 *      viewCompletedParticipants: // value for 'viewCompletedParticipants'
 *      viewTeamCount: // value for 'viewTeamCount'
 *      voucherConfiguration: // value for 'voucherConfiguration'
 *      enabledLocales: // value for 'enabledLocales'
 *      participationProfileRequirements: // value for 'participationProfileRequirements'
 *      data: // value for 'data'
 *      contentsIds: // value for 'contentsIds'
 *      superDates: // value for 'superDates'
 *      autoParticipationEnabled: // value for 'autoParticipationEnabled'
 *      disableComments: // value for 'disableComments'
 *      withAdvancedMode: // value for 'withAdvancedMode'
 *      activityMultipliers: // value for 'activityMultipliers'
 *   },
 * });
 */
export function useAddChallengeMutation(baseOptions?: Apollo.MutationHookOptions<AddChallengeMutation, AddChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddChallengeMutation, AddChallengeMutationVariables>(Operations.addChallenge, options);
      }
export type AddChallengeMutationHookResult = ReturnType<typeof useAddChallengeMutation>;
export type AddChallengeMutationResult = ApolloReactCommon.MutationResult<AddChallengeMutation>;
export type AddChallengeMutationOptions = ApolloReactCommon.BaseMutationOptions<AddChallengeMutation, AddChallengeMutationVariables>;
export type AddChallengeTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddChallengeTagMutation, AddChallengeTagMutationVariables>
    } & TChildProps;
export function withAddChallengeTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddChallengeTagMutation,
  AddChallengeTagMutationVariables,
  AddChallengeTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddChallengeTagMutation, AddChallengeTagMutationVariables, AddChallengeTagProps<TChildProps, TDataName>>(Operations.addChallengeTag, {
      alias: 'addChallengeTag',
      ...operationOptions
    });
};

/**
 * __useAddChallengeTagMutation__
 *
 * To run a mutation, you first call `useAddChallengeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChallengeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChallengeTagMutation, { data, loading, error }] = useAddChallengeTagMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useAddChallengeTagMutation(baseOptions?: Apollo.MutationHookOptions<AddChallengeTagMutation, AddChallengeTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddChallengeTagMutation, AddChallengeTagMutationVariables>(Operations.addChallengeTag, options);
      }
export type AddChallengeTagMutationHookResult = ReturnType<typeof useAddChallengeTagMutation>;
export type AddChallengeTagMutationResult = ApolloReactCommon.MutationResult<AddChallengeTagMutation>;
export type AddChallengeTagMutationOptions = ApolloReactCommon.BaseMutationOptions<AddChallengeTagMutation, AddChallengeTagMutationVariables>;
export type AddChallengeTeamProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddChallengeTeamMutation, AddChallengeTeamMutationVariables>
    } & TChildProps;
export function withAddChallengeTeam<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddChallengeTeamMutation,
  AddChallengeTeamMutationVariables,
  AddChallengeTeamProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddChallengeTeamMutation, AddChallengeTeamMutationVariables, AddChallengeTeamProps<TChildProps, TDataName>>(Operations.addChallengeTeam, {
      alias: 'addChallengeTeam',
      ...operationOptions
    });
};

/**
 * __useAddChallengeTeamMutation__
 *
 * To run a mutation, you first call `useAddChallengeTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChallengeTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChallengeTeamMutation, { data, loading, error }] = useAddChallengeTeamMutation({
 *   variables: {
 *      title: // value for 'title'
 *      challengeId: // value for 'challengeId'
 *      profileValue: // value for 'profileValue'
 *      captainUserId: // value for 'captainUserId'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useAddChallengeTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddChallengeTeamMutation, AddChallengeTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddChallengeTeamMutation, AddChallengeTeamMutationVariables>(Operations.addChallengeTeam, options);
      }
export type AddChallengeTeamMutationHookResult = ReturnType<typeof useAddChallengeTeamMutation>;
export type AddChallengeTeamMutationResult = ApolloReactCommon.MutationResult<AddChallengeTeamMutation>;
export type AddChallengeTeamMutationOptions = ApolloReactCommon.BaseMutationOptions<AddChallengeTeamMutation, AddChallengeTeamMutationVariables>;
export type BanFromChallengeTeamProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<BanFromChallengeTeamMutation, BanFromChallengeTeamMutationVariables>
    } & TChildProps;
export function withBanFromChallengeTeam<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BanFromChallengeTeamMutation,
  BanFromChallengeTeamMutationVariables,
  BanFromChallengeTeamProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, BanFromChallengeTeamMutation, BanFromChallengeTeamMutationVariables, BanFromChallengeTeamProps<TChildProps, TDataName>>(Operations.banFromChallengeTeam, {
      alias: 'banFromChallengeTeam',
      ...operationOptions
    });
};

/**
 * __useBanFromChallengeTeamMutation__
 *
 * To run a mutation, you first call `useBanFromChallengeTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanFromChallengeTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banFromChallengeTeamMutation, { data, loading, error }] = useBanFromChallengeTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBanFromChallengeTeamMutation(baseOptions?: Apollo.MutationHookOptions<BanFromChallengeTeamMutation, BanFromChallengeTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BanFromChallengeTeamMutation, BanFromChallengeTeamMutationVariables>(Operations.banFromChallengeTeam, options);
      }
export type BanFromChallengeTeamMutationHookResult = ReturnType<typeof useBanFromChallengeTeamMutation>;
export type BanFromChallengeTeamMutationResult = ApolloReactCommon.MutationResult<BanFromChallengeTeamMutation>;
export type BanFromChallengeTeamMutationOptions = ApolloReactCommon.BaseMutationOptions<BanFromChallengeTeamMutation, BanFromChallengeTeamMutationVariables>;
export type ExportChallengeParticipationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ExportChallengeParticipationMutation, ExportChallengeParticipationMutationVariables>
    } & TChildProps;
export function withExportChallengeParticipation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ExportChallengeParticipationMutation,
  ExportChallengeParticipationMutationVariables,
  ExportChallengeParticipationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ExportChallengeParticipationMutation, ExportChallengeParticipationMutationVariables, ExportChallengeParticipationProps<TChildProps, TDataName>>(Operations.exportChallengeParticipation, {
      alias: 'exportChallengeParticipation',
      ...operationOptions
    });
};

/**
 * __useExportChallengeParticipationMutation__
 *
 * To run a mutation, you first call `useExportChallengeParticipationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportChallengeParticipationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportChallengeParticipationMutation, { data, loading, error }] = useExportChallengeParticipationMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useExportChallengeParticipationMutation(baseOptions?: Apollo.MutationHookOptions<ExportChallengeParticipationMutation, ExportChallengeParticipationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportChallengeParticipationMutation, ExportChallengeParticipationMutationVariables>(Operations.exportChallengeParticipation, options);
      }
export type ExportChallengeParticipationMutationHookResult = ReturnType<typeof useExportChallengeParticipationMutation>;
export type ExportChallengeParticipationMutationResult = ApolloReactCommon.MutationResult<ExportChallengeParticipationMutation>;
export type ExportChallengeParticipationMutationOptions = ApolloReactCommon.BaseMutationOptions<ExportChallengeParticipationMutation, ExportChallengeParticipationMutationVariables>;
export type ExportChallengeParticipationFormConditionDataProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ExportChallengeParticipationFormConditionDataMutation, ExportChallengeParticipationFormConditionDataMutationVariables>
    } & TChildProps;
export function withExportChallengeParticipationFormConditionData<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ExportChallengeParticipationFormConditionDataMutation,
  ExportChallengeParticipationFormConditionDataMutationVariables,
  ExportChallengeParticipationFormConditionDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ExportChallengeParticipationFormConditionDataMutation, ExportChallengeParticipationFormConditionDataMutationVariables, ExportChallengeParticipationFormConditionDataProps<TChildProps, TDataName>>(Operations.exportChallengeParticipationFormConditionData, {
      alias: 'exportChallengeParticipationFormConditionData',
      ...operationOptions
    });
};

/**
 * __useExportChallengeParticipationFormConditionDataMutation__
 *
 * To run a mutation, you first call `useExportChallengeParticipationFormConditionDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportChallengeParticipationFormConditionDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportChallengeParticipationFormConditionDataMutation, { data, loading, error }] = useExportChallengeParticipationFormConditionDataMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useExportChallengeParticipationFormConditionDataMutation(baseOptions?: Apollo.MutationHookOptions<ExportChallengeParticipationFormConditionDataMutation, ExportChallengeParticipationFormConditionDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportChallengeParticipationFormConditionDataMutation, ExportChallengeParticipationFormConditionDataMutationVariables>(Operations.exportChallengeParticipationFormConditionData, options);
      }
export type ExportChallengeParticipationFormConditionDataMutationHookResult = ReturnType<typeof useExportChallengeParticipationFormConditionDataMutation>;
export type ExportChallengeParticipationFormConditionDataMutationResult = ApolloReactCommon.MutationResult<ExportChallengeParticipationFormConditionDataMutation>;
export type ExportChallengeParticipationFormConditionDataMutationOptions = ApolloReactCommon.BaseMutationOptions<ExportChallengeParticipationFormConditionDataMutation, ExportChallengeParticipationFormConditionDataMutationVariables>;
export type GetChallengeCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetChallengeCountQuery, GetChallengeCountQueryVariables>
    } & TChildProps;
export function withGetChallengeCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetChallengeCountQuery,
  GetChallengeCountQueryVariables,
  GetChallengeCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetChallengeCountQuery, GetChallengeCountQueryVariables, GetChallengeCountProps<TChildProps, TDataName>>(Operations.getChallengeCount, {
      alias: 'getChallengeCount',
      ...operationOptions
    });
};

/**
 * __useGetChallengeCountQuery__
 *
 * To run a query within a React component, call `useGetChallengeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetChallengeCountQuery(baseOptions?: Apollo.QueryHookOptions<GetChallengeCountQuery, GetChallengeCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeCountQuery, GetChallengeCountQueryVariables>(Operations.getChallengeCount, options);
      }
export function useGetChallengeCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeCountQuery, GetChallengeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeCountQuery, GetChallengeCountQueryVariables>(Operations.getChallengeCount, options);
        }
export type GetChallengeCountQueryHookResult = ReturnType<typeof useGetChallengeCountQuery>;
export type GetChallengeCountLazyQueryHookResult = ReturnType<typeof useGetChallengeCountLazyQuery>;
export type GetChallengeCountQueryResult = ApolloReactCommon.QueryResult<GetChallengeCountQuery, GetChallengeCountQueryVariables>;
export function refetchGetChallengeCountQuery(variables?: GetChallengeCountQueryVariables) {
      return { query: Operations.getChallengeCount, variables: variables }
    }
export type GetChallengeParticipantCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetChallengeParticipantCountQuery, GetChallengeParticipantCountQueryVariables>
    } & TChildProps;
export function withGetChallengeParticipantCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetChallengeParticipantCountQuery,
  GetChallengeParticipantCountQueryVariables,
  GetChallengeParticipantCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetChallengeParticipantCountQuery, GetChallengeParticipantCountQueryVariables, GetChallengeParticipantCountProps<TChildProps, TDataName>>(Operations.getChallengeParticipantCount, {
      alias: 'getChallengeParticipantCount',
      ...operationOptions
    });
};

/**
 * __useGetChallengeParticipantCountQuery__
 *
 * To run a query within a React component, call `useGetChallengeParticipantCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeParticipantCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeParticipantCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetChallengeParticipantCountQuery(baseOptions: Apollo.QueryHookOptions<GetChallengeParticipantCountQuery, GetChallengeParticipantCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeParticipantCountQuery, GetChallengeParticipantCountQueryVariables>(Operations.getChallengeParticipantCount, options);
      }
export function useGetChallengeParticipantCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeParticipantCountQuery, GetChallengeParticipantCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeParticipantCountQuery, GetChallengeParticipantCountQueryVariables>(Operations.getChallengeParticipantCount, options);
        }
export type GetChallengeParticipantCountQueryHookResult = ReturnType<typeof useGetChallengeParticipantCountQuery>;
export type GetChallengeParticipantCountLazyQueryHookResult = ReturnType<typeof useGetChallengeParticipantCountLazyQuery>;
export type GetChallengeParticipantCountQueryResult = ApolloReactCommon.QueryResult<GetChallengeParticipantCountQuery, GetChallengeParticipantCountQueryVariables>;
export function refetchGetChallengeParticipantCountQuery(variables: GetChallengeParticipantCountQueryVariables) {
      return { query: Operations.getChallengeParticipantCount, variables: variables }
    }
export type GetChallengeParticipantsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetChallengeParticipantsQuery, GetChallengeParticipantsQueryVariables>
    } & TChildProps;
export function withGetChallengeParticipants<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetChallengeParticipantsQuery,
  GetChallengeParticipantsQueryVariables,
  GetChallengeParticipantsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetChallengeParticipantsQuery, GetChallengeParticipantsQueryVariables, GetChallengeParticipantsProps<TChildProps, TDataName>>(Operations.getChallengeParticipants, {
      alias: 'getChallengeParticipants',
      ...operationOptions
    });
};

/**
 * __useGetChallengeParticipantsQuery__
 *
 * To run a query within a React component, call `useGetChallengeParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeParticipantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetChallengeParticipantsQuery(baseOptions: Apollo.QueryHookOptions<GetChallengeParticipantsQuery, GetChallengeParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeParticipantsQuery, GetChallengeParticipantsQueryVariables>(Operations.getChallengeParticipants, options);
      }
export function useGetChallengeParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeParticipantsQuery, GetChallengeParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeParticipantsQuery, GetChallengeParticipantsQueryVariables>(Operations.getChallengeParticipants, options);
        }
export type GetChallengeParticipantsQueryHookResult = ReturnType<typeof useGetChallengeParticipantsQuery>;
export type GetChallengeParticipantsLazyQueryHookResult = ReturnType<typeof useGetChallengeParticipantsLazyQuery>;
export type GetChallengeParticipantsQueryResult = ApolloReactCommon.QueryResult<GetChallengeParticipantsQuery, GetChallengeParticipantsQueryVariables>;
export function refetchGetChallengeParticipantsQuery(variables: GetChallengeParticipantsQueryVariables) {
      return { query: Operations.getChallengeParticipants, variables: variables }
    }
export type GetChallengeTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetChallengeTagsQuery, GetChallengeTagsQueryVariables>
    } & TChildProps;
export function withGetChallengeTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetChallengeTagsQuery,
  GetChallengeTagsQueryVariables,
  GetChallengeTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetChallengeTagsQuery, GetChallengeTagsQueryVariables, GetChallengeTagsProps<TChildProps, TDataName>>(Operations.getChallengeTags, {
      alias: 'getChallengeTags',
      ...operationOptions
    });
};

/**
 * __useGetChallengeTagsQuery__
 *
 * To run a query within a React component, call `useGetChallengeTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChallengeTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetChallengeTagsQuery, GetChallengeTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeTagsQuery, GetChallengeTagsQueryVariables>(Operations.getChallengeTags, options);
      }
export function useGetChallengeTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeTagsQuery, GetChallengeTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeTagsQuery, GetChallengeTagsQueryVariables>(Operations.getChallengeTags, options);
        }
export type GetChallengeTagsQueryHookResult = ReturnType<typeof useGetChallengeTagsQuery>;
export type GetChallengeTagsLazyQueryHookResult = ReturnType<typeof useGetChallengeTagsLazyQuery>;
export type GetChallengeTagsQueryResult = ApolloReactCommon.QueryResult<GetChallengeTagsQuery, GetChallengeTagsQueryVariables>;
export function refetchGetChallengeTagsQuery(variables?: GetChallengeTagsQueryVariables) {
      return { query: Operations.getChallengeTags, variables: variables }
    }
export type GetChallengeTeamCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetChallengeTeamCountQuery, GetChallengeTeamCountQueryVariables>
    } & TChildProps;
export function withGetChallengeTeamCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetChallengeTeamCountQuery,
  GetChallengeTeamCountQueryVariables,
  GetChallengeTeamCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetChallengeTeamCountQuery, GetChallengeTeamCountQueryVariables, GetChallengeTeamCountProps<TChildProps, TDataName>>(Operations.getChallengeTeamCount, {
      alias: 'getChallengeTeamCount',
      ...operationOptions
    });
};

/**
 * __useGetChallengeTeamCountQuery__
 *
 * To run a query within a React component, call `useGetChallengeTeamCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeTeamCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeTeamCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetChallengeTeamCountQuery(baseOptions?: Apollo.QueryHookOptions<GetChallengeTeamCountQuery, GetChallengeTeamCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeTeamCountQuery, GetChallengeTeamCountQueryVariables>(Operations.getChallengeTeamCount, options);
      }
export function useGetChallengeTeamCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeTeamCountQuery, GetChallengeTeamCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeTeamCountQuery, GetChallengeTeamCountQueryVariables>(Operations.getChallengeTeamCount, options);
        }
export type GetChallengeTeamCountQueryHookResult = ReturnType<typeof useGetChallengeTeamCountQuery>;
export type GetChallengeTeamCountLazyQueryHookResult = ReturnType<typeof useGetChallengeTeamCountLazyQuery>;
export type GetChallengeTeamCountQueryResult = ApolloReactCommon.QueryResult<GetChallengeTeamCountQuery, GetChallengeTeamCountQueryVariables>;
export function refetchGetChallengeTeamCountQuery(variables?: GetChallengeTeamCountQueryVariables) {
      return { query: Operations.getChallengeTeamCount, variables: variables }
    }
export type GetChallengeTeamsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetChallengeTeamsQuery, GetChallengeTeamsQueryVariables>
    } & TChildProps;
export function withGetChallengeTeams<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetChallengeTeamsQuery,
  GetChallengeTeamsQueryVariables,
  GetChallengeTeamsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetChallengeTeamsQuery, GetChallengeTeamsQueryVariables, GetChallengeTeamsProps<TChildProps, TDataName>>(Operations.getChallengeTeams, {
      alias: 'getChallengeTeams',
      ...operationOptions
    });
};

/**
 * __useGetChallengeTeamsQuery__
 *
 * To run a query within a React component, call `useGetChallengeTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeTeamsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetChallengeTeamsQuery(baseOptions?: Apollo.QueryHookOptions<GetChallengeTeamsQuery, GetChallengeTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeTeamsQuery, GetChallengeTeamsQueryVariables>(Operations.getChallengeTeams, options);
      }
export function useGetChallengeTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeTeamsQuery, GetChallengeTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeTeamsQuery, GetChallengeTeamsQueryVariables>(Operations.getChallengeTeams, options);
        }
export type GetChallengeTeamsQueryHookResult = ReturnType<typeof useGetChallengeTeamsQuery>;
export type GetChallengeTeamsLazyQueryHookResult = ReturnType<typeof useGetChallengeTeamsLazyQuery>;
export type GetChallengeTeamsQueryResult = ApolloReactCommon.QueryResult<GetChallengeTeamsQuery, GetChallengeTeamsQueryVariables>;
export function refetchGetChallengeTeamsQuery(variables?: GetChallengeTeamsQueryVariables) {
      return { query: Operations.getChallengeTeams, variables: variables }
    }
export type GetChallengeTitlesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetChallengeTitlesQuery, GetChallengeTitlesQueryVariables>
    } & TChildProps;
export function withGetChallengeTitles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetChallengeTitlesQuery,
  GetChallengeTitlesQueryVariables,
  GetChallengeTitlesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetChallengeTitlesQuery, GetChallengeTitlesQueryVariables, GetChallengeTitlesProps<TChildProps, TDataName>>(Operations.getChallengeTitles, {
      alias: 'getChallengeTitles',
      ...operationOptions
    });
};

/**
 * __useGetChallengeTitlesQuery__
 *
 * To run a query within a React component, call `useGetChallengeTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeTitlesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetChallengeTitlesQuery(baseOptions?: Apollo.QueryHookOptions<GetChallengeTitlesQuery, GetChallengeTitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeTitlesQuery, GetChallengeTitlesQueryVariables>(Operations.getChallengeTitles, options);
      }
export function useGetChallengeTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeTitlesQuery, GetChallengeTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeTitlesQuery, GetChallengeTitlesQueryVariables>(Operations.getChallengeTitles, options);
        }
export type GetChallengeTitlesQueryHookResult = ReturnType<typeof useGetChallengeTitlesQuery>;
export type GetChallengeTitlesLazyQueryHookResult = ReturnType<typeof useGetChallengeTitlesLazyQuery>;
export type GetChallengeTitlesQueryResult = ApolloReactCommon.QueryResult<GetChallengeTitlesQuery, GetChallengeTitlesQueryVariables>;
export function refetchGetChallengeTitlesQuery(variables?: GetChallengeTitlesQueryVariables) {
      return { query: Operations.getChallengeTitles, variables: variables }
    }
export type GetChallengesBasicProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetChallengesBasicQuery, GetChallengesBasicQueryVariables>
    } & TChildProps;
export function withGetChallengesBasic<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetChallengesBasicQuery,
  GetChallengesBasicQueryVariables,
  GetChallengesBasicProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetChallengesBasicQuery, GetChallengesBasicQueryVariables, GetChallengesBasicProps<TChildProps, TDataName>>(Operations.getChallengesBasic, {
      alias: 'getChallengesBasic',
      ...operationOptions
    });
};

/**
 * __useGetChallengesBasicQuery__
 *
 * To run a query within a React component, call `useGetChallengesBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengesBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengesBasicQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetChallengesBasicQuery(baseOptions?: Apollo.QueryHookOptions<GetChallengesBasicQuery, GetChallengesBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengesBasicQuery, GetChallengesBasicQueryVariables>(Operations.getChallengesBasic, options);
      }
export function useGetChallengesBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengesBasicQuery, GetChallengesBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengesBasicQuery, GetChallengesBasicQueryVariables>(Operations.getChallengesBasic, options);
        }
export type GetChallengesBasicQueryHookResult = ReturnType<typeof useGetChallengesBasicQuery>;
export type GetChallengesBasicLazyQueryHookResult = ReturnType<typeof useGetChallengesBasicLazyQuery>;
export type GetChallengesBasicQueryResult = ApolloReactCommon.QueryResult<GetChallengesBasicQuery, GetChallengesBasicQueryVariables>;
export function refetchGetChallengesBasicQuery(variables?: GetChallengesBasicQueryVariables) {
      return { query: Operations.getChallengesBasic, variables: variables }
    }
export type GetChallengesDetailProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetChallengesDetailQuery, GetChallengesDetailQueryVariables>
    } & TChildProps;
export function withGetChallengesDetail<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetChallengesDetailQuery,
  GetChallengesDetailQueryVariables,
  GetChallengesDetailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetChallengesDetailQuery, GetChallengesDetailQueryVariables, GetChallengesDetailProps<TChildProps, TDataName>>(Operations.getChallengesDetail, {
      alias: 'getChallengesDetail',
      ...operationOptions
    });
};

/**
 * __useGetChallengesDetailQuery__
 *
 * To run a query within a React component, call `useGetChallengesDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengesDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengesDetailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetChallengesDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetChallengesDetailQuery, GetChallengesDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengesDetailQuery, GetChallengesDetailQueryVariables>(Operations.getChallengesDetail, options);
      }
export function useGetChallengesDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengesDetailQuery, GetChallengesDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengesDetailQuery, GetChallengesDetailQueryVariables>(Operations.getChallengesDetail, options);
        }
export type GetChallengesDetailQueryHookResult = ReturnType<typeof useGetChallengesDetailQuery>;
export type GetChallengesDetailLazyQueryHookResult = ReturnType<typeof useGetChallengesDetailLazyQuery>;
export type GetChallengesDetailQueryResult = ApolloReactCommon.QueryResult<GetChallengesDetailQuery, GetChallengesDetailQueryVariables>;
export function refetchGetChallengesDetailQuery(variables?: GetChallengesDetailQueryVariables) {
      return { query: Operations.getChallengesDetail, variables: variables }
    }
export type RemoveChallengeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveChallengeMutation, RemoveChallengeMutationVariables>
    } & TChildProps;
export function withRemoveChallenge<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveChallengeMutation,
  RemoveChallengeMutationVariables,
  RemoveChallengeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveChallengeMutation, RemoveChallengeMutationVariables, RemoveChallengeProps<TChildProps, TDataName>>(Operations.removeChallenge, {
      alias: 'removeChallenge',
      ...operationOptions
    });
};

/**
 * __useRemoveChallengeMutation__
 *
 * To run a mutation, you first call `useRemoveChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChallengeMutation, { data, loading, error }] = useRemoveChallengeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveChallengeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChallengeMutation, RemoveChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChallengeMutation, RemoveChallengeMutationVariables>(Operations.removeChallenge, options);
      }
export type RemoveChallengeMutationHookResult = ReturnType<typeof useRemoveChallengeMutation>;
export type RemoveChallengeMutationResult = ApolloReactCommon.MutationResult<RemoveChallengeMutation>;
export type RemoveChallengeMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveChallengeMutation, RemoveChallengeMutationVariables>;
export type RemoveChallengeParticipationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveChallengeParticipationMutation, RemoveChallengeParticipationMutationVariables>
    } & TChildProps;
export function withRemoveChallengeParticipation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveChallengeParticipationMutation,
  RemoveChallengeParticipationMutationVariables,
  RemoveChallengeParticipationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveChallengeParticipationMutation, RemoveChallengeParticipationMutationVariables, RemoveChallengeParticipationProps<TChildProps, TDataName>>(Operations.removeChallengeParticipation, {
      alias: 'removeChallengeParticipation',
      ...operationOptions
    });
};

/**
 * __useRemoveChallengeParticipationMutation__
 *
 * To run a mutation, you first call `useRemoveChallengeParticipationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChallengeParticipationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChallengeParticipationMutation, { data, loading, error }] = useRemoveChallengeParticipationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useRemoveChallengeParticipationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChallengeParticipationMutation, RemoveChallengeParticipationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChallengeParticipationMutation, RemoveChallengeParticipationMutationVariables>(Operations.removeChallengeParticipation, options);
      }
export type RemoveChallengeParticipationMutationHookResult = ReturnType<typeof useRemoveChallengeParticipationMutation>;
export type RemoveChallengeParticipationMutationResult = ApolloReactCommon.MutationResult<RemoveChallengeParticipationMutation>;
export type RemoveChallengeParticipationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveChallengeParticipationMutation, RemoveChallengeParticipationMutationVariables>;
export type RemoveChallengeTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveChallengeTagMutation, RemoveChallengeTagMutationVariables>
    } & TChildProps;
export function withRemoveChallengeTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveChallengeTagMutation,
  RemoveChallengeTagMutationVariables,
  RemoveChallengeTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveChallengeTagMutation, RemoveChallengeTagMutationVariables, RemoveChallengeTagProps<TChildProps, TDataName>>(Operations.removeChallengeTag, {
      alias: 'removeChallengeTag',
      ...operationOptions
    });
};

/**
 * __useRemoveChallengeTagMutation__
 *
 * To run a mutation, you first call `useRemoveChallengeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChallengeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChallengeTagMutation, { data, loading, error }] = useRemoveChallengeTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveChallengeTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChallengeTagMutation, RemoveChallengeTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChallengeTagMutation, RemoveChallengeTagMutationVariables>(Operations.removeChallengeTag, options);
      }
export type RemoveChallengeTagMutationHookResult = ReturnType<typeof useRemoveChallengeTagMutation>;
export type RemoveChallengeTagMutationResult = ApolloReactCommon.MutationResult<RemoveChallengeTagMutation>;
export type RemoveChallengeTagMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveChallengeTagMutation, RemoveChallengeTagMutationVariables>;
export type RemoveChallengeTeamProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveChallengeTeamMutation, RemoveChallengeTeamMutationVariables>
    } & TChildProps;
export function withRemoveChallengeTeam<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveChallengeTeamMutation,
  RemoveChallengeTeamMutationVariables,
  RemoveChallengeTeamProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveChallengeTeamMutation, RemoveChallengeTeamMutationVariables, RemoveChallengeTeamProps<TChildProps, TDataName>>(Operations.removeChallengeTeam, {
      alias: 'removeChallengeTeam',
      ...operationOptions
    });
};

/**
 * __useRemoveChallengeTeamMutation__
 *
 * To run a mutation, you first call `useRemoveChallengeTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChallengeTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChallengeTeamMutation, { data, loading, error }] = useRemoveChallengeTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveChallengeTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChallengeTeamMutation, RemoveChallengeTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChallengeTeamMutation, RemoveChallengeTeamMutationVariables>(Operations.removeChallengeTeam, options);
      }
export type RemoveChallengeTeamMutationHookResult = ReturnType<typeof useRemoveChallengeTeamMutation>;
export type RemoveChallengeTeamMutationResult = ApolloReactCommon.MutationResult<RemoveChallengeTeamMutation>;
export type RemoveChallengeTeamMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveChallengeTeamMutation, RemoveChallengeTeamMutationVariables>;
export type RemoveFromChallengeTeamProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveFromChallengeTeamMutation, RemoveFromChallengeTeamMutationVariables>
    } & TChildProps;
export function withRemoveFromChallengeTeam<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveFromChallengeTeamMutation,
  RemoveFromChallengeTeamMutationVariables,
  RemoveFromChallengeTeamProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveFromChallengeTeamMutation, RemoveFromChallengeTeamMutationVariables, RemoveFromChallengeTeamProps<TChildProps, TDataName>>(Operations.removeFromChallengeTeam, {
      alias: 'removeFromChallengeTeam',
      ...operationOptions
    });
};

/**
 * __useRemoveFromChallengeTeamMutation__
 *
 * To run a mutation, you first call `useRemoveFromChallengeTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromChallengeTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromChallengeTeamMutation, { data, loading, error }] = useRemoveFromChallengeTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveFromChallengeTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFromChallengeTeamMutation, RemoveFromChallengeTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFromChallengeTeamMutation, RemoveFromChallengeTeamMutationVariables>(Operations.removeFromChallengeTeam, options);
      }
export type RemoveFromChallengeTeamMutationHookResult = ReturnType<typeof useRemoveFromChallengeTeamMutation>;
export type RemoveFromChallengeTeamMutationResult = ApolloReactCommon.MutationResult<RemoveFromChallengeTeamMutation>;
export type RemoveFromChallengeTeamMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveFromChallengeTeamMutation, RemoveFromChallengeTeamMutationVariables>;
export type ResyncChallengeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ResyncChallengeMutation, ResyncChallengeMutationVariables>
    } & TChildProps;
export function withResyncChallenge<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ResyncChallengeMutation,
  ResyncChallengeMutationVariables,
  ResyncChallengeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ResyncChallengeMutation, ResyncChallengeMutationVariables, ResyncChallengeProps<TChildProps, TDataName>>(Operations.resyncChallenge, {
      alias: 'resyncChallenge',
      ...operationOptions
    });
};

/**
 * __useResyncChallengeMutation__
 *
 * To run a mutation, you first call `useResyncChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResyncChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resyncChallengeMutation, { data, loading, error }] = useResyncChallengeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResyncChallengeMutation(baseOptions?: Apollo.MutationHookOptions<ResyncChallengeMutation, ResyncChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResyncChallengeMutation, ResyncChallengeMutationVariables>(Operations.resyncChallenge, options);
      }
export type ResyncChallengeMutationHookResult = ReturnType<typeof useResyncChallengeMutation>;
export type ResyncChallengeMutationResult = ApolloReactCommon.MutationResult<ResyncChallengeMutation>;
export type ResyncChallengeMutationOptions = ApolloReactCommon.BaseMutationOptions<ResyncChallengeMutation, ResyncChallengeMutationVariables>;
export type SendMilestoneEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SendMilestoneEmailMutation, SendMilestoneEmailMutationVariables>
    } & TChildProps;
export function withSendMilestoneEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SendMilestoneEmailMutation,
  SendMilestoneEmailMutationVariables,
  SendMilestoneEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SendMilestoneEmailMutation, SendMilestoneEmailMutationVariables, SendMilestoneEmailProps<TChildProps, TDataName>>(Operations.sendMilestoneEmail, {
      alias: 'sendMilestoneEmail',
      ...operationOptions
    });
};

/**
 * __useSendMilestoneEmailMutation__
 *
 * To run a mutation, you first call `useSendMilestoneEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMilestoneEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMilestoneEmailMutation, { data, loading, error }] = useSendMilestoneEmailMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      milestoneId: // value for 'milestoneId'
 *   },
 * });
 */
export function useSendMilestoneEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendMilestoneEmailMutation, SendMilestoneEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMilestoneEmailMutation, SendMilestoneEmailMutationVariables>(Operations.sendMilestoneEmail, options);
      }
export type SendMilestoneEmailMutationHookResult = ReturnType<typeof useSendMilestoneEmailMutation>;
export type SendMilestoneEmailMutationResult = ApolloReactCommon.MutationResult<SendMilestoneEmailMutation>;
export type SendMilestoneEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendMilestoneEmailMutation, SendMilestoneEmailMutationVariables>;
export type UpdateChallengeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateChallengeMutation, UpdateChallengeMutationVariables>
    } & TChildProps;
export function withUpdateChallenge<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateChallengeMutation,
  UpdateChallengeMutationVariables,
  UpdateChallengeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateChallengeMutation, UpdateChallengeMutationVariables, UpdateChallengeProps<TChildProps, TDataName>>(Operations.updateChallenge, {
      alias: 'updateChallenge',
      ...operationOptions
    });
};

/**
 * __useUpdateChallengeMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeMutation, { data, loading, error }] = useUpdateChallengeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      subtitle: // value for 'subtitle'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      rewards: // value for 'rewards'
 *      difficultyLevel: // value for 'difficultyLevel'
 *      duration: // value for 'duration'
 *      registration: // value for 'registration'
 *      activityTypes: // value for 'activityTypes'
 *      tieBreaker: // value for 'tieBreaker'
 *      conditionsInOrder: // value for 'conditionsInOrder'
 *      conditions: // value for 'conditions'
 *      ultimateSyncTime: // value for 'ultimateSyncTime'
 *      milestones: // value for 'milestones'
 *      featured: // value for 'featured'
 *      publishedOn: // value for 'publishedOn'
 *      expiresOn: // value for 'expiresOn'
 *      visualizeType: // value for 'visualizeType'
 *      roles: // value for 'roles'
 *      team: // value for 'team'
 *      endless: // value for 'endless'
 *      exceedConditionLimit: // value for 'exceedConditionLimit'
 *      hideInList: // value for 'hideInList'
 *      hideProgressInList: // value for 'hideProgressInList'
 *      hideProgressInDetails: // value for 'hideProgressInDetails'
 *      hideProgressInInsights: // value for 'hideProgressInInsights'
 *      priority: // value for 'priority'
 *      payment: // value for 'payment'
 *      totals: // value for 'totals'
 *      visualisations: // value for 'visualisations'
 *      tags: // value for 'tags'
 *      viewParticipants: // value for 'viewParticipants'
 *      viewParticipantCount: // value for 'viewParticipantCount'
 *      viewTeamCount: // value for 'viewTeamCount'
 *      viewCompletedParticipants: // value for 'viewCompletedParticipants'
 *      voucherConfiguration: // value for 'voucherConfiguration'
 *      enabledLocales: // value for 'enabledLocales'
 *      participationProfileRequirements: // value for 'participationProfileRequirements'
 *      data: // value for 'data'
 *      contentsIds: // value for 'contentsIds'
 *      superDates: // value for 'superDates'
 *      autoParticipationEnabled: // value for 'autoParticipationEnabled'
 *      disableComments: // value for 'disableComments'
 *      withAdvancedMode: // value for 'withAdvancedMode'
 *      activityMultipliers: // value for 'activityMultipliers'
 *   },
 * });
 */
export function useUpdateChallengeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeMutation, UpdateChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeMutation, UpdateChallengeMutationVariables>(Operations.updateChallenge, options);
      }
export type UpdateChallengeMutationHookResult = ReturnType<typeof useUpdateChallengeMutation>;
export type UpdateChallengeMutationResult = ApolloReactCommon.MutationResult<UpdateChallengeMutation>;
export type UpdateChallengeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChallengeMutation, UpdateChallengeMutationVariables>;
export type UpdateChallengeTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateChallengeTagMutation, UpdateChallengeTagMutationVariables>
    } & TChildProps;
export function withUpdateChallengeTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateChallengeTagMutation,
  UpdateChallengeTagMutationVariables,
  UpdateChallengeTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateChallengeTagMutation, UpdateChallengeTagMutationVariables, UpdateChallengeTagProps<TChildProps, TDataName>>(Operations.updateChallengeTag, {
      alias: 'updateChallengeTag',
      ...operationOptions
    });
};

/**
 * __useUpdateChallengeTagMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeTagMutation, { data, loading, error }] = useUpdateChallengeTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useUpdateChallengeTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeTagMutation, UpdateChallengeTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeTagMutation, UpdateChallengeTagMutationVariables>(Operations.updateChallengeTag, options);
      }
export type UpdateChallengeTagMutationHookResult = ReturnType<typeof useUpdateChallengeTagMutation>;
export type UpdateChallengeTagMutationResult = ApolloReactCommon.MutationResult<UpdateChallengeTagMutation>;
export type UpdateChallengeTagMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChallengeTagMutation, UpdateChallengeTagMutationVariables>;
export type UpdateChallengeTeamProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateChallengeTeamMutation, UpdateChallengeTeamMutationVariables>
    } & TChildProps;
export function withUpdateChallengeTeam<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateChallengeTeamMutation,
  UpdateChallengeTeamMutationVariables,
  UpdateChallengeTeamProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateChallengeTeamMutation, UpdateChallengeTeamMutationVariables, UpdateChallengeTeamProps<TChildProps, TDataName>>(Operations.updateChallengeTeam, {
      alias: 'updateChallengeTeam',
      ...operationOptions
    });
};

/**
 * __useUpdateChallengeTeamMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeTeamMutation, { data, loading, error }] = useUpdateChallengeTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      profileValue: // value for 'profileValue'
 *      captainUserId: // value for 'captainUserId'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useUpdateChallengeTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeTeamMutation, UpdateChallengeTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeTeamMutation, UpdateChallengeTeamMutationVariables>(Operations.updateChallengeTeam, options);
      }
export type UpdateChallengeTeamMutationHookResult = ReturnType<typeof useUpdateChallengeTeamMutation>;
export type UpdateChallengeTeamMutationResult = ApolloReactCommon.MutationResult<UpdateChallengeTeamMutation>;
export type UpdateChallengeTeamMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChallengeTeamMutation, UpdateChallengeTeamMutationVariables>;
export type UpdateChallengeTeamCaptainProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateChallengeTeamCaptainMutation, UpdateChallengeTeamCaptainMutationVariables>
    } & TChildProps;
export function withUpdateChallengeTeamCaptain<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateChallengeTeamCaptainMutation,
  UpdateChallengeTeamCaptainMutationVariables,
  UpdateChallengeTeamCaptainProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateChallengeTeamCaptainMutation, UpdateChallengeTeamCaptainMutationVariables, UpdateChallengeTeamCaptainProps<TChildProps, TDataName>>(Operations.updateChallengeTeamCaptain, {
      alias: 'updateChallengeTeamCaptain',
      ...operationOptions
    });
};

/**
 * __useUpdateChallengeTeamCaptainMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeTeamCaptainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeTeamCaptainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeTeamCaptainMutation, { data, loading, error }] = useUpdateChallengeTeamCaptainMutation({
 *   variables: {
 *      id: // value for 'id'
 *      captainUserId: // value for 'captainUserId'
 *   },
 * });
 */
export function useUpdateChallengeTeamCaptainMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeTeamCaptainMutation, UpdateChallengeTeamCaptainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeTeamCaptainMutation, UpdateChallengeTeamCaptainMutationVariables>(Operations.updateChallengeTeamCaptain, options);
      }
export type UpdateChallengeTeamCaptainMutationHookResult = ReturnType<typeof useUpdateChallengeTeamCaptainMutation>;
export type UpdateChallengeTeamCaptainMutationResult = ApolloReactCommon.MutationResult<UpdateChallengeTeamCaptainMutation>;
export type UpdateChallengeTeamCaptainMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChallengeTeamCaptainMutation, UpdateChallengeTeamCaptainMutationVariables>;
export type AddCheckupLocationAvailabilityProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddCheckupLocationAvailabilityMutation, AddCheckupLocationAvailabilityMutationVariables>
    } & TChildProps;
export function withAddCheckupLocationAvailability<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddCheckupLocationAvailabilityMutation,
  AddCheckupLocationAvailabilityMutationVariables,
  AddCheckupLocationAvailabilityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddCheckupLocationAvailabilityMutation, AddCheckupLocationAvailabilityMutationVariables, AddCheckupLocationAvailabilityProps<TChildProps, TDataName>>(Operations.addCheckupLocationAvailability, {
      alias: 'addCheckupLocationAvailability',
      ...operationOptions
    });
};

/**
 * __useAddCheckupLocationAvailabilityMutation__
 *
 * To run a mutation, you first call `useAddCheckupLocationAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCheckupLocationAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCheckupLocationAvailabilityMutation, { data, loading, error }] = useAddCheckupLocationAvailabilityMutation({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      coachId: // value for 'coachId'
 *      checkupLocationId: // value for 'checkupLocationId'
 *      cost: // value for 'cost'
 *      coachType: // value for 'coachType'
 *   },
 * });
 */
export function useAddCheckupLocationAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<AddCheckupLocationAvailabilityMutation, AddCheckupLocationAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCheckupLocationAvailabilityMutation, AddCheckupLocationAvailabilityMutationVariables>(Operations.addCheckupLocationAvailability, options);
      }
export type AddCheckupLocationAvailabilityMutationHookResult = ReturnType<typeof useAddCheckupLocationAvailabilityMutation>;
export type AddCheckupLocationAvailabilityMutationResult = ApolloReactCommon.MutationResult<AddCheckupLocationAvailabilityMutation>;
export type AddCheckupLocationAvailabilityMutationOptions = ApolloReactCommon.BaseMutationOptions<AddCheckupLocationAvailabilityMutation, AddCheckupLocationAvailabilityMutationVariables>;
export type GetCheckupLocationAvailabilitiesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCheckupLocationAvailabilitiesQuery, GetCheckupLocationAvailabilitiesQueryVariables>
    } & TChildProps;
export function withGetCheckupLocationAvailabilities<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCheckupLocationAvailabilitiesQuery,
  GetCheckupLocationAvailabilitiesQueryVariables,
  GetCheckupLocationAvailabilitiesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCheckupLocationAvailabilitiesQuery, GetCheckupLocationAvailabilitiesQueryVariables, GetCheckupLocationAvailabilitiesProps<TChildProps, TDataName>>(Operations.getCheckupLocationAvailabilities, {
      alias: 'getCheckupLocationAvailabilities',
      ...operationOptions
    });
};

/**
 * __useGetCheckupLocationAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useGetCheckupLocationAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckupLocationAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckupLocationAvailabilitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCheckupLocationAvailabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetCheckupLocationAvailabilitiesQuery, GetCheckupLocationAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckupLocationAvailabilitiesQuery, GetCheckupLocationAvailabilitiesQueryVariables>(Operations.getCheckupLocationAvailabilities, options);
      }
export function useGetCheckupLocationAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckupLocationAvailabilitiesQuery, GetCheckupLocationAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckupLocationAvailabilitiesQuery, GetCheckupLocationAvailabilitiesQueryVariables>(Operations.getCheckupLocationAvailabilities, options);
        }
export type GetCheckupLocationAvailabilitiesQueryHookResult = ReturnType<typeof useGetCheckupLocationAvailabilitiesQuery>;
export type GetCheckupLocationAvailabilitiesLazyQueryHookResult = ReturnType<typeof useGetCheckupLocationAvailabilitiesLazyQuery>;
export type GetCheckupLocationAvailabilitiesQueryResult = ApolloReactCommon.QueryResult<GetCheckupLocationAvailabilitiesQuery, GetCheckupLocationAvailabilitiesQueryVariables>;
export function refetchGetCheckupLocationAvailabilitiesQuery(variables?: GetCheckupLocationAvailabilitiesQueryVariables) {
      return { query: Operations.getCheckupLocationAvailabilities, variables: variables }
    }
export type GetCheckupLocationAvailabilityCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCheckupLocationAvailabilityCountQuery, GetCheckupLocationAvailabilityCountQueryVariables>
    } & TChildProps;
export function withGetCheckupLocationAvailabilityCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCheckupLocationAvailabilityCountQuery,
  GetCheckupLocationAvailabilityCountQueryVariables,
  GetCheckupLocationAvailabilityCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCheckupLocationAvailabilityCountQuery, GetCheckupLocationAvailabilityCountQueryVariables, GetCheckupLocationAvailabilityCountProps<TChildProps, TDataName>>(Operations.getCheckupLocationAvailabilityCount, {
      alias: 'getCheckupLocationAvailabilityCount',
      ...operationOptions
    });
};

/**
 * __useGetCheckupLocationAvailabilityCountQuery__
 *
 * To run a query within a React component, call `useGetCheckupLocationAvailabilityCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckupLocationAvailabilityCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckupLocationAvailabilityCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCheckupLocationAvailabilityCountQuery(baseOptions?: Apollo.QueryHookOptions<GetCheckupLocationAvailabilityCountQuery, GetCheckupLocationAvailabilityCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckupLocationAvailabilityCountQuery, GetCheckupLocationAvailabilityCountQueryVariables>(Operations.getCheckupLocationAvailabilityCount, options);
      }
export function useGetCheckupLocationAvailabilityCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckupLocationAvailabilityCountQuery, GetCheckupLocationAvailabilityCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckupLocationAvailabilityCountQuery, GetCheckupLocationAvailabilityCountQueryVariables>(Operations.getCheckupLocationAvailabilityCount, options);
        }
export type GetCheckupLocationAvailabilityCountQueryHookResult = ReturnType<typeof useGetCheckupLocationAvailabilityCountQuery>;
export type GetCheckupLocationAvailabilityCountLazyQueryHookResult = ReturnType<typeof useGetCheckupLocationAvailabilityCountLazyQuery>;
export type GetCheckupLocationAvailabilityCountQueryResult = ApolloReactCommon.QueryResult<GetCheckupLocationAvailabilityCountQuery, GetCheckupLocationAvailabilityCountQueryVariables>;
export function refetchGetCheckupLocationAvailabilityCountQuery(variables?: GetCheckupLocationAvailabilityCountQueryVariables) {
      return { query: Operations.getCheckupLocationAvailabilityCount, variables: variables }
    }
export type GetCheckupLocationCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCheckupLocationCountQuery, GetCheckupLocationCountQueryVariables>
    } & TChildProps;
export function withGetCheckupLocationCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCheckupLocationCountQuery,
  GetCheckupLocationCountQueryVariables,
  GetCheckupLocationCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCheckupLocationCountQuery, GetCheckupLocationCountQueryVariables, GetCheckupLocationCountProps<TChildProps, TDataName>>(Operations.getCheckupLocationCount, {
      alias: 'getCheckupLocationCount',
      ...operationOptions
    });
};

/**
 * __useGetCheckupLocationCountQuery__
 *
 * To run a query within a React component, call `useGetCheckupLocationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckupLocationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckupLocationCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCheckupLocationCountQuery(baseOptions?: Apollo.QueryHookOptions<GetCheckupLocationCountQuery, GetCheckupLocationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckupLocationCountQuery, GetCheckupLocationCountQueryVariables>(Operations.getCheckupLocationCount, options);
      }
export function useGetCheckupLocationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckupLocationCountQuery, GetCheckupLocationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckupLocationCountQuery, GetCheckupLocationCountQueryVariables>(Operations.getCheckupLocationCount, options);
        }
export type GetCheckupLocationCountQueryHookResult = ReturnType<typeof useGetCheckupLocationCountQuery>;
export type GetCheckupLocationCountLazyQueryHookResult = ReturnType<typeof useGetCheckupLocationCountLazyQuery>;
export type GetCheckupLocationCountQueryResult = ApolloReactCommon.QueryResult<GetCheckupLocationCountQuery, GetCheckupLocationCountQueryVariables>;
export function refetchGetCheckupLocationCountQuery(variables?: GetCheckupLocationCountQueryVariables) {
      return { query: Operations.getCheckupLocationCount, variables: variables }
    }
export type GetCheckupLocationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCheckupLocationsQuery, GetCheckupLocationsQueryVariables>
    } & TChildProps;
export function withGetCheckupLocations<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCheckupLocationsQuery,
  GetCheckupLocationsQueryVariables,
  GetCheckupLocationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCheckupLocationsQuery, GetCheckupLocationsQueryVariables, GetCheckupLocationsProps<TChildProps, TDataName>>(Operations.getCheckupLocations, {
      alias: 'getCheckupLocations',
      ...operationOptions
    });
};

/**
 * __useGetCheckupLocationsQuery__
 *
 * To run a query within a React component, call `useGetCheckupLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckupLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckupLocationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCheckupLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetCheckupLocationsQuery, GetCheckupLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckupLocationsQuery, GetCheckupLocationsQueryVariables>(Operations.getCheckupLocations, options);
      }
export function useGetCheckupLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckupLocationsQuery, GetCheckupLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckupLocationsQuery, GetCheckupLocationsQueryVariables>(Operations.getCheckupLocations, options);
        }
export type GetCheckupLocationsQueryHookResult = ReturnType<typeof useGetCheckupLocationsQuery>;
export type GetCheckupLocationsLazyQueryHookResult = ReturnType<typeof useGetCheckupLocationsLazyQuery>;
export type GetCheckupLocationsQueryResult = ApolloReactCommon.QueryResult<GetCheckupLocationsQuery, GetCheckupLocationsQueryVariables>;
export function refetchGetCheckupLocationsQuery(variables?: GetCheckupLocationsQueryVariables) {
      return { query: Operations.getCheckupLocations, variables: variables }
    }
export type GetCheckupParticipationCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCheckupParticipationCountQuery, GetCheckupParticipationCountQueryVariables>
    } & TChildProps;
export function withGetCheckupParticipationCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCheckupParticipationCountQuery,
  GetCheckupParticipationCountQueryVariables,
  GetCheckupParticipationCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCheckupParticipationCountQuery, GetCheckupParticipationCountQueryVariables, GetCheckupParticipationCountProps<TChildProps, TDataName>>(Operations.getCheckupParticipationCount, {
      alias: 'getCheckupParticipationCount',
      ...operationOptions
    });
};

/**
 * __useGetCheckupParticipationCountQuery__
 *
 * To run a query within a React component, call `useGetCheckupParticipationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckupParticipationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckupParticipationCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCheckupParticipationCountQuery(baseOptions?: Apollo.QueryHookOptions<GetCheckupParticipationCountQuery, GetCheckupParticipationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckupParticipationCountQuery, GetCheckupParticipationCountQueryVariables>(Operations.getCheckupParticipationCount, options);
      }
export function useGetCheckupParticipationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckupParticipationCountQuery, GetCheckupParticipationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckupParticipationCountQuery, GetCheckupParticipationCountQueryVariables>(Operations.getCheckupParticipationCount, options);
        }
export type GetCheckupParticipationCountQueryHookResult = ReturnType<typeof useGetCheckupParticipationCountQuery>;
export type GetCheckupParticipationCountLazyQueryHookResult = ReturnType<typeof useGetCheckupParticipationCountLazyQuery>;
export type GetCheckupParticipationCountQueryResult = ApolloReactCommon.QueryResult<GetCheckupParticipationCountQuery, GetCheckupParticipationCountQueryVariables>;
export function refetchGetCheckupParticipationCountQuery(variables?: GetCheckupParticipationCountQueryVariables) {
      return { query: Operations.getCheckupParticipationCount, variables: variables }
    }
export type GetCheckupParticipationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCheckupParticipationsQuery, GetCheckupParticipationsQueryVariables>
    } & TChildProps;
export function withGetCheckupParticipations<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCheckupParticipationsQuery,
  GetCheckupParticipationsQueryVariables,
  GetCheckupParticipationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCheckupParticipationsQuery, GetCheckupParticipationsQueryVariables, GetCheckupParticipationsProps<TChildProps, TDataName>>(Operations.getCheckupParticipations, {
      alias: 'getCheckupParticipations',
      ...operationOptions
    });
};

/**
 * __useGetCheckupParticipationsQuery__
 *
 * To run a query within a React component, call `useGetCheckupParticipationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckupParticipationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckupParticipationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCheckupParticipationsQuery(baseOptions?: Apollo.QueryHookOptions<GetCheckupParticipationsQuery, GetCheckupParticipationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckupParticipationsQuery, GetCheckupParticipationsQueryVariables>(Operations.getCheckupParticipations, options);
      }
export function useGetCheckupParticipationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckupParticipationsQuery, GetCheckupParticipationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckupParticipationsQuery, GetCheckupParticipationsQueryVariables>(Operations.getCheckupParticipations, options);
        }
export type GetCheckupParticipationsQueryHookResult = ReturnType<typeof useGetCheckupParticipationsQuery>;
export type GetCheckupParticipationsLazyQueryHookResult = ReturnType<typeof useGetCheckupParticipationsLazyQuery>;
export type GetCheckupParticipationsQueryResult = ApolloReactCommon.QueryResult<GetCheckupParticipationsQuery, GetCheckupParticipationsQueryVariables>;
export function refetchGetCheckupParticipationsQuery(variables?: GetCheckupParticipationsQueryVariables) {
      return { query: Operations.getCheckupParticipations, variables: variables }
    }
export type RemoveCheckupLocationAvailabilityProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveCheckupLocationAvailabilityMutation, RemoveCheckupLocationAvailabilityMutationVariables>
    } & TChildProps;
export function withRemoveCheckupLocationAvailability<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveCheckupLocationAvailabilityMutation,
  RemoveCheckupLocationAvailabilityMutationVariables,
  RemoveCheckupLocationAvailabilityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveCheckupLocationAvailabilityMutation, RemoveCheckupLocationAvailabilityMutationVariables, RemoveCheckupLocationAvailabilityProps<TChildProps, TDataName>>(Operations.removeCheckupLocationAvailability, {
      alias: 'removeCheckupLocationAvailability',
      ...operationOptions
    });
};

/**
 * __useRemoveCheckupLocationAvailabilityMutation__
 *
 * To run a mutation, you first call `useRemoveCheckupLocationAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCheckupLocationAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCheckupLocationAvailabilityMutation, { data, loading, error }] = useRemoveCheckupLocationAvailabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCheckupLocationAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCheckupLocationAvailabilityMutation, RemoveCheckupLocationAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCheckupLocationAvailabilityMutation, RemoveCheckupLocationAvailabilityMutationVariables>(Operations.removeCheckupLocationAvailability, options);
      }
export type RemoveCheckupLocationAvailabilityMutationHookResult = ReturnType<typeof useRemoveCheckupLocationAvailabilityMutation>;
export type RemoveCheckupLocationAvailabilityMutationResult = ApolloReactCommon.MutationResult<RemoveCheckupLocationAvailabilityMutation>;
export type RemoveCheckupLocationAvailabilityMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveCheckupLocationAvailabilityMutation, RemoveCheckupLocationAvailabilityMutationVariables>;
export type UpdateCheckupLocationAvailabilityProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateCheckupLocationAvailabilityMutation, UpdateCheckupLocationAvailabilityMutationVariables>
    } & TChildProps;
export function withUpdateCheckupLocationAvailability<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCheckupLocationAvailabilityMutation,
  UpdateCheckupLocationAvailabilityMutationVariables,
  UpdateCheckupLocationAvailabilityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCheckupLocationAvailabilityMutation, UpdateCheckupLocationAvailabilityMutationVariables, UpdateCheckupLocationAvailabilityProps<TChildProps, TDataName>>(Operations.updateCheckupLocationAvailability, {
      alias: 'updateCheckupLocationAvailability',
      ...operationOptions
    });
};

/**
 * __useUpdateCheckupLocationAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateCheckupLocationAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckupLocationAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckupLocationAvailabilityMutation, { data, loading, error }] = useUpdateCheckupLocationAvailabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      coachId: // value for 'coachId'
 *      checkupLocationId: // value for 'checkupLocationId'
 *      cost: // value for 'cost'
 *      coachType: // value for 'coachType'
 *   },
 * });
 */
export function useUpdateCheckupLocationAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckupLocationAvailabilityMutation, UpdateCheckupLocationAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckupLocationAvailabilityMutation, UpdateCheckupLocationAvailabilityMutationVariables>(Operations.updateCheckupLocationAvailability, options);
      }
export type UpdateCheckupLocationAvailabilityMutationHookResult = ReturnType<typeof useUpdateCheckupLocationAvailabilityMutation>;
export type UpdateCheckupLocationAvailabilityMutationResult = ApolloReactCommon.MutationResult<UpdateCheckupLocationAvailabilityMutation>;
export type UpdateCheckupLocationAvailabilityMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCheckupLocationAvailabilityMutation, UpdateCheckupLocationAvailabilityMutationVariables>;
export type GetCommentCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCommentCountQuery, GetCommentCountQueryVariables>
    } & TChildProps;
export function withGetCommentCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCommentCountQuery,
  GetCommentCountQueryVariables,
  GetCommentCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCommentCountQuery, GetCommentCountQueryVariables, GetCommentCountProps<TChildProps, TDataName>>(Operations.getCommentCount, {
      alias: 'getCommentCount',
      ...operationOptions
    });
};

/**
 * __useGetCommentCountQuery__
 *
 * To run a query within a React component, call `useGetCommentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCommentCountQuery(baseOptions?: Apollo.QueryHookOptions<GetCommentCountQuery, GetCommentCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentCountQuery, GetCommentCountQueryVariables>(Operations.getCommentCount, options);
      }
export function useGetCommentCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentCountQuery, GetCommentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentCountQuery, GetCommentCountQueryVariables>(Operations.getCommentCount, options);
        }
export type GetCommentCountQueryHookResult = ReturnType<typeof useGetCommentCountQuery>;
export type GetCommentCountLazyQueryHookResult = ReturnType<typeof useGetCommentCountLazyQuery>;
export type GetCommentCountQueryResult = ApolloReactCommon.QueryResult<GetCommentCountQuery, GetCommentCountQueryVariables>;
export function refetchGetCommentCountQuery(variables?: GetCommentCountQueryVariables) {
      return { query: Operations.getCommentCount, variables: variables }
    }
export type GetCommentsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCommentsQuery, GetCommentsQueryVariables>
    } & TChildProps;
export function withGetComments<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCommentsQuery,
  GetCommentsQueryVariables,
  GetCommentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCommentsQuery, GetCommentsQueryVariables, GetCommentsProps<TChildProps, TDataName>>(Operations.getComments, {
      alias: 'getComments',
      ...operationOptions
    });
};

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions?: Apollo.QueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsQuery, GetCommentsQueryVariables>(Operations.getComments, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsQuery, GetCommentsQueryVariables>(Operations.getComments, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsQueryResult = ApolloReactCommon.QueryResult<GetCommentsQuery, GetCommentsQueryVariables>;
export function refetchGetCommentsQuery(variables?: GetCommentsQueryVariables) {
      return { query: Operations.getComments, variables: variables }
    }
export type RemoveCommentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveCommentMutation, RemoveCommentMutationVariables>
    } & TChildProps;
export function withRemoveComment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveCommentMutation,
  RemoveCommentMutationVariables,
  RemoveCommentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveCommentMutation, RemoveCommentMutationVariables, RemoveCommentProps<TChildProps, TDataName>>(Operations.removeComment, {
      alias: 'removeComment',
      ...operationOptions
    });
};

/**
 * __useRemoveCommentMutation__
 *
 * To run a mutation, you first call `useRemoveCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommentMutation, { data, loading, error }] = useRemoveCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveCommentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCommentMutation, RemoveCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCommentMutation, RemoveCommentMutationVariables>(Operations.removeComment, options);
      }
export type RemoveCommentMutationHookResult = ReturnType<typeof useRemoveCommentMutation>;
export type RemoveCommentMutationResult = ApolloReactCommon.MutationResult<RemoveCommentMutation>;
export type RemoveCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveCommentMutation, RemoveCommentMutationVariables>;
export type UpdateCommentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>
    } & TChildProps;
export function withUpdateComment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCommentMutation,
  UpdateCommentMutationVariables,
  UpdateCommentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCommentMutation, UpdateCommentMutationVariables, UpdateCommentProps<TChildProps, TDataName>>(Operations.updateComment, {
      alias: 'updateComment',
      ...operationOptions
    });
};

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reported: // value for 'reported'
 *      moderated: // value for 'moderated'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(Operations.updateComment, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = ApolloReactCommon.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export type AddCompanyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddCompanyMutation, AddCompanyMutationVariables>
    } & TChildProps;
export function withAddCompany<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddCompanyMutation,
  AddCompanyMutationVariables,
  AddCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddCompanyMutation, AddCompanyMutationVariables, AddCompanyProps<TChildProps, TDataName>>(Operations.addCompany, {
      alias: 'addCompany',
      ...operationOptions
    });
};

/**
 * __useAddCompanyMutation__
 *
 * To run a mutation, you first call `useAddCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyMutation, { data, loading, error }] = useAddCompanyMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      code: // value for 'code'
 *      role: // value for 'role'
 *      limitRegistrations: // value for 'limitRegistrations'
 *      maxRegistrations: // value for 'maxRegistrations'
 *      hasSupport: // value for 'hasSupport'
 *      coach: // value for 'coach'
 *      brandColor: // value for 'brandColor'
 *      connect: // value for 'connect'
 *      team: // value for 'team'
 *      languages: // value for 'languages'
 *      introMessage: // value for 'introMessage'
 *      introTitle: // value for 'introTitle'
 *      logo: // value for 'logo'
 *      profileRequirements: // value for 'profileRequirements'
 *   },
 * });
 */
export function useAddCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyMutation, AddCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyMutation, AddCompanyMutationVariables>(Operations.addCompany, options);
      }
export type AddCompanyMutationHookResult = ReturnType<typeof useAddCompanyMutation>;
export type AddCompanyMutationResult = ApolloReactCommon.MutationResult<AddCompanyMutation>;
export type AddCompanyMutationOptions = ApolloReactCommon.BaseMutationOptions<AddCompanyMutation, AddCompanyMutationVariables>;
export type GetCompaniesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCompaniesQuery, GetCompaniesQueryVariables>
    } & TChildProps;
export function withGetCompanies<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCompaniesQuery,
  GetCompaniesQueryVariables,
  GetCompaniesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCompaniesQuery, GetCompaniesQueryVariables, GetCompaniesProps<TChildProps, TDataName>>(Operations.getCompanies, {
      alias: 'getCompanies',
      ...operationOptions
    });
};

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(Operations.getCompanies, options);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(Operations.getCompanies, options);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesQueryResult = ApolloReactCommon.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export function refetchGetCompaniesQuery(variables?: GetCompaniesQueryVariables) {
      return { query: Operations.getCompanies, variables: variables }
    }
export type RemoveCompanyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveCompanyMutation, RemoveCompanyMutationVariables>
    } & TChildProps;
export function withRemoveCompany<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveCompanyMutation,
  RemoveCompanyMutationVariables,
  RemoveCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveCompanyMutation, RemoveCompanyMutationVariables, RemoveCompanyProps<TChildProps, TDataName>>(Operations.removeCompany, {
      alias: 'removeCompany',
      ...operationOptions
    });
};

/**
 * __useRemoveCompanyMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyMutation, { data, loading, error }] = useRemoveCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCompanyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyMutation, RemoveCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyMutation, RemoveCompanyMutationVariables>(Operations.removeCompany, options);
      }
export type RemoveCompanyMutationHookResult = ReturnType<typeof useRemoveCompanyMutation>;
export type RemoveCompanyMutationResult = ApolloReactCommon.MutationResult<RemoveCompanyMutation>;
export type RemoveCompanyMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveCompanyMutation, RemoveCompanyMutationVariables>;
export type UpdateCompanyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>
    } & TChildProps;
export function withUpdateCompany<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCompanyMutation,
  UpdateCompanyMutationVariables,
  UpdateCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCompanyMutation, UpdateCompanyMutationVariables, UpdateCompanyProps<TChildProps, TDataName>>(Operations.updateCompany, {
      alias: 'updateCompany',
      ...operationOptions
    });
};

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      code: // value for 'code'
 *      role: // value for 'role'
 *      limitRegistrations: // value for 'limitRegistrations'
 *      maxRegistrations: // value for 'maxRegistrations'
 *      hasSupport: // value for 'hasSupport'
 *      coach: // value for 'coach'
 *      brandColor: // value for 'brandColor'
 *      connect: // value for 'connect'
 *      team: // value for 'team'
 *      languages: // value for 'languages'
 *      introMessage: // value for 'introMessage'
 *      introTitle: // value for 'introTitle'
 *      logo: // value for 'logo'
 *      profileRequirements: // value for 'profileRequirements'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(Operations.updateCompany, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = ApolloReactCommon.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export type ConsumeConfirmCodeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ConsumeConfirmCodeMutation, ConsumeConfirmCodeMutationVariables>
    } & TChildProps;
export function withConsumeConfirmCode<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ConsumeConfirmCodeMutation,
  ConsumeConfirmCodeMutationVariables,
  ConsumeConfirmCodeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ConsumeConfirmCodeMutation, ConsumeConfirmCodeMutationVariables, ConsumeConfirmCodeProps<TChildProps, TDataName>>(Operations.consumeConfirmCode, {
      alias: 'consumeConfirmCode',
      ...operationOptions
    });
};

/**
 * __useConsumeConfirmCodeMutation__
 *
 * To run a mutation, you first call `useConsumeConfirmCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumeConfirmCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumeConfirmCodeMutation, { data, loading, error }] = useConsumeConfirmCodeMutation({
 *   variables: {
 *      confirmCodeChallengeId: // value for 'confirmCodeChallengeId'
 *      confirmCode: // value for 'confirmCode'
 *   },
 * });
 */
export function useConsumeConfirmCodeMutation(baseOptions?: Apollo.MutationHookOptions<ConsumeConfirmCodeMutation, ConsumeConfirmCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumeConfirmCodeMutation, ConsumeConfirmCodeMutationVariables>(Operations.consumeConfirmCode, options);
      }
export type ConsumeConfirmCodeMutationHookResult = ReturnType<typeof useConsumeConfirmCodeMutation>;
export type ConsumeConfirmCodeMutationResult = ApolloReactCommon.MutationResult<ConsumeConfirmCodeMutation>;
export type ConsumeConfirmCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<ConsumeConfirmCodeMutation, ConsumeConfirmCodeMutationVariables>;
export type AddContentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddContentMutation, AddContentMutationVariables>
    } & TChildProps;
export function withAddContent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddContentMutation,
  AddContentMutationVariables,
  AddContentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddContentMutation, AddContentMutationVariables, AddContentProps<TChildProps, TDataName>>(Operations.addContent, {
      alias: 'addContent',
      ...operationOptions
    });
};

/**
 * __useAddContentMutation__
 *
 * To run a mutation, you first call `useAddContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContentMutation, { data, loading, error }] = useAddContentMutation({
 *   variables: {
 *      type: // value for 'type'
 *      isPublic: // value for 'isPublic'
 *      publishOn: // value for 'publishOn'
 *      expiresOn: // value for 'expiresOn'
 *      isDraft: // value for 'isDraft'
 *      title: // value for 'title'
 *      content: // value for 'content'
 *      preview: // value for 'preview'
 *      imageUrl: // value for 'imageUrl'
 *      url: // value for 'url'
 *      roles: // value for 'roles'
 *      tags: // value for 'tags'
 *      attachments: // value for 'attachments'
 *      featured: // value for 'featured'
 *      userId: // value for 'userId'
 *      enabledLocales: // value for 'enabledLocales'
 *      disableComments: // value for 'disableComments'
 *      isAdvancedMode: // value for 'isAdvancedMode'
 *   },
 * });
 */
export function useAddContentMutation(baseOptions?: Apollo.MutationHookOptions<AddContentMutation, AddContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContentMutation, AddContentMutationVariables>(Operations.addContent, options);
      }
export type AddContentMutationHookResult = ReturnType<typeof useAddContentMutation>;
export type AddContentMutationResult = ApolloReactCommon.MutationResult<AddContentMutation>;
export type AddContentMutationOptions = ApolloReactCommon.BaseMutationOptions<AddContentMutation, AddContentMutationVariables>;
export type AddContentTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddContentTagMutation, AddContentTagMutationVariables>
    } & TChildProps;
export function withAddContentTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddContentTagMutation,
  AddContentTagMutationVariables,
  AddContentTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddContentTagMutation, AddContentTagMutationVariables, AddContentTagProps<TChildProps, TDataName>>(Operations.addContentTag, {
      alias: 'addContentTag',
      ...operationOptions
    });
};

/**
 * __useAddContentTagMutation__
 *
 * To run a mutation, you first call `useAddContentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContentTagMutation, { data, loading, error }] = useAddContentTagMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useAddContentTagMutation(baseOptions?: Apollo.MutationHookOptions<AddContentTagMutation, AddContentTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContentTagMutation, AddContentTagMutationVariables>(Operations.addContentTag, options);
      }
export type AddContentTagMutationHookResult = ReturnType<typeof useAddContentTagMutation>;
export type AddContentTagMutationResult = ApolloReactCommon.MutationResult<AddContentTagMutation>;
export type AddContentTagMutationOptions = ApolloReactCommon.BaseMutationOptions<AddContentTagMutation, AddContentTagMutationVariables>;
export type GetContentCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetContentCountQuery, GetContentCountQueryVariables>
    } & TChildProps;
export function withGetContentCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetContentCountQuery,
  GetContentCountQueryVariables,
  GetContentCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetContentCountQuery, GetContentCountQueryVariables, GetContentCountProps<TChildProps, TDataName>>(Operations.getContentCount, {
      alias: 'getContentCount',
      ...operationOptions
    });
};

/**
 * __useGetContentCountQuery__
 *
 * To run a query within a React component, call `useGetContentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetContentCountQuery(baseOptions?: Apollo.QueryHookOptions<GetContentCountQuery, GetContentCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentCountQuery, GetContentCountQueryVariables>(Operations.getContentCount, options);
      }
export function useGetContentCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentCountQuery, GetContentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentCountQuery, GetContentCountQueryVariables>(Operations.getContentCount, options);
        }
export type GetContentCountQueryHookResult = ReturnType<typeof useGetContentCountQuery>;
export type GetContentCountLazyQueryHookResult = ReturnType<typeof useGetContentCountLazyQuery>;
export type GetContentCountQueryResult = ApolloReactCommon.QueryResult<GetContentCountQuery, GetContentCountQueryVariables>;
export function refetchGetContentCountQuery(variables?: GetContentCountQueryVariables) {
      return { query: Operations.getContentCount, variables: variables }
    }
export type GetContentTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetContentTagsQuery, GetContentTagsQueryVariables>
    } & TChildProps;
export function withGetContentTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetContentTagsQuery,
  GetContentTagsQueryVariables,
  GetContentTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetContentTagsQuery, GetContentTagsQueryVariables, GetContentTagsProps<TChildProps, TDataName>>(Operations.getContentTags, {
      alias: 'getContentTags',
      ...operationOptions
    });
};

/**
 * __useGetContentTagsQuery__
 *
 * To run a query within a React component, call `useGetContentTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentTagsQuery, GetContentTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentTagsQuery, GetContentTagsQueryVariables>(Operations.getContentTags, options);
      }
export function useGetContentTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentTagsQuery, GetContentTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentTagsQuery, GetContentTagsQueryVariables>(Operations.getContentTags, options);
        }
export type GetContentTagsQueryHookResult = ReturnType<typeof useGetContentTagsQuery>;
export type GetContentTagsLazyQueryHookResult = ReturnType<typeof useGetContentTagsLazyQuery>;
export type GetContentTagsQueryResult = ApolloReactCommon.QueryResult<GetContentTagsQuery, GetContentTagsQueryVariables>;
export function refetchGetContentTagsQuery(variables?: GetContentTagsQueryVariables) {
      return { query: Operations.getContentTags, variables: variables }
    }
export type GetContentTitlesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetContentTitlesQuery, GetContentTitlesQueryVariables>
    } & TChildProps;
export function withGetContentTitles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetContentTitlesQuery,
  GetContentTitlesQueryVariables,
  GetContentTitlesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetContentTitlesQuery, GetContentTitlesQueryVariables, GetContentTitlesProps<TChildProps, TDataName>>(Operations.getContentTitles, {
      alias: 'getContentTitles',
      ...operationOptions
    });
};

/**
 * __useGetContentTitlesQuery__
 *
 * To run a query within a React component, call `useGetContentTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentTitlesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetContentTitlesQuery(baseOptions?: Apollo.QueryHookOptions<GetContentTitlesQuery, GetContentTitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentTitlesQuery, GetContentTitlesQueryVariables>(Operations.getContentTitles, options);
      }
export function useGetContentTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentTitlesQuery, GetContentTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentTitlesQuery, GetContentTitlesQueryVariables>(Operations.getContentTitles, options);
        }
export type GetContentTitlesQueryHookResult = ReturnType<typeof useGetContentTitlesQuery>;
export type GetContentTitlesLazyQueryHookResult = ReturnType<typeof useGetContentTitlesLazyQuery>;
export type GetContentTitlesQueryResult = ApolloReactCommon.QueryResult<GetContentTitlesQuery, GetContentTitlesQueryVariables>;
export function refetchGetContentTitlesQuery(variables?: GetContentTitlesQueryVariables) {
      return { query: Operations.getContentTitles, variables: variables }
    }
export type GetContentsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetContentsQuery, GetContentsQueryVariables>
    } & TChildProps;
export function withGetContents<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetContentsQuery,
  GetContentsQueryVariables,
  GetContentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetContentsQuery, GetContentsQueryVariables, GetContentsProps<TChildProps, TDataName>>(Operations.getContents, {
      alias: 'getContents',
      ...operationOptions
    });
};

/**
 * __useGetContentsQuery__
 *
 * To run a query within a React component, call `useGetContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetContentsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentsQuery, GetContentsQueryVariables>(Operations.getContents, options);
      }
export function useGetContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentsQuery, GetContentsQueryVariables>(Operations.getContents, options);
        }
export type GetContentsQueryHookResult = ReturnType<typeof useGetContentsQuery>;
export type GetContentsLazyQueryHookResult = ReturnType<typeof useGetContentsLazyQuery>;
export type GetContentsQueryResult = ApolloReactCommon.QueryResult<GetContentsQuery, GetContentsQueryVariables>;
export function refetchGetContentsQuery(variables?: GetContentsQueryVariables) {
      return { query: Operations.getContents, variables: variables }
    }
export type RemoveContentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveContentMutation, RemoveContentMutationVariables>
    } & TChildProps;
export function withRemoveContent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveContentMutation,
  RemoveContentMutationVariables,
  RemoveContentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveContentMutation, RemoveContentMutationVariables, RemoveContentProps<TChildProps, TDataName>>(Operations.removeContent, {
      alias: 'removeContent',
      ...operationOptions
    });
};

/**
 * __useRemoveContentMutation__
 *
 * To run a mutation, you first call `useRemoveContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContentMutation, { data, loading, error }] = useRemoveContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveContentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContentMutation, RemoveContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContentMutation, RemoveContentMutationVariables>(Operations.removeContent, options);
      }
export type RemoveContentMutationHookResult = ReturnType<typeof useRemoveContentMutation>;
export type RemoveContentMutationResult = ApolloReactCommon.MutationResult<RemoveContentMutation>;
export type RemoveContentMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveContentMutation, RemoveContentMutationVariables>;
export type RemoveContentTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveContentTagMutation, RemoveContentTagMutationVariables>
    } & TChildProps;
export function withRemoveContentTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveContentTagMutation,
  RemoveContentTagMutationVariables,
  RemoveContentTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveContentTagMutation, RemoveContentTagMutationVariables, RemoveContentTagProps<TChildProps, TDataName>>(Operations.removeContentTag, {
      alias: 'removeContentTag',
      ...operationOptions
    });
};

/**
 * __useRemoveContentTagMutation__
 *
 * To run a mutation, you first call `useRemoveContentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContentTagMutation, { data, loading, error }] = useRemoveContentTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveContentTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContentTagMutation, RemoveContentTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContentTagMutation, RemoveContentTagMutationVariables>(Operations.removeContentTag, options);
      }
export type RemoveContentTagMutationHookResult = ReturnType<typeof useRemoveContentTagMutation>;
export type RemoveContentTagMutationResult = ApolloReactCommon.MutationResult<RemoveContentTagMutation>;
export type RemoveContentTagMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveContentTagMutation, RemoveContentTagMutationVariables>;
export type UpdateContentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateContentMutation, UpdateContentMutationVariables>
    } & TChildProps;
export function withUpdateContent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateContentMutation,
  UpdateContentMutationVariables,
  UpdateContentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateContentMutation, UpdateContentMutationVariables, UpdateContentProps<TChildProps, TDataName>>(Operations.updateContent, {
      alias: 'updateContent',
      ...operationOptions
    });
};

/**
 * __useUpdateContentMutation__
 *
 * To run a mutation, you first call `useUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentMutation, { data, loading, error }] = useUpdateContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isPublic: // value for 'isPublic'
 *      type: // value for 'type'
 *      publishOn: // value for 'publishOn'
 *      expiresOn: // value for 'expiresOn'
 *      isDraft: // value for 'isDraft'
 *      title: // value for 'title'
 *      content: // value for 'content'
 *      preview: // value for 'preview'
 *      imageUrl: // value for 'imageUrl'
 *      url: // value for 'url'
 *      roles: // value for 'roles'
 *      tags: // value for 'tags'
 *      attachments: // value for 'attachments'
 *      featured: // value for 'featured'
 *      userId: // value for 'userId'
 *      enabledLocales: // value for 'enabledLocales'
 *      disableComments: // value for 'disableComments'
 *      isAdvancedMode: // value for 'isAdvancedMode'
 *   },
 * });
 */
export function useUpdateContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentMutation, UpdateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentMutation, UpdateContentMutationVariables>(Operations.updateContent, options);
      }
export type UpdateContentMutationHookResult = ReturnType<typeof useUpdateContentMutation>;
export type UpdateContentMutationResult = ApolloReactCommon.MutationResult<UpdateContentMutation>;
export type UpdateContentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContentMutation, UpdateContentMutationVariables>;
export type UpdateContentTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateContentTagMutation, UpdateContentTagMutationVariables>
    } & TChildProps;
export function withUpdateContentTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateContentTagMutation,
  UpdateContentTagMutationVariables,
  UpdateContentTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateContentTagMutation, UpdateContentTagMutationVariables, UpdateContentTagProps<TChildProps, TDataName>>(Operations.updateContentTag, {
      alias: 'updateContentTag',
      ...operationOptions
    });
};

/**
 * __useUpdateContentTagMutation__
 *
 * To run a mutation, you first call `useUpdateContentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentTagMutation, { data, loading, error }] = useUpdateContentTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useUpdateContentTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentTagMutation, UpdateContentTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentTagMutation, UpdateContentTagMutationVariables>(Operations.updateContentTag, options);
      }
export type UpdateContentTagMutationHookResult = ReturnType<typeof useUpdateContentTagMutation>;
export type UpdateContentTagMutationResult = ApolloReactCommon.MutationResult<UpdateContentTagMutation>;
export type UpdateContentTagMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContentTagMutation, UpdateContentTagMutationVariables>;
export type AddCreditConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddCreditConfigMutation, AddCreditConfigMutationVariables>
    } & TChildProps;
export function withAddCreditConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddCreditConfigMutation,
  AddCreditConfigMutationVariables,
  AddCreditConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddCreditConfigMutation, AddCreditConfigMutationVariables, AddCreditConfigProps<TChildProps, TDataName>>(Operations.addCreditConfig, {
      alias: 'addCreditConfig',
      ...operationOptions
    });
};

/**
 * __useAddCreditConfigMutation__
 *
 * To run a mutation, you first call `useAddCreditConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCreditConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCreditConfigMutation, { data, loading, error }] = useAddCreditConfigMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      creditConfig: // value for 'creditConfig'
 *   },
 * });
 */
export function useAddCreditConfigMutation(baseOptions?: Apollo.MutationHookOptions<AddCreditConfigMutation, AddCreditConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCreditConfigMutation, AddCreditConfigMutationVariables>(Operations.addCreditConfig, options);
      }
export type AddCreditConfigMutationHookResult = ReturnType<typeof useAddCreditConfigMutation>;
export type AddCreditConfigMutationResult = ApolloReactCommon.MutationResult<AddCreditConfigMutation>;
export type AddCreditConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<AddCreditConfigMutation, AddCreditConfigMutationVariables>;
export type GetCreditConfigCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCreditConfigCountQuery, GetCreditConfigCountQueryVariables>
    } & TChildProps;
export function withGetCreditConfigCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCreditConfigCountQuery,
  GetCreditConfigCountQueryVariables,
  GetCreditConfigCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCreditConfigCountQuery, GetCreditConfigCountQueryVariables, GetCreditConfigCountProps<TChildProps, TDataName>>(Operations.getCreditConfigCount, {
      alias: 'getCreditConfigCount',
      ...operationOptions
    });
};

/**
 * __useGetCreditConfigCountQuery__
 *
 * To run a query within a React component, call `useGetCreditConfigCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditConfigCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditConfigCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditConfigCountQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditConfigCountQuery, GetCreditConfigCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditConfigCountQuery, GetCreditConfigCountQueryVariables>(Operations.getCreditConfigCount, options);
      }
export function useGetCreditConfigCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditConfigCountQuery, GetCreditConfigCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditConfigCountQuery, GetCreditConfigCountQueryVariables>(Operations.getCreditConfigCount, options);
        }
export type GetCreditConfigCountQueryHookResult = ReturnType<typeof useGetCreditConfigCountQuery>;
export type GetCreditConfigCountLazyQueryHookResult = ReturnType<typeof useGetCreditConfigCountLazyQuery>;
export type GetCreditConfigCountQueryResult = ApolloReactCommon.QueryResult<GetCreditConfigCountQuery, GetCreditConfigCountQueryVariables>;
export function refetchGetCreditConfigCountQuery(variables?: GetCreditConfigCountQueryVariables) {
      return { query: Operations.getCreditConfigCount, variables: variables }
    }
export type GetCreditConfigsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCreditConfigsQuery, GetCreditConfigsQueryVariables>
    } & TChildProps;
export function withGetCreditConfigs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCreditConfigsQuery,
  GetCreditConfigsQueryVariables,
  GetCreditConfigsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCreditConfigsQuery, GetCreditConfigsQueryVariables, GetCreditConfigsProps<TChildProps, TDataName>>(Operations.getCreditConfigs, {
      alias: 'getCreditConfigs',
      ...operationOptions
    });
};

/**
 * __useGetCreditConfigsQuery__
 *
 * To run a query within a React component, call `useGetCreditConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditConfigsQuery, GetCreditConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditConfigsQuery, GetCreditConfigsQueryVariables>(Operations.getCreditConfigs, options);
      }
export function useGetCreditConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditConfigsQuery, GetCreditConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditConfigsQuery, GetCreditConfigsQueryVariables>(Operations.getCreditConfigs, options);
        }
export type GetCreditConfigsQueryHookResult = ReturnType<typeof useGetCreditConfigsQuery>;
export type GetCreditConfigsLazyQueryHookResult = ReturnType<typeof useGetCreditConfigsLazyQuery>;
export type GetCreditConfigsQueryResult = ApolloReactCommon.QueryResult<GetCreditConfigsQuery, GetCreditConfigsQueryVariables>;
export function refetchGetCreditConfigsQuery(variables?: GetCreditConfigsQueryVariables) {
      return { query: Operations.getCreditConfigs, variables: variables }
    }
export type UpdateCreditConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateCreditConfigMutation, UpdateCreditConfigMutationVariables>
    } & TChildProps;
export function withUpdateCreditConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCreditConfigMutation,
  UpdateCreditConfigMutationVariables,
  UpdateCreditConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCreditConfigMutation, UpdateCreditConfigMutationVariables, UpdateCreditConfigProps<TChildProps, TDataName>>(Operations.updateCreditConfig, {
      alias: 'updateCreditConfig',
      ...operationOptions
    });
};

/**
 * __useUpdateCreditConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCreditConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditConfigMutation, { data, loading, error }] = useUpdateCreditConfigMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      creditConfig: // value for 'creditConfig'
 *   },
 * });
 */
export function useUpdateCreditConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreditConfigMutation, UpdateCreditConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreditConfigMutation, UpdateCreditConfigMutationVariables>(Operations.updateCreditConfig, options);
      }
export type UpdateCreditConfigMutationHookResult = ReturnType<typeof useUpdateCreditConfigMutation>;
export type UpdateCreditConfigMutationResult = ApolloReactCommon.MutationResult<UpdateCreditConfigMutation>;
export type UpdateCreditConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCreditConfigMutation, UpdateCreditConfigMutationVariables>;
export type AddDashboardConfigurationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddDashboardConfigurationMutation, AddDashboardConfigurationMutationVariables>
    } & TChildProps;
export function withAddDashboardConfiguration<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddDashboardConfigurationMutation,
  AddDashboardConfigurationMutationVariables,
  AddDashboardConfigurationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddDashboardConfigurationMutation, AddDashboardConfigurationMutationVariables, AddDashboardConfigurationProps<TChildProps, TDataName>>(Operations.addDashboardConfiguration, {
      alias: 'addDashboardConfiguration',
      ...operationOptions
    });
};

/**
 * __useAddDashboardConfigurationMutation__
 *
 * To run a mutation, you first call `useAddDashboardConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDashboardConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDashboardConfigurationMutation, { data, loading, error }] = useAddDashboardConfigurationMutation({
 *   variables: {
 *      place: // value for 'place'
 *      desktopWidths: // value for 'desktopWidths'
 *      tabletWidths: // value for 'tabletWidths'
 *      mobileWidths: // value for 'mobileWidths'
 *      widgets: // value for 'widgets'
 *      publishOn: // value for 'publishOn'
 *      sequence: // value for 'sequence'
 *      background: // value for 'background'
 *      expiresOn: // value for 'expiresOn'
 *   },
 * });
 */
export function useAddDashboardConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<AddDashboardConfigurationMutation, AddDashboardConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDashboardConfigurationMutation, AddDashboardConfigurationMutationVariables>(Operations.addDashboardConfiguration, options);
      }
export type AddDashboardConfigurationMutationHookResult = ReturnType<typeof useAddDashboardConfigurationMutation>;
export type AddDashboardConfigurationMutationResult = ApolloReactCommon.MutationResult<AddDashboardConfigurationMutation>;
export type AddDashboardConfigurationMutationOptions = ApolloReactCommon.BaseMutationOptions<AddDashboardConfigurationMutation, AddDashboardConfigurationMutationVariables>;
export type GetDashboardsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDashboardsQuery, GetDashboardsQueryVariables>
    } & TChildProps;
export function withGetDashboards<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDashboardsQuery,
  GetDashboardsQueryVariables,
  GetDashboardsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDashboardsQuery, GetDashboardsQueryVariables, GetDashboardsProps<TChildProps, TDataName>>(Operations.getDashboards, {
      alias: 'getDashboards',
      ...operationOptions
    });
};

/**
 * __useGetDashboardsQuery__
 *
 * To run a query within a React component, call `useGetDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetDashboardsQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardsQuery, GetDashboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardsQuery, GetDashboardsQueryVariables>(Operations.getDashboards, options);
      }
export function useGetDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardsQuery, GetDashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardsQuery, GetDashboardsQueryVariables>(Operations.getDashboards, options);
        }
export type GetDashboardsQueryHookResult = ReturnType<typeof useGetDashboardsQuery>;
export type GetDashboardsLazyQueryHookResult = ReturnType<typeof useGetDashboardsLazyQuery>;
export type GetDashboardsQueryResult = ApolloReactCommon.QueryResult<GetDashboardsQuery, GetDashboardsQueryVariables>;
export function refetchGetDashboardsQuery(variables?: GetDashboardsQueryVariables) {
      return { query: Operations.getDashboards, variables: variables }
    }
export type GetDashboardsOverviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDashboardsOverviewQuery, GetDashboardsOverviewQueryVariables>
    } & TChildProps;
export function withGetDashboardsOverview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDashboardsOverviewQuery,
  GetDashboardsOverviewQueryVariables,
  GetDashboardsOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDashboardsOverviewQuery, GetDashboardsOverviewQueryVariables, GetDashboardsOverviewProps<TChildProps, TDataName>>(Operations.getDashboardsOverview, {
      alias: 'getDashboardsOverview',
      ...operationOptions
    });
};

/**
 * __useGetDashboardsOverviewQuery__
 *
 * To run a query within a React component, call `useGetDashboardsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardsOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetDashboardsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardsOverviewQuery, GetDashboardsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardsOverviewQuery, GetDashboardsOverviewQueryVariables>(Operations.getDashboardsOverview, options);
      }
export function useGetDashboardsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardsOverviewQuery, GetDashboardsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardsOverviewQuery, GetDashboardsOverviewQueryVariables>(Operations.getDashboardsOverview, options);
        }
export type GetDashboardsOverviewQueryHookResult = ReturnType<typeof useGetDashboardsOverviewQuery>;
export type GetDashboardsOverviewLazyQueryHookResult = ReturnType<typeof useGetDashboardsOverviewLazyQuery>;
export type GetDashboardsOverviewQueryResult = ApolloReactCommon.QueryResult<GetDashboardsOverviewQuery, GetDashboardsOverviewQueryVariables>;
export function refetchGetDashboardsOverviewQuery(variables?: GetDashboardsOverviewQueryVariables) {
      return { query: Operations.getDashboardsOverview, variables: variables }
    }
export type GetDashboardsOverviewCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDashboardsOverviewCountQuery, GetDashboardsOverviewCountQueryVariables>
    } & TChildProps;
export function withGetDashboardsOverviewCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDashboardsOverviewCountQuery,
  GetDashboardsOverviewCountQueryVariables,
  GetDashboardsOverviewCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDashboardsOverviewCountQuery, GetDashboardsOverviewCountQueryVariables, GetDashboardsOverviewCountProps<TChildProps, TDataName>>(Operations.getDashboardsOverviewCount, {
      alias: 'getDashboardsOverviewCount',
      ...operationOptions
    });
};

/**
 * __useGetDashboardsOverviewCountQuery__
 *
 * To run a query within a React component, call `useGetDashboardsOverviewCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardsOverviewCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardsOverviewCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDashboardsOverviewCountQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardsOverviewCountQuery, GetDashboardsOverviewCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardsOverviewCountQuery, GetDashboardsOverviewCountQueryVariables>(Operations.getDashboardsOverviewCount, options);
      }
export function useGetDashboardsOverviewCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardsOverviewCountQuery, GetDashboardsOverviewCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardsOverviewCountQuery, GetDashboardsOverviewCountQueryVariables>(Operations.getDashboardsOverviewCount, options);
        }
export type GetDashboardsOverviewCountQueryHookResult = ReturnType<typeof useGetDashboardsOverviewCountQuery>;
export type GetDashboardsOverviewCountLazyQueryHookResult = ReturnType<typeof useGetDashboardsOverviewCountLazyQuery>;
export type GetDashboardsOverviewCountQueryResult = ApolloReactCommon.QueryResult<GetDashboardsOverviewCountQuery, GetDashboardsOverviewCountQueryVariables>;
export function refetchGetDashboardsOverviewCountQuery(variables?: GetDashboardsOverviewCountQueryVariables) {
      return { query: Operations.getDashboardsOverviewCount, variables: variables }
    }
export type RemoveDashboardConfigurationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveDashboardConfigurationMutation, RemoveDashboardConfigurationMutationVariables>
    } & TChildProps;
export function withRemoveDashboardConfiguration<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveDashboardConfigurationMutation,
  RemoveDashboardConfigurationMutationVariables,
  RemoveDashboardConfigurationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveDashboardConfigurationMutation, RemoveDashboardConfigurationMutationVariables, RemoveDashboardConfigurationProps<TChildProps, TDataName>>(Operations.removeDashboardConfiguration, {
      alias: 'removeDashboardConfiguration',
      ...operationOptions
    });
};

/**
 * __useRemoveDashboardConfigurationMutation__
 *
 * To run a mutation, you first call `useRemoveDashboardConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDashboardConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDashboardConfigurationMutation, { data, loading, error }] = useRemoveDashboardConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDashboardConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDashboardConfigurationMutation, RemoveDashboardConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDashboardConfigurationMutation, RemoveDashboardConfigurationMutationVariables>(Operations.removeDashboardConfiguration, options);
      }
export type RemoveDashboardConfigurationMutationHookResult = ReturnType<typeof useRemoveDashboardConfigurationMutation>;
export type RemoveDashboardConfigurationMutationResult = ApolloReactCommon.MutationResult<RemoveDashboardConfigurationMutation>;
export type RemoveDashboardConfigurationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveDashboardConfigurationMutation, RemoveDashboardConfigurationMutationVariables>;
export type UpdateDashboardConfigurationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateDashboardConfigurationMutation, UpdateDashboardConfigurationMutationVariables>
    } & TChildProps;
export function withUpdateDashboardConfiguration<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateDashboardConfigurationMutation,
  UpdateDashboardConfigurationMutationVariables,
  UpdateDashboardConfigurationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateDashboardConfigurationMutation, UpdateDashboardConfigurationMutationVariables, UpdateDashboardConfigurationProps<TChildProps, TDataName>>(Operations.updateDashboardConfiguration, {
      alias: 'updateDashboardConfiguration',
      ...operationOptions
    });
};

/**
 * __useUpdateDashboardConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardConfigurationMutation, { data, loading, error }] = useUpdateDashboardConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      place: // value for 'place'
 *      desktopWidths: // value for 'desktopWidths'
 *      tabletWidths: // value for 'tabletWidths'
 *      mobileWidths: // value for 'mobileWidths'
 *      widgets: // value for 'widgets'
 *      publishOn: // value for 'publishOn'
 *      sequence: // value for 'sequence'
 *      background: // value for 'background'
 *      expiresOn: // value for 'expiresOn'
 *   },
 * });
 */
export function useUpdateDashboardConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDashboardConfigurationMutation, UpdateDashboardConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDashboardConfigurationMutation, UpdateDashboardConfigurationMutationVariables>(Operations.updateDashboardConfiguration, options);
      }
export type UpdateDashboardConfigurationMutationHookResult = ReturnType<typeof useUpdateDashboardConfigurationMutation>;
export type UpdateDashboardConfigurationMutationResult = ApolloReactCommon.MutationResult<UpdateDashboardConfigurationMutation>;
export type UpdateDashboardConfigurationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDashboardConfigurationMutation, UpdateDashboardConfigurationMutationVariables>;
export type AddEventProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddEventMutation, AddEventMutationVariables>
    } & TChildProps;
export function withAddEvent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddEventMutation,
  AddEventMutationVariables,
  AddEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddEventMutation, AddEventMutationVariables, AddEventProps<TChildProps, TDataName>>(Operations.addEvent, {
      alias: 'addEvent',
      ...operationOptions
    });
};

/**
 * __useAddEventMutation__
 *
 * To run a mutation, you first call `useAddEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventMutation, { data, loading, error }] = useAddEventMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      url: // value for 'url'
 *      organizator: // value for 'organizator'
 *      publishedOn: // value for 'publishedOn'
 *      expiresOn: // value for 'expiresOn'
 *      registration: // value for 'registration'
 *      image: // value for 'image'
 *      chronoraceEventId: // value for 'chronoraceEventId'
 *      activityTypes: // value for 'activityTypes'
 *      hideInList: // value for 'hideInList'
 *      disableComments: // value for 'disableComments'
 *      subEvents: // value for 'subEvents'
 *      projects: // value for 'projects'
 *      withAdvancedMode: // value for 'withAdvancedMode'
 *   },
 * });
 */
export function useAddEventMutation(baseOptions?: Apollo.MutationHookOptions<AddEventMutation, AddEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventMutation, AddEventMutationVariables>(Operations.addEvent, options);
      }
export type AddEventMutationHookResult = ReturnType<typeof useAddEventMutation>;
export type AddEventMutationResult = ApolloReactCommon.MutationResult<AddEventMutation>;
export type AddEventMutationOptions = ApolloReactCommon.BaseMutationOptions<AddEventMutation, AddEventMutationVariables>;
export type AddEventTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddEventTagMutation, AddEventTagMutationVariables>
    } & TChildProps;
export function withAddEventTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddEventTagMutation,
  AddEventTagMutationVariables,
  AddEventTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddEventTagMutation, AddEventTagMutationVariables, AddEventTagProps<TChildProps, TDataName>>(Operations.addEventTag, {
      alias: 'addEventTag',
      ...operationOptions
    });
};

/**
 * __useAddEventTagMutation__
 *
 * To run a mutation, you first call `useAddEventTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventTagMutation, { data, loading, error }] = useAddEventTagMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      color: // value for 'color'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useAddEventTagMutation(baseOptions?: Apollo.MutationHookOptions<AddEventTagMutation, AddEventTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventTagMutation, AddEventTagMutationVariables>(Operations.addEventTag, options);
      }
export type AddEventTagMutationHookResult = ReturnType<typeof useAddEventTagMutation>;
export type AddEventTagMutationResult = ApolloReactCommon.MutationResult<AddEventTagMutation>;
export type AddEventTagMutationOptions = ApolloReactCommon.BaseMutationOptions<AddEventTagMutation, AddEventTagMutationVariables>;
export type CopyEventProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CopyEventMutation, CopyEventMutationVariables>
    } & TChildProps;
export function withCopyEvent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CopyEventMutation,
  CopyEventMutationVariables,
  CopyEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CopyEventMutation, CopyEventMutationVariables, CopyEventProps<TChildProps, TDataName>>(Operations.copyEvent, {
      alias: 'copyEvent',
      ...operationOptions
    });
};

/**
 * __useCopyEventMutation__
 *
 * To run a mutation, you first call `useCopyEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyEventMutation, { data, loading, error }] = useCopyEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dates: // value for 'dates'
 *   },
 * });
 */
export function useCopyEventMutation(baseOptions?: Apollo.MutationHookOptions<CopyEventMutation, CopyEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyEventMutation, CopyEventMutationVariables>(Operations.copyEvent, options);
      }
export type CopyEventMutationHookResult = ReturnType<typeof useCopyEventMutation>;
export type CopyEventMutationResult = ApolloReactCommon.MutationResult<CopyEventMutation>;
export type CopyEventMutationOptions = ApolloReactCommon.BaseMutationOptions<CopyEventMutation, CopyEventMutationVariables>;
export type ExportEventParticipationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ExportEventParticipationMutation, ExportEventParticipationMutationVariables>
    } & TChildProps;
export function withExportEventParticipation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ExportEventParticipationMutation,
  ExportEventParticipationMutationVariables,
  ExportEventParticipationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ExportEventParticipationMutation, ExportEventParticipationMutationVariables, ExportEventParticipationProps<TChildProps, TDataName>>(Operations.exportEventParticipation, {
      alias: 'exportEventParticipation',
      ...operationOptions
    });
};

/**
 * __useExportEventParticipationMutation__
 *
 * To run a mutation, you first call `useExportEventParticipationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportEventParticipationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportEventParticipationMutation, { data, loading, error }] = useExportEventParticipationMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useExportEventParticipationMutation(baseOptions?: Apollo.MutationHookOptions<ExportEventParticipationMutation, ExportEventParticipationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportEventParticipationMutation, ExportEventParticipationMutationVariables>(Operations.exportEventParticipation, options);
      }
export type ExportEventParticipationMutationHookResult = ReturnType<typeof useExportEventParticipationMutation>;
export type ExportEventParticipationMutationResult = ApolloReactCommon.MutationResult<ExportEventParticipationMutation>;
export type ExportEventParticipationMutationOptions = ApolloReactCommon.BaseMutationOptions<ExportEventParticipationMutation, ExportEventParticipationMutationVariables>;
export type GetChronoRaceEventsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetChronoRaceEventsQuery, GetChronoRaceEventsQueryVariables>
    } & TChildProps;
export function withGetChronoRaceEvents<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetChronoRaceEventsQuery,
  GetChronoRaceEventsQueryVariables,
  GetChronoRaceEventsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetChronoRaceEventsQuery, GetChronoRaceEventsQueryVariables, GetChronoRaceEventsProps<TChildProps, TDataName>>(Operations.getChronoRaceEvents, {
      alias: 'getChronoRaceEvents',
      ...operationOptions
    });
};

/**
 * __useGetChronoRaceEventsQuery__
 *
 * To run a query within a React component, call `useGetChronoRaceEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChronoRaceEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChronoRaceEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetChronoRaceEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetChronoRaceEventsQuery, GetChronoRaceEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChronoRaceEventsQuery, GetChronoRaceEventsQueryVariables>(Operations.getChronoRaceEvents, options);
      }
export function useGetChronoRaceEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChronoRaceEventsQuery, GetChronoRaceEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChronoRaceEventsQuery, GetChronoRaceEventsQueryVariables>(Operations.getChronoRaceEvents, options);
        }
export type GetChronoRaceEventsQueryHookResult = ReturnType<typeof useGetChronoRaceEventsQuery>;
export type GetChronoRaceEventsLazyQueryHookResult = ReturnType<typeof useGetChronoRaceEventsLazyQuery>;
export type GetChronoRaceEventsQueryResult = ApolloReactCommon.QueryResult<GetChronoRaceEventsQuery, GetChronoRaceEventsQueryVariables>;
export function refetchGetChronoRaceEventsQuery(variables?: GetChronoRaceEventsQueryVariables) {
      return { query: Operations.getChronoRaceEvents, variables: variables }
    }
export type GetEventCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventCountQuery, GetEventCountQueryVariables>
    } & TChildProps;
export function withGetEventCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventCountQuery,
  GetEventCountQueryVariables,
  GetEventCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventCountQuery, GetEventCountQueryVariables, GetEventCountProps<TChildProps, TDataName>>(Operations.getEventCount, {
      alias: 'getEventCount',
      ...operationOptions
    });
};

/**
 * __useGetEventCountQuery__
 *
 * To run a query within a React component, call `useGetEventCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEventCountQuery(baseOptions?: Apollo.QueryHookOptions<GetEventCountQuery, GetEventCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventCountQuery, GetEventCountQueryVariables>(Operations.getEventCount, options);
      }
export function useGetEventCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventCountQuery, GetEventCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventCountQuery, GetEventCountQueryVariables>(Operations.getEventCount, options);
        }
export type GetEventCountQueryHookResult = ReturnType<typeof useGetEventCountQuery>;
export type GetEventCountLazyQueryHookResult = ReturnType<typeof useGetEventCountLazyQuery>;
export type GetEventCountQueryResult = ApolloReactCommon.QueryResult<GetEventCountQuery, GetEventCountQueryVariables>;
export function refetchGetEventCountQuery(variables?: GetEventCountQueryVariables) {
      return { query: Operations.getEventCount, variables: variables }
    }
export type GetEventParticipantsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>
    } & TChildProps;
export function withGetEventParticipants<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventParticipantsQuery,
  GetEventParticipantsQueryVariables,
  GetEventParticipantsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventParticipantsQuery, GetEventParticipantsQueryVariables, GetEventParticipantsProps<TChildProps, TDataName>>(Operations.getEventParticipants, {
      alias: 'getEventParticipants',
      ...operationOptions
    });
};

/**
 * __useGetEventParticipantsQuery__
 *
 * To run a query within a React component, call `useGetEventParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventParticipantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEventParticipantsQuery(baseOptions: Apollo.QueryHookOptions<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>(Operations.getEventParticipants, options);
      }
export function useGetEventParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>(Operations.getEventParticipants, options);
        }
export type GetEventParticipantsQueryHookResult = ReturnType<typeof useGetEventParticipantsQuery>;
export type GetEventParticipantsLazyQueryHookResult = ReturnType<typeof useGetEventParticipantsLazyQuery>;
export type GetEventParticipantsQueryResult = ApolloReactCommon.QueryResult<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>;
export function refetchGetEventParticipantsQuery(variables: GetEventParticipantsQueryVariables) {
      return { query: Operations.getEventParticipants, variables: variables }
    }
export type GetEventTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventTagsQuery, GetEventTagsQueryVariables>
    } & TChildProps;
export function withGetEventTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventTagsQuery,
  GetEventTagsQueryVariables,
  GetEventTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventTagsQuery, GetEventTagsQueryVariables, GetEventTagsProps<TChildProps, TDataName>>(Operations.getEventTags, {
      alias: 'getEventTags',
      ...operationOptions
    });
};

/**
 * __useGetEventTagsQuery__
 *
 * To run a query within a React component, call `useGetEventTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEventTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventTagsQuery, GetEventTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventTagsQuery, GetEventTagsQueryVariables>(Operations.getEventTags, options);
      }
export function useGetEventTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventTagsQuery, GetEventTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventTagsQuery, GetEventTagsQueryVariables>(Operations.getEventTags, options);
        }
export type GetEventTagsQueryHookResult = ReturnType<typeof useGetEventTagsQuery>;
export type GetEventTagsLazyQueryHookResult = ReturnType<typeof useGetEventTagsLazyQuery>;
export type GetEventTagsQueryResult = ApolloReactCommon.QueryResult<GetEventTagsQuery, GetEventTagsQueryVariables>;
export function refetchGetEventTagsQuery(variables?: GetEventTagsQueryVariables) {
      return { query: Operations.getEventTags, variables: variables }
    }
export type GetEventTitlesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventTitlesQuery, GetEventTitlesQueryVariables>
    } & TChildProps;
export function withGetEventTitles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventTitlesQuery,
  GetEventTitlesQueryVariables,
  GetEventTitlesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventTitlesQuery, GetEventTitlesQueryVariables, GetEventTitlesProps<TChildProps, TDataName>>(Operations.getEventTitles, {
      alias: 'getEventTitles',
      ...operationOptions
    });
};

/**
 * __useGetEventTitlesQuery__
 *
 * To run a query within a React component, call `useGetEventTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTitlesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEventTitlesQuery(baseOptions?: Apollo.QueryHookOptions<GetEventTitlesQuery, GetEventTitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventTitlesQuery, GetEventTitlesQueryVariables>(Operations.getEventTitles, options);
      }
export function useGetEventTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventTitlesQuery, GetEventTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventTitlesQuery, GetEventTitlesQueryVariables>(Operations.getEventTitles, options);
        }
export type GetEventTitlesQueryHookResult = ReturnType<typeof useGetEventTitlesQuery>;
export type GetEventTitlesLazyQueryHookResult = ReturnType<typeof useGetEventTitlesLazyQuery>;
export type GetEventTitlesQueryResult = ApolloReactCommon.QueryResult<GetEventTitlesQuery, GetEventTitlesQueryVariables>;
export function refetchGetEventTitlesQuery(variables?: GetEventTitlesQueryVariables) {
      return { query: Operations.getEventTitles, variables: variables }
    }
export type GetEventsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventsQuery, GetEventsQueryVariables>
    } & TChildProps;
export function withGetEvents<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventsQuery,
  GetEventsQueryVariables,
  GetEventsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventsQuery, GetEventsQueryVariables, GetEventsProps<TChildProps, TDataName>>(Operations.getEvents, {
      alias: 'getEvents',
      ...operationOptions
    });
};

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEventsQuery(baseOptions: Apollo.QueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsQuery, GetEventsQueryVariables>(Operations.getEvents, options);
      }
export function useGetEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(Operations.getEvents, options);
        }
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryHookResult = ReturnType<typeof useGetEventsLazyQuery>;
export type GetEventsQueryResult = ApolloReactCommon.QueryResult<GetEventsQuery, GetEventsQueryVariables>;
export function refetchGetEventsQuery(variables: GetEventsQueryVariables) {
      return { query: Operations.getEvents, variables: variables }
    }
export type GetEventsOverviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventsOverviewQuery, GetEventsOverviewQueryVariables>
    } & TChildProps;
export function withGetEventsOverview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventsOverviewQuery,
  GetEventsOverviewQueryVariables,
  GetEventsOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventsOverviewQuery, GetEventsOverviewQueryVariables, GetEventsOverviewProps<TChildProps, TDataName>>(Operations.getEventsOverview, {
      alias: 'getEventsOverview',
      ...operationOptions
    });
};

/**
 * __useGetEventsOverviewQuery__
 *
 * To run a query within a React component, call `useGetEventsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEventsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsOverviewQuery, GetEventsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsOverviewQuery, GetEventsOverviewQueryVariables>(Operations.getEventsOverview, options);
      }
export function useGetEventsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsOverviewQuery, GetEventsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsOverviewQuery, GetEventsOverviewQueryVariables>(Operations.getEventsOverview, options);
        }
export type GetEventsOverviewQueryHookResult = ReturnType<typeof useGetEventsOverviewQuery>;
export type GetEventsOverviewLazyQueryHookResult = ReturnType<typeof useGetEventsOverviewLazyQuery>;
export type GetEventsOverviewQueryResult = ApolloReactCommon.QueryResult<GetEventsOverviewQuery, GetEventsOverviewQueryVariables>;
export function refetchGetEventsOverviewQuery(variables?: GetEventsOverviewQueryVariables) {
      return { query: Operations.getEventsOverview, variables: variables }
    }
export type RemoveEventProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveEventMutation, RemoveEventMutationVariables>
    } & TChildProps;
export function withRemoveEvent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveEventMutation,
  RemoveEventMutationVariables,
  RemoveEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveEventMutation, RemoveEventMutationVariables, RemoveEventProps<TChildProps, TDataName>>(Operations.removeEvent, {
      alias: 'removeEvent',
      ...operationOptions
    });
};

/**
 * __useRemoveEventMutation__
 *
 * To run a mutation, you first call `useRemoveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventMutation, { data, loading, error }] = useRemoveEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEventMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventMutation, RemoveEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventMutation, RemoveEventMutationVariables>(Operations.removeEvent, options);
      }
export type RemoveEventMutationHookResult = ReturnType<typeof useRemoveEventMutation>;
export type RemoveEventMutationResult = ApolloReactCommon.MutationResult<RemoveEventMutation>;
export type RemoveEventMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveEventMutation, RemoveEventMutationVariables>;
export type RemoveEventParticipationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveEventParticipationMutation, RemoveEventParticipationMutationVariables>
    } & TChildProps;
export function withRemoveEventParticipation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveEventParticipationMutation,
  RemoveEventParticipationMutationVariables,
  RemoveEventParticipationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveEventParticipationMutation, RemoveEventParticipationMutationVariables, RemoveEventParticipationProps<TChildProps, TDataName>>(Operations.removeEventParticipation, {
      alias: 'removeEventParticipation',
      ...operationOptions
    });
};

/**
 * __useRemoveEventParticipationMutation__
 *
 * To run a mutation, you first call `useRemoveEventParticipationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventParticipationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventParticipationMutation, { data, loading, error }] = useRemoveEventParticipationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      eventId: // value for 'eventId'
 *      subEventId: // value for 'subEventId'
 *   },
 * });
 */
export function useRemoveEventParticipationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventParticipationMutation, RemoveEventParticipationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventParticipationMutation, RemoveEventParticipationMutationVariables>(Operations.removeEventParticipation, options);
      }
export type RemoveEventParticipationMutationHookResult = ReturnType<typeof useRemoveEventParticipationMutation>;
export type RemoveEventParticipationMutationResult = ApolloReactCommon.MutationResult<RemoveEventParticipationMutation>;
export type RemoveEventParticipationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveEventParticipationMutation, RemoveEventParticipationMutationVariables>;
export type RemoveEventTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveEventTagMutation, RemoveEventTagMutationVariables>
    } & TChildProps;
export function withRemoveEventTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveEventTagMutation,
  RemoveEventTagMutationVariables,
  RemoveEventTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveEventTagMutation, RemoveEventTagMutationVariables, RemoveEventTagProps<TChildProps, TDataName>>(Operations.removeEventTag, {
      alias: 'removeEventTag',
      ...operationOptions
    });
};

/**
 * __useRemoveEventTagMutation__
 *
 * To run a mutation, you first call `useRemoveEventTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventTagMutation, { data, loading, error }] = useRemoveEventTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEventTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventTagMutation, RemoveEventTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventTagMutation, RemoveEventTagMutationVariables>(Operations.removeEventTag, options);
      }
export type RemoveEventTagMutationHookResult = ReturnType<typeof useRemoveEventTagMutation>;
export type RemoveEventTagMutationResult = ApolloReactCommon.MutationResult<RemoveEventTagMutation>;
export type RemoveEventTagMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveEventTagMutation, RemoveEventTagMutationVariables>;
export type UpdateEventProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>
    } & TChildProps;
export function withUpdateEvent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEventMutation,
  UpdateEventMutationVariables,
  UpdateEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEventMutation, UpdateEventMutationVariables, UpdateEventProps<TChildProps, TDataName>>(Operations.updateEvent, {
      alias: 'updateEvent',
      ...operationOptions
    });
};

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      url: // value for 'url'
 *      organizator: // value for 'organizator'
 *      publishedOn: // value for 'publishedOn'
 *      expiresOn: // value for 'expiresOn'
 *      registration: // value for 'registration'
 *      image: // value for 'image'
 *      chronoraceEventId: // value for 'chronoraceEventId'
 *      activityTypes: // value for 'activityTypes'
 *      hideInList: // value for 'hideInList'
 *      disableComments: // value for 'disableComments'
 *      subEvents: // value for 'subEvents'
 *      projects: // value for 'projects'
 *      withAdvancedMode: // value for 'withAdvancedMode'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(Operations.updateEvent, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = ApolloReactCommon.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export type UpdateEventApprovalProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEventApprovalMutation, UpdateEventApprovalMutationVariables>
    } & TChildProps;
export function withUpdateEventApproval<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEventApprovalMutation,
  UpdateEventApprovalMutationVariables,
  UpdateEventApprovalProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEventApprovalMutation, UpdateEventApprovalMutationVariables, UpdateEventApprovalProps<TChildProps, TDataName>>(Operations.updateEventApproval, {
      alias: 'updateEventApproval',
      ...operationOptions
    });
};

/**
 * __useUpdateEventApprovalMutation__
 *
 * To run a mutation, you first call `useUpdateEventApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventApprovalMutation, { data, loading, error }] = useUpdateEventApprovalMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      eventId: // value for 'eventId'
 *      subEventId: // value for 'subEventId'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useUpdateEventApprovalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventApprovalMutation, UpdateEventApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventApprovalMutation, UpdateEventApprovalMutationVariables>(Operations.updateEventApproval, options);
      }
export type UpdateEventApprovalMutationHookResult = ReturnType<typeof useUpdateEventApprovalMutation>;
export type UpdateEventApprovalMutationResult = ApolloReactCommon.MutationResult<UpdateEventApprovalMutation>;
export type UpdateEventApprovalMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEventApprovalMutation, UpdateEventApprovalMutationVariables>;
export type UpdateEventTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEventTagMutation, UpdateEventTagMutationVariables>
    } & TChildProps;
export function withUpdateEventTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEventTagMutation,
  UpdateEventTagMutationVariables,
  UpdateEventTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEventTagMutation, UpdateEventTagMutationVariables, UpdateEventTagProps<TChildProps, TDataName>>(Operations.updateEventTag, {
      alias: 'updateEventTag',
      ...operationOptions
    });
};

/**
 * __useUpdateEventTagMutation__
 *
 * To run a mutation, you first call `useUpdateEventTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventTagMutation, { data, loading, error }] = useUpdateEventTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      color: // value for 'color'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUpdateEventTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventTagMutation, UpdateEventTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventTagMutation, UpdateEventTagMutationVariables>(Operations.updateEventTag, options);
      }
export type UpdateEventTagMutationHookResult = ReturnType<typeof useUpdateEventTagMutation>;
export type UpdateEventTagMutationResult = ApolloReactCommon.MutationResult<UpdateEventTagMutation>;
export type UpdateEventTagMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEventTagMutation, UpdateEventTagMutationVariables>;
export type AddEventGroupProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddEventGroupMutation, AddEventGroupMutationVariables>
    } & TChildProps;
export function withAddEventGroup<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddEventGroupMutation,
  AddEventGroupMutationVariables,
  AddEventGroupProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddEventGroupMutation, AddEventGroupMutationVariables, AddEventGroupProps<TChildProps, TDataName>>(Operations.addEventGroup, {
      alias: 'addEventGroup',
      ...operationOptions
    });
};

/**
 * __useAddEventGroupMutation__
 *
 * To run a mutation, you first call `useAddEventGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventGroupMutation, { data, loading, error }] = useAddEventGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      subscriptionsCount: // value for 'subscriptionsCount'
 *      eventIds: // value for 'eventIds'
 *      color: // value for 'color'
 *      projectId: // value for 'projectId'
 *      dontAllowSubEventIntersection: // value for 'dontAllowSubEventIntersection'
 *   },
 * });
 */
export function useAddEventGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddEventGroupMutation, AddEventGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventGroupMutation, AddEventGroupMutationVariables>(Operations.addEventGroup, options);
      }
export type AddEventGroupMutationHookResult = ReturnType<typeof useAddEventGroupMutation>;
export type AddEventGroupMutationResult = ApolloReactCommon.MutationResult<AddEventGroupMutation>;
export type AddEventGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<AddEventGroupMutation, AddEventGroupMutationVariables>;
export type GetEventGroupCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventGroupCountQuery, GetEventGroupCountQueryVariables>
    } & TChildProps;
export function withGetEventGroupCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventGroupCountQuery,
  GetEventGroupCountQueryVariables,
  GetEventGroupCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventGroupCountQuery, GetEventGroupCountQueryVariables, GetEventGroupCountProps<TChildProps, TDataName>>(Operations.getEventGroupCount, {
      alias: 'getEventGroupCount',
      ...operationOptions
    });
};

/**
 * __useGetEventGroupCountQuery__
 *
 * To run a query within a React component, call `useGetEventGroupCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventGroupCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventGroupCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEventGroupCountQuery(baseOptions?: Apollo.QueryHookOptions<GetEventGroupCountQuery, GetEventGroupCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventGroupCountQuery, GetEventGroupCountQueryVariables>(Operations.getEventGroupCount, options);
      }
export function useGetEventGroupCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventGroupCountQuery, GetEventGroupCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventGroupCountQuery, GetEventGroupCountQueryVariables>(Operations.getEventGroupCount, options);
        }
export type GetEventGroupCountQueryHookResult = ReturnType<typeof useGetEventGroupCountQuery>;
export type GetEventGroupCountLazyQueryHookResult = ReturnType<typeof useGetEventGroupCountLazyQuery>;
export type GetEventGroupCountQueryResult = ApolloReactCommon.QueryResult<GetEventGroupCountQuery, GetEventGroupCountQueryVariables>;
export function refetchGetEventGroupCountQuery(variables?: GetEventGroupCountQueryVariables) {
      return { query: Operations.getEventGroupCount, variables: variables }
    }
export type GetEventGroupsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventGroupsQuery, GetEventGroupsQueryVariables>
    } & TChildProps;
export function withGetEventGroups<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventGroupsQuery,
  GetEventGroupsQueryVariables,
  GetEventGroupsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventGroupsQuery, GetEventGroupsQueryVariables, GetEventGroupsProps<TChildProps, TDataName>>(Operations.getEventGroups, {
      alias: 'getEventGroups',
      ...operationOptions
    });
};

/**
 * __useGetEventGroupsQuery__
 *
 * To run a query within a React component, call `useGetEventGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEventGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventGroupsQuery, GetEventGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventGroupsQuery, GetEventGroupsQueryVariables>(Operations.getEventGroups, options);
      }
export function useGetEventGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventGroupsQuery, GetEventGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventGroupsQuery, GetEventGroupsQueryVariables>(Operations.getEventGroups, options);
        }
export type GetEventGroupsQueryHookResult = ReturnType<typeof useGetEventGroupsQuery>;
export type GetEventGroupsLazyQueryHookResult = ReturnType<typeof useGetEventGroupsLazyQuery>;
export type GetEventGroupsQueryResult = ApolloReactCommon.QueryResult<GetEventGroupsQuery, GetEventGroupsQueryVariables>;
export function refetchGetEventGroupsQuery(variables?: GetEventGroupsQueryVariables) {
      return { query: Operations.getEventGroups, variables: variables }
    }
export type RemoveEventGroupProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveEventGroupMutation, RemoveEventGroupMutationVariables>
    } & TChildProps;
export function withRemoveEventGroup<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveEventGroupMutation,
  RemoveEventGroupMutationVariables,
  RemoveEventGroupProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveEventGroupMutation, RemoveEventGroupMutationVariables, RemoveEventGroupProps<TChildProps, TDataName>>(Operations.removeEventGroup, {
      alias: 'removeEventGroup',
      ...operationOptions
    });
};

/**
 * __useRemoveEventGroupMutation__
 *
 * To run a mutation, you first call `useRemoveEventGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventGroupMutation, { data, loading, error }] = useRemoveEventGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEventGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventGroupMutation, RemoveEventGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventGroupMutation, RemoveEventGroupMutationVariables>(Operations.removeEventGroup, options);
      }
export type RemoveEventGroupMutationHookResult = ReturnType<typeof useRemoveEventGroupMutation>;
export type RemoveEventGroupMutationResult = ApolloReactCommon.MutationResult<RemoveEventGroupMutation>;
export type RemoveEventGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveEventGroupMutation, RemoveEventGroupMutationVariables>;
export type UpdateEventGroupProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEventGroupMutation, UpdateEventGroupMutationVariables>
    } & TChildProps;
export function withUpdateEventGroup<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEventGroupMutation,
  UpdateEventGroupMutationVariables,
  UpdateEventGroupProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEventGroupMutation, UpdateEventGroupMutationVariables, UpdateEventGroupProps<TChildProps, TDataName>>(Operations.updateEventGroup, {
      alias: 'updateEventGroup',
      ...operationOptions
    });
};

/**
 * __useUpdateEventGroupMutation__
 *
 * To run a mutation, you first call `useUpdateEventGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventGroupMutation, { data, loading, error }] = useUpdateEventGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      subscriptionsCount: // value for 'subscriptionsCount'
 *      eventIds: // value for 'eventIds'
 *      color: // value for 'color'
 *      projectId: // value for 'projectId'
 *      dontAllowSubEventIntersection: // value for 'dontAllowSubEventIntersection'
 *   },
 * });
 */
export function useUpdateEventGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventGroupMutation, UpdateEventGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventGroupMutation, UpdateEventGroupMutationVariables>(Operations.updateEventGroup, options);
      }
export type UpdateEventGroupMutationHookResult = ReturnType<typeof useUpdateEventGroupMutation>;
export type UpdateEventGroupMutationResult = ApolloReactCommon.MutationResult<UpdateEventGroupMutation>;
export type UpdateEventGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEventGroupMutation, UpdateEventGroupMutationVariables>;
export type AddFlowProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddFlowMutation, AddFlowMutationVariables>
    } & TChildProps;
export function withAddFlow<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddFlowMutation,
  AddFlowMutationVariables,
  AddFlowProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddFlowMutation, AddFlowMutationVariables, AddFlowProps<TChildProps, TDataName>>(Operations.addFlow, {
      alias: 'addFlow',
      ...operationOptions
    });
};

/**
 * __useAddFlowMutation__
 *
 * To run a mutation, you first call `useAddFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFlowMutation, { data, loading, error }] = useAddFlowMutation({
 *   variables: {
 *      flowInput: // value for 'flowInput'
 *   },
 * });
 */
export function useAddFlowMutation(baseOptions?: Apollo.MutationHookOptions<AddFlowMutation, AddFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFlowMutation, AddFlowMutationVariables>(Operations.addFlow, options);
      }
export type AddFlowMutationHookResult = ReturnType<typeof useAddFlowMutation>;
export type AddFlowMutationResult = ApolloReactCommon.MutationResult<AddFlowMutation>;
export type AddFlowMutationOptions = ApolloReactCommon.BaseMutationOptions<AddFlowMutation, AddFlowMutationVariables>;
export type GetFlowsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFlowsQuery, GetFlowsQueryVariables>
    } & TChildProps;
export function withGetFlows<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFlowsQuery,
  GetFlowsQueryVariables,
  GetFlowsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFlowsQuery, GetFlowsQueryVariables, GetFlowsProps<TChildProps, TDataName>>(Operations.getFlows, {
      alias: 'getFlows',
      ...operationOptions
    });
};

/**
 * __useGetFlowsQuery__
 *
 * To run a query within a React component, call `useGetFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlowsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetFlowsQuery(baseOptions?: Apollo.QueryHookOptions<GetFlowsQuery, GetFlowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFlowsQuery, GetFlowsQueryVariables>(Operations.getFlows, options);
      }
export function useGetFlowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFlowsQuery, GetFlowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFlowsQuery, GetFlowsQueryVariables>(Operations.getFlows, options);
        }
export type GetFlowsQueryHookResult = ReturnType<typeof useGetFlowsQuery>;
export type GetFlowsLazyQueryHookResult = ReturnType<typeof useGetFlowsLazyQuery>;
export type GetFlowsQueryResult = ApolloReactCommon.QueryResult<GetFlowsQuery, GetFlowsQueryVariables>;
export function refetchGetFlowsQuery(variables?: GetFlowsQueryVariables) {
      return { query: Operations.getFlows, variables: variables }
    }
export type GetFlowsCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFlowsCountQuery, GetFlowsCountQueryVariables>
    } & TChildProps;
export function withGetFlowsCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFlowsCountQuery,
  GetFlowsCountQueryVariables,
  GetFlowsCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFlowsCountQuery, GetFlowsCountQueryVariables, GetFlowsCountProps<TChildProps, TDataName>>(Operations.getFlowsCount, {
      alias: 'getFlowsCount',
      ...operationOptions
    });
};

/**
 * __useGetFlowsCountQuery__
 *
 * To run a query within a React component, call `useGetFlowsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlowsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlowsCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFlowsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetFlowsCountQuery, GetFlowsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFlowsCountQuery, GetFlowsCountQueryVariables>(Operations.getFlowsCount, options);
      }
export function useGetFlowsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFlowsCountQuery, GetFlowsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFlowsCountQuery, GetFlowsCountQueryVariables>(Operations.getFlowsCount, options);
        }
export type GetFlowsCountQueryHookResult = ReturnType<typeof useGetFlowsCountQuery>;
export type GetFlowsCountLazyQueryHookResult = ReturnType<typeof useGetFlowsCountLazyQuery>;
export type GetFlowsCountQueryResult = ApolloReactCommon.QueryResult<GetFlowsCountQuery, GetFlowsCountQueryVariables>;
export function refetchGetFlowsCountQuery(variables?: GetFlowsCountQueryVariables) {
      return { query: Operations.getFlowsCount, variables: variables }
    }
export type RemoveFlowProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveFlowMutation, RemoveFlowMutationVariables>
    } & TChildProps;
export function withRemoveFlow<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveFlowMutation,
  RemoveFlowMutationVariables,
  RemoveFlowProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveFlowMutation, RemoveFlowMutationVariables, RemoveFlowProps<TChildProps, TDataName>>(Operations.removeFlow, {
      alias: 'removeFlow',
      ...operationOptions
    });
};

/**
 * __useRemoveFlowMutation__
 *
 * To run a mutation, you first call `useRemoveFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFlowMutation, { data, loading, error }] = useRemoveFlowMutation({
 *   variables: {
 *      flowId: // value for 'flowId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRemoveFlowMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFlowMutation, RemoveFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFlowMutation, RemoveFlowMutationVariables>(Operations.removeFlow, options);
      }
export type RemoveFlowMutationHookResult = ReturnType<typeof useRemoveFlowMutation>;
export type RemoveFlowMutationResult = ApolloReactCommon.MutationResult<RemoveFlowMutation>;
export type RemoveFlowMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveFlowMutation, RemoveFlowMutationVariables>;
export type UpdateFlowProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateFlowMutation, UpdateFlowMutationVariables>
    } & TChildProps;
export function withUpdateFlow<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateFlowMutation,
  UpdateFlowMutationVariables,
  UpdateFlowProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateFlowMutation, UpdateFlowMutationVariables, UpdateFlowProps<TChildProps, TDataName>>(Operations.updateFlow, {
      alias: 'updateFlow',
      ...operationOptions
    });
};

/**
 * __useUpdateFlowMutation__
 *
 * To run a mutation, you first call `useUpdateFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFlowMutation, { data, loading, error }] = useUpdateFlowMutation({
 *   variables: {
 *      flowId: // value for 'flowId'
 *      flowInput: // value for 'flowInput'
 *   },
 * });
 */
export function useUpdateFlowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFlowMutation, UpdateFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFlowMutation, UpdateFlowMutationVariables>(Operations.updateFlow, options);
      }
export type UpdateFlowMutationHookResult = ReturnType<typeof useUpdateFlowMutation>;
export type UpdateFlowMutationResult = ApolloReactCommon.MutationResult<UpdateFlowMutation>;
export type UpdateFlowMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFlowMutation, UpdateFlowMutationVariables>;
export type AddFormTemplateProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddFormTemplateMutation, AddFormTemplateMutationVariables>
    } & TChildProps;
export function withAddFormTemplate<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddFormTemplateMutation,
  AddFormTemplateMutationVariables,
  AddFormTemplateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddFormTemplateMutation, AddFormTemplateMutationVariables, AddFormTemplateProps<TChildProps, TDataName>>(Operations.addFormTemplate, {
      alias: 'addFormTemplate',
      ...operationOptions
    });
};

/**
 * __useAddFormTemplateMutation__
 *
 * To run a mutation, you first call `useAddFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFormTemplateMutation, { data, loading, error }] = useAddFormTemplateMutation({
 *   variables: {
 *      type: // value for 'type'
 *      title: // value for 'title'
 *      errorMessages: // value for 'errorMessages'
 *      elements: // value for 'elements'
 *   },
 * });
 */
export function useAddFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddFormTemplateMutation, AddFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFormTemplateMutation, AddFormTemplateMutationVariables>(Operations.addFormTemplate, options);
      }
export type AddFormTemplateMutationHookResult = ReturnType<typeof useAddFormTemplateMutation>;
export type AddFormTemplateMutationResult = ApolloReactCommon.MutationResult<AddFormTemplateMutation>;
export type AddFormTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<AddFormTemplateMutation, AddFormTemplateMutationVariables>;
export type GetFormTemplatesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFormTemplatesQuery, GetFormTemplatesQueryVariables>
    } & TChildProps;
export function withGetFormTemplates<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFormTemplatesQuery,
  GetFormTemplatesQueryVariables,
  GetFormTemplatesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFormTemplatesQuery, GetFormTemplatesQueryVariables, GetFormTemplatesProps<TChildProps, TDataName>>(Operations.getFormTemplates, {
      alias: 'getFormTemplates',
      ...operationOptions
    });
};

/**
 * __useGetFormTemplatesQuery__
 *
 * To run a query within a React component, call `useGetFormTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFormTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetFormTemplatesQuery, GetFormTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormTemplatesQuery, GetFormTemplatesQueryVariables>(Operations.getFormTemplates, options);
      }
export function useGetFormTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormTemplatesQuery, GetFormTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormTemplatesQuery, GetFormTemplatesQueryVariables>(Operations.getFormTemplates, options);
        }
export type GetFormTemplatesQueryHookResult = ReturnType<typeof useGetFormTemplatesQuery>;
export type GetFormTemplatesLazyQueryHookResult = ReturnType<typeof useGetFormTemplatesLazyQuery>;
export type GetFormTemplatesQueryResult = ApolloReactCommon.QueryResult<GetFormTemplatesQuery, GetFormTemplatesQueryVariables>;
export function refetchGetFormTemplatesQuery(variables: GetFormTemplatesQueryVariables) {
      return { query: Operations.getFormTemplates, variables: variables }
    }
export type GetFormTemplatesOverviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFormTemplatesOverviewQuery, GetFormTemplatesOverviewQueryVariables>
    } & TChildProps;
export function withGetFormTemplatesOverview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFormTemplatesOverviewQuery,
  GetFormTemplatesOverviewQueryVariables,
  GetFormTemplatesOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFormTemplatesOverviewQuery, GetFormTemplatesOverviewQueryVariables, GetFormTemplatesOverviewProps<TChildProps, TDataName>>(Operations.getFormTemplatesOverview, {
      alias: 'getFormTemplatesOverview',
      ...operationOptions
    });
};

/**
 * __useGetFormTemplatesOverviewQuery__
 *
 * To run a query within a React component, call `useGetFormTemplatesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormTemplatesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormTemplatesOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFormTemplatesOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetFormTemplatesOverviewQuery, GetFormTemplatesOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormTemplatesOverviewQuery, GetFormTemplatesOverviewQueryVariables>(Operations.getFormTemplatesOverview, options);
      }
export function useGetFormTemplatesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormTemplatesOverviewQuery, GetFormTemplatesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormTemplatesOverviewQuery, GetFormTemplatesOverviewQueryVariables>(Operations.getFormTemplatesOverview, options);
        }
export type GetFormTemplatesOverviewQueryHookResult = ReturnType<typeof useGetFormTemplatesOverviewQuery>;
export type GetFormTemplatesOverviewLazyQueryHookResult = ReturnType<typeof useGetFormTemplatesOverviewLazyQuery>;
export type GetFormTemplatesOverviewQueryResult = ApolloReactCommon.QueryResult<GetFormTemplatesOverviewQuery, GetFormTemplatesOverviewQueryVariables>;
export function refetchGetFormTemplatesOverviewQuery(variables: GetFormTemplatesOverviewQueryVariables) {
      return { query: Operations.getFormTemplatesOverview, variables: variables }
    }
export type RemoveFormTemplateProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveFormTemplateMutation, RemoveFormTemplateMutationVariables>
    } & TChildProps;
export function withRemoveFormTemplate<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveFormTemplateMutation,
  RemoveFormTemplateMutationVariables,
  RemoveFormTemplateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveFormTemplateMutation, RemoveFormTemplateMutationVariables, RemoveFormTemplateProps<TChildProps, TDataName>>(Operations.removeFormTemplate, {
      alias: 'removeFormTemplate',
      ...operationOptions
    });
};

/**
 * __useRemoveFormTemplateMutation__
 *
 * To run a mutation, you first call `useRemoveFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFormTemplateMutation, { data, loading, error }] = useRemoveFormTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFormTemplateMutation, RemoveFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFormTemplateMutation, RemoveFormTemplateMutationVariables>(Operations.removeFormTemplate, options);
      }
export type RemoveFormTemplateMutationHookResult = ReturnType<typeof useRemoveFormTemplateMutation>;
export type RemoveFormTemplateMutationResult = ApolloReactCommon.MutationResult<RemoveFormTemplateMutation>;
export type RemoveFormTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveFormTemplateMutation, RemoveFormTemplateMutationVariables>;
export type UpdateFormTemplateProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>
    } & TChildProps;
export function withUpdateFormTemplate<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateFormTemplateMutation,
  UpdateFormTemplateMutationVariables,
  UpdateFormTemplateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables, UpdateFormTemplateProps<TChildProps, TDataName>>(Operations.updateFormTemplate, {
      alias: 'updateFormTemplate',
      ...operationOptions
    });
};

/**
 * __useUpdateFormTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormTemplateMutation, { data, loading, error }] = useUpdateFormTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      title: // value for 'title'
 *      errorMessages: // value for 'errorMessages'
 *      elements: // value for 'elements'
 *   },
 * });
 */
export function useUpdateFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>(Operations.updateFormTemplate, options);
      }
export type UpdateFormTemplateMutationHookResult = ReturnType<typeof useUpdateFormTemplateMutation>;
export type UpdateFormTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateFormTemplateMutation>;
export type UpdateFormTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>;
export type AddGalleryProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddGalleryMutation, AddGalleryMutationVariables>
    } & TChildProps;
export function withAddGallery<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddGalleryMutation,
  AddGalleryMutationVariables,
  AddGalleryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddGalleryMutation, AddGalleryMutationVariables, AddGalleryProps<TChildProps, TDataName>>(Operations.addGallery, {
      alias: 'addGallery',
      ...operationOptions
    });
};

/**
 * __useAddGalleryMutation__
 *
 * To run a mutation, you first call `useAddGalleryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGalleryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGalleryMutation, { data, loading, error }] = useAddGalleryMutation({
 *   variables: {
 *      type: // value for 'type'
 *      typeId: // value for 'typeId'
 *      publishOn: // value for 'publishOn'
 *      expiresOn: // value for 'expiresOn'
 *      isDraft: // value for 'isDraft'
 *      title: // value for 'title'
 *      preview: // value for 'preview'
 *      description: // value for 'description'
 *      roles: // value for 'roles'
 *      tags: // value for 'tags'
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useAddGalleryMutation(baseOptions?: Apollo.MutationHookOptions<AddGalleryMutation, AddGalleryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGalleryMutation, AddGalleryMutationVariables>(Operations.addGallery, options);
      }
export type AddGalleryMutationHookResult = ReturnType<typeof useAddGalleryMutation>;
export type AddGalleryMutationResult = ApolloReactCommon.MutationResult<AddGalleryMutation>;
export type AddGalleryMutationOptions = ApolloReactCommon.BaseMutationOptions<AddGalleryMutation, AddGalleryMutationVariables>;
export type AddGalleryImageProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddGalleryImageMutation, AddGalleryImageMutationVariables>
    } & TChildProps;
export function withAddGalleryImage<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddGalleryImageMutation,
  AddGalleryImageMutationVariables,
  AddGalleryImageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddGalleryImageMutation, AddGalleryImageMutationVariables, AddGalleryImageProps<TChildProps, TDataName>>(Operations.addGalleryImage, {
      alias: 'addGalleryImage',
      ...operationOptions
    });
};

/**
 * __useAddGalleryImageMutation__
 *
 * To run a mutation, you first call `useAddGalleryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGalleryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGalleryImageMutation, { data, loading, error }] = useAddGalleryImageMutation({
 *   variables: {
 *      galleryId: // value for 'galleryId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      url: // value for 'url'
 *      embedUrl: // value for 'embedUrl'
 *   },
 * });
 */
export function useAddGalleryImageMutation(baseOptions?: Apollo.MutationHookOptions<AddGalleryImageMutation, AddGalleryImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGalleryImageMutation, AddGalleryImageMutationVariables>(Operations.addGalleryImage, options);
      }
export type AddGalleryImageMutationHookResult = ReturnType<typeof useAddGalleryImageMutation>;
export type AddGalleryImageMutationResult = ApolloReactCommon.MutationResult<AddGalleryImageMutation>;
export type AddGalleryImageMutationOptions = ApolloReactCommon.BaseMutationOptions<AddGalleryImageMutation, AddGalleryImageMutationVariables>;
export type AddGalleryTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddGalleryTagMutation, AddGalleryTagMutationVariables>
    } & TChildProps;
export function withAddGalleryTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddGalleryTagMutation,
  AddGalleryTagMutationVariables,
  AddGalleryTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddGalleryTagMutation, AddGalleryTagMutationVariables, AddGalleryTagProps<TChildProps, TDataName>>(Operations.addGalleryTag, {
      alias: 'addGalleryTag',
      ...operationOptions
    });
};

/**
 * __useAddGalleryTagMutation__
 *
 * To run a mutation, you first call `useAddGalleryTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGalleryTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGalleryTagMutation, { data, loading, error }] = useAddGalleryTagMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useAddGalleryTagMutation(baseOptions?: Apollo.MutationHookOptions<AddGalleryTagMutation, AddGalleryTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGalleryTagMutation, AddGalleryTagMutationVariables>(Operations.addGalleryTag, options);
      }
export type AddGalleryTagMutationHookResult = ReturnType<typeof useAddGalleryTagMutation>;
export type AddGalleryTagMutationResult = ApolloReactCommon.MutationResult<AddGalleryTagMutation>;
export type AddGalleryTagMutationOptions = ApolloReactCommon.BaseMutationOptions<AddGalleryTagMutation, AddGalleryTagMutationVariables>;
export type GetGalleriesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetGalleriesQuery, GetGalleriesQueryVariables>
    } & TChildProps;
export function withGetGalleries<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetGalleriesQuery,
  GetGalleriesQueryVariables,
  GetGalleriesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetGalleriesQuery, GetGalleriesQueryVariables, GetGalleriesProps<TChildProps, TDataName>>(Operations.getGalleries, {
      alias: 'getGalleries',
      ...operationOptions
    });
};

/**
 * __useGetGalleriesQuery__
 *
 * To run a query within a React component, call `useGetGalleriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGalleriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGalleriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetGalleriesQuery(baseOptions?: Apollo.QueryHookOptions<GetGalleriesQuery, GetGalleriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGalleriesQuery, GetGalleriesQueryVariables>(Operations.getGalleries, options);
      }
export function useGetGalleriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGalleriesQuery, GetGalleriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGalleriesQuery, GetGalleriesQueryVariables>(Operations.getGalleries, options);
        }
export type GetGalleriesQueryHookResult = ReturnType<typeof useGetGalleriesQuery>;
export type GetGalleriesLazyQueryHookResult = ReturnType<typeof useGetGalleriesLazyQuery>;
export type GetGalleriesQueryResult = ApolloReactCommon.QueryResult<GetGalleriesQuery, GetGalleriesQueryVariables>;
export function refetchGetGalleriesQuery(variables?: GetGalleriesQueryVariables) {
      return { query: Operations.getGalleries, variables: variables }
    }
export type GetGalleriesOverviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetGalleriesOverviewQuery, GetGalleriesOverviewQueryVariables>
    } & TChildProps;
export function withGetGalleriesOverview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetGalleriesOverviewQuery,
  GetGalleriesOverviewQueryVariables,
  GetGalleriesOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetGalleriesOverviewQuery, GetGalleriesOverviewQueryVariables, GetGalleriesOverviewProps<TChildProps, TDataName>>(Operations.getGalleriesOverview, {
      alias: 'getGalleriesOverview',
      ...operationOptions
    });
};

/**
 * __useGetGalleriesOverviewQuery__
 *
 * To run a query within a React component, call `useGetGalleriesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGalleriesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGalleriesOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetGalleriesOverviewQuery(baseOptions?: Apollo.QueryHookOptions<GetGalleriesOverviewQuery, GetGalleriesOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGalleriesOverviewQuery, GetGalleriesOverviewQueryVariables>(Operations.getGalleriesOverview, options);
      }
export function useGetGalleriesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGalleriesOverviewQuery, GetGalleriesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGalleriesOverviewQuery, GetGalleriesOverviewQueryVariables>(Operations.getGalleriesOverview, options);
        }
export type GetGalleriesOverviewQueryHookResult = ReturnType<typeof useGetGalleriesOverviewQuery>;
export type GetGalleriesOverviewLazyQueryHookResult = ReturnType<typeof useGetGalleriesOverviewLazyQuery>;
export type GetGalleriesOverviewQueryResult = ApolloReactCommon.QueryResult<GetGalleriesOverviewQuery, GetGalleriesOverviewQueryVariables>;
export function refetchGetGalleriesOverviewQuery(variables?: GetGalleriesOverviewQueryVariables) {
      return { query: Operations.getGalleriesOverview, variables: variables }
    }
export type GetGalleriesOverviewCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetGalleriesOverviewCountQuery, GetGalleriesOverviewCountQueryVariables>
    } & TChildProps;
export function withGetGalleriesOverviewCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetGalleriesOverviewCountQuery,
  GetGalleriesOverviewCountQueryVariables,
  GetGalleriesOverviewCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetGalleriesOverviewCountQuery, GetGalleriesOverviewCountQueryVariables, GetGalleriesOverviewCountProps<TChildProps, TDataName>>(Operations.getGalleriesOverviewCount, {
      alias: 'getGalleriesOverviewCount',
      ...operationOptions
    });
};

/**
 * __useGetGalleriesOverviewCountQuery__
 *
 * To run a query within a React component, call `useGetGalleriesOverviewCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGalleriesOverviewCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGalleriesOverviewCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetGalleriesOverviewCountQuery(baseOptions?: Apollo.QueryHookOptions<GetGalleriesOverviewCountQuery, GetGalleriesOverviewCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGalleriesOverviewCountQuery, GetGalleriesOverviewCountQueryVariables>(Operations.getGalleriesOverviewCount, options);
      }
export function useGetGalleriesOverviewCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGalleriesOverviewCountQuery, GetGalleriesOverviewCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGalleriesOverviewCountQuery, GetGalleriesOverviewCountQueryVariables>(Operations.getGalleriesOverviewCount, options);
        }
export type GetGalleriesOverviewCountQueryHookResult = ReturnType<typeof useGetGalleriesOverviewCountQuery>;
export type GetGalleriesOverviewCountLazyQueryHookResult = ReturnType<typeof useGetGalleriesOverviewCountLazyQuery>;
export type GetGalleriesOverviewCountQueryResult = ApolloReactCommon.QueryResult<GetGalleriesOverviewCountQuery, GetGalleriesOverviewCountQueryVariables>;
export function refetchGetGalleriesOverviewCountQuery(variables?: GetGalleriesOverviewCountQueryVariables) {
      return { query: Operations.getGalleriesOverviewCount, variables: variables }
    }
export type GetGalleryTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetGalleryTagsQuery, GetGalleryTagsQueryVariables>
    } & TChildProps;
export function withGetGalleryTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetGalleryTagsQuery,
  GetGalleryTagsQueryVariables,
  GetGalleryTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetGalleryTagsQuery, GetGalleryTagsQueryVariables, GetGalleryTagsProps<TChildProps, TDataName>>(Operations.getGalleryTags, {
      alias: 'getGalleryTags',
      ...operationOptions
    });
};

/**
 * __useGetGalleryTagsQuery__
 *
 * To run a query within a React component, call `useGetGalleryTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGalleryTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGalleryTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGalleryTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetGalleryTagsQuery, GetGalleryTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGalleryTagsQuery, GetGalleryTagsQueryVariables>(Operations.getGalleryTags, options);
      }
export function useGetGalleryTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGalleryTagsQuery, GetGalleryTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGalleryTagsQuery, GetGalleryTagsQueryVariables>(Operations.getGalleryTags, options);
        }
export type GetGalleryTagsQueryHookResult = ReturnType<typeof useGetGalleryTagsQuery>;
export type GetGalleryTagsLazyQueryHookResult = ReturnType<typeof useGetGalleryTagsLazyQuery>;
export type GetGalleryTagsQueryResult = ApolloReactCommon.QueryResult<GetGalleryTagsQuery, GetGalleryTagsQueryVariables>;
export function refetchGetGalleryTagsQuery(variables?: GetGalleryTagsQueryVariables) {
      return { query: Operations.getGalleryTags, variables: variables }
    }
export type RemoveGalleryProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveGalleryMutation, RemoveGalleryMutationVariables>
    } & TChildProps;
export function withRemoveGallery<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveGalleryMutation,
  RemoveGalleryMutationVariables,
  RemoveGalleryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveGalleryMutation, RemoveGalleryMutationVariables, RemoveGalleryProps<TChildProps, TDataName>>(Operations.removeGallery, {
      alias: 'removeGallery',
      ...operationOptions
    });
};

/**
 * __useRemoveGalleryMutation__
 *
 * To run a mutation, you first call `useRemoveGalleryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGalleryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGalleryMutation, { data, loading, error }] = useRemoveGalleryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGalleryMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGalleryMutation, RemoveGalleryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGalleryMutation, RemoveGalleryMutationVariables>(Operations.removeGallery, options);
      }
export type RemoveGalleryMutationHookResult = ReturnType<typeof useRemoveGalleryMutation>;
export type RemoveGalleryMutationResult = ApolloReactCommon.MutationResult<RemoveGalleryMutation>;
export type RemoveGalleryMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveGalleryMutation, RemoveGalleryMutationVariables>;
export type RemoveGalleryImageProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveGalleryImageMutation, RemoveGalleryImageMutationVariables>
    } & TChildProps;
export function withRemoveGalleryImage<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveGalleryImageMutation,
  RemoveGalleryImageMutationVariables,
  RemoveGalleryImageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveGalleryImageMutation, RemoveGalleryImageMutationVariables, RemoveGalleryImageProps<TChildProps, TDataName>>(Operations.removeGalleryImage, {
      alias: 'removeGalleryImage',
      ...operationOptions
    });
};

/**
 * __useRemoveGalleryImageMutation__
 *
 * To run a mutation, you first call `useRemoveGalleryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGalleryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGalleryImageMutation, { data, loading, error }] = useRemoveGalleryImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGalleryImageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGalleryImageMutation, RemoveGalleryImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGalleryImageMutation, RemoveGalleryImageMutationVariables>(Operations.removeGalleryImage, options);
      }
export type RemoveGalleryImageMutationHookResult = ReturnType<typeof useRemoveGalleryImageMutation>;
export type RemoveGalleryImageMutationResult = ApolloReactCommon.MutationResult<RemoveGalleryImageMutation>;
export type RemoveGalleryImageMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveGalleryImageMutation, RemoveGalleryImageMutationVariables>;
export type RemoveGalleryTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveGalleryTagMutation, RemoveGalleryTagMutationVariables>
    } & TChildProps;
export function withRemoveGalleryTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveGalleryTagMutation,
  RemoveGalleryTagMutationVariables,
  RemoveGalleryTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveGalleryTagMutation, RemoveGalleryTagMutationVariables, RemoveGalleryTagProps<TChildProps, TDataName>>(Operations.removeGalleryTag, {
      alias: 'removeGalleryTag',
      ...operationOptions
    });
};

/**
 * __useRemoveGalleryTagMutation__
 *
 * To run a mutation, you first call `useRemoveGalleryTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGalleryTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGalleryTagMutation, { data, loading, error }] = useRemoveGalleryTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGalleryTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGalleryTagMutation, RemoveGalleryTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGalleryTagMutation, RemoveGalleryTagMutationVariables>(Operations.removeGalleryTag, options);
      }
export type RemoveGalleryTagMutationHookResult = ReturnType<typeof useRemoveGalleryTagMutation>;
export type RemoveGalleryTagMutationResult = ApolloReactCommon.MutationResult<RemoveGalleryTagMutation>;
export type RemoveGalleryTagMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveGalleryTagMutation, RemoveGalleryTagMutationVariables>;
export type UpdateGalleryProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateGalleryMutation, UpdateGalleryMutationVariables>
    } & TChildProps;
export function withUpdateGallery<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateGalleryMutation,
  UpdateGalleryMutationVariables,
  UpdateGalleryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateGalleryMutation, UpdateGalleryMutationVariables, UpdateGalleryProps<TChildProps, TDataName>>(Operations.updateGallery, {
      alias: 'updateGallery',
      ...operationOptions
    });
};

/**
 * __useUpdateGalleryMutation__
 *
 * To run a mutation, you first call `useUpdateGalleryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGalleryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGalleryMutation, { data, loading, error }] = useUpdateGalleryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      typeId: // value for 'typeId'
 *      publishOn: // value for 'publishOn'
 *      expiresOn: // value for 'expiresOn'
 *      isDraft: // value for 'isDraft'
 *      title: // value for 'title'
 *      preview: // value for 'preview'
 *      description: // value for 'description'
 *      roles: // value for 'roles'
 *      tags: // value for 'tags'
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useUpdateGalleryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGalleryMutation, UpdateGalleryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGalleryMutation, UpdateGalleryMutationVariables>(Operations.updateGallery, options);
      }
export type UpdateGalleryMutationHookResult = ReturnType<typeof useUpdateGalleryMutation>;
export type UpdateGalleryMutationResult = ApolloReactCommon.MutationResult<UpdateGalleryMutation>;
export type UpdateGalleryMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGalleryMutation, UpdateGalleryMutationVariables>;
export type UpdateGalleryImageProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateGalleryImageMutation, UpdateGalleryImageMutationVariables>
    } & TChildProps;
export function withUpdateGalleryImage<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateGalleryImageMutation,
  UpdateGalleryImageMutationVariables,
  UpdateGalleryImageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateGalleryImageMutation, UpdateGalleryImageMutationVariables, UpdateGalleryImageProps<TChildProps, TDataName>>(Operations.updateGalleryImage, {
      alias: 'updateGalleryImage',
      ...operationOptions
    });
};

/**
 * __useUpdateGalleryImageMutation__
 *
 * To run a mutation, you first call `useUpdateGalleryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGalleryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGalleryImageMutation, { data, loading, error }] = useUpdateGalleryImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      url: // value for 'url'
 *      embedUrl: // value for 'embedUrl'
 *      reported: // value for 'reported'
 *   },
 * });
 */
export function useUpdateGalleryImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGalleryImageMutation, UpdateGalleryImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGalleryImageMutation, UpdateGalleryImageMutationVariables>(Operations.updateGalleryImage, options);
      }
export type UpdateGalleryImageMutationHookResult = ReturnType<typeof useUpdateGalleryImageMutation>;
export type UpdateGalleryImageMutationResult = ApolloReactCommon.MutationResult<UpdateGalleryImageMutation>;
export type UpdateGalleryImageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGalleryImageMutation, UpdateGalleryImageMutationVariables>;
export type UpdateGalleryTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateGalleryTagMutation, UpdateGalleryTagMutationVariables>
    } & TChildProps;
export function withUpdateGalleryTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateGalleryTagMutation,
  UpdateGalleryTagMutationVariables,
  UpdateGalleryTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateGalleryTagMutation, UpdateGalleryTagMutationVariables, UpdateGalleryTagProps<TChildProps, TDataName>>(Operations.updateGalleryTag, {
      alias: 'updateGalleryTag',
      ...operationOptions
    });
};

/**
 * __useUpdateGalleryTagMutation__
 *
 * To run a mutation, you first call `useUpdateGalleryTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGalleryTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGalleryTagMutation, { data, loading, error }] = useUpdateGalleryTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useUpdateGalleryTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGalleryTagMutation, UpdateGalleryTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGalleryTagMutation, UpdateGalleryTagMutationVariables>(Operations.updateGalleryTag, options);
      }
export type UpdateGalleryTagMutationHookResult = ReturnType<typeof useUpdateGalleryTagMutation>;
export type UpdateGalleryTagMutationResult = ApolloReactCommon.MutationResult<UpdateGalleryTagMutation>;
export type UpdateGalleryTagMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGalleryTagMutation, UpdateGalleryTagMutationVariables>;
export type AddJourneyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddJourneyMutation, AddJourneyMutationVariables>
    } & TChildProps;
export function withAddJourney<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddJourneyMutation,
  AddJourneyMutationVariables,
  AddJourneyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddJourneyMutation, AddJourneyMutationVariables, AddJourneyProps<TChildProps, TDataName>>(Operations.addJourney, {
      alias: 'addJourney',
      ...operationOptions
    });
};

/**
 * __useAddJourneyMutation__
 *
 * To run a mutation, you first call `useAddJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJourneyMutation, { data, loading, error }] = useAddJourneyMutation({
 *   variables: {
 *      journey: // value for 'journey'
 *   },
 * });
 */
export function useAddJourneyMutation(baseOptions?: Apollo.MutationHookOptions<AddJourneyMutation, AddJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddJourneyMutation, AddJourneyMutationVariables>(Operations.addJourney, options);
      }
export type AddJourneyMutationHookResult = ReturnType<typeof useAddJourneyMutation>;
export type AddJourneyMutationResult = ApolloReactCommon.MutationResult<AddJourneyMutation>;
export type AddJourneyMutationOptions = ApolloReactCommon.BaseMutationOptions<AddJourneyMutation, AddJourneyMutationVariables>;
export type AddJourneyTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddJourneyTagMutation, AddJourneyTagMutationVariables>
    } & TChildProps;
export function withAddJourneyTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddJourneyTagMutation,
  AddJourneyTagMutationVariables,
  AddJourneyTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddJourneyTagMutation, AddJourneyTagMutationVariables, AddJourneyTagProps<TChildProps, TDataName>>(Operations.addJourneyTag, {
      alias: 'addJourneyTag',
      ...operationOptions
    });
};

/**
 * __useAddJourneyTagMutation__
 *
 * To run a mutation, you first call `useAddJourneyTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJourneyTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJourneyTagMutation, { data, loading, error }] = useAddJourneyTagMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useAddJourneyTagMutation(baseOptions?: Apollo.MutationHookOptions<AddJourneyTagMutation, AddJourneyTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddJourneyTagMutation, AddJourneyTagMutationVariables>(Operations.addJourneyTag, options);
      }
export type AddJourneyTagMutationHookResult = ReturnType<typeof useAddJourneyTagMutation>;
export type AddJourneyTagMutationResult = ApolloReactCommon.MutationResult<AddJourneyTagMutation>;
export type AddJourneyTagMutationOptions = ApolloReactCommon.BaseMutationOptions<AddJourneyTagMutation, AddJourneyTagMutationVariables>;
export type GetJourneyCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetJourneyCountQuery, GetJourneyCountQueryVariables>
    } & TChildProps;
export function withGetJourneyCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetJourneyCountQuery,
  GetJourneyCountQueryVariables,
  GetJourneyCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetJourneyCountQuery, GetJourneyCountQueryVariables, GetJourneyCountProps<TChildProps, TDataName>>(Operations.getJourneyCount, {
      alias: 'getJourneyCount',
      ...operationOptions
    });
};

/**
 * __useGetJourneyCountQuery__
 *
 * To run a query within a React component, call `useGetJourneyCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJourneyCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJourneyCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetJourneyCountQuery(baseOptions?: Apollo.QueryHookOptions<GetJourneyCountQuery, GetJourneyCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJourneyCountQuery, GetJourneyCountQueryVariables>(Operations.getJourneyCount, options);
      }
export function useGetJourneyCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJourneyCountQuery, GetJourneyCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJourneyCountQuery, GetJourneyCountQueryVariables>(Operations.getJourneyCount, options);
        }
export type GetJourneyCountQueryHookResult = ReturnType<typeof useGetJourneyCountQuery>;
export type GetJourneyCountLazyQueryHookResult = ReturnType<typeof useGetJourneyCountLazyQuery>;
export type GetJourneyCountQueryResult = ApolloReactCommon.QueryResult<GetJourneyCountQuery, GetJourneyCountQueryVariables>;
export function refetchGetJourneyCountQuery(variables?: GetJourneyCountQueryVariables) {
      return { query: Operations.getJourneyCount, variables: variables }
    }
export type GetJourneyTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetJourneyTagsQuery, GetJourneyTagsQueryVariables>
    } & TChildProps;
export function withGetJourneyTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetJourneyTagsQuery,
  GetJourneyTagsQueryVariables,
  GetJourneyTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetJourneyTagsQuery, GetJourneyTagsQueryVariables, GetJourneyTagsProps<TChildProps, TDataName>>(Operations.getJourneyTags, {
      alias: 'getJourneyTags',
      ...operationOptions
    });
};

/**
 * __useGetJourneyTagsQuery__
 *
 * To run a query within a React component, call `useGetJourneyTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJourneyTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJourneyTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJourneyTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetJourneyTagsQuery, GetJourneyTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJourneyTagsQuery, GetJourneyTagsQueryVariables>(Operations.getJourneyTags, options);
      }
export function useGetJourneyTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJourneyTagsQuery, GetJourneyTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJourneyTagsQuery, GetJourneyTagsQueryVariables>(Operations.getJourneyTags, options);
        }
export type GetJourneyTagsQueryHookResult = ReturnType<typeof useGetJourneyTagsQuery>;
export type GetJourneyTagsLazyQueryHookResult = ReturnType<typeof useGetJourneyTagsLazyQuery>;
export type GetJourneyTagsQueryResult = ApolloReactCommon.QueryResult<GetJourneyTagsQuery, GetJourneyTagsQueryVariables>;
export function refetchGetJourneyTagsQuery(variables?: GetJourneyTagsQueryVariables) {
      return { query: Operations.getJourneyTags, variables: variables }
    }
export type GetJourneysProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetJourneysQuery, GetJourneysQueryVariables>
    } & TChildProps;
export function withGetJourneys<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetJourneysQuery,
  GetJourneysQueryVariables,
  GetJourneysProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetJourneysQuery, GetJourneysQueryVariables, GetJourneysProps<TChildProps, TDataName>>(Operations.getJourneys, {
      alias: 'getJourneys',
      ...operationOptions
    });
};

/**
 * __useGetJourneysQuery__
 *
 * To run a query within a React component, call `useGetJourneysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJourneysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJourneysQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetJourneysQuery(baseOptions?: Apollo.QueryHookOptions<GetJourneysQuery, GetJourneysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJourneysQuery, GetJourneysQueryVariables>(Operations.getJourneys, options);
      }
export function useGetJourneysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJourneysQuery, GetJourneysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJourneysQuery, GetJourneysQueryVariables>(Operations.getJourneys, options);
        }
export type GetJourneysQueryHookResult = ReturnType<typeof useGetJourneysQuery>;
export type GetJourneysLazyQueryHookResult = ReturnType<typeof useGetJourneysLazyQuery>;
export type GetJourneysQueryResult = ApolloReactCommon.QueryResult<GetJourneysQuery, GetJourneysQueryVariables>;
export function refetchGetJourneysQuery(variables?: GetJourneysQueryVariables) {
      return { query: Operations.getJourneys, variables: variables }
    }
export type RemoveJourneyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveJourneyMutation, RemoveJourneyMutationVariables>
    } & TChildProps;
export function withRemoveJourney<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveJourneyMutation,
  RemoveJourneyMutationVariables,
  RemoveJourneyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveJourneyMutation, RemoveJourneyMutationVariables, RemoveJourneyProps<TChildProps, TDataName>>(Operations.removeJourney, {
      alias: 'removeJourney',
      ...operationOptions
    });
};

/**
 * __useRemoveJourneyMutation__
 *
 * To run a mutation, you first call `useRemoveJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeJourneyMutation, { data, loading, error }] = useRemoveJourneyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveJourneyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveJourneyMutation, RemoveJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveJourneyMutation, RemoveJourneyMutationVariables>(Operations.removeJourney, options);
      }
export type RemoveJourneyMutationHookResult = ReturnType<typeof useRemoveJourneyMutation>;
export type RemoveJourneyMutationResult = ApolloReactCommon.MutationResult<RemoveJourneyMutation>;
export type RemoveJourneyMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveJourneyMutation, RemoveJourneyMutationVariables>;
export type RemoveJourneyTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveJourneyTagMutation, RemoveJourneyTagMutationVariables>
    } & TChildProps;
export function withRemoveJourneyTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveJourneyTagMutation,
  RemoveJourneyTagMutationVariables,
  RemoveJourneyTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveJourneyTagMutation, RemoveJourneyTagMutationVariables, RemoveJourneyTagProps<TChildProps, TDataName>>(Operations.removeJourneyTag, {
      alias: 'removeJourneyTag',
      ...operationOptions
    });
};

/**
 * __useRemoveJourneyTagMutation__
 *
 * To run a mutation, you first call `useRemoveJourneyTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveJourneyTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeJourneyTagMutation, { data, loading, error }] = useRemoveJourneyTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveJourneyTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveJourneyTagMutation, RemoveJourneyTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveJourneyTagMutation, RemoveJourneyTagMutationVariables>(Operations.removeJourneyTag, options);
      }
export type RemoveJourneyTagMutationHookResult = ReturnType<typeof useRemoveJourneyTagMutation>;
export type RemoveJourneyTagMutationResult = ApolloReactCommon.MutationResult<RemoveJourneyTagMutation>;
export type RemoveJourneyTagMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveJourneyTagMutation, RemoveJourneyTagMutationVariables>;
export type UpdateJourneyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateJourneyMutation, UpdateJourneyMutationVariables>
    } & TChildProps;
export function withUpdateJourney<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateJourneyMutation,
  UpdateJourneyMutationVariables,
  UpdateJourneyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateJourneyMutation, UpdateJourneyMutationVariables, UpdateJourneyProps<TChildProps, TDataName>>(Operations.updateJourney, {
      alias: 'updateJourney',
      ...operationOptions
    });
};

/**
 * __useUpdateJourneyMutation__
 *
 * To run a mutation, you first call `useUpdateJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJourneyMutation, { data, loading, error }] = useUpdateJourneyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      journey: // value for 'journey'
 *   },
 * });
 */
export function useUpdateJourneyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJourneyMutation, UpdateJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJourneyMutation, UpdateJourneyMutationVariables>(Operations.updateJourney, options);
      }
export type UpdateJourneyMutationHookResult = ReturnType<typeof useUpdateJourneyMutation>;
export type UpdateJourneyMutationResult = ApolloReactCommon.MutationResult<UpdateJourneyMutation>;
export type UpdateJourneyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateJourneyMutation, UpdateJourneyMutationVariables>;
export type UpdateJourneyTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateJourneyTagMutation, UpdateJourneyTagMutationVariables>
    } & TChildProps;
export function withUpdateJourneyTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateJourneyTagMutation,
  UpdateJourneyTagMutationVariables,
  UpdateJourneyTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateJourneyTagMutation, UpdateJourneyTagMutationVariables, UpdateJourneyTagProps<TChildProps, TDataName>>(Operations.updateJourneyTag, {
      alias: 'updateJourneyTag',
      ...operationOptions
    });
};

/**
 * __useUpdateJourneyTagMutation__
 *
 * To run a mutation, you first call `useUpdateJourneyTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJourneyTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJourneyTagMutation, { data, loading, error }] = useUpdateJourneyTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useUpdateJourneyTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJourneyTagMutation, UpdateJourneyTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJourneyTagMutation, UpdateJourneyTagMutationVariables>(Operations.updateJourneyTag, options);
      }
export type UpdateJourneyTagMutationHookResult = ReturnType<typeof useUpdateJourneyTagMutation>;
export type UpdateJourneyTagMutationResult = ApolloReactCommon.MutationResult<UpdateJourneyTagMutation>;
export type UpdateJourneyTagMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateJourneyTagMutation, UpdateJourneyTagMutationVariables>;
export type LoginProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<LoginMutation, LoginMutationVariables>
    } & TChildProps;
export function withLogin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LoginMutation,
  LoginMutationVariables,
  LoginProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, LoginMutation, LoginMutationVariables, LoginProps<TChildProps, TDataName>>(Operations.login, {
      alias: 'login',
      ...operationOptions
    });
};

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(Operations.login, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = ApolloReactCommon.MutationResult<LoginMutation>;
export type LoginMutationOptions = ApolloReactCommon.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export type LogoutProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<LogoutMutation, LogoutMutationVariables>
    } & TChildProps;
export function withLogout<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LogoutMutation,
  LogoutMutationVariables,
  LogoutProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, LogoutMutation, LogoutMutationVariables, LogoutProps<TChildProps, TDataName>>(Operations.logout, {
      alias: 'logout',
      ...operationOptions
    });
};

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(Operations.logout, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = ApolloReactCommon.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export type GetOrdersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetOrdersQuery, GetOrdersQueryVariables>
    } & TChildProps;
export function withGetOrders<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOrdersQuery,
  GetOrdersQueryVariables,
  GetOrdersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetOrdersQuery, GetOrdersQueryVariables, GetOrdersProps<TChildProps, TDataName>>(Operations.getOrders, {
      alias: 'getOrders',
      ...operationOptions
    });
};

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(Operations.getOrders, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(Operations.getOrders, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersQueryResult = ApolloReactCommon.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export function refetchGetOrdersQuery(variables?: GetOrdersQueryVariables) {
      return { query: Operations.getOrders, variables: variables }
    }
export type GetOrdersCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetOrdersCountQuery, GetOrdersCountQueryVariables>
    } & TChildProps;
export function withGetOrdersCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOrdersCountQuery,
  GetOrdersCountQueryVariables,
  GetOrdersCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetOrdersCountQuery, GetOrdersCountQueryVariables, GetOrdersCountProps<TChildProps, TDataName>>(Operations.getOrdersCount, {
      alias: 'getOrdersCount',
      ...operationOptions
    });
};

/**
 * __useGetOrdersCountQuery__
 *
 * To run a query within a React component, call `useGetOrdersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrdersCountQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersCountQuery, GetOrdersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersCountQuery, GetOrdersCountQueryVariables>(Operations.getOrdersCount, options);
      }
export function useGetOrdersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersCountQuery, GetOrdersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersCountQuery, GetOrdersCountQueryVariables>(Operations.getOrdersCount, options);
        }
export type GetOrdersCountQueryHookResult = ReturnType<typeof useGetOrdersCountQuery>;
export type GetOrdersCountLazyQueryHookResult = ReturnType<typeof useGetOrdersCountLazyQuery>;
export type GetOrdersCountQueryResult = ApolloReactCommon.QueryResult<GetOrdersCountQuery, GetOrdersCountQueryVariables>;
export function refetchGetOrdersCountQuery(variables?: GetOrdersCountQueryVariables) {
      return { query: Operations.getOrdersCount, variables: variables }
    }
export type AddRoleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddRoleMutation, AddRoleMutationVariables>
    } & TChildProps;
export function withAddRole<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddRoleMutation,
  AddRoleMutationVariables,
  AddRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddRoleMutation, AddRoleMutationVariables, AddRoleProps<TChildProps, TDataName>>(Operations.addRole, {
      alias: 'addRole',
      ...operationOptions
    });
};

/**
 * __useAddRoleMutation__
 *
 * To run a mutation, you first call `useAddRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoleMutation, { data, loading, error }] = useAddRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useAddRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddRoleMutation, AddRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRoleMutation, AddRoleMutationVariables>(Operations.addRole, options);
      }
export type AddRoleMutationHookResult = ReturnType<typeof useAddRoleMutation>;
export type AddRoleMutationResult = ApolloReactCommon.MutationResult<AddRoleMutation>;
export type AddRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<AddRoleMutation, AddRoleMutationVariables>;
export type GetApplicationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetApplicationsQuery, GetApplicationsQueryVariables>
    } & TChildProps;
export function withGetApplications<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetApplicationsQuery,
  GetApplicationsQueryVariables,
  GetApplicationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetApplicationsQuery, GetApplicationsQueryVariables, GetApplicationsProps<TChildProps, TDataName>>(Operations.getApplications, {
      alias: 'getApplications',
      ...operationOptions
    });
};

/**
 * __useGetApplicationsQuery__
 *
 * To run a query within a React component, call `useGetApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(Operations.getApplications, options);
      }
export function useGetApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(Operations.getApplications, options);
        }
export type GetApplicationsQueryHookResult = ReturnType<typeof useGetApplicationsQuery>;
export type GetApplicationsLazyQueryHookResult = ReturnType<typeof useGetApplicationsLazyQuery>;
export type GetApplicationsQueryResult = ApolloReactCommon.QueryResult<GetApplicationsQuery, GetApplicationsQueryVariables>;
export function refetchGetApplicationsQuery(variables?: GetApplicationsQueryVariables) {
      return { query: Operations.getApplications, variables: variables }
    }
export type GetProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProjectsQuery, GetProjectsQueryVariables>
    } & TChildProps;
export function withGetProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProjectsQuery,
  GetProjectsQueryVariables,
  GetProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProjectsQuery, GetProjectsQueryVariables, GetProjectsProps<TChildProps, TDataName>>(Operations.getProjects, {
      alias: 'getProjects',
      ...operationOptions
    });
};

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsQuery, GetProjectsQueryVariables>(Operations.getProjects, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsQuery, GetProjectsQueryVariables>(Operations.getProjects, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsQueryResult = ApolloReactCommon.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export function refetchGetProjectsQuery(variables?: GetProjectsQueryVariables) {
      return { query: Operations.getProjects, variables: variables }
    }
export type RemoveRoleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveRoleMutation, RemoveRoleMutationVariables>
    } & TChildProps;
export function withRemoveRole<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveRoleMutation,
  RemoveRoleMutationVariables,
  RemoveRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveRoleMutation, RemoveRoleMutationVariables, RemoveRoleProps<TChildProps, TDataName>>(Operations.removeRole, {
      alias: 'removeRole',
      ...operationOptions
    });
};

/**
 * __useRemoveRoleMutation__
 *
 * To run a mutation, you first call `useRemoveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoleMutation, { data, loading, error }] = useRemoveRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      applicationId: // value for 'applicationId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRemoveRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRoleMutation, RemoveRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRoleMutation, RemoveRoleMutationVariables>(Operations.removeRole, options);
      }
export type RemoveRoleMutationHookResult = ReturnType<typeof useRemoveRoleMutation>;
export type RemoveRoleMutationResult = ApolloReactCommon.MutationResult<RemoveRoleMutation>;
export type RemoveRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveRoleMutation, RemoveRoleMutationVariables>;
export type UpdateRoleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>
    } & TChildProps;
export function withUpdateRole<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateRoleMutation,
  UpdateRoleMutationVariables,
  UpdateRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateRoleMutation, UpdateRoleMutationVariables, UpdateRoleProps<TChildProps, TDataName>>(Operations.updateRole, {
      alias: 'updateRole',
      ...operationOptions
    });
};

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(Operations.updateRole, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = ApolloReactCommon.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export type CreateProjectConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateProjectConfigMutation, CreateProjectConfigMutationVariables>
    } & TChildProps;
export function withCreateProjectConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateProjectConfigMutation,
  CreateProjectConfigMutationVariables,
  CreateProjectConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateProjectConfigMutation, CreateProjectConfigMutationVariables, CreateProjectConfigProps<TChildProps, TDataName>>(Operations.createProjectConfig, {
      alias: 'createProjectConfig',
      ...operationOptions
    });
};

/**
 * __useCreateProjectConfigMutation__
 *
 * To run a mutation, you first call `useCreateProjectConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectConfigMutation, { data, loading, error }] = useCreateProjectConfigMutation({
 *   variables: {
 *      place: // value for 'place'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProjectConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectConfigMutation, CreateProjectConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectConfigMutation, CreateProjectConfigMutationVariables>(Operations.createProjectConfig, options);
      }
export type CreateProjectConfigMutationHookResult = ReturnType<typeof useCreateProjectConfigMutation>;
export type CreateProjectConfigMutationResult = ApolloReactCommon.MutationResult<CreateProjectConfigMutation>;
export type CreateProjectConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProjectConfigMutation, CreateProjectConfigMutationVariables>;
export type DeleteProjectConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteProjectConfigMutation, DeleteProjectConfigMutationVariables>
    } & TChildProps;
export function withDeleteProjectConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteProjectConfigMutation,
  DeleteProjectConfigMutationVariables,
  DeleteProjectConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteProjectConfigMutation, DeleteProjectConfigMutationVariables, DeleteProjectConfigProps<TChildProps, TDataName>>(Operations.deleteProjectConfig, {
      alias: 'deleteProjectConfig',
      ...operationOptions
    });
};

/**
 * __useDeleteProjectConfigMutation__
 *
 * To run a mutation, you first call `useDeleteProjectConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectConfigMutation, { data, loading, error }] = useDeleteProjectConfigMutation({
 *   variables: {
 *      configId: // value for 'configId'
 *   },
 * });
 */
export function useDeleteProjectConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectConfigMutation, DeleteProjectConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectConfigMutation, DeleteProjectConfigMutationVariables>(Operations.deleteProjectConfig, options);
      }
export type DeleteProjectConfigMutationHookResult = ReturnType<typeof useDeleteProjectConfigMutation>;
export type DeleteProjectConfigMutationResult = ApolloReactCommon.MutationResult<DeleteProjectConfigMutation>;
export type DeleteProjectConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProjectConfigMutation, DeleteProjectConfigMutationVariables>;
export type GetProjectConfigsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProjectConfigsQuery, GetProjectConfigsQueryVariables>
    } & TChildProps;
export function withGetProjectConfigs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProjectConfigsQuery,
  GetProjectConfigsQueryVariables,
  GetProjectConfigsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProjectConfigsQuery, GetProjectConfigsQueryVariables, GetProjectConfigsProps<TChildProps, TDataName>>(Operations.getProjectConfigs, {
      alias: 'getProjectConfigs',
      ...operationOptions
    });
};

/**
 * __useGetProjectConfigsQuery__
 *
 * To run a query within a React component, call `useGetProjectConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectConfigsQuery({
 *   variables: {
 *      places: // value for 'places'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetProjectConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectConfigsQuery, GetProjectConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectConfigsQuery, GetProjectConfigsQueryVariables>(Operations.getProjectConfigs, options);
      }
export function useGetProjectConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectConfigsQuery, GetProjectConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectConfigsQuery, GetProjectConfigsQueryVariables>(Operations.getProjectConfigs, options);
        }
export type GetProjectConfigsQueryHookResult = ReturnType<typeof useGetProjectConfigsQuery>;
export type GetProjectConfigsLazyQueryHookResult = ReturnType<typeof useGetProjectConfigsLazyQuery>;
export type GetProjectConfigsQueryResult = ApolloReactCommon.QueryResult<GetProjectConfigsQuery, GetProjectConfigsQueryVariables>;
export function refetchGetProjectConfigsQuery(variables?: GetProjectConfigsQueryVariables) {
      return { query: Operations.getProjectConfigs, variables: variables }
    }
export type UpdateProjectConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateProjectConfigMutation, UpdateProjectConfigMutationVariables>
    } & TChildProps;
export function withUpdateProjectConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateProjectConfigMutation,
  UpdateProjectConfigMutationVariables,
  UpdateProjectConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateProjectConfigMutation, UpdateProjectConfigMutationVariables, UpdateProjectConfigProps<TChildProps, TDataName>>(Operations.updateProjectConfig, {
      alias: 'updateProjectConfig',
      ...operationOptions
    });
};

/**
 * __useUpdateProjectConfigMutation__
 *
 * To run a mutation, you first call `useUpdateProjectConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectConfigMutation, { data, loading, error }] = useUpdateProjectConfigMutation({
 *   variables: {
 *      configId: // value for 'configId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProjectConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectConfigMutation, UpdateProjectConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectConfigMutation, UpdateProjectConfigMutationVariables>(Operations.updateProjectConfig, options);
      }
export type UpdateProjectConfigMutationHookResult = ReturnType<typeof useUpdateProjectConfigMutation>;
export type UpdateProjectConfigMutationResult = ApolloReactCommon.MutationResult<UpdateProjectConfigMutation>;
export type UpdateProjectConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectConfigMutation, UpdateProjectConfigMutationVariables>;
export type UnlinkProviderProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UnlinkProviderMutation, UnlinkProviderMutationVariables>
    } & TChildProps;
export function withUnlinkProvider<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnlinkProviderMutation,
  UnlinkProviderMutationVariables,
  UnlinkProviderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UnlinkProviderMutation, UnlinkProviderMutationVariables, UnlinkProviderProps<TChildProps, TDataName>>(Operations.unlinkProvider, {
      alias: 'unlinkProvider',
      ...operationOptions
    });
};

/**
 * __useUnlinkProviderMutation__
 *
 * To run a mutation, you first call `useUnlinkProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkProviderMutation, { data, loading, error }] = useUnlinkProviderMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useUnlinkProviderMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkProviderMutation, UnlinkProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkProviderMutation, UnlinkProviderMutationVariables>(Operations.unlinkProvider, options);
      }
export type UnlinkProviderMutationHookResult = ReturnType<typeof useUnlinkProviderMutation>;
export type UnlinkProviderMutationResult = ApolloReactCommon.MutationResult<UnlinkProviderMutation>;
export type UnlinkProviderMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlinkProviderMutation, UnlinkProviderMutationVariables>;
export type RegenerateConfirmCodeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RegenerateConfirmCodeMutation, RegenerateConfirmCodeMutationVariables>
    } & TChildProps;
export function withRegenerateConfirmCode<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegenerateConfirmCodeMutation,
  RegenerateConfirmCodeMutationVariables,
  RegenerateConfirmCodeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RegenerateConfirmCodeMutation, RegenerateConfirmCodeMutationVariables, RegenerateConfirmCodeProps<TChildProps, TDataName>>(Operations.regenerateConfirmCode, {
      alias: 'regenerateConfirmCode',
      ...operationOptions
    });
};

/**
 * __useRegenerateConfirmCodeMutation__
 *
 * To run a mutation, you first call `useRegenerateConfirmCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateConfirmCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateConfirmCodeMutation, { data, loading, error }] = useRegenerateConfirmCodeMutation({
 *   variables: {
 *      confirmCodeChallengeId: // value for 'confirmCodeChallengeId'
 *   },
 * });
 */
export function useRegenerateConfirmCodeMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateConfirmCodeMutation, RegenerateConfirmCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateConfirmCodeMutation, RegenerateConfirmCodeMutationVariables>(Operations.regenerateConfirmCode, options);
      }
export type RegenerateConfirmCodeMutationHookResult = ReturnType<typeof useRegenerateConfirmCodeMutation>;
export type RegenerateConfirmCodeMutationResult = ApolloReactCommon.MutationResult<RegenerateConfirmCodeMutation>;
export type RegenerateConfirmCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<RegenerateConfirmCodeMutation, RegenerateConfirmCodeMutationVariables>;
export type GetSessionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSessionQuery, GetSessionQueryVariables>
    } & TChildProps;
export function withGetSession<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSessionQuery,
  GetSessionQueryVariables,
  GetSessionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSessionQuery, GetSessionQueryVariables, GetSessionProps<TChildProps, TDataName>>(Operations.getSession, {
      alias: 'getSession',
      ...operationOptions
    });
};

/**
 * __useGetSessionQuery__
 *
 * To run a query within a React component, call `useGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionQuery, GetSessionQueryVariables>(Operations.getSession, options);
      }
export function useGetSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionQuery, GetSessionQueryVariables>(Operations.getSession, options);
        }
export type GetSessionQueryHookResult = ReturnType<typeof useGetSessionQuery>;
export type GetSessionLazyQueryHookResult = ReturnType<typeof useGetSessionLazyQuery>;
export type GetSessionQueryResult = ApolloReactCommon.QueryResult<GetSessionQuery, GetSessionQueryVariables>;
export function refetchGetSessionQuery(variables?: GetSessionQueryVariables) {
      return { query: Operations.getSession, variables: variables }
    }
export type AddSocialFilterWordProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddSocialFilterWordMutation, AddSocialFilterWordMutationVariables>
    } & TChildProps;
export function withAddSocialFilterWord<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddSocialFilterWordMutation,
  AddSocialFilterWordMutationVariables,
  AddSocialFilterWordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddSocialFilterWordMutation, AddSocialFilterWordMutationVariables, AddSocialFilterWordProps<TChildProps, TDataName>>(Operations.addSocialFilterWord, {
      alias: 'addSocialFilterWord',
      ...operationOptions
    });
};

/**
 * __useAddSocialFilterWordMutation__
 *
 * To run a mutation, you first call `useAddSocialFilterWordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSocialFilterWordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSocialFilterWordMutation, { data, loading, error }] = useAddSocialFilterWordMutation({
 *   variables: {
 *      word: // value for 'word'
 *   },
 * });
 */
export function useAddSocialFilterWordMutation(baseOptions?: Apollo.MutationHookOptions<AddSocialFilterWordMutation, AddSocialFilterWordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSocialFilterWordMutation, AddSocialFilterWordMutationVariables>(Operations.addSocialFilterWord, options);
      }
export type AddSocialFilterWordMutationHookResult = ReturnType<typeof useAddSocialFilterWordMutation>;
export type AddSocialFilterWordMutationResult = ApolloReactCommon.MutationResult<AddSocialFilterWordMutation>;
export type AddSocialFilterWordMutationOptions = ApolloReactCommon.BaseMutationOptions<AddSocialFilterWordMutation, AddSocialFilterWordMutationVariables>;
export type AddSocialTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddSocialTagMutation, AddSocialTagMutationVariables>
    } & TChildProps;
export function withAddSocialTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddSocialTagMutation,
  AddSocialTagMutationVariables,
  AddSocialTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddSocialTagMutation, AddSocialTagMutationVariables, AddSocialTagProps<TChildProps, TDataName>>(Operations.addSocialTag, {
      alias: 'addSocialTag',
      ...operationOptions
    });
};

/**
 * __useAddSocialTagMutation__
 *
 * To run a mutation, you first call `useAddSocialTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSocialTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSocialTagMutation, { data, loading, error }] = useAddSocialTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useAddSocialTagMutation(baseOptions?: Apollo.MutationHookOptions<AddSocialTagMutation, AddSocialTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSocialTagMutation, AddSocialTagMutationVariables>(Operations.addSocialTag, options);
      }
export type AddSocialTagMutationHookResult = ReturnType<typeof useAddSocialTagMutation>;
export type AddSocialTagMutationResult = ApolloReactCommon.MutationResult<AddSocialTagMutation>;
export type AddSocialTagMutationOptions = ApolloReactCommon.BaseMutationOptions<AddSocialTagMutation, AddSocialTagMutationVariables>;
export type ChangeVisibleInstagramFeedProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ChangeVisibleInstagramFeedMutation, ChangeVisibleInstagramFeedMutationVariables>
    } & TChildProps;
export function withChangeVisibleInstagramFeed<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ChangeVisibleInstagramFeedMutation,
  ChangeVisibleInstagramFeedMutationVariables,
  ChangeVisibleInstagramFeedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ChangeVisibleInstagramFeedMutation, ChangeVisibleInstagramFeedMutationVariables, ChangeVisibleInstagramFeedProps<TChildProps, TDataName>>(Operations.changeVisibleInstagramFeed, {
      alias: 'changeVisibleInstagramFeed',
      ...operationOptions
    });
};

/**
 * __useChangeVisibleInstagramFeedMutation__
 *
 * To run a mutation, you first call `useChangeVisibleInstagramFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeVisibleInstagramFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeVisibleInstagramFeedMutation, { data, loading, error }] = useChangeVisibleInstagramFeedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visible: // value for 'visible'
 *   },
 * });
 */
export function useChangeVisibleInstagramFeedMutation(baseOptions?: Apollo.MutationHookOptions<ChangeVisibleInstagramFeedMutation, ChangeVisibleInstagramFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeVisibleInstagramFeedMutation, ChangeVisibleInstagramFeedMutationVariables>(Operations.changeVisibleInstagramFeed, options);
      }
export type ChangeVisibleInstagramFeedMutationHookResult = ReturnType<typeof useChangeVisibleInstagramFeedMutation>;
export type ChangeVisibleInstagramFeedMutationResult = ApolloReactCommon.MutationResult<ChangeVisibleInstagramFeedMutation>;
export type ChangeVisibleInstagramFeedMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeVisibleInstagramFeedMutation, ChangeVisibleInstagramFeedMutationVariables>;
export type ChangeVisibleTwitterFeedProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ChangeVisibleTwitterFeedMutation, ChangeVisibleTwitterFeedMutationVariables>
    } & TChildProps;
export function withChangeVisibleTwitterFeed<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ChangeVisibleTwitterFeedMutation,
  ChangeVisibleTwitterFeedMutationVariables,
  ChangeVisibleTwitterFeedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ChangeVisibleTwitterFeedMutation, ChangeVisibleTwitterFeedMutationVariables, ChangeVisibleTwitterFeedProps<TChildProps, TDataName>>(Operations.changeVisibleTwitterFeed, {
      alias: 'changeVisibleTwitterFeed',
      ...operationOptions
    });
};

/**
 * __useChangeVisibleTwitterFeedMutation__
 *
 * To run a mutation, you first call `useChangeVisibleTwitterFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeVisibleTwitterFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeVisibleTwitterFeedMutation, { data, loading, error }] = useChangeVisibleTwitterFeedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visible: // value for 'visible'
 *   },
 * });
 */
export function useChangeVisibleTwitterFeedMutation(baseOptions?: Apollo.MutationHookOptions<ChangeVisibleTwitterFeedMutation, ChangeVisibleTwitterFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeVisibleTwitterFeedMutation, ChangeVisibleTwitterFeedMutationVariables>(Operations.changeVisibleTwitterFeed, options);
      }
export type ChangeVisibleTwitterFeedMutationHookResult = ReturnType<typeof useChangeVisibleTwitterFeedMutation>;
export type ChangeVisibleTwitterFeedMutationResult = ApolloReactCommon.MutationResult<ChangeVisibleTwitterFeedMutation>;
export type ChangeVisibleTwitterFeedMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeVisibleTwitterFeedMutation, ChangeVisibleTwitterFeedMutationVariables>;
export type GetInstagramFeedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInstagramFeedQuery, GetInstagramFeedQueryVariables>
    } & TChildProps;
export function withGetInstagramFeed<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInstagramFeedQuery,
  GetInstagramFeedQueryVariables,
  GetInstagramFeedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInstagramFeedQuery, GetInstagramFeedQueryVariables, GetInstagramFeedProps<TChildProps, TDataName>>(Operations.getInstagramFeed, {
      alias: 'getInstagramFeed',
      ...operationOptions
    });
};

/**
 * __useGetInstagramFeedQuery__
 *
 * To run a query within a React component, call `useGetInstagramFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstagramFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstagramFeedQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetInstagramFeedQuery(baseOptions?: Apollo.QueryHookOptions<GetInstagramFeedQuery, GetInstagramFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstagramFeedQuery, GetInstagramFeedQueryVariables>(Operations.getInstagramFeed, options);
      }
export function useGetInstagramFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstagramFeedQuery, GetInstagramFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstagramFeedQuery, GetInstagramFeedQueryVariables>(Operations.getInstagramFeed, options);
        }
export type GetInstagramFeedQueryHookResult = ReturnType<typeof useGetInstagramFeedQuery>;
export type GetInstagramFeedLazyQueryHookResult = ReturnType<typeof useGetInstagramFeedLazyQuery>;
export type GetInstagramFeedQueryResult = ApolloReactCommon.QueryResult<GetInstagramFeedQuery, GetInstagramFeedQueryVariables>;
export function refetchGetInstagramFeedQuery(variables?: GetInstagramFeedQueryVariables) {
      return { query: Operations.getInstagramFeed, variables: variables }
    }
export type GetInstagramFeedCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInstagramFeedCountQuery, GetInstagramFeedCountQueryVariables>
    } & TChildProps;
export function withGetInstagramFeedCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInstagramFeedCountQuery,
  GetInstagramFeedCountQueryVariables,
  GetInstagramFeedCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInstagramFeedCountQuery, GetInstagramFeedCountQueryVariables, GetInstagramFeedCountProps<TChildProps, TDataName>>(Operations.getInstagramFeedCount, {
      alias: 'getInstagramFeedCount',
      ...operationOptions
    });
};

/**
 * __useGetInstagramFeedCountQuery__
 *
 * To run a query within a React component, call `useGetInstagramFeedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstagramFeedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstagramFeedCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetInstagramFeedCountQuery(baseOptions?: Apollo.QueryHookOptions<GetInstagramFeedCountQuery, GetInstagramFeedCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstagramFeedCountQuery, GetInstagramFeedCountQueryVariables>(Operations.getInstagramFeedCount, options);
      }
export function useGetInstagramFeedCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstagramFeedCountQuery, GetInstagramFeedCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstagramFeedCountQuery, GetInstagramFeedCountQueryVariables>(Operations.getInstagramFeedCount, options);
        }
export type GetInstagramFeedCountQueryHookResult = ReturnType<typeof useGetInstagramFeedCountQuery>;
export type GetInstagramFeedCountLazyQueryHookResult = ReturnType<typeof useGetInstagramFeedCountLazyQuery>;
export type GetInstagramFeedCountQueryResult = ApolloReactCommon.QueryResult<GetInstagramFeedCountQuery, GetInstagramFeedCountQueryVariables>;
export function refetchGetInstagramFeedCountQuery(variables?: GetInstagramFeedCountQueryVariables) {
      return { query: Operations.getInstagramFeedCount, variables: variables }
    }
export type GetSocialFilterWordsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSocialFilterWordsQuery, GetSocialFilterWordsQueryVariables>
    } & TChildProps;
export function withGetSocialFilterWords<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSocialFilterWordsQuery,
  GetSocialFilterWordsQueryVariables,
  GetSocialFilterWordsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSocialFilterWordsQuery, GetSocialFilterWordsQueryVariables, GetSocialFilterWordsProps<TChildProps, TDataName>>(Operations.getSocialFilterWords, {
      alias: 'getSocialFilterWords',
      ...operationOptions
    });
};

/**
 * __useGetSocialFilterWordsQuery__
 *
 * To run a query within a React component, call `useGetSocialFilterWordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialFilterWordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialFilterWordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSocialFilterWordsQuery(baseOptions?: Apollo.QueryHookOptions<GetSocialFilterWordsQuery, GetSocialFilterWordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialFilterWordsQuery, GetSocialFilterWordsQueryVariables>(Operations.getSocialFilterWords, options);
      }
export function useGetSocialFilterWordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialFilterWordsQuery, GetSocialFilterWordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialFilterWordsQuery, GetSocialFilterWordsQueryVariables>(Operations.getSocialFilterWords, options);
        }
export type GetSocialFilterWordsQueryHookResult = ReturnType<typeof useGetSocialFilterWordsQuery>;
export type GetSocialFilterWordsLazyQueryHookResult = ReturnType<typeof useGetSocialFilterWordsLazyQuery>;
export type GetSocialFilterWordsQueryResult = ApolloReactCommon.QueryResult<GetSocialFilterWordsQuery, GetSocialFilterWordsQueryVariables>;
export function refetchGetSocialFilterWordsQuery(variables?: GetSocialFilterWordsQueryVariables) {
      return { query: Operations.getSocialFilterWords, variables: variables }
    }
export type GetSocialTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSocialTagsQuery, GetSocialTagsQueryVariables>
    } & TChildProps;
export function withGetSocialTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSocialTagsQuery,
  GetSocialTagsQueryVariables,
  GetSocialTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSocialTagsQuery, GetSocialTagsQueryVariables, GetSocialTagsProps<TChildProps, TDataName>>(Operations.getSocialTags, {
      alias: 'getSocialTags',
      ...operationOptions
    });
};

/**
 * __useGetSocialTagsQuery__
 *
 * To run a query within a React component, call `useGetSocialTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSocialTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetSocialTagsQuery, GetSocialTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialTagsQuery, GetSocialTagsQueryVariables>(Operations.getSocialTags, options);
      }
export function useGetSocialTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialTagsQuery, GetSocialTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialTagsQuery, GetSocialTagsQueryVariables>(Operations.getSocialTags, options);
        }
export type GetSocialTagsQueryHookResult = ReturnType<typeof useGetSocialTagsQuery>;
export type GetSocialTagsLazyQueryHookResult = ReturnType<typeof useGetSocialTagsLazyQuery>;
export type GetSocialTagsQueryResult = ApolloReactCommon.QueryResult<GetSocialTagsQuery, GetSocialTagsQueryVariables>;
export function refetchGetSocialTagsQuery(variables?: GetSocialTagsQueryVariables) {
      return { query: Operations.getSocialTags, variables: variables }
    }
export type GetTwitterFeedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTwitterFeedQuery, GetTwitterFeedQueryVariables>
    } & TChildProps;
export function withGetTwitterFeed<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTwitterFeedQuery,
  GetTwitterFeedQueryVariables,
  GetTwitterFeedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTwitterFeedQuery, GetTwitterFeedQueryVariables, GetTwitterFeedProps<TChildProps, TDataName>>(Operations.getTwitterFeed, {
      alias: 'getTwitterFeed',
      ...operationOptions
    });
};

/**
 * __useGetTwitterFeedQuery__
 *
 * To run a query within a React component, call `useGetTwitterFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwitterFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwitterFeedQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetTwitterFeedQuery(baseOptions?: Apollo.QueryHookOptions<GetTwitterFeedQuery, GetTwitterFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwitterFeedQuery, GetTwitterFeedQueryVariables>(Operations.getTwitterFeed, options);
      }
export function useGetTwitterFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwitterFeedQuery, GetTwitterFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwitterFeedQuery, GetTwitterFeedQueryVariables>(Operations.getTwitterFeed, options);
        }
export type GetTwitterFeedQueryHookResult = ReturnType<typeof useGetTwitterFeedQuery>;
export type GetTwitterFeedLazyQueryHookResult = ReturnType<typeof useGetTwitterFeedLazyQuery>;
export type GetTwitterFeedQueryResult = ApolloReactCommon.QueryResult<GetTwitterFeedQuery, GetTwitterFeedQueryVariables>;
export function refetchGetTwitterFeedQuery(variables?: GetTwitterFeedQueryVariables) {
      return { query: Operations.getTwitterFeed, variables: variables }
    }
export type GetTwitterFeedCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTwitterFeedCountQuery, GetTwitterFeedCountQueryVariables>
    } & TChildProps;
export function withGetTwitterFeedCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTwitterFeedCountQuery,
  GetTwitterFeedCountQueryVariables,
  GetTwitterFeedCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTwitterFeedCountQuery, GetTwitterFeedCountQueryVariables, GetTwitterFeedCountProps<TChildProps, TDataName>>(Operations.getTwitterFeedCount, {
      alias: 'getTwitterFeedCount',
      ...operationOptions
    });
};

/**
 * __useGetTwitterFeedCountQuery__
 *
 * To run a query within a React component, call `useGetTwitterFeedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwitterFeedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwitterFeedCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTwitterFeedCountQuery(baseOptions?: Apollo.QueryHookOptions<GetTwitterFeedCountQuery, GetTwitterFeedCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwitterFeedCountQuery, GetTwitterFeedCountQueryVariables>(Operations.getTwitterFeedCount, options);
      }
export function useGetTwitterFeedCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwitterFeedCountQuery, GetTwitterFeedCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwitterFeedCountQuery, GetTwitterFeedCountQueryVariables>(Operations.getTwitterFeedCount, options);
        }
export type GetTwitterFeedCountQueryHookResult = ReturnType<typeof useGetTwitterFeedCountQuery>;
export type GetTwitterFeedCountLazyQueryHookResult = ReturnType<typeof useGetTwitterFeedCountLazyQuery>;
export type GetTwitterFeedCountQueryResult = ApolloReactCommon.QueryResult<GetTwitterFeedCountQuery, GetTwitterFeedCountQueryVariables>;
export function refetchGetTwitterFeedCountQuery(variables?: GetTwitterFeedCountQueryVariables) {
      return { query: Operations.getTwitterFeedCount, variables: variables }
    }
export type RemoveSocialFilterWordProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveSocialFilterWordMutation, RemoveSocialFilterWordMutationVariables>
    } & TChildProps;
export function withRemoveSocialFilterWord<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveSocialFilterWordMutation,
  RemoveSocialFilterWordMutationVariables,
  RemoveSocialFilterWordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveSocialFilterWordMutation, RemoveSocialFilterWordMutationVariables, RemoveSocialFilterWordProps<TChildProps, TDataName>>(Operations.removeSocialFilterWord, {
      alias: 'removeSocialFilterWord',
      ...operationOptions
    });
};

/**
 * __useRemoveSocialFilterWordMutation__
 *
 * To run a mutation, you first call `useRemoveSocialFilterWordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSocialFilterWordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSocialFilterWordMutation, { data, loading, error }] = useRemoveSocialFilterWordMutation({
 *   variables: {
 *      word: // value for 'word'
 *   },
 * });
 */
export function useRemoveSocialFilterWordMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSocialFilterWordMutation, RemoveSocialFilterWordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSocialFilterWordMutation, RemoveSocialFilterWordMutationVariables>(Operations.removeSocialFilterWord, options);
      }
export type RemoveSocialFilterWordMutationHookResult = ReturnType<typeof useRemoveSocialFilterWordMutation>;
export type RemoveSocialFilterWordMutationResult = ApolloReactCommon.MutationResult<RemoveSocialFilterWordMutation>;
export type RemoveSocialFilterWordMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveSocialFilterWordMutation, RemoveSocialFilterWordMutationVariables>;
export type RemoveSocialTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveSocialTagMutation, RemoveSocialTagMutationVariables>
    } & TChildProps;
export function withRemoveSocialTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveSocialTagMutation,
  RemoveSocialTagMutationVariables,
  RemoveSocialTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveSocialTagMutation, RemoveSocialTagMutationVariables, RemoveSocialTagProps<TChildProps, TDataName>>(Operations.removeSocialTag, {
      alias: 'removeSocialTag',
      ...operationOptions
    });
};

/**
 * __useRemoveSocialTagMutation__
 *
 * To run a mutation, you first call `useRemoveSocialTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSocialTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSocialTagMutation, { data, loading, error }] = useRemoveSocialTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useRemoveSocialTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSocialTagMutation, RemoveSocialTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSocialTagMutation, RemoveSocialTagMutationVariables>(Operations.removeSocialTag, options);
      }
export type RemoveSocialTagMutationHookResult = ReturnType<typeof useRemoveSocialTagMutation>;
export type RemoveSocialTagMutationResult = ApolloReactCommon.MutationResult<RemoveSocialTagMutation>;
export type RemoveSocialTagMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveSocialTagMutation, RemoveSocialTagMutationVariables>;
export type UpdateSocialFilterWordProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateSocialFilterWordMutation, UpdateSocialFilterWordMutationVariables>
    } & TChildProps;
export function withUpdateSocialFilterWord<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSocialFilterWordMutation,
  UpdateSocialFilterWordMutationVariables,
  UpdateSocialFilterWordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSocialFilterWordMutation, UpdateSocialFilterWordMutationVariables, UpdateSocialFilterWordProps<TChildProps, TDataName>>(Operations.updateSocialFilterWord, {
      alias: 'updateSocialFilterWord',
      ...operationOptions
    });
};

/**
 * __useUpdateSocialFilterWordMutation__
 *
 * To run a mutation, you first call `useUpdateSocialFilterWordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialFilterWordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialFilterWordMutation, { data, loading, error }] = useUpdateSocialFilterWordMutation({
 *   variables: {
 *      oldWord: // value for 'oldWord'
 *      newWord: // value for 'newWord'
 *   },
 * });
 */
export function useUpdateSocialFilterWordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialFilterWordMutation, UpdateSocialFilterWordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialFilterWordMutation, UpdateSocialFilterWordMutationVariables>(Operations.updateSocialFilterWord, options);
      }
export type UpdateSocialFilterWordMutationHookResult = ReturnType<typeof useUpdateSocialFilterWordMutation>;
export type UpdateSocialFilterWordMutationResult = ApolloReactCommon.MutationResult<UpdateSocialFilterWordMutation>;
export type UpdateSocialFilterWordMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSocialFilterWordMutation, UpdateSocialFilterWordMutationVariables>;
export type UpdateSocialTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateSocialTagMutation, UpdateSocialTagMutationVariables>
    } & TChildProps;
export function withUpdateSocialTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSocialTagMutation,
  UpdateSocialTagMutationVariables,
  UpdateSocialTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSocialTagMutation, UpdateSocialTagMutationVariables, UpdateSocialTagProps<TChildProps, TDataName>>(Operations.updateSocialTag, {
      alias: 'updateSocialTag',
      ...operationOptions
    });
};

/**
 * __useUpdateSocialTagMutation__
 *
 * To run a mutation, you first call `useUpdateSocialTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialTagMutation, { data, loading, error }] = useUpdateSocialTagMutation({
 *   variables: {
 *      oldTag: // value for 'oldTag'
 *      newTag: // value for 'newTag'
 *   },
 * });
 */
export function useUpdateSocialTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialTagMutation, UpdateSocialTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialTagMutation, UpdateSocialTagMutationVariables>(Operations.updateSocialTag, options);
      }
export type UpdateSocialTagMutationHookResult = ReturnType<typeof useUpdateSocialTagMutation>;
export type UpdateSocialTagMutationResult = ApolloReactCommon.MutationResult<UpdateSocialTagMutation>;
export type UpdateSocialTagMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSocialTagMutation, UpdateSocialTagMutationVariables>;
export type AddTranslationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddTranslationMutation, AddTranslationMutationVariables>
    } & TChildProps;
export function withAddTranslation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddTranslationMutation,
  AddTranslationMutationVariables,
  AddTranslationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddTranslationMutation, AddTranslationMutationVariables, AddTranslationProps<TChildProps, TDataName>>(Operations.addTranslation, {
      alias: 'addTranslation',
      ...operationOptions
    });
};

/**
 * __useAddTranslationMutation__
 *
 * To run a mutation, you first call `useAddTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTranslationMutation, { data, loading, error }] = useAddTranslationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      key: // value for 'key'
 *      translations: // value for 'translations'
 *   },
 * });
 */
export function useAddTranslationMutation(baseOptions?: Apollo.MutationHookOptions<AddTranslationMutation, AddTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTranslationMutation, AddTranslationMutationVariables>(Operations.addTranslation, options);
      }
export type AddTranslationMutationHookResult = ReturnType<typeof useAddTranslationMutation>;
export type AddTranslationMutationResult = ApolloReactCommon.MutationResult<AddTranslationMutation>;
export type AddTranslationMutationOptions = ApolloReactCommon.BaseMutationOptions<AddTranslationMutation, AddTranslationMutationVariables>;
export type GetTranslationCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTranslationCountQuery, GetTranslationCountQueryVariables>
    } & TChildProps;
export function withGetTranslationCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTranslationCountQuery,
  GetTranslationCountQueryVariables,
  GetTranslationCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTranslationCountQuery, GetTranslationCountQueryVariables, GetTranslationCountProps<TChildProps, TDataName>>(Operations.getTranslationCount, {
      alias: 'getTranslationCount',
      ...operationOptions
    });
};

/**
 * __useGetTranslationCountQuery__
 *
 * To run a query within a React component, call `useGetTranslationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTranslationCountQuery(baseOptions: Apollo.QueryHookOptions<GetTranslationCountQuery, GetTranslationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationCountQuery, GetTranslationCountQueryVariables>(Operations.getTranslationCount, options);
      }
export function useGetTranslationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationCountQuery, GetTranslationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationCountQuery, GetTranslationCountQueryVariables>(Operations.getTranslationCount, options);
        }
export type GetTranslationCountQueryHookResult = ReturnType<typeof useGetTranslationCountQuery>;
export type GetTranslationCountLazyQueryHookResult = ReturnType<typeof useGetTranslationCountLazyQuery>;
export type GetTranslationCountQueryResult = ApolloReactCommon.QueryResult<GetTranslationCountQuery, GetTranslationCountQueryVariables>;
export function refetchGetTranslationCountQuery(variables: GetTranslationCountQueryVariables) {
      return { query: Operations.getTranslationCount, variables: variables }
    }
export type GetTranslationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTranslationsQuery, GetTranslationsQueryVariables>
    } & TChildProps;
export function withGetTranslations<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTranslationsQuery,
  GetTranslationsQueryVariables,
  GetTranslationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTranslationsQuery, GetTranslationsQueryVariables, GetTranslationsProps<TChildProps, TDataName>>(Operations.getTranslations, {
      alias: 'getTranslations',
      ...operationOptions
    });
};

/**
 * __useGetTranslationsQuery__
 *
 * To run a query within a React component, call `useGetTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetTranslationsQuery(baseOptions: Apollo.QueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(Operations.getTranslations, options);
      }
export function useGetTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(Operations.getTranslations, options);
        }
export type GetTranslationsQueryHookResult = ReturnType<typeof useGetTranslationsQuery>;
export type GetTranslationsLazyQueryHookResult = ReturnType<typeof useGetTranslationsLazyQuery>;
export type GetTranslationsQueryResult = ApolloReactCommon.QueryResult<GetTranslationsQuery, GetTranslationsQueryVariables>;
export function refetchGetTranslationsQuery(variables: GetTranslationsQueryVariables) {
      return { query: Operations.getTranslations, variables: variables }
    }
export type RemoveTranslationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveTranslationMutation, RemoveTranslationMutationVariables>
    } & TChildProps;
export function withRemoveTranslation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveTranslationMutation,
  RemoveTranslationMutationVariables,
  RemoveTranslationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveTranslationMutation, RemoveTranslationMutationVariables, RemoveTranslationProps<TChildProps, TDataName>>(Operations.removeTranslation, {
      alias: 'removeTranslation',
      ...operationOptions
    });
};

/**
 * __useRemoveTranslationMutation__
 *
 * To run a mutation, you first call `useRemoveTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTranslationMutation, { data, loading, error }] = useRemoveTranslationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRemoveTranslationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTranslationMutation, RemoveTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTranslationMutation, RemoveTranslationMutationVariables>(Operations.removeTranslation, options);
      }
export type RemoveTranslationMutationHookResult = ReturnType<typeof useRemoveTranslationMutation>;
export type RemoveTranslationMutationResult = ApolloReactCommon.MutationResult<RemoveTranslationMutation>;
export type RemoveTranslationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveTranslationMutation, RemoveTranslationMutationVariables>;
export type UpdateTranslationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateTranslationMutation, UpdateTranslationMutationVariables>
    } & TChildProps;
export function withUpdateTranslation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateTranslationMutation,
  UpdateTranslationMutationVariables,
  UpdateTranslationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateTranslationMutation, UpdateTranslationMutationVariables, UpdateTranslationProps<TChildProps, TDataName>>(Operations.updateTranslation, {
      alias: 'updateTranslation',
      ...operationOptions
    });
};

/**
 * __useUpdateTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationMutation, { data, loading, error }] = useUpdateTranslationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *      key: // value for 'key'
 *      translations: // value for 'translations'
 *   },
 * });
 */
export function useUpdateTranslationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranslationMutation, UpdateTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranslationMutation, UpdateTranslationMutationVariables>(Operations.updateTranslation, options);
      }
export type UpdateTranslationMutationHookResult = ReturnType<typeof useUpdateTranslationMutation>;
export type UpdateTranslationMutationResult = ApolloReactCommon.MutationResult<UpdateTranslationMutation>;
export type UpdateTranslationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTranslationMutation, UpdateTranslationMutationVariables>;
export type AddUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddUserMutation, AddUserMutationVariables>
    } & TChildProps;
export function withAddUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddUserMutation,
  AddUserMutationVariables,
  AddUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddUserMutation, AddUserMutationVariables, AddUserProps<TChildProps, TDataName>>(Operations.addUser, {
      alias: 'addUser',
      ...operationOptions
    });
};

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      locale: // value for 'locale'
 *      avatar: // value for 'avatar'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      profile: // value for 'profile'
 *      privacy: // value for 'privacy'
 *      notifications: // value for 'notifications'
 *      timezone: // value for 'timezone'
 *      applications: // value for 'applications'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: Apollo.MutationHookOptions<AddUserMutation, AddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserMutation, AddUserMutationVariables>(Operations.addUser, options);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = ApolloReactCommon.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserMutation, AddUserMutationVariables>;
export type AddUserWhiteListProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddUserWhiteListMutation, AddUserWhiteListMutationVariables>
    } & TChildProps;
export function withAddUserWhiteList<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddUserWhiteListMutation,
  AddUserWhiteListMutationVariables,
  AddUserWhiteListProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddUserWhiteListMutation, AddUserWhiteListMutationVariables, AddUserWhiteListProps<TChildProps, TDataName>>(Operations.addUserWhiteList, {
      alias: 'addUserWhiteList',
      ...operationOptions
    });
};

/**
 * __useAddUserWhiteListMutation__
 *
 * To run a mutation, you first call `useAddUserWhiteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserWhiteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserWhiteListMutation, { data, loading, error }] = useAddUserWhiteListMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      group: // value for 'group'
 *      whitelist: // value for 'whitelist'
 *      roles: // value for 'roles'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAddUserWhiteListMutation(baseOptions?: Apollo.MutationHookOptions<AddUserWhiteListMutation, AddUserWhiteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserWhiteListMutation, AddUserWhiteListMutationVariables>(Operations.addUserWhiteList, options);
      }
export type AddUserWhiteListMutationHookResult = ReturnType<typeof useAddUserWhiteListMutation>;
export type AddUserWhiteListMutationResult = ApolloReactCommon.MutationResult<AddUserWhiteListMutation>;
export type AddUserWhiteListMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserWhiteListMutation, AddUserWhiteListMutationVariables>;
export type CreateUserCreditTransactionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateUserCreditTransactionMutation, CreateUserCreditTransactionMutationVariables>
    } & TChildProps;
export function withCreateUserCreditTransaction<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateUserCreditTransactionMutation,
  CreateUserCreditTransactionMutationVariables,
  CreateUserCreditTransactionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateUserCreditTransactionMutation, CreateUserCreditTransactionMutationVariables, CreateUserCreditTransactionProps<TChildProps, TDataName>>(Operations.createUserCreditTransaction, {
      alias: 'createUserCreditTransaction',
      ...operationOptions
    });
};

/**
 * __useCreateUserCreditTransactionMutation__
 *
 * To run a mutation, you first call `useCreateUserCreditTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserCreditTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserCreditTransactionMutation, { data, loading, error }] = useCreateUserCreditTransactionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      amount: // value for 'amount'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateUserCreditTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserCreditTransactionMutation, CreateUserCreditTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserCreditTransactionMutation, CreateUserCreditTransactionMutationVariables>(Operations.createUserCreditTransaction, options);
      }
export type CreateUserCreditTransactionMutationHookResult = ReturnType<typeof useCreateUserCreditTransactionMutation>;
export type CreateUserCreditTransactionMutationResult = ApolloReactCommon.MutationResult<CreateUserCreditTransactionMutation>;
export type CreateUserCreditTransactionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserCreditTransactionMutation, CreateUserCreditTransactionMutationVariables>;
export type GetUserCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserCountQuery, GetUserCountQueryVariables>
    } & TChildProps;
export function withGetUserCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserCountQuery,
  GetUserCountQueryVariables,
  GetUserCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserCountQuery, GetUserCountQueryVariables, GetUserCountProps<TChildProps, TDataName>>(Operations.getUserCount, {
      alias: 'getUserCount',
      ...operationOptions
    });
};

/**
 * __useGetUserCountQuery__
 *
 * To run a query within a React component, call `useGetUserCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUserCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUserCountQuery, GetUserCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCountQuery, GetUserCountQueryVariables>(Operations.getUserCount, options);
      }
export function useGetUserCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCountQuery, GetUserCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCountQuery, GetUserCountQueryVariables>(Operations.getUserCount, options);
        }
export type GetUserCountQueryHookResult = ReturnType<typeof useGetUserCountQuery>;
export type GetUserCountLazyQueryHookResult = ReturnType<typeof useGetUserCountLazyQuery>;
export type GetUserCountQueryResult = ApolloReactCommon.QueryResult<GetUserCountQuery, GetUserCountQueryVariables>;
export function refetchGetUserCountQuery(variables?: GetUserCountQueryVariables) {
      return { query: Operations.getUserCount, variables: variables }
    }
export type GetUserCreditStatisticsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserCreditStatisticsQuery, GetUserCreditStatisticsQueryVariables>
    } & TChildProps;
export function withGetUserCreditStatistics<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserCreditStatisticsQuery,
  GetUserCreditStatisticsQueryVariables,
  GetUserCreditStatisticsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserCreditStatisticsQuery, GetUserCreditStatisticsQueryVariables, GetUserCreditStatisticsProps<TChildProps, TDataName>>(Operations.getUserCreditStatistics, {
      alias: 'getUserCreditStatistics',
      ...operationOptions
    });
};

/**
 * __useGetUserCreditStatisticsQuery__
 *
 * To run a query within a React component, call `useGetUserCreditStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCreditStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCreditStatisticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUserCreditStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserCreditStatisticsQuery, GetUserCreditStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCreditStatisticsQuery, GetUserCreditStatisticsQueryVariables>(Operations.getUserCreditStatistics, options);
      }
export function useGetUserCreditStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCreditStatisticsQuery, GetUserCreditStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCreditStatisticsQuery, GetUserCreditStatisticsQueryVariables>(Operations.getUserCreditStatistics, options);
        }
export type GetUserCreditStatisticsQueryHookResult = ReturnType<typeof useGetUserCreditStatisticsQuery>;
export type GetUserCreditStatisticsLazyQueryHookResult = ReturnType<typeof useGetUserCreditStatisticsLazyQuery>;
export type GetUserCreditStatisticsQueryResult = ApolloReactCommon.QueryResult<GetUserCreditStatisticsQuery, GetUserCreditStatisticsQueryVariables>;
export function refetchGetUserCreditStatisticsQuery(variables?: GetUserCreditStatisticsQueryVariables) {
      return { query: Operations.getUserCreditStatistics, variables: variables }
    }
export type GetUserWhiteListsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserWhiteListsQuery, GetUserWhiteListsQueryVariables>
    } & TChildProps;
export function withGetUserWhiteLists<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserWhiteListsQuery,
  GetUserWhiteListsQueryVariables,
  GetUserWhiteListsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserWhiteListsQuery, GetUserWhiteListsQueryVariables, GetUserWhiteListsProps<TChildProps, TDataName>>(Operations.getUserWhiteLists, {
      alias: 'getUserWhiteLists',
      ...operationOptions
    });
};

/**
 * __useGetUserWhiteListsQuery__
 *
 * To run a query within a React component, call `useGetUserWhiteListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWhiteListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWhiteListsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUserWhiteListsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWhiteListsQuery, GetUserWhiteListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWhiteListsQuery, GetUserWhiteListsQueryVariables>(Operations.getUserWhiteLists, options);
      }
export function useGetUserWhiteListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWhiteListsQuery, GetUserWhiteListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWhiteListsQuery, GetUserWhiteListsQueryVariables>(Operations.getUserWhiteLists, options);
        }
export type GetUserWhiteListsQueryHookResult = ReturnType<typeof useGetUserWhiteListsQuery>;
export type GetUserWhiteListsLazyQueryHookResult = ReturnType<typeof useGetUserWhiteListsLazyQuery>;
export type GetUserWhiteListsQueryResult = ApolloReactCommon.QueryResult<GetUserWhiteListsQuery, GetUserWhiteListsQueryVariables>;
export function refetchGetUserWhiteListsQuery(variables?: GetUserWhiteListsQueryVariables) {
      return { query: Operations.getUserWhiteLists, variables: variables }
    }
export type GetUsersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUsersQuery, GetUsersQueryVariables>
    } & TChildProps;
export function withGetUsers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUsersQuery,
  GetUsersQueryVariables,
  GetUsersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUsersQuery, GetUsersQueryVariables, GetUsersProps<TChildProps, TDataName>>(Operations.getUsers, {
      alias: 'getUsers',
      ...operationOptions
    });
};

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(Operations.getUsers, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(Operations.getUsers, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = ApolloReactCommon.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function refetchGetUsersQuery(variables?: GetUsersQueryVariables) {
      return { query: Operations.getUsers, variables: variables }
    }
export type GetUsersDataToExportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUsersDataToExportQuery, GetUsersDataToExportQueryVariables>
    } & TChildProps;
export function withGetUsersDataToExport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUsersDataToExportQuery,
  GetUsersDataToExportQueryVariables,
  GetUsersDataToExportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUsersDataToExportQuery, GetUsersDataToExportQueryVariables, GetUsersDataToExportProps<TChildProps, TDataName>>(Operations.getUsersDataToExport, {
      alias: 'getUsersDataToExport',
      ...operationOptions
    });
};

/**
 * __useGetUsersDataToExportQuery__
 *
 * To run a query within a React component, call `useGetUsersDataToExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersDataToExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersDataToExportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUsersDataToExportQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersDataToExportQuery, GetUsersDataToExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersDataToExportQuery, GetUsersDataToExportQueryVariables>(Operations.getUsersDataToExport, options);
      }
export function useGetUsersDataToExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersDataToExportQuery, GetUsersDataToExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersDataToExportQuery, GetUsersDataToExportQueryVariables>(Operations.getUsersDataToExport, options);
        }
export type GetUsersDataToExportQueryHookResult = ReturnType<typeof useGetUsersDataToExportQuery>;
export type GetUsersDataToExportLazyQueryHookResult = ReturnType<typeof useGetUsersDataToExportLazyQuery>;
export type GetUsersDataToExportQueryResult = ApolloReactCommon.QueryResult<GetUsersDataToExportQuery, GetUsersDataToExportQueryVariables>;
export function refetchGetUsersDataToExportQuery(variables?: GetUsersDataToExportQueryVariables) {
      return { query: Operations.getUsersDataToExport, variables: variables }
    }
export type GetUsersLightProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUsersLightQuery, GetUsersLightQueryVariables>
    } & TChildProps;
export function withGetUsersLight<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUsersLightQuery,
  GetUsersLightQueryVariables,
  GetUsersLightProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUsersLightQuery, GetUsersLightQueryVariables, GetUsersLightProps<TChildProps, TDataName>>(Operations.getUsersLight, {
      alias: 'getUsersLight',
      ...operationOptions
    });
};

/**
 * __useGetUsersLightQuery__
 *
 * To run a query within a React component, call `useGetUsersLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersLightQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUsersLightQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersLightQuery, GetUsersLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersLightQuery, GetUsersLightQueryVariables>(Operations.getUsersLight, options);
      }
export function useGetUsersLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersLightQuery, GetUsersLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersLightQuery, GetUsersLightQueryVariables>(Operations.getUsersLight, options);
        }
export type GetUsersLightQueryHookResult = ReturnType<typeof useGetUsersLightQuery>;
export type GetUsersLightLazyQueryHookResult = ReturnType<typeof useGetUsersLightLazyQuery>;
export type GetUsersLightQueryResult = ApolloReactCommon.QueryResult<GetUsersLightQuery, GetUsersLightQueryVariables>;
export function refetchGetUsersLightQuery(variables?: GetUsersLightQueryVariables) {
      return { query: Operations.getUsersLight, variables: variables }
    }
export type GetUsersOverviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUsersOverviewQuery, GetUsersOverviewQueryVariables>
    } & TChildProps;
export function withGetUsersOverview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUsersOverviewQuery,
  GetUsersOverviewQueryVariables,
  GetUsersOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUsersOverviewQuery, GetUsersOverviewQueryVariables, GetUsersOverviewProps<TChildProps, TDataName>>(Operations.getUsersOverview, {
      alias: 'getUsersOverview',
      ...operationOptions
    });
};

/**
 * __useGetUsersOverviewQuery__
 *
 * To run a query within a React component, call `useGetUsersOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUsersOverviewQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersOverviewQuery, GetUsersOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersOverviewQuery, GetUsersOverviewQueryVariables>(Operations.getUsersOverview, options);
      }
export function useGetUsersOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersOverviewQuery, GetUsersOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersOverviewQuery, GetUsersOverviewQueryVariables>(Operations.getUsersOverview, options);
        }
export type GetUsersOverviewQueryHookResult = ReturnType<typeof useGetUsersOverviewQuery>;
export type GetUsersOverviewLazyQueryHookResult = ReturnType<typeof useGetUsersOverviewLazyQuery>;
export type GetUsersOverviewQueryResult = ApolloReactCommon.QueryResult<GetUsersOverviewQuery, GetUsersOverviewQueryVariables>;
export function refetchGetUsersOverviewQuery(variables?: GetUsersOverviewQueryVariables) {
      return { query: Operations.getUsersOverview, variables: variables }
    }
export type ImpersonateUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ImpersonateUserMutation, ImpersonateUserMutationVariables>
    } & TChildProps;
export function withImpersonateUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ImpersonateUserMutation,
  ImpersonateUserMutationVariables,
  ImpersonateUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ImpersonateUserMutation, ImpersonateUserMutationVariables, ImpersonateUserProps<TChildProps, TDataName>>(Operations.impersonateUser, {
      alias: 'impersonateUser',
      ...operationOptions
    });
};

/**
 * __useImpersonateUserMutation__
 *
 * To run a mutation, you first call `useImpersonateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateUserMutation, { data, loading, error }] = useImpersonateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      applicationId: // value for 'applicationId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useImpersonateUserMutation(baseOptions?: Apollo.MutationHookOptions<ImpersonateUserMutation, ImpersonateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImpersonateUserMutation, ImpersonateUserMutationVariables>(Operations.impersonateUser, options);
      }
export type ImpersonateUserMutationHookResult = ReturnType<typeof useImpersonateUserMutation>;
export type ImpersonateUserMutationResult = ApolloReactCommon.MutationResult<ImpersonateUserMutation>;
export type ImpersonateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<ImpersonateUserMutation, ImpersonateUserMutationVariables>;
export type RemoveUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>
    } & TChildProps;
export function withRemoveUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveUserMutation,
  RemoveUserMutationVariables,
  RemoveUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveUserMutation, RemoveUserMutationVariables, RemoveUserProps<TChildProps, TDataName>>(Operations.removeUser, {
      alias: 'removeUser',
      ...operationOptions
    });
};

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      anonymize: // value for 'anonymize'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(Operations.removeUser, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = ApolloReactCommon.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export type RemoveUserWhiteListProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveUserWhiteListMutation, RemoveUserWhiteListMutationVariables>
    } & TChildProps;
export function withRemoveUserWhiteList<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveUserWhiteListMutation,
  RemoveUserWhiteListMutationVariables,
  RemoveUserWhiteListProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveUserWhiteListMutation, RemoveUserWhiteListMutationVariables, RemoveUserWhiteListProps<TChildProps, TDataName>>(Operations.removeUserWhiteList, {
      alias: 'removeUserWhiteList',
      ...operationOptions
    });
};

/**
 * __useRemoveUserWhiteListMutation__
 *
 * To run a mutation, you first call `useRemoveUserWhiteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserWhiteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserWhiteListMutation, { data, loading, error }] = useRemoveUserWhiteListMutation({
 *   variables: {
 *      group: // value for 'group'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRemoveUserWhiteListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserWhiteListMutation, RemoveUserWhiteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserWhiteListMutation, RemoveUserWhiteListMutationVariables>(Operations.removeUserWhiteList, options);
      }
export type RemoveUserWhiteListMutationHookResult = ReturnType<typeof useRemoveUserWhiteListMutation>;
export type RemoveUserWhiteListMutationResult = ApolloReactCommon.MutationResult<RemoveUserWhiteListMutation>;
export type RemoveUserWhiteListMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserWhiteListMutation, RemoveUserWhiteListMutationVariables>;
export type RemoveUsersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveUsersMutation, RemoveUsersMutationVariables>
    } & TChildProps;
export function withRemoveUsers<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveUsersMutation,
  RemoveUsersMutationVariables,
  RemoveUsersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveUsersMutation, RemoveUsersMutationVariables, RemoveUsersProps<TChildProps, TDataName>>(Operations.removeUsers, {
      alias: 'removeUsers',
      ...operationOptions
    });
};

/**
 * __useRemoveUsersMutation__
 *
 * To run a mutation, you first call `useRemoveUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersMutation, { data, loading, error }] = useRemoveUsersMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *      anonymize: // value for 'anonymize'
 *   },
 * });
 */
export function useRemoveUsersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUsersMutation, RemoveUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUsersMutation, RemoveUsersMutationVariables>(Operations.removeUsers, options);
      }
export type RemoveUsersMutationHookResult = ReturnType<typeof useRemoveUsersMutation>;
export type RemoveUsersMutationResult = ApolloReactCommon.MutationResult<RemoveUsersMutation>;
export type RemoveUsersMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUsersMutation, RemoveUsersMutationVariables>;
export type RequestValidateEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RequestValidateEmailMutation, RequestValidateEmailMutationVariables>
    } & TChildProps;
export function withRequestValidateEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RequestValidateEmailMutation,
  RequestValidateEmailMutationVariables,
  RequestValidateEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RequestValidateEmailMutation, RequestValidateEmailMutationVariables, RequestValidateEmailProps<TChildProps, TDataName>>(Operations.requestValidateEmail, {
      alias: 'requestValidateEmail',
      ...operationOptions
    });
};

/**
 * __useRequestValidateEmailMutation__
 *
 * To run a mutation, you first call `useRequestValidateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestValidateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestValidateEmailMutation, { data, loading, error }] = useRequestValidateEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestValidateEmailMutation(baseOptions?: Apollo.MutationHookOptions<RequestValidateEmailMutation, RequestValidateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestValidateEmailMutation, RequestValidateEmailMutationVariables>(Operations.requestValidateEmail, options);
      }
export type RequestValidateEmailMutationHookResult = ReturnType<typeof useRequestValidateEmailMutation>;
export type RequestValidateEmailMutationResult = ApolloReactCommon.MutationResult<RequestValidateEmailMutation>;
export type RequestValidateEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestValidateEmailMutation, RequestValidateEmailMutationVariables>;
export type ResyncProviderProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ResyncProviderMutation, ResyncProviderMutationVariables>
    } & TChildProps;
export function withResyncProvider<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ResyncProviderMutation,
  ResyncProviderMutationVariables,
  ResyncProviderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ResyncProviderMutation, ResyncProviderMutationVariables, ResyncProviderProps<TChildProps, TDataName>>(Operations.resyncProvider, {
      alias: 'resyncProvider',
      ...operationOptions
    });
};

/**
 * __useResyncProviderMutation__
 *
 * To run a mutation, you first call `useResyncProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResyncProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resyncProviderMutation, { data, loading, error }] = useResyncProviderMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      provider: // value for 'provider'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useResyncProviderMutation(baseOptions?: Apollo.MutationHookOptions<ResyncProviderMutation, ResyncProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResyncProviderMutation, ResyncProviderMutationVariables>(Operations.resyncProvider, options);
      }
export type ResyncProviderMutationHookResult = ReturnType<typeof useResyncProviderMutation>;
export type ResyncProviderMutationResult = ApolloReactCommon.MutationResult<ResyncProviderMutation>;
export type ResyncProviderMutationOptions = ApolloReactCommon.BaseMutationOptions<ResyncProviderMutation, ResyncProviderMutationVariables>;
export type UpdateUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>
    } & TChildProps;
export function withUpdateUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserMutation,
  UpdateUserMutationVariables,
  UpdateUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserMutation, UpdateUserMutationVariables, UpdateUserProps<TChildProps, TDataName>>(Operations.updateUser, {
      alias: 'updateUser',
      ...operationOptions
    });
};

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      locale: // value for 'locale'
 *      avatar: // value for 'avatar'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      profile: // value for 'profile'
 *      privacy: // value for 'privacy'
 *      notifications: // value for 'notifications'
 *      timezone: // value for 'timezone'
 *      applications: // value for 'applications'
 *      projectId: // value for 'projectId'
 *      locked: // value for 'locked'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(Operations.updateUser, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export type UpdateUserWhiteListProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateUserWhiteListMutation, UpdateUserWhiteListMutationVariables>
    } & TChildProps;
export function withUpdateUserWhiteList<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserWhiteListMutation,
  UpdateUserWhiteListMutationVariables,
  UpdateUserWhiteListProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserWhiteListMutation, UpdateUserWhiteListMutationVariables, UpdateUserWhiteListProps<TChildProps, TDataName>>(Operations.updateUserWhiteList, {
      alias: 'updateUserWhiteList',
      ...operationOptions
    });
};

/**
 * __useUpdateUserWhiteListMutation__
 *
 * To run a mutation, you first call `useUpdateUserWhiteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserWhiteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserWhiteListMutation, { data, loading, error }] = useUpdateUserWhiteListMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      group: // value for 'group'
 *      whitelist: // value for 'whitelist'
 *      roles: // value for 'roles'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUpdateUserWhiteListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserWhiteListMutation, UpdateUserWhiteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserWhiteListMutation, UpdateUserWhiteListMutationVariables>(Operations.updateUserWhiteList, options);
      }
export type UpdateUserWhiteListMutationHookResult = ReturnType<typeof useUpdateUserWhiteListMutation>;
export type UpdateUserWhiteListMutationResult = ApolloReactCommon.MutationResult<UpdateUserWhiteListMutation>;
export type UpdateUserWhiteListMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserWhiteListMutation, UpdateUserWhiteListMutationVariables>;
export type ValidateEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ValidateEmailMutation, ValidateEmailMutationVariables>
    } & TChildProps;
export function withValidateEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ValidateEmailMutation,
  ValidateEmailMutationVariables,
  ValidateEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ValidateEmailMutation, ValidateEmailMutationVariables, ValidateEmailProps<TChildProps, TDataName>>(Operations.validateEmail, {
      alias: 'validateEmail',
      ...operationOptions
    });
};

/**
 * __useValidateEmailMutation__
 *
 * To run a mutation, you first call `useValidateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateEmailMutation, { data, loading, error }] = useValidateEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useValidateEmailMutation(baseOptions?: Apollo.MutationHookOptions<ValidateEmailMutation, ValidateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateEmailMutation, ValidateEmailMutationVariables>(Operations.validateEmail, options);
      }
export type ValidateEmailMutationHookResult = ReturnType<typeof useValidateEmailMutation>;
export type ValidateEmailMutationResult = ApolloReactCommon.MutationResult<ValidateEmailMutation>;
export type ValidateEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<ValidateEmailMutation, ValidateEmailMutationVariables>;
export type AddVoucherProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddVoucherMutation, AddVoucherMutationVariables>
    } & TChildProps;
export function withAddVoucher<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddVoucherMutation,
  AddVoucherMutationVariables,
  AddVoucherProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddVoucherMutation, AddVoucherMutationVariables, AddVoucherProps<TChildProps, TDataName>>(Operations.addVoucher, {
      alias: 'addVoucher',
      ...operationOptions
    });
};

/**
 * __useAddVoucherMutation__
 *
 * To run a mutation, you first call `useAddVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVoucherMutation, { data, loading, error }] = useAddVoucherMutation({
 *   variables: {
 *      code: // value for 'code'
 *      enabled: // value for 'enabled'
 *      maxUsage: // value for 'maxUsage'
 *      maxUsagePerUser: // value for 'maxUsagePerUser'
 *      assignments: // value for 'assignments'
 *      discount: // value for 'discount'
 *      enableVoucherPeriod: // value for 'enableVoucherPeriod'
 *      enabledMaxUsage: // value for 'enabledMaxUsage'
 *      enabledMaxUsagePerUser: // value for 'enabledMaxUsagePerUser'
 *      enabledOn: // value for 'enabledOn'
 *      title: // value for 'title'
 *      voucherEnd: // value for 'voucherEnd'
 *      voucherStart: // value for 'voucherStart'
 *   },
 * });
 */
export function useAddVoucherMutation(baseOptions?: Apollo.MutationHookOptions<AddVoucherMutation, AddVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVoucherMutation, AddVoucherMutationVariables>(Operations.addVoucher, options);
      }
export type AddVoucherMutationHookResult = ReturnType<typeof useAddVoucherMutation>;
export type AddVoucherMutationResult = ApolloReactCommon.MutationResult<AddVoucherMutation>;
export type AddVoucherMutationOptions = ApolloReactCommon.BaseMutationOptions<AddVoucherMutation, AddVoucherMutationVariables>;
export type ExportVoucherProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ExportVoucherMutation, ExportVoucherMutationVariables>
    } & TChildProps;
export function withExportVoucher<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ExportVoucherMutation,
  ExportVoucherMutationVariables,
  ExportVoucherProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ExportVoucherMutation, ExportVoucherMutationVariables, ExportVoucherProps<TChildProps, TDataName>>(Operations.exportVoucher, {
      alias: 'exportVoucher',
      ...operationOptions
    });
};

/**
 * __useExportVoucherMutation__
 *
 * To run a mutation, you first call `useExportVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportVoucherMutation, { data, loading, error }] = useExportVoucherMutation({
 *   variables: {
 *      format: // value for 'format'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportVoucherMutation(baseOptions?: Apollo.MutationHookOptions<ExportVoucherMutation, ExportVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportVoucherMutation, ExportVoucherMutationVariables>(Operations.exportVoucher, options);
      }
export type ExportVoucherMutationHookResult = ReturnType<typeof useExportVoucherMutation>;
export type ExportVoucherMutationResult = ApolloReactCommon.MutationResult<ExportVoucherMutation>;
export type ExportVoucherMutationOptions = ApolloReactCommon.BaseMutationOptions<ExportVoucherMutation, ExportVoucherMutationVariables>;
export type GetVoucherCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetVoucherCountQuery, GetVoucherCountQueryVariables>
    } & TChildProps;
export function withGetVoucherCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetVoucherCountQuery,
  GetVoucherCountQueryVariables,
  GetVoucherCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetVoucherCountQuery, GetVoucherCountQueryVariables, GetVoucherCountProps<TChildProps, TDataName>>(Operations.getVoucherCount, {
      alias: 'getVoucherCount',
      ...operationOptions
    });
};

/**
 * __useGetVoucherCountQuery__
 *
 * To run a query within a React component, call `useGetVoucherCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoucherCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoucherCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetVoucherCountQuery(baseOptions?: Apollo.QueryHookOptions<GetVoucherCountQuery, GetVoucherCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoucherCountQuery, GetVoucherCountQueryVariables>(Operations.getVoucherCount, options);
      }
export function useGetVoucherCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoucherCountQuery, GetVoucherCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoucherCountQuery, GetVoucherCountQueryVariables>(Operations.getVoucherCount, options);
        }
export type GetVoucherCountQueryHookResult = ReturnType<typeof useGetVoucherCountQuery>;
export type GetVoucherCountLazyQueryHookResult = ReturnType<typeof useGetVoucherCountLazyQuery>;
export type GetVoucherCountQueryResult = ApolloReactCommon.QueryResult<GetVoucherCountQuery, GetVoucherCountQueryVariables>;
export function refetchGetVoucherCountQuery(variables?: GetVoucherCountQueryVariables) {
      return { query: Operations.getVoucherCount, variables: variables }
    }
export type GetVouchersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetVouchersQuery, GetVouchersQueryVariables>
    } & TChildProps;
export function withGetVouchers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetVouchersQuery,
  GetVouchersQueryVariables,
  GetVouchersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetVouchersQuery, GetVouchersQueryVariables, GetVouchersProps<TChildProps, TDataName>>(Operations.getVouchers, {
      alias: 'getVouchers',
      ...operationOptions
    });
};

/**
 * __useGetVouchersQuery__
 *
 * To run a query within a React component, call `useGetVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVouchersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetVouchersQuery(baseOptions?: Apollo.QueryHookOptions<GetVouchersQuery, GetVouchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVouchersQuery, GetVouchersQueryVariables>(Operations.getVouchers, options);
      }
export function useGetVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVouchersQuery, GetVouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVouchersQuery, GetVouchersQueryVariables>(Operations.getVouchers, options);
        }
export type GetVouchersQueryHookResult = ReturnType<typeof useGetVouchersQuery>;
export type GetVouchersLazyQueryHookResult = ReturnType<typeof useGetVouchersLazyQuery>;
export type GetVouchersQueryResult = ApolloReactCommon.QueryResult<GetVouchersQuery, GetVouchersQueryVariables>;
export function refetchGetVouchersQuery(variables?: GetVouchersQueryVariables) {
      return { query: Operations.getVouchers, variables: variables }
    }
export type RemoveVoucherProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveVoucherMutation, RemoveVoucherMutationVariables>
    } & TChildProps;
export function withRemoveVoucher<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveVoucherMutation,
  RemoveVoucherMutationVariables,
  RemoveVoucherProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveVoucherMutation, RemoveVoucherMutationVariables, RemoveVoucherProps<TChildProps, TDataName>>(Operations.removeVoucher, {
      alias: 'removeVoucher',
      ...operationOptions
    });
};

/**
 * __useRemoveVoucherMutation__
 *
 * To run a mutation, you first call `useRemoveVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVoucherMutation, { data, loading, error }] = useRemoveVoucherMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveVoucherMutation(baseOptions?: Apollo.MutationHookOptions<RemoveVoucherMutation, RemoveVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveVoucherMutation, RemoveVoucherMutationVariables>(Operations.removeVoucher, options);
      }
export type RemoveVoucherMutationHookResult = ReturnType<typeof useRemoveVoucherMutation>;
export type RemoveVoucherMutationResult = ApolloReactCommon.MutationResult<RemoveVoucherMutation>;
export type RemoveVoucherMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveVoucherMutation, RemoveVoucherMutationVariables>;
export type UpdateVoucherProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateVoucherMutation, UpdateVoucherMutationVariables>
    } & TChildProps;
export function withUpdateVoucher<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateVoucherMutation,
  UpdateVoucherMutationVariables,
  UpdateVoucherProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateVoucherMutation, UpdateVoucherMutationVariables, UpdateVoucherProps<TChildProps, TDataName>>(Operations.updateVoucher, {
      alias: 'updateVoucher',
      ...operationOptions
    });
};

/**
 * __useUpdateVoucherMutation__
 *
 * To run a mutation, you first call `useUpdateVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoucherMutation, { data, loading, error }] = useUpdateVoucherMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *      enabled: // value for 'enabled'
 *      maxUsage: // value for 'maxUsage'
 *      maxUsagePerUser: // value for 'maxUsagePerUser'
 *      assignments: // value for 'assignments'
 *      discount: // value for 'discount'
 *      enableVoucherPeriod: // value for 'enableVoucherPeriod'
 *      enabledMaxUsage: // value for 'enabledMaxUsage'
 *      enabledMaxUsagePerUser: // value for 'enabledMaxUsagePerUser'
 *      enabledOn: // value for 'enabledOn'
 *      title: // value for 'title'
 *      voucherEnd: // value for 'voucherEnd'
 *      voucherStart: // value for 'voucherStart'
 *   },
 * });
 */
export function useUpdateVoucherMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVoucherMutation, UpdateVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVoucherMutation, UpdateVoucherMutationVariables>(Operations.updateVoucher, options);
      }
export type UpdateVoucherMutationHookResult = ReturnType<typeof useUpdateVoucherMutation>;
export type UpdateVoucherMutationResult = ApolloReactCommon.MutationResult<UpdateVoucherMutation>;
export type UpdateVoucherMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateVoucherMutation, UpdateVoucherMutationVariables>;